function T(r, t, o) {
  function s(_, S) {
    if (_._zod || Object.defineProperty(_, "_zod", {
      value: {
        def: S,
        constr: p,
        traits: /* @__PURE__ */ new Set()
      },
      enumerable: !1
    }), _._zod.traits.has(r))
      return;
    _._zod.traits.add(r), t(_, S);
    const N = p.prototype, w = Object.keys(N);
    for (let F = 0; F < w.length; F++) {
      const k = w[F];
      k in _ || (_[k] = N[k].bind(_));
    }
  }
  const u = o?.Parent ?? Object;
  class f extends u {
  }
  Object.defineProperty(f, "name", { value: r });
  function p(_) {
    var S;
    const N = o?.Parent ? new f() : this;
    s(N, _), (S = N._zod).deferred ?? (S.deferred = []);
    for (const w of N._zod.deferred)
      w();
    return N;
  }
  return Object.defineProperty(p, "init", { value: s }), Object.defineProperty(p, Symbol.hasInstance, {
    value: (_) => o?.Parent && _ instanceof o.Parent ? !0 : _?._zod?.traits?.has(r)
  }), Object.defineProperty(p, "name", { value: r }), p;
}
class lr extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}
class Fu extends Error {
  constructor(t) {
    super(`Encountered unidirectional transform during encode: ${t}`), this.name = "ZodEncodeError";
  }
}
const Gu = {};
function $n(r) {
  return Gu;
}
function Du(r) {
  const t = Object.values(r).filter((s) => typeof s == "number");
  return Object.entries(r).filter(([s, u]) => t.indexOf(+s) === -1).map(([s, u]) => u);
}
function Ii(r, t) {
  return typeof t == "bigint" ? t.toString() : t;
}
function Ci(r) {
  return {
    get value() {
      {
        const t = r();
        return Object.defineProperty(this, "value", { value: t }), t;
      }
    }
  };
}
function yi(r) {
  return r == null;
}
function Ni(r) {
  const t = r.startsWith("^") ? 1 : 0, o = r.endsWith("$") ? r.length - 1 : r.length;
  return r.slice(t, o);
}
function Sg(r, t) {
  const o = (r.toString().split(".")[1] || "").length, s = t.toString();
  let u = (s.split(".")[1] || "").length;
  if (u === 0 && /\d?e-\d?/.test(s)) {
    const S = s.match(/\d?e-(\d?)/);
    S?.[1] && (u = Number.parseInt(S[1]));
  }
  const f = o > u ? o : u, p = Number.parseInt(r.toFixed(f).replace(".", "")), _ = Number.parseInt(t.toFixed(f).replace(".", ""));
  return p % _ / 10 ** f;
}
const fu = /* @__PURE__ */ Symbol("evaluating");
function J(r, t, o) {
  let s;
  Object.defineProperty(r, t, {
    get() {
      if (s !== fu)
        return s === void 0 && (s = fu, s = o()), s;
    },
    set(u) {
      Object.defineProperty(r, t, {
        value: u
        // configurable: true,
      });
    },
    configurable: !0
  });
}
function Hn(r, t, o) {
  Object.defineProperty(r, t, {
    value: o,
    writable: !0,
    enumerable: !0,
    configurable: !0
  });
}
function Mn(...r) {
  const t = {};
  for (const o of r) {
    const s = Object.getOwnPropertyDescriptors(o);
    Object.assign(t, s);
  }
  return Object.defineProperties({}, t);
}
function hu(r) {
  return JSON.stringify(r);
}
function Ag(r) {
  return r.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
}
const Zu = "captureStackTrace" in Error ? Error.captureStackTrace : (...r) => {
};
function Gt(r) {
  return typeof r == "object" && r !== null && !Array.isArray(r);
}
const Tg = Ci(() => {
  if (typeof navigator < "u" && navigator?.userAgent?.includes("Cloudflare"))
    return !1;
  try {
    const r = Function;
    return new r(""), !0;
  } catch {
    return !1;
  }
});
function Zr(r) {
  if (Gt(r) === !1)
    return !1;
  const t = r.constructor;
  if (t === void 0 || typeof t != "function")
    return !0;
  const o = t.prototype;
  return !(Gt(o) === !1 || Object.prototype.hasOwnProperty.call(o, "isPrototypeOf") === !1);
}
function Uu(r) {
  return Zr(r) ? { ...r } : Array.isArray(r) ? [...r] : r;
}
const Cg = /* @__PURE__ */ new Set(["string", "number", "symbol"]);
function dr(r) {
  return r.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function kn(r, t, o) {
  const s = new r._zod.constr(t ?? r._zod.def);
  return (!t || o?.parent) && (s._zod.parent = r), s;
}
function B(r) {
  const t = r;
  if (!t)
    return {};
  if (typeof t == "string")
    return { error: () => t };
  if (t?.message !== void 0) {
    if (t?.error !== void 0)
      throw new Error("Cannot specify both `message` and `error` params");
    t.error = t.message;
  }
  return delete t.message, typeof t.error == "string" ? { ...t, error: () => t.error } : t;
}
function yg(r) {
  return Object.keys(r).filter((t) => r[t]._zod.optin === "optional" && r[t]._zod.optout === "optional");
}
const Ng = {
  safeint: [Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER],
  int32: [-2147483648, 2147483647],
  uint32: [0, 4294967295],
  float32: [-34028234663852886e22, 34028234663852886e22],
  float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
};
function xg(r, t) {
  const o = r._zod.def, s = o.checks;
  if (s && s.length > 0)
    throw new Error(".pick() cannot be used on object schemas containing refinements");
  const f = Mn(r._zod.def, {
    get shape() {
      const p = {};
      for (const _ in t) {
        if (!(_ in o.shape))
          throw new Error(`Unrecognized key: "${_}"`);
        t[_] && (p[_] = o.shape[_]);
      }
      return Hn(this, "shape", p), p;
    },
    checks: []
  });
  return kn(r, f);
}
function Eg(r, t) {
  const o = r._zod.def, s = o.checks;
  if (s && s.length > 0)
    throw new Error(".omit() cannot be used on object schemas containing refinements");
  const f = Mn(r._zod.def, {
    get shape() {
      const p = { ...r._zod.def.shape };
      for (const _ in t) {
        if (!(_ in o.shape))
          throw new Error(`Unrecognized key: "${_}"`);
        t[_] && delete p[_];
      }
      return Hn(this, "shape", p), p;
    },
    checks: []
  });
  return kn(r, f);
}
function wg(r, t) {
  if (!Zr(t))
    throw new Error("Invalid input to extend: expected a plain object");
  const o = r._zod.def.checks;
  if (o && o.length > 0) {
    const f = r._zod.def.shape;
    for (const p in t)
      if (Object.getOwnPropertyDescriptor(f, p) !== void 0)
        throw new Error("Cannot overwrite keys on object schemas containing refinements. Use `.safeExtend()` instead.");
  }
  const u = Mn(r._zod.def, {
    get shape() {
      const f = { ...r._zod.def.shape, ...t };
      return Hn(this, "shape", f), f;
    }
  });
  return kn(r, u);
}
function Mg(r, t) {
  if (!Zr(t))
    throw new Error("Invalid input to safeExtend: expected a plain object");
  const o = Mn(r._zod.def, {
    get shape() {
      const s = { ...r._zod.def.shape, ...t };
      return Hn(this, "shape", s), s;
    }
  });
  return kn(r, o);
}
function kg(r, t) {
  const o = Mn(r._zod.def, {
    get shape() {
      const s = { ...r._zod.def.shape, ...t._zod.def.shape };
      return Hn(this, "shape", s), s;
    },
    get catchall() {
      return t._zod.def.catchall;
    },
    checks: []
    // delete existing checks
  });
  return kn(r, o);
}
function Bg(r, t, o) {
  const u = t._zod.def.checks;
  if (u && u.length > 0)
    throw new Error(".partial() cannot be used on object schemas containing refinements");
  const p = Mn(t._zod.def, {
    get shape() {
      const _ = t._zod.def.shape, S = { ..._ };
      if (o)
        for (const N in o) {
          if (!(N in _))
            throw new Error(`Unrecognized key: "${N}"`);
          o[N] && (S[N] = r ? new r({
            type: "optional",
            innerType: _[N]
          }) : _[N]);
        }
      else
        for (const N in _)
          S[N] = r ? new r({
            type: "optional",
            innerType: _[N]
          }) : _[N];
      return Hn(this, "shape", S), S;
    },
    checks: []
  });
  return kn(t, p);
}
function Pg(r, t, o) {
  const s = Mn(t._zod.def, {
    get shape() {
      const u = t._zod.def.shape, f = { ...u };
      if (o)
        for (const p in o) {
          if (!(p in f))
            throw new Error(`Unrecognized key: "${p}"`);
          o[p] && (f[p] = new r({
            type: "nonoptional",
            innerType: u[p]
          }));
        }
      else
        for (const p in u)
          f[p] = new r({
            type: "nonoptional",
            innerType: u[p]
          });
      return Hn(this, "shape", f), f;
    }
  });
  return kn(t, s);
}
function ur(r, t = 0) {
  if (r.aborted === !0)
    return !0;
  for (let o = t; o < r.issues.length; o++)
    if (r.issues[o]?.continue !== !0)
      return !0;
  return !1;
}
function $u(r, t) {
  return t.map((o) => {
    var s;
    return (s = o).path ?? (s.path = []), o.path.unshift(r), o;
  });
}
function zt(r) {
  return typeof r == "string" ? r : r?.message;
}
function Kn(r, t, o) {
  const s = { ...r, path: r.path ?? [] };
  if (!r.message) {
    const u = zt(r.inst?._zod.def?.error?.(r)) ?? zt(t?.error?.(r)) ?? zt(o.customError?.(r)) ?? zt(o.localeError?.(r)) ?? "Invalid input";
    s.message = u;
  }
  return delete s.inst, delete s.continue, t?.reportInput || delete s.input, s;
}
function xi(r) {
  return Array.isArray(r) ? "array" : typeof r == "string" ? "string" : "unknown";
}
function Ur(...r) {
  const [t, o, s] = r;
  return typeof t == "string" ? {
    message: t,
    code: "custom",
    input: o,
    inst: s
  } : { ...t };
}
const Ku = (r, t) => {
  r.name = "$ZodError", Object.defineProperty(r, "_zod", {
    value: r._zod,
    enumerable: !1
  }), Object.defineProperty(r, "issues", {
    value: t,
    enumerable: !1
  }), r.message = JSON.stringify(t, Ii, 2), Object.defineProperty(r, "toString", {
    value: () => r.message,
    enumerable: !1
  });
}, Hu = T("$ZodError", Ku), Wu = T("$ZodError", Ku, { Parent: Error });
function Rg(r, t = (o) => o.message) {
  const o = {}, s = [];
  for (const u of r.issues)
    u.path.length > 0 ? (o[u.path[0]] = o[u.path[0]] || [], o[u.path[0]].push(t(u))) : s.push(t(u));
  return { formErrors: s, fieldErrors: o };
}
function Og(r, t = (o) => o.message) {
  const o = { _errors: [] }, s = (u) => {
    for (const f of u.issues)
      if (f.code === "invalid_union" && f.errors.length)
        f.errors.map((p) => s({ issues: p }));
      else if (f.code === "invalid_key")
        s({ issues: f.issues });
      else if (f.code === "invalid_element")
        s({ issues: f.issues });
      else if (f.path.length === 0)
        o._errors.push(t(f));
      else {
        let p = o, _ = 0;
        for (; _ < f.path.length; ) {
          const S = f.path[_];
          _ === f.path.length - 1 ? (p[S] = p[S] || { _errors: [] }, p[S]._errors.push(t(f))) : p[S] = p[S] || { _errors: [] }, p = p[S], _++;
        }
      }
  };
  return s(r), o;
}
const Ei = (r) => (t, o, s, u) => {
  const f = s ? Object.assign(s, { async: !1 }) : { async: !1 }, p = t._zod.run({ value: o, issues: [] }, f);
  if (p instanceof Promise)
    throw new lr();
  if (p.issues.length) {
    const _ = new (u?.Err ?? r)(p.issues.map((S) => Kn(S, f, $n())));
    throw Zu(_, u?.callee), _;
  }
  return p.value;
}, wi = (r) => async (t, o, s, u) => {
  const f = s ? Object.assign(s, { async: !0 }) : { async: !0 };
  let p = t._zod.run({ value: o, issues: [] }, f);
  if (p instanceof Promise && (p = await p), p.issues.length) {
    const _ = new (u?.Err ?? r)(p.issues.map((S) => Kn(S, f, $n())));
    throw Zu(_, u?.callee), _;
  }
  return p.value;
}, Kt = (r) => (t, o, s) => {
  const u = s ? { ...s, async: !1 } : { async: !1 }, f = t._zod.run({ value: o, issues: [] }, u);
  if (f instanceof Promise)
    throw new lr();
  return f.issues.length ? {
    success: !1,
    error: new (r ?? Hu)(f.issues.map((p) => Kn(p, u, $n())))
  } : { success: !0, data: f.value };
}, zg = /* @__PURE__ */ Kt(Wu), Ht = (r) => async (t, o, s) => {
  const u = s ? Object.assign(s, { async: !0 }) : { async: !0 };
  let f = t._zod.run({ value: o, issues: [] }, u);
  return f instanceof Promise && (f = await f), f.issues.length ? {
    success: !1,
    error: new r(f.issues.map((p) => Kn(p, u, $n())))
  } : { success: !0, data: f.value };
}, Lg = /* @__PURE__ */ Ht(Wu), Fg = (r) => (t, o, s) => {
  const u = s ? Object.assign(s, { direction: "backward" }) : { direction: "backward" };
  return Ei(r)(t, o, u);
}, Gg = (r) => (t, o, s) => Ei(r)(t, o, s), Dg = (r) => async (t, o, s) => {
  const u = s ? Object.assign(s, { direction: "backward" }) : { direction: "backward" };
  return wi(r)(t, o, u);
}, Zg = (r) => async (t, o, s) => wi(r)(t, o, s), Ug = (r) => (t, o, s) => {
  const u = s ? Object.assign(s, { direction: "backward" }) : { direction: "backward" };
  return Kt(r)(t, o, u);
}, $g = (r) => (t, o, s) => Kt(r)(t, o, s), Kg = (r) => async (t, o, s) => {
  const u = s ? Object.assign(s, { direction: "backward" }) : { direction: "backward" };
  return Ht(r)(t, o, u);
}, Hg = (r) => async (t, o, s) => Ht(r)(t, o, s), Wg = /^[cC][^\s-]{8,}$/, qg = /^[0-9a-z]+$/, Vg = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, Jg = /^[0-9a-vA-V]{20}$/, jg = /^[A-Za-z0-9]{27}$/, Yg = /^[a-zA-Z0-9_-]{21}$/, Xg = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, Qg = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, mu = (r) => r ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${r}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, ev = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, nv = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function rv() {
  return new RegExp(nv, "u");
}
const tv = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, ov = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/, iv = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, av = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, sv = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, qu = /^[A-Za-z0-9_-]*$/, uv = /^\+[1-9]\d{6,14}$/, Vu = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", cv = /* @__PURE__ */ new RegExp(`^${Vu}$`);
function Ju(r) {
  const t = "(?:[01]\\d|2[0-3]):[0-5]\\d";
  return typeof r.precision == "number" ? r.precision === -1 ? `${t}` : r.precision === 0 ? `${t}:[0-5]\\d` : `${t}:[0-5]\\d\\.\\d{${r.precision}}` : `${t}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function lv(r) {
  return new RegExp(`^${Ju(r)}$`);
}
function dv(r) {
  const t = Ju({ precision: r.precision }), o = ["Z"];
  r.local && o.push(""), r.offset && o.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
  const s = `${t}(?:${o.join("|")})`;
  return new RegExp(`^${Vu}T(?:${s})$`);
}
const pv = (r) => {
  const t = r ? `[\\s\\S]{${r?.minimum ?? 0},${r?.maximum ?? ""}}` : "[\\s\\S]*";
  return new RegExp(`^${t}$`);
}, fv = /^-?\d+$/, hv = /^-?\d+(?:\.\d+)?$/, mv = /^[^A-Z]*$/, _v = /^[^a-z]*$/, we = /* @__PURE__ */ T("$ZodCheck", (r, t) => {
  var o;
  r._zod ?? (r._zod = {}), r._zod.def = t, (o = r._zod).onattach ?? (o.onattach = []);
}), ju = {
  number: "number",
  bigint: "bigint",
  object: "date"
}, Yu = /* @__PURE__ */ T("$ZodCheckLessThan", (r, t) => {
  we.init(r, t);
  const o = ju[typeof t.value];
  r._zod.onattach.push((s) => {
    const u = s._zod.bag, f = (t.inclusive ? u.maximum : u.exclusiveMaximum) ?? Number.POSITIVE_INFINITY;
    t.value < f && (t.inclusive ? u.maximum = t.value : u.exclusiveMaximum = t.value);
  }), r._zod.check = (s) => {
    (t.inclusive ? s.value <= t.value : s.value < t.value) || s.issues.push({
      origin: o,
      code: "too_big",
      maximum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: s.value,
      inclusive: t.inclusive,
      inst: r,
      continue: !t.abort
    });
  };
}), Xu = /* @__PURE__ */ T("$ZodCheckGreaterThan", (r, t) => {
  we.init(r, t);
  const o = ju[typeof t.value];
  r._zod.onattach.push((s) => {
    const u = s._zod.bag, f = (t.inclusive ? u.minimum : u.exclusiveMinimum) ?? Number.NEGATIVE_INFINITY;
    t.value > f && (t.inclusive ? u.minimum = t.value : u.exclusiveMinimum = t.value);
  }), r._zod.check = (s) => {
    (t.inclusive ? s.value >= t.value : s.value > t.value) || s.issues.push({
      origin: o,
      code: "too_small",
      minimum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: s.value,
      inclusive: t.inclusive,
      inst: r,
      continue: !t.abort
    });
  };
}), gv = /* @__PURE__ */ T("$ZodCheckMultipleOf", (r, t) => {
  we.init(r, t), r._zod.onattach.push((o) => {
    var s;
    (s = o._zod.bag).multipleOf ?? (s.multipleOf = t.value);
  }), r._zod.check = (o) => {
    if (typeof o.value != typeof t.value)
      throw new Error("Cannot mix number and bigint in multiple_of check.");
    (typeof o.value == "bigint" ? o.value % t.value === BigInt(0) : Sg(o.value, t.value) === 0) || o.issues.push({
      origin: typeof o.value,
      code: "not_multiple_of",
      divisor: t.value,
      input: o.value,
      inst: r,
      continue: !t.abort
    });
  };
}), vv = /* @__PURE__ */ T("$ZodCheckNumberFormat", (r, t) => {
  we.init(r, t), t.format = t.format || "float64";
  const o = t.format?.includes("int"), s = o ? "int" : "number", [u, f] = Ng[t.format];
  r._zod.onattach.push((p) => {
    const _ = p._zod.bag;
    _.format = t.format, _.minimum = u, _.maximum = f, o && (_.pattern = fv);
  }), r._zod.check = (p) => {
    const _ = p.value;
    if (o) {
      if (!Number.isInteger(_)) {
        p.issues.push({
          expected: s,
          format: t.format,
          code: "invalid_type",
          continue: !1,
          input: _,
          inst: r
        });
        return;
      }
      if (!Number.isSafeInteger(_)) {
        _ > 0 ? p.issues.push({
          input: _,
          code: "too_big",
          maximum: Number.MAX_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: r,
          origin: s,
          inclusive: !0,
          continue: !t.abort
        }) : p.issues.push({
          input: _,
          code: "too_small",
          minimum: Number.MIN_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: r,
          origin: s,
          inclusive: !0,
          continue: !t.abort
        });
        return;
      }
    }
    _ < u && p.issues.push({
      origin: "number",
      input: _,
      code: "too_small",
      minimum: u,
      inclusive: !0,
      inst: r,
      continue: !t.abort
    }), _ > f && p.issues.push({
      origin: "number",
      input: _,
      code: "too_big",
      maximum: f,
      inclusive: !0,
      inst: r,
      continue: !t.abort
    });
  };
}), Iv = /* @__PURE__ */ T("$ZodCheckMaxLength", (r, t) => {
  var o;
  we.init(r, t), (o = r._zod.def).when ?? (o.when = (s) => {
    const u = s.value;
    return !yi(u) && u.length !== void 0;
  }), r._zod.onattach.push((s) => {
    const u = s._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
    t.maximum < u && (s._zod.bag.maximum = t.maximum);
  }), r._zod.check = (s) => {
    const u = s.value;
    if (u.length <= t.maximum)
      return;
    const p = xi(u);
    s.issues.push({
      origin: p,
      code: "too_big",
      maximum: t.maximum,
      inclusive: !0,
      input: u,
      inst: r,
      continue: !t.abort
    });
  };
}), bv = /* @__PURE__ */ T("$ZodCheckMinLength", (r, t) => {
  var o;
  we.init(r, t), (o = r._zod.def).when ?? (o.when = (s) => {
    const u = s.value;
    return !yi(u) && u.length !== void 0;
  }), r._zod.onattach.push((s) => {
    const u = s._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
    t.minimum > u && (s._zod.bag.minimum = t.minimum);
  }), r._zod.check = (s) => {
    const u = s.value;
    if (u.length >= t.minimum)
      return;
    const p = xi(u);
    s.issues.push({
      origin: p,
      code: "too_small",
      minimum: t.minimum,
      inclusive: !0,
      input: u,
      inst: r,
      continue: !t.abort
    });
  };
}), Sv = /* @__PURE__ */ T("$ZodCheckLengthEquals", (r, t) => {
  var o;
  we.init(r, t), (o = r._zod.def).when ?? (o.when = (s) => {
    const u = s.value;
    return !yi(u) && u.length !== void 0;
  }), r._zod.onattach.push((s) => {
    const u = s._zod.bag;
    u.minimum = t.length, u.maximum = t.length, u.length = t.length;
  }), r._zod.check = (s) => {
    const u = s.value, f = u.length;
    if (f === t.length)
      return;
    const p = xi(u), _ = f > t.length;
    s.issues.push({
      origin: p,
      ..._ ? { code: "too_big", maximum: t.length } : { code: "too_small", minimum: t.length },
      inclusive: !0,
      exact: !0,
      input: s.value,
      inst: r,
      continue: !t.abort
    });
  };
}), Wt = /* @__PURE__ */ T("$ZodCheckStringFormat", (r, t) => {
  var o, s;
  we.init(r, t), r._zod.onattach.push((u) => {
    const f = u._zod.bag;
    f.format = t.format, t.pattern && (f.patterns ?? (f.patterns = /* @__PURE__ */ new Set()), f.patterns.add(t.pattern));
  }), t.pattern ? (o = r._zod).check ?? (o.check = (u) => {
    t.pattern.lastIndex = 0, !t.pattern.test(u.value) && u.issues.push({
      origin: "string",
      code: "invalid_format",
      format: t.format,
      input: u.value,
      ...t.pattern ? { pattern: t.pattern.toString() } : {},
      inst: r,
      continue: !t.abort
    });
  }) : (s = r._zod).check ?? (s.check = () => {
  });
}), Av = /* @__PURE__ */ T("$ZodCheckRegex", (r, t) => {
  Wt.init(r, t), r._zod.check = (o) => {
    t.pattern.lastIndex = 0, !t.pattern.test(o.value) && o.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "regex",
      input: o.value,
      pattern: t.pattern.toString(),
      inst: r,
      continue: !t.abort
    });
  };
}), Tv = /* @__PURE__ */ T("$ZodCheckLowerCase", (r, t) => {
  t.pattern ?? (t.pattern = mv), Wt.init(r, t);
}), Cv = /* @__PURE__ */ T("$ZodCheckUpperCase", (r, t) => {
  t.pattern ?? (t.pattern = _v), Wt.init(r, t);
}), yv = /* @__PURE__ */ T("$ZodCheckIncludes", (r, t) => {
  we.init(r, t);
  const o = dr(t.includes), s = new RegExp(typeof t.position == "number" ? `^.{${t.position}}${o}` : o);
  t.pattern = s, r._zod.onattach.push((u) => {
    const f = u._zod.bag;
    f.patterns ?? (f.patterns = /* @__PURE__ */ new Set()), f.patterns.add(s);
  }), r._zod.check = (u) => {
    u.value.includes(t.includes, t.position) || u.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "includes",
      includes: t.includes,
      input: u.value,
      inst: r,
      continue: !t.abort
    });
  };
}), Nv = /* @__PURE__ */ T("$ZodCheckStartsWith", (r, t) => {
  we.init(r, t);
  const o = new RegExp(`^${dr(t.prefix)}.*`);
  t.pattern ?? (t.pattern = o), r._zod.onattach.push((s) => {
    const u = s._zod.bag;
    u.patterns ?? (u.patterns = /* @__PURE__ */ new Set()), u.patterns.add(o);
  }), r._zod.check = (s) => {
    s.value.startsWith(t.prefix) || s.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "starts_with",
      prefix: t.prefix,
      input: s.value,
      inst: r,
      continue: !t.abort
    });
  };
}), xv = /* @__PURE__ */ T("$ZodCheckEndsWith", (r, t) => {
  we.init(r, t);
  const o = new RegExp(`.*${dr(t.suffix)}$`);
  t.pattern ?? (t.pattern = o), r._zod.onattach.push((s) => {
    const u = s._zod.bag;
    u.patterns ?? (u.patterns = /* @__PURE__ */ new Set()), u.patterns.add(o);
  }), r._zod.check = (s) => {
    s.value.endsWith(t.suffix) || s.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "ends_with",
      suffix: t.suffix,
      input: s.value,
      inst: r,
      continue: !t.abort
    });
  };
}), Ev = /* @__PURE__ */ T("$ZodCheckOverwrite", (r, t) => {
  we.init(r, t), r._zod.check = (o) => {
    o.value = t.tx(o.value);
  };
});
class wv {
  constructor(t = []) {
    this.content = [], this.indent = 0, this && (this.args = t);
  }
  indented(t) {
    this.indent += 1, t(this), this.indent -= 1;
  }
  write(t) {
    if (typeof t == "function") {
      t(this, { execution: "sync" }), t(this, { execution: "async" });
      return;
    }
    const s = t.split(`
`).filter((p) => p), u = Math.min(...s.map((p) => p.length - p.trimStart().length)), f = s.map((p) => p.slice(u)).map((p) => " ".repeat(this.indent * 2) + p);
    for (const p of f)
      this.content.push(p);
  }
  compile() {
    const t = Function, o = this?.args, u = [...(this?.content ?? [""]).map((f) => `  ${f}`)];
    return new t(...o, u.join(`
`));
  }
}
const Mv = {
  major: 4,
  minor: 3,
  patch: 6
}, ce = /* @__PURE__ */ T("$ZodType", (r, t) => {
  var o;
  r ?? (r = {}), r._zod.def = t, r._zod.bag = r._zod.bag || {}, r._zod.version = Mv;
  const s = [...r._zod.def.checks ?? []];
  r._zod.traits.has("$ZodCheck") && s.unshift(r);
  for (const u of s)
    for (const f of u._zod.onattach)
      f(r);
  if (s.length === 0)
    (o = r._zod).deferred ?? (o.deferred = []), r._zod.deferred?.push(() => {
      r._zod.run = r._zod.parse;
    });
  else {
    const u = (p, _, S) => {
      let N = ur(p), w;
      for (const F of _) {
        if (F._zod.def.when) {
          if (!F._zod.def.when(p))
            continue;
        } else if (N)
          continue;
        const k = p.issues.length, z = F._zod.check(p);
        if (z instanceof Promise && S?.async === !1)
          throw new lr();
        if (w || z instanceof Promise)
          w = (w ?? Promise.resolve()).then(async () => {
            await z, p.issues.length !== k && (N || (N = ur(p, k)));
          });
        else {
          if (p.issues.length === k)
            continue;
          N || (N = ur(p, k));
        }
      }
      return w ? w.then(() => p) : p;
    }, f = (p, _, S) => {
      if (ur(p))
        return p.aborted = !0, p;
      const N = u(_, s, S);
      if (N instanceof Promise) {
        if (S.async === !1)
          throw new lr();
        return N.then((w) => r._zod.parse(w, S));
      }
      return r._zod.parse(N, S);
    };
    r._zod.run = (p, _) => {
      if (_.skipChecks)
        return r._zod.parse(p, _);
      if (_.direction === "backward") {
        const N = r._zod.parse({ value: p.value, issues: [] }, { ..._, skipChecks: !0 });
        return N instanceof Promise ? N.then((w) => f(w, p, _)) : f(N, p, _);
      }
      const S = r._zod.parse(p, _);
      if (S instanceof Promise) {
        if (_.async === !1)
          throw new lr();
        return S.then((N) => u(N, s, _));
      }
      return u(S, s, _);
    };
  }
  J(r, "~standard", () => ({
    validate: (u) => {
      try {
        const f = zg(r, u);
        return f.success ? { value: f.data } : { issues: f.error?.issues };
      } catch {
        return Lg(r, u).then((p) => p.success ? { value: p.data } : { issues: p.error?.issues });
      }
    },
    vendor: "zod",
    version: 1
  }));
}), Mi = /* @__PURE__ */ T("$ZodString", (r, t) => {
  ce.init(r, t), r._zod.pattern = [...r?._zod.bag?.patterns ?? []].pop() ?? pv(r._zod.bag), r._zod.parse = (o, s) => {
    if (t.coerce)
      try {
        o.value = String(o.value);
      } catch {
      }
    return typeof o.value == "string" || o.issues.push({
      expected: "string",
      code: "invalid_type",
      input: o.value,
      inst: r
    }), o;
  };
}), re = /* @__PURE__ */ T("$ZodStringFormat", (r, t) => {
  Wt.init(r, t), Mi.init(r, t);
}), kv = /* @__PURE__ */ T("$ZodGUID", (r, t) => {
  t.pattern ?? (t.pattern = Qg), re.init(r, t);
}), Bv = /* @__PURE__ */ T("$ZodUUID", (r, t) => {
  if (t.version) {
    const s = {
      v1: 1,
      v2: 2,
      v3: 3,
      v4: 4,
      v5: 5,
      v6: 6,
      v7: 7,
      v8: 8
    }[t.version];
    if (s === void 0)
      throw new Error(`Invalid UUID version: "${t.version}"`);
    t.pattern ?? (t.pattern = mu(s));
  } else
    t.pattern ?? (t.pattern = mu());
  re.init(r, t);
}), Pv = /* @__PURE__ */ T("$ZodEmail", (r, t) => {
  t.pattern ?? (t.pattern = ev), re.init(r, t);
}), Rv = /* @__PURE__ */ T("$ZodURL", (r, t) => {
  re.init(r, t), r._zod.check = (o) => {
    try {
      const s = o.value.trim(), u = new URL(s);
      t.hostname && (t.hostname.lastIndex = 0, t.hostname.test(u.hostname) || o.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid hostname",
        pattern: t.hostname.source,
        input: o.value,
        inst: r,
        continue: !t.abort
      })), t.protocol && (t.protocol.lastIndex = 0, t.protocol.test(u.protocol.endsWith(":") ? u.protocol.slice(0, -1) : u.protocol) || o.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid protocol",
        pattern: t.protocol.source,
        input: o.value,
        inst: r,
        continue: !t.abort
      })), t.normalize ? o.value = u.href : o.value = s;
      return;
    } catch {
      o.issues.push({
        code: "invalid_format",
        format: "url",
        input: o.value,
        inst: r,
        continue: !t.abort
      });
    }
  };
}), Ov = /* @__PURE__ */ T("$ZodEmoji", (r, t) => {
  t.pattern ?? (t.pattern = rv()), re.init(r, t);
}), zv = /* @__PURE__ */ T("$ZodNanoID", (r, t) => {
  t.pattern ?? (t.pattern = Yg), re.init(r, t);
}), Lv = /* @__PURE__ */ T("$ZodCUID", (r, t) => {
  t.pattern ?? (t.pattern = Wg), re.init(r, t);
}), Fv = /* @__PURE__ */ T("$ZodCUID2", (r, t) => {
  t.pattern ?? (t.pattern = qg), re.init(r, t);
}), Gv = /* @__PURE__ */ T("$ZodULID", (r, t) => {
  t.pattern ?? (t.pattern = Vg), re.init(r, t);
}), Dv = /* @__PURE__ */ T("$ZodXID", (r, t) => {
  t.pattern ?? (t.pattern = Jg), re.init(r, t);
}), Zv = /* @__PURE__ */ T("$ZodKSUID", (r, t) => {
  t.pattern ?? (t.pattern = jg), re.init(r, t);
}), Uv = /* @__PURE__ */ T("$ZodISODateTime", (r, t) => {
  t.pattern ?? (t.pattern = dv(t)), re.init(r, t);
}), $v = /* @__PURE__ */ T("$ZodISODate", (r, t) => {
  t.pattern ?? (t.pattern = cv), re.init(r, t);
}), Kv = /* @__PURE__ */ T("$ZodISOTime", (r, t) => {
  t.pattern ?? (t.pattern = lv(t)), re.init(r, t);
}), Hv = /* @__PURE__ */ T("$ZodISODuration", (r, t) => {
  t.pattern ?? (t.pattern = Xg), re.init(r, t);
}), Wv = /* @__PURE__ */ T("$ZodIPv4", (r, t) => {
  t.pattern ?? (t.pattern = tv), re.init(r, t), r._zod.bag.format = "ipv4";
}), qv = /* @__PURE__ */ T("$ZodIPv6", (r, t) => {
  t.pattern ?? (t.pattern = ov), re.init(r, t), r._zod.bag.format = "ipv6", r._zod.check = (o) => {
    try {
      new URL(`http://[${o.value}]`);
    } catch {
      o.issues.push({
        code: "invalid_format",
        format: "ipv6",
        input: o.value,
        inst: r,
        continue: !t.abort
      });
    }
  };
}), Vv = /* @__PURE__ */ T("$ZodCIDRv4", (r, t) => {
  t.pattern ?? (t.pattern = iv), re.init(r, t);
}), Jv = /* @__PURE__ */ T("$ZodCIDRv6", (r, t) => {
  t.pattern ?? (t.pattern = av), re.init(r, t), r._zod.check = (o) => {
    const s = o.value.split("/");
    try {
      if (s.length !== 2)
        throw new Error();
      const [u, f] = s;
      if (!f)
        throw new Error();
      const p = Number(f);
      if (`${p}` !== f)
        throw new Error();
      if (p < 0 || p > 128)
        throw new Error();
      new URL(`http://[${u}]`);
    } catch {
      o.issues.push({
        code: "invalid_format",
        format: "cidrv6",
        input: o.value,
        inst: r,
        continue: !t.abort
      });
    }
  };
});
function Qu(r) {
  if (r === "")
    return !0;
  if (r.length % 4 !== 0)
    return !1;
  try {
    return atob(r), !0;
  } catch {
    return !1;
  }
}
const jv = /* @__PURE__ */ T("$ZodBase64", (r, t) => {
  t.pattern ?? (t.pattern = sv), re.init(r, t), r._zod.bag.contentEncoding = "base64", r._zod.check = (o) => {
    Qu(o.value) || o.issues.push({
      code: "invalid_format",
      format: "base64",
      input: o.value,
      inst: r,
      continue: !t.abort
    });
  };
});
function Yv(r) {
  if (!qu.test(r))
    return !1;
  const t = r.replace(/[-_]/g, (s) => s === "-" ? "+" : "/"), o = t.padEnd(Math.ceil(t.length / 4) * 4, "=");
  return Qu(o);
}
const Xv = /* @__PURE__ */ T("$ZodBase64URL", (r, t) => {
  t.pattern ?? (t.pattern = qu), re.init(r, t), r._zod.bag.contentEncoding = "base64url", r._zod.check = (o) => {
    Yv(o.value) || o.issues.push({
      code: "invalid_format",
      format: "base64url",
      input: o.value,
      inst: r,
      continue: !t.abort
    });
  };
}), Qv = /* @__PURE__ */ T("$ZodE164", (r, t) => {
  t.pattern ?? (t.pattern = uv), re.init(r, t);
});
function eI(r, t = null) {
  try {
    const o = r.split(".");
    if (o.length !== 3)
      return !1;
    const [s] = o;
    if (!s)
      return !1;
    const u = JSON.parse(atob(s));
    return !("typ" in u && u?.typ !== "JWT" || !u.alg || t && (!("alg" in u) || u.alg !== t));
  } catch {
    return !1;
  }
}
const nI = /* @__PURE__ */ T("$ZodJWT", (r, t) => {
  re.init(r, t), r._zod.check = (o) => {
    eI(o.value, t.alg) || o.issues.push({
      code: "invalid_format",
      format: "jwt",
      input: o.value,
      inst: r,
      continue: !t.abort
    });
  };
}), ec = /* @__PURE__ */ T("$ZodNumber", (r, t) => {
  ce.init(r, t), r._zod.pattern = r._zod.bag.pattern ?? hv, r._zod.parse = (o, s) => {
    if (t.coerce)
      try {
        o.value = Number(o.value);
      } catch {
      }
    const u = o.value;
    if (typeof u == "number" && !Number.isNaN(u) && Number.isFinite(u))
      return o;
    const f = typeof u == "number" ? Number.isNaN(u) ? "NaN" : Number.isFinite(u) ? void 0 : "Infinity" : void 0;
    return o.issues.push({
      expected: "number",
      code: "invalid_type",
      input: u,
      inst: r,
      ...f ? { received: f } : {}
    }), o;
  };
}), rI = /* @__PURE__ */ T("$ZodNumberFormat", (r, t) => {
  vv.init(r, t), ec.init(r, t);
}), tI = /* @__PURE__ */ T("$ZodUnknown", (r, t) => {
  ce.init(r, t), r._zod.parse = (o) => o;
}), oI = /* @__PURE__ */ T("$ZodNever", (r, t) => {
  ce.init(r, t), r._zod.parse = (o, s) => (o.issues.push({
    expected: "never",
    code: "invalid_type",
    input: o.value,
    inst: r
  }), o);
});
function _u(r, t, o) {
  r.issues.length && t.issues.push(...$u(o, r.issues)), t.value[o] = r.value;
}
const iI = /* @__PURE__ */ T("$ZodArray", (r, t) => {
  ce.init(r, t), r._zod.parse = (o, s) => {
    const u = o.value;
    if (!Array.isArray(u))
      return o.issues.push({
        expected: "array",
        code: "invalid_type",
        input: u,
        inst: r
      }), o;
    o.value = Array(u.length);
    const f = [];
    for (let p = 0; p < u.length; p++) {
      const _ = u[p], S = t.element._zod.run({
        value: _,
        issues: []
      }, s);
      S instanceof Promise ? f.push(S.then((N) => _u(N, o, p))) : _u(S, o, p);
    }
    return f.length ? Promise.all(f).then(() => o) : o;
  };
});
function Dt(r, t, o, s, u) {
  if (r.issues.length) {
    if (u && !(o in s))
      return;
    t.issues.push(...$u(o, r.issues));
  }
  r.value === void 0 ? o in s && (t.value[o] = void 0) : t.value[o] = r.value;
}
function nc(r) {
  const t = Object.keys(r.shape);
  for (const s of t)
    if (!r.shape?.[s]?._zod?.traits?.has("$ZodType"))
      throw new Error(`Invalid element at key "${s}": expected a Zod schema`);
  const o = yg(r.shape);
  return {
    ...r,
    keys: t,
    keySet: new Set(t),
    numKeys: t.length,
    optionalKeys: new Set(o)
  };
}
function rc(r, t, o, s, u, f) {
  const p = [], _ = u.keySet, S = u.catchall._zod, N = S.def.type, w = S.optout === "optional";
  for (const F in t) {
    if (_.has(F))
      continue;
    if (N === "never") {
      p.push(F);
      continue;
    }
    const k = S.run({ value: t[F], issues: [] }, s);
    k instanceof Promise ? r.push(k.then((z) => Dt(z, o, F, t, w))) : Dt(k, o, F, t, w);
  }
  return p.length && o.issues.push({
    code: "unrecognized_keys",
    keys: p,
    input: t,
    inst: f
  }), r.length ? Promise.all(r).then(() => o) : o;
}
const aI = /* @__PURE__ */ T("$ZodObject", (r, t) => {
  if (ce.init(r, t), !Object.getOwnPropertyDescriptor(t, "shape")?.get) {
    const _ = t.shape;
    Object.defineProperty(t, "shape", {
      get: () => {
        const S = { ..._ };
        return Object.defineProperty(t, "shape", {
          value: S
        }), S;
      }
    });
  }
  const s = Ci(() => nc(t));
  J(r._zod, "propValues", () => {
    const _ = t.shape, S = {};
    for (const N in _) {
      const w = _[N]._zod;
      if (w.values) {
        S[N] ?? (S[N] = /* @__PURE__ */ new Set());
        for (const F of w.values)
          S[N].add(F);
      }
    }
    return S;
  });
  const u = Gt, f = t.catchall;
  let p;
  r._zod.parse = (_, S) => {
    p ?? (p = s.value);
    const N = _.value;
    if (!u(N))
      return _.issues.push({
        expected: "object",
        code: "invalid_type",
        input: N,
        inst: r
      }), _;
    _.value = {};
    const w = [], F = p.shape;
    for (const k of p.keys) {
      const z = F[k], ie = z._zod.optout === "optional", Q = z._zod.run({ value: N[k], issues: [] }, S);
      Q instanceof Promise ? w.push(Q.then((un) => Dt(un, _, k, N, ie))) : Dt(Q, _, k, N, ie);
    }
    return f ? rc(w, N, _, S, s.value, r) : w.length ? Promise.all(w).then(() => _) : _;
  };
}), sI = /* @__PURE__ */ T("$ZodObjectJIT", (r, t) => {
  aI.init(r, t);
  const o = r._zod.parse, s = Ci(() => nc(t)), u = (k) => {
    const z = new wv(["shape", "payload", "ctx"]), ie = s.value, Q = (ke) => {
      const ee = hu(ke);
      return `shape[${ee}]._zod.run({ value: input[${ee}], issues: [] }, ctx)`;
    };
    z.write("const input = payload.value;");
    const un = /* @__PURE__ */ Object.create(null);
    let Me = 0;
    for (const ke of ie.keys)
      un[ke] = `key_${Me++}`;
    z.write("const newResult = {};");
    for (const ke of ie.keys) {
      const ee = un[ke], he = hu(ke), Bn = k[ke]?._zod?.optout === "optional";
      z.write(`const ${ee} = ${Q(ke)};`), Bn ? z.write(`
        if (${ee}.issues.length) {
          if (${he} in input) {
            payload.issues = payload.issues.concat(${ee}.issues.map(iss => ({
              ...iss,
              path: iss.path ? [${he}, ...iss.path] : [${he}]
            })));
          }
        }
        
        if (${ee}.value === undefined) {
          if (${he} in input) {
            newResult[${he}] = undefined;
          }
        } else {
          newResult[${he}] = ${ee}.value;
        }
        
      `) : z.write(`
        if (${ee}.issues.length) {
          payload.issues = payload.issues.concat(${ee}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${he}, ...iss.path] : [${he}]
          })));
        }
        
        if (${ee}.value === undefined) {
          if (${he} in input) {
            newResult[${he}] = undefined;
          }
        } else {
          newResult[${he}] = ${ee}.value;
        }
        
      `);
    }
    z.write("payload.value = newResult;"), z.write("return payload;");
    const In = z.compile();
    return (ke, ee) => In(k, ke, ee);
  };
  let f;
  const p = Gt, _ = !Gu.jitless, N = _ && Tg.value, w = t.catchall;
  let F;
  r._zod.parse = (k, z) => {
    F ?? (F = s.value);
    const ie = k.value;
    return p(ie) ? _ && N && z?.async === !1 && z.jitless !== !0 ? (f || (f = u(t.shape)), k = f(k, z), w ? rc([], ie, k, z, F, r) : k) : o(k, z) : (k.issues.push({
      expected: "object",
      code: "invalid_type",
      input: ie,
      inst: r
    }), k);
  };
});
function gu(r, t, o, s) {
  for (const f of r)
    if (f.issues.length === 0)
      return t.value = f.value, t;
  const u = r.filter((f) => !ur(f));
  return u.length === 1 ? (t.value = u[0].value, u[0]) : (t.issues.push({
    code: "invalid_union",
    input: t.value,
    inst: o,
    errors: r.map((f) => f.issues.map((p) => Kn(p, s, $n())))
  }), t);
}
const uI = /* @__PURE__ */ T("$ZodUnion", (r, t) => {
  ce.init(r, t), J(r._zod, "optin", () => t.options.some((u) => u._zod.optin === "optional") ? "optional" : void 0), J(r._zod, "optout", () => t.options.some((u) => u._zod.optout === "optional") ? "optional" : void 0), J(r._zod, "values", () => {
    if (t.options.every((u) => u._zod.values))
      return new Set(t.options.flatMap((u) => Array.from(u._zod.values)));
  }), J(r._zod, "pattern", () => {
    if (t.options.every((u) => u._zod.pattern)) {
      const u = t.options.map((f) => f._zod.pattern);
      return new RegExp(`^(${u.map((f) => Ni(f.source)).join("|")})$`);
    }
  });
  const o = t.options.length === 1, s = t.options[0]._zod.run;
  r._zod.parse = (u, f) => {
    if (o)
      return s(u, f);
    let p = !1;
    const _ = [];
    for (const S of t.options) {
      const N = S._zod.run({
        value: u.value,
        issues: []
      }, f);
      if (N instanceof Promise)
        _.push(N), p = !0;
      else {
        if (N.issues.length === 0)
          return N;
        _.push(N);
      }
    }
    return p ? Promise.all(_).then((S) => gu(S, u, r, f)) : gu(_, u, r, f);
  };
}), cI = /* @__PURE__ */ T("$ZodIntersection", (r, t) => {
  ce.init(r, t), r._zod.parse = (o, s) => {
    const u = o.value, f = t.left._zod.run({ value: u, issues: [] }, s), p = t.right._zod.run({ value: u, issues: [] }, s);
    return f instanceof Promise || p instanceof Promise ? Promise.all([f, p]).then(([S, N]) => vu(o, S, N)) : vu(o, f, p);
  };
});
function bi(r, t) {
  if (r === t)
    return { valid: !0, data: r };
  if (r instanceof Date && t instanceof Date && +r == +t)
    return { valid: !0, data: r };
  if (Zr(r) && Zr(t)) {
    const o = Object.keys(t), s = Object.keys(r).filter((f) => o.indexOf(f) !== -1), u = { ...r, ...t };
    for (const f of s) {
      const p = bi(r[f], t[f]);
      if (!p.valid)
        return {
          valid: !1,
          mergeErrorPath: [f, ...p.mergeErrorPath]
        };
      u[f] = p.data;
    }
    return { valid: !0, data: u };
  }
  if (Array.isArray(r) && Array.isArray(t)) {
    if (r.length !== t.length)
      return { valid: !1, mergeErrorPath: [] };
    const o = [];
    for (let s = 0; s < r.length; s++) {
      const u = r[s], f = t[s], p = bi(u, f);
      if (!p.valid)
        return {
          valid: !1,
          mergeErrorPath: [s, ...p.mergeErrorPath]
        };
      o.push(p.data);
    }
    return { valid: !0, data: o };
  }
  return { valid: !1, mergeErrorPath: [] };
}
function vu(r, t, o) {
  const s = /* @__PURE__ */ new Map();
  let u;
  for (const _ of t.issues)
    if (_.code === "unrecognized_keys") {
      u ?? (u = _);
      for (const S of _.keys)
        s.has(S) || s.set(S, {}), s.get(S).l = !0;
    } else
      r.issues.push(_);
  for (const _ of o.issues)
    if (_.code === "unrecognized_keys")
      for (const S of _.keys)
        s.has(S) || s.set(S, {}), s.get(S).r = !0;
    else
      r.issues.push(_);
  const f = [...s].filter(([, _]) => _.l && _.r).map(([_]) => _);
  if (f.length && u && r.issues.push({ ...u, keys: f }), ur(r))
    return r;
  const p = bi(t.value, o.value);
  if (!p.valid)
    throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(p.mergeErrorPath)}`);
  return r.value = p.data, r;
}
const lI = /* @__PURE__ */ T("$ZodEnum", (r, t) => {
  ce.init(r, t);
  const o = Du(t.entries), s = new Set(o);
  r._zod.values = s, r._zod.pattern = new RegExp(`^(${o.filter((u) => Cg.has(typeof u)).map((u) => typeof u == "string" ? dr(u) : u.toString()).join("|")})$`), r._zod.parse = (u, f) => {
    const p = u.value;
    return s.has(p) || u.issues.push({
      code: "invalid_value",
      values: o,
      input: p,
      inst: r
    }), u;
  };
}), dI = /* @__PURE__ */ T("$ZodLiteral", (r, t) => {
  if (ce.init(r, t), t.values.length === 0)
    throw new Error("Cannot create literal schema with no valid values");
  const o = new Set(t.values);
  r._zod.values = o, r._zod.pattern = new RegExp(`^(${t.values.map((s) => typeof s == "string" ? dr(s) : s ? dr(s.toString()) : String(s)).join("|")})$`), r._zod.parse = (s, u) => {
    const f = s.value;
    return o.has(f) || s.issues.push({
      code: "invalid_value",
      values: t.values,
      input: f,
      inst: r
    }), s;
  };
}), pI = /* @__PURE__ */ T("$ZodTransform", (r, t) => {
  ce.init(r, t), r._zod.parse = (o, s) => {
    if (s.direction === "backward")
      throw new Fu(r.constructor.name);
    const u = t.transform(o.value, o);
    if (s.async)
      return (u instanceof Promise ? u : Promise.resolve(u)).then((p) => (o.value = p, o));
    if (u instanceof Promise)
      throw new lr();
    return o.value = u, o;
  };
});
function Iu(r, t) {
  return r.issues.length && t === void 0 ? { issues: [], value: void 0 } : r;
}
const tc = /* @__PURE__ */ T("$ZodOptional", (r, t) => {
  ce.init(r, t), r._zod.optin = "optional", r._zod.optout = "optional", J(r._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, void 0]) : void 0), J(r._zod, "pattern", () => {
    const o = t.innerType._zod.pattern;
    return o ? new RegExp(`^(${Ni(o.source)})?$`) : void 0;
  }), r._zod.parse = (o, s) => {
    if (t.innerType._zod.optin === "optional") {
      const u = t.innerType._zod.run(o, s);
      return u instanceof Promise ? u.then((f) => Iu(f, o.value)) : Iu(u, o.value);
    }
    return o.value === void 0 ? o : t.innerType._zod.run(o, s);
  };
}), fI = /* @__PURE__ */ T("$ZodExactOptional", (r, t) => {
  tc.init(r, t), J(r._zod, "values", () => t.innerType._zod.values), J(r._zod, "pattern", () => t.innerType._zod.pattern), r._zod.parse = (o, s) => t.innerType._zod.run(o, s);
}), hI = /* @__PURE__ */ T("$ZodNullable", (r, t) => {
  ce.init(r, t), J(r._zod, "optin", () => t.innerType._zod.optin), J(r._zod, "optout", () => t.innerType._zod.optout), J(r._zod, "pattern", () => {
    const o = t.innerType._zod.pattern;
    return o ? new RegExp(`^(${Ni(o.source)}|null)$`) : void 0;
  }), J(r._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, null]) : void 0), r._zod.parse = (o, s) => o.value === null ? o : t.innerType._zod.run(o, s);
}), mI = /* @__PURE__ */ T("$ZodDefault", (r, t) => {
  ce.init(r, t), r._zod.optin = "optional", J(r._zod, "values", () => t.innerType._zod.values), r._zod.parse = (o, s) => {
    if (s.direction === "backward")
      return t.innerType._zod.run(o, s);
    if (o.value === void 0)
      return o.value = t.defaultValue, o;
    const u = t.innerType._zod.run(o, s);
    return u instanceof Promise ? u.then((f) => bu(f, t)) : bu(u, t);
  };
});
function bu(r, t) {
  return r.value === void 0 && (r.value = t.defaultValue), r;
}
const _I = /* @__PURE__ */ T("$ZodPrefault", (r, t) => {
  ce.init(r, t), r._zod.optin = "optional", J(r._zod, "values", () => t.innerType._zod.values), r._zod.parse = (o, s) => (s.direction === "backward" || o.value === void 0 && (o.value = t.defaultValue), t.innerType._zod.run(o, s));
}), gI = /* @__PURE__ */ T("$ZodNonOptional", (r, t) => {
  ce.init(r, t), J(r._zod, "values", () => {
    const o = t.innerType._zod.values;
    return o ? new Set([...o].filter((s) => s !== void 0)) : void 0;
  }), r._zod.parse = (o, s) => {
    const u = t.innerType._zod.run(o, s);
    return u instanceof Promise ? u.then((f) => Su(f, r)) : Su(u, r);
  };
});
function Su(r, t) {
  return !r.issues.length && r.value === void 0 && r.issues.push({
    code: "invalid_type",
    expected: "nonoptional",
    input: r.value,
    inst: t
  }), r;
}
const vI = /* @__PURE__ */ T("$ZodCatch", (r, t) => {
  ce.init(r, t), J(r._zod, "optin", () => t.innerType._zod.optin), J(r._zod, "optout", () => t.innerType._zod.optout), J(r._zod, "values", () => t.innerType._zod.values), r._zod.parse = (o, s) => {
    if (s.direction === "backward")
      return t.innerType._zod.run(o, s);
    const u = t.innerType._zod.run(o, s);
    return u instanceof Promise ? u.then((f) => (o.value = f.value, f.issues.length && (o.value = t.catchValue({
      ...o,
      error: {
        issues: f.issues.map((p) => Kn(p, s, $n()))
      },
      input: o.value
    }), o.issues = []), o)) : (o.value = u.value, u.issues.length && (o.value = t.catchValue({
      ...o,
      error: {
        issues: u.issues.map((f) => Kn(f, s, $n()))
      },
      input: o.value
    }), o.issues = []), o);
  };
}), II = /* @__PURE__ */ T("$ZodPipe", (r, t) => {
  ce.init(r, t), J(r._zod, "values", () => t.in._zod.values), J(r._zod, "optin", () => t.in._zod.optin), J(r._zod, "optout", () => t.out._zod.optout), J(r._zod, "propValues", () => t.in._zod.propValues), r._zod.parse = (o, s) => {
    if (s.direction === "backward") {
      const f = t.out._zod.run(o, s);
      return f instanceof Promise ? f.then((p) => Lt(p, t.in, s)) : Lt(f, t.in, s);
    }
    const u = t.in._zod.run(o, s);
    return u instanceof Promise ? u.then((f) => Lt(f, t.out, s)) : Lt(u, t.out, s);
  };
});
function Lt(r, t, o) {
  return r.issues.length ? (r.aborted = !0, r) : t._zod.run({ value: r.value, issues: r.issues }, o);
}
const bI = /* @__PURE__ */ T("$ZodReadonly", (r, t) => {
  ce.init(r, t), J(r._zod, "propValues", () => t.innerType._zod.propValues), J(r._zod, "values", () => t.innerType._zod.values), J(r._zod, "optin", () => t.innerType?._zod?.optin), J(r._zod, "optout", () => t.innerType?._zod?.optout), r._zod.parse = (o, s) => {
    if (s.direction === "backward")
      return t.innerType._zod.run(o, s);
    const u = t.innerType._zod.run(o, s);
    return u instanceof Promise ? u.then(Au) : Au(u);
  };
});
function Au(r) {
  return r.value = Object.freeze(r.value), r;
}
const SI = /* @__PURE__ */ T("$ZodCustom", (r, t) => {
  we.init(r, t), ce.init(r, t), r._zod.parse = (o, s) => o, r._zod.check = (o) => {
    const s = o.value, u = t.fn(s);
    if (u instanceof Promise)
      return u.then((f) => Tu(f, o, s, r));
    Tu(u, o, s, r);
  };
});
function Tu(r, t, o, s) {
  if (!r) {
    const u = {
      code: "custom",
      input: o,
      inst: s,
      // incorporates params.error into issue reporting
      path: [...s._zod.def.path ?? []],
      // incorporates params.error into issue reporting
      continue: !s._zod.def.abort
      // params: inst._zod.def.params,
    };
    s._zod.def.params && (u.params = s._zod.def.params), t.issues.push(Ur(u));
  }
}
var Cu;
class AI {
  constructor() {
    this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
  }
  add(t, ...o) {
    const s = o[0];
    return this._map.set(t, s), s && typeof s == "object" && "id" in s && this._idmap.set(s.id, t), this;
  }
  clear() {
    return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
  }
  remove(t) {
    const o = this._map.get(t);
    return o && typeof o == "object" && "id" in o && this._idmap.delete(o.id), this._map.delete(t), this;
  }
  get(t) {
    const o = t._zod.parent;
    if (o) {
      const s = { ...this.get(o) ?? {} };
      delete s.id;
      const u = { ...s, ...this._map.get(t) };
      return Object.keys(u).length ? u : void 0;
    }
    return this._map.get(t);
  }
  has(t) {
    return this._map.has(t);
  }
}
function TI() {
  return new AI();
}
(Cu = globalThis).__zod_globalRegistry ?? (Cu.__zod_globalRegistry = TI());
const Lr = globalThis.__zod_globalRegistry;
// @__NO_SIDE_EFFECTS__
function CI(r, t) {
  return new r({
    type: "string",
    ...B(t)
  });
}
// @__NO_SIDE_EFFECTS__
function yI(r, t) {
  return new r({
    type: "string",
    format: "email",
    check: "string_format",
    abort: !1,
    ...B(t)
  });
}
// @__NO_SIDE_EFFECTS__
function yu(r, t) {
  return new r({
    type: "string",
    format: "guid",
    check: "string_format",
    abort: !1,
    ...B(t)
  });
}
// @__NO_SIDE_EFFECTS__
function oc(r, t) {
  return new r({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    ...B(t)
  });
}
// @__NO_SIDE_EFFECTS__
function NI(r, t) {
  return new r({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v4",
    ...B(t)
  });
}
// @__NO_SIDE_EFFECTS__
function xI(r, t) {
  return new r({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v6",
    ...B(t)
  });
}
// @__NO_SIDE_EFFECTS__
function EI(r, t) {
  return new r({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v7",
    ...B(t)
  });
}
// @__NO_SIDE_EFFECTS__
function wI(r, t) {
  return new r({
    type: "string",
    format: "url",
    check: "string_format",
    abort: !1,
    ...B(t)
  });
}
// @__NO_SIDE_EFFECTS__
function MI(r, t) {
  return new r({
    type: "string",
    format: "emoji",
    check: "string_format",
    abort: !1,
    ...B(t)
  });
}
// @__NO_SIDE_EFFECTS__
function kI(r, t) {
  return new r({
    type: "string",
    format: "nanoid",
    check: "string_format",
    abort: !1,
    ...B(t)
  });
}
// @__NO_SIDE_EFFECTS__
function BI(r, t) {
  return new r({
    type: "string",
    format: "cuid",
    check: "string_format",
    abort: !1,
    ...B(t)
  });
}
// @__NO_SIDE_EFFECTS__
function PI(r, t) {
  return new r({
    type: "string",
    format: "cuid2",
    check: "string_format",
    abort: !1,
    ...B(t)
  });
}
// @__NO_SIDE_EFFECTS__
function RI(r, t) {
  return new r({
    type: "string",
    format: "ulid",
    check: "string_format",
    abort: !1,
    ...B(t)
  });
}
// @__NO_SIDE_EFFECTS__
function OI(r, t) {
  return new r({
    type: "string",
    format: "xid",
    check: "string_format",
    abort: !1,
    ...B(t)
  });
}
// @__NO_SIDE_EFFECTS__
function zI(r, t) {
  return new r({
    type: "string",
    format: "ksuid",
    check: "string_format",
    abort: !1,
    ...B(t)
  });
}
// @__NO_SIDE_EFFECTS__
function LI(r, t) {
  return new r({
    type: "string",
    format: "ipv4",
    check: "string_format",
    abort: !1,
    ...B(t)
  });
}
// @__NO_SIDE_EFFECTS__
function FI(r, t) {
  return new r({
    type: "string",
    format: "ipv6",
    check: "string_format",
    abort: !1,
    ...B(t)
  });
}
// @__NO_SIDE_EFFECTS__
function GI(r, t) {
  return new r({
    type: "string",
    format: "cidrv4",
    check: "string_format",
    abort: !1,
    ...B(t)
  });
}
// @__NO_SIDE_EFFECTS__
function DI(r, t) {
  return new r({
    type: "string",
    format: "cidrv6",
    check: "string_format",
    abort: !1,
    ...B(t)
  });
}
// @__NO_SIDE_EFFECTS__
function ZI(r, t) {
  return new r({
    type: "string",
    format: "base64",
    check: "string_format",
    abort: !1,
    ...B(t)
  });
}
// @__NO_SIDE_EFFECTS__
function UI(r, t) {
  return new r({
    type: "string",
    format: "base64url",
    check: "string_format",
    abort: !1,
    ...B(t)
  });
}
// @__NO_SIDE_EFFECTS__
function $I(r, t) {
  return new r({
    type: "string",
    format: "e164",
    check: "string_format",
    abort: !1,
    ...B(t)
  });
}
// @__NO_SIDE_EFFECTS__
function KI(r, t) {
  return new r({
    type: "string",
    format: "jwt",
    check: "string_format",
    abort: !1,
    ...B(t)
  });
}
// @__NO_SIDE_EFFECTS__
function HI(r, t) {
  return new r({
    type: "string",
    format: "datetime",
    check: "string_format",
    offset: !1,
    local: !1,
    precision: null,
    ...B(t)
  });
}
// @__NO_SIDE_EFFECTS__
function WI(r, t) {
  return new r({
    type: "string",
    format: "date",
    check: "string_format",
    ...B(t)
  });
}
// @__NO_SIDE_EFFECTS__
function qI(r, t) {
  return new r({
    type: "string",
    format: "time",
    check: "string_format",
    precision: null,
    ...B(t)
  });
}
// @__NO_SIDE_EFFECTS__
function VI(r, t) {
  return new r({
    type: "string",
    format: "duration",
    check: "string_format",
    ...B(t)
  });
}
// @__NO_SIDE_EFFECTS__
function JI(r, t) {
  return new r({
    type: "number",
    checks: [],
    ...B(t)
  });
}
// @__NO_SIDE_EFFECTS__
function jI(r, t) {
  return new r({
    type: "number",
    check: "number_format",
    abort: !1,
    format: "safeint",
    ...B(t)
  });
}
// @__NO_SIDE_EFFECTS__
function YI(r) {
  return new r({
    type: "unknown"
  });
}
// @__NO_SIDE_EFFECTS__
function XI(r, t) {
  return new r({
    type: "never",
    ...B(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Nu(r, t) {
  return new Yu({
    check: "less_than",
    ...B(t),
    value: r,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function gi(r, t) {
  return new Yu({
    check: "less_than",
    ...B(t),
    value: r,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function xu(r, t) {
  return new Xu({
    check: "greater_than",
    ...B(t),
    value: r,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function vi(r, t) {
  return new Xu({
    check: "greater_than",
    ...B(t),
    value: r,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function Eu(r, t) {
  return new gv({
    check: "multiple_of",
    ...B(t),
    value: r
  });
}
// @__NO_SIDE_EFFECTS__
function ic(r, t) {
  return new Iv({
    check: "max_length",
    ...B(t),
    maximum: r
  });
}
// @__NO_SIDE_EFFECTS__
function Zt(r, t) {
  return new bv({
    check: "min_length",
    ...B(t),
    minimum: r
  });
}
// @__NO_SIDE_EFFECTS__
function ac(r, t) {
  return new Sv({
    check: "length_equals",
    ...B(t),
    length: r
  });
}
// @__NO_SIDE_EFFECTS__
function QI(r, t) {
  return new Av({
    check: "string_format",
    format: "regex",
    ...B(t),
    pattern: r
  });
}
// @__NO_SIDE_EFFECTS__
function eb(r) {
  return new Tv({
    check: "string_format",
    format: "lowercase",
    ...B(r)
  });
}
// @__NO_SIDE_EFFECTS__
function nb(r) {
  return new Cv({
    check: "string_format",
    format: "uppercase",
    ...B(r)
  });
}
// @__NO_SIDE_EFFECTS__
function rb(r, t) {
  return new yv({
    check: "string_format",
    format: "includes",
    ...B(t),
    includes: r
  });
}
// @__NO_SIDE_EFFECTS__
function tb(r, t) {
  return new Nv({
    check: "string_format",
    format: "starts_with",
    ...B(t),
    prefix: r
  });
}
// @__NO_SIDE_EFFECTS__
function ob(r, t) {
  return new xv({
    check: "string_format",
    format: "ends_with",
    ...B(t),
    suffix: r
  });
}
// @__NO_SIDE_EFFECTS__
function fr(r) {
  return new Ev({
    check: "overwrite",
    tx: r
  });
}
// @__NO_SIDE_EFFECTS__
function ib(r) {
  return /* @__PURE__ */ fr((t) => t.normalize(r));
}
// @__NO_SIDE_EFFECTS__
function ab() {
  return /* @__PURE__ */ fr((r) => r.trim());
}
// @__NO_SIDE_EFFECTS__
function sb() {
  return /* @__PURE__ */ fr((r) => r.toLowerCase());
}
// @__NO_SIDE_EFFECTS__
function ub() {
  return /* @__PURE__ */ fr((r) => r.toUpperCase());
}
// @__NO_SIDE_EFFECTS__
function cb() {
  return /* @__PURE__ */ fr((r) => Ag(r));
}
// @__NO_SIDE_EFFECTS__
function lb(r, t, o) {
  return new r({
    type: "array",
    element: t,
    // get element() {
    //   return element;
    // },
    ...B(o)
  });
}
// @__NO_SIDE_EFFECTS__
function db(r, t, o) {
  return new r({
    type: "custom",
    check: "custom",
    fn: t,
    ...B(o)
  });
}
// @__NO_SIDE_EFFECTS__
function pb(r) {
  const t = /* @__PURE__ */ fb((o) => (o.addIssue = (s) => {
    if (typeof s == "string")
      o.issues.push(Ur(s, o.value, t._zod.def));
    else {
      const u = s;
      u.fatal && (u.continue = !1), u.code ?? (u.code = "custom"), u.input ?? (u.input = o.value), u.inst ?? (u.inst = t), u.continue ?? (u.continue = !t._zod.def.abort), o.issues.push(Ur(u));
    }
  }, r(o.value, o)));
  return t;
}
// @__NO_SIDE_EFFECTS__
function fb(r, t) {
  const o = new we({
    check: "custom",
    ...B(t)
  });
  return o._zod.check = r, o;
}
function sc(r) {
  let t = r?.target ?? "draft-2020-12";
  return t === "draft-4" && (t = "draft-04"), t === "draft-7" && (t = "draft-07"), {
    processors: r.processors ?? {},
    metadataRegistry: r?.metadata ?? Lr,
    target: t,
    unrepresentable: r?.unrepresentable ?? "throw",
    override: r?.override ?? (() => {
    }),
    io: r?.io ?? "output",
    counter: 0,
    seen: /* @__PURE__ */ new Map(),
    cycles: r?.cycles ?? "ref",
    reused: r?.reused ?? "inline",
    external: r?.external ?? void 0
  };
}
function ge(r, t, o = { path: [], schemaPath: [] }) {
  var s;
  const u = r._zod.def, f = t.seen.get(r);
  if (f)
    return f.count++, o.schemaPath.includes(r) && (f.cycle = o.path), f.schema;
  const p = { schema: {}, count: 1, cycle: void 0, path: o.path };
  t.seen.set(r, p);
  const _ = r._zod.toJSONSchema?.();
  if (_)
    p.schema = _;
  else {
    const w = {
      ...o,
      schemaPath: [...o.schemaPath, r],
      path: o.path
    };
    if (r._zod.processJSONSchema)
      r._zod.processJSONSchema(t, p.schema, w);
    else {
      const k = p.schema, z = t.processors[u.type];
      if (!z)
        throw new Error(`[toJSONSchema]: Non-representable type encountered: ${u.type}`);
      z(r, t, k, w);
    }
    const F = r._zod.parent;
    F && (p.ref || (p.ref = F), ge(F, t, w), t.seen.get(F).isParent = !0);
  }
  const S = t.metadataRegistry.get(r);
  return S && Object.assign(p.schema, S), t.io === "input" && Te(r) && (delete p.schema.examples, delete p.schema.default), t.io === "input" && p.schema._prefault && ((s = p.schema).default ?? (s.default = p.schema._prefault)), delete p.schema._prefault, t.seen.get(r).schema;
}
function uc(r, t) {
  const o = r.seen.get(t);
  if (!o)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const s = /* @__PURE__ */ new Map();
  for (const p of r.seen.entries()) {
    const _ = r.metadataRegistry.get(p[0])?.id;
    if (_) {
      const S = s.get(_);
      if (S && S !== p[0])
        throw new Error(`Duplicate schema id "${_}" detected during JSON Schema conversion. Two different schemas cannot share the same id when converted together.`);
      s.set(_, p[0]);
    }
  }
  const u = (p) => {
    const _ = r.target === "draft-2020-12" ? "$defs" : "definitions";
    if (r.external) {
      const F = r.external.registry.get(p[0])?.id, k = r.external.uri ?? ((ie) => ie);
      if (F)
        return { ref: k(F) };
      const z = p[1].defId ?? p[1].schema.id ?? `schema${r.counter++}`;
      return p[1].defId = z, { defId: z, ref: `${k("__shared")}#/${_}/${z}` };
    }
    if (p[1] === o)
      return { ref: "#" };
    const N = `#/${_}/`, w = p[1].schema.id ?? `__schema${r.counter++}`;
    return { defId: w, ref: N + w };
  }, f = (p) => {
    if (p[1].schema.$ref)
      return;
    const _ = p[1], { ref: S, defId: N } = u(p);
    _.def = { ..._.schema }, N && (_.defId = N);
    const w = _.schema;
    for (const F in w)
      delete w[F];
    w.$ref = S;
  };
  if (r.cycles === "throw")
    for (const p of r.seen.entries()) {
      const _ = p[1];
      if (_.cycle)
        throw new Error(`Cycle detected: #/${_.cycle?.join("/")}/<root>

Set the \`cycles\` parameter to \`"ref"\` to resolve cyclical schemas with defs.`);
    }
  for (const p of r.seen.entries()) {
    const _ = p[1];
    if (t === p[0]) {
      f(p);
      continue;
    }
    if (r.external) {
      const N = r.external.registry.get(p[0])?.id;
      if (t !== p[0] && N) {
        f(p);
        continue;
      }
    }
    if (r.metadataRegistry.get(p[0])?.id) {
      f(p);
      continue;
    }
    if (_.cycle) {
      f(p);
      continue;
    }
    if (_.count > 1 && r.reused === "ref") {
      f(p);
      continue;
    }
  }
}
function cc(r, t) {
  const o = r.seen.get(t);
  if (!o)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const s = (p) => {
    const _ = r.seen.get(p);
    if (_.ref === null)
      return;
    const S = _.def ?? _.schema, N = { ...S }, w = _.ref;
    if (_.ref = null, w) {
      s(w);
      const k = r.seen.get(w), z = k.schema;
      if (z.$ref && (r.target === "draft-07" || r.target === "draft-04" || r.target === "openapi-3.0") ? (S.allOf = S.allOf ?? [], S.allOf.push(z)) : Object.assign(S, z), Object.assign(S, N), p._zod.parent === w)
        for (const Q in S)
          Q === "$ref" || Q === "allOf" || Q in N || delete S[Q];
      if (z.$ref && k.def)
        for (const Q in S)
          Q === "$ref" || Q === "allOf" || Q in k.def && JSON.stringify(S[Q]) === JSON.stringify(k.def[Q]) && delete S[Q];
    }
    const F = p._zod.parent;
    if (F && F !== w) {
      s(F);
      const k = r.seen.get(F);
      if (k?.schema.$ref && (S.$ref = k.schema.$ref, k.def))
        for (const z in S)
          z === "$ref" || z === "allOf" || z in k.def && JSON.stringify(S[z]) === JSON.stringify(k.def[z]) && delete S[z];
    }
    r.override({
      zodSchema: p,
      jsonSchema: S,
      path: _.path ?? []
    });
  };
  for (const p of [...r.seen.entries()].reverse())
    s(p[0]);
  const u = {};
  if (r.target === "draft-2020-12" ? u.$schema = "https://json-schema.org/draft/2020-12/schema" : r.target === "draft-07" ? u.$schema = "http://json-schema.org/draft-07/schema#" : r.target === "draft-04" ? u.$schema = "http://json-schema.org/draft-04/schema#" : r.target, r.external?.uri) {
    const p = r.external.registry.get(t)?.id;
    if (!p)
      throw new Error("Schema is missing an `id` property");
    u.$id = r.external.uri(p);
  }
  Object.assign(u, o.def ?? o.schema);
  const f = r.external?.defs ?? {};
  for (const p of r.seen.entries()) {
    const _ = p[1];
    _.def && _.defId && (f[_.defId] = _.def);
  }
  r.external || Object.keys(f).length > 0 && (r.target === "draft-2020-12" ? u.$defs = f : u.definitions = f);
  try {
    const p = JSON.parse(JSON.stringify(u));
    return Object.defineProperty(p, "~standard", {
      value: {
        ...t["~standard"],
        jsonSchema: {
          input: Ut(t, "input", r.processors),
          output: Ut(t, "output", r.processors)
        }
      },
      enumerable: !1,
      writable: !1
    }), p;
  } catch {
    throw new Error("Error converting schema to JSON.");
  }
}
function Te(r, t) {
  const o = t ?? { seen: /* @__PURE__ */ new Set() };
  if (o.seen.has(r))
    return !1;
  o.seen.add(r);
  const s = r._zod.def;
  if (s.type === "transform")
    return !0;
  if (s.type === "array")
    return Te(s.element, o);
  if (s.type === "set")
    return Te(s.valueType, o);
  if (s.type === "lazy")
    return Te(s.getter(), o);
  if (s.type === "promise" || s.type === "optional" || s.type === "nonoptional" || s.type === "nullable" || s.type === "readonly" || s.type === "default" || s.type === "prefault")
    return Te(s.innerType, o);
  if (s.type === "intersection")
    return Te(s.left, o) || Te(s.right, o);
  if (s.type === "record" || s.type === "map")
    return Te(s.keyType, o) || Te(s.valueType, o);
  if (s.type === "pipe")
    return Te(s.in, o) || Te(s.out, o);
  if (s.type === "object") {
    for (const u in s.shape)
      if (Te(s.shape[u], o))
        return !0;
    return !1;
  }
  if (s.type === "union") {
    for (const u of s.options)
      if (Te(u, o))
        return !0;
    return !1;
  }
  if (s.type === "tuple") {
    for (const u of s.items)
      if (Te(u, o))
        return !0;
    return !!(s.rest && Te(s.rest, o));
  }
  return !1;
}
const hb = (r, t = {}) => (o) => {
  const s = sc({ ...o, processors: t });
  return ge(r, s), uc(s, r), cc(s, r);
}, Ut = (r, t, o = {}) => (s) => {
  const { libraryOptions: u, target: f } = s ?? {}, p = sc({ ...u ?? {}, target: f, io: t, processors: o });
  return ge(r, p), uc(p, r), cc(p, r);
}, mb = {
  guid: "uuid",
  url: "uri",
  datetime: "date-time",
  json_string: "json-string",
  regex: ""
  // do not set
}, _b = (r, t, o, s) => {
  const u = o;
  u.type = "string";
  const { minimum: f, maximum: p, format: _, patterns: S, contentEncoding: N } = r._zod.bag;
  if (typeof f == "number" && (u.minLength = f), typeof p == "number" && (u.maxLength = p), _ && (u.format = mb[_] ?? _, u.format === "" && delete u.format, _ === "time" && delete u.format), N && (u.contentEncoding = N), S && S.size > 0) {
    const w = [...S];
    w.length === 1 ? u.pattern = w[0].source : w.length > 1 && (u.allOf = [
      ...w.map((F) => ({
        ...t.target === "draft-07" || t.target === "draft-04" || t.target === "openapi-3.0" ? { type: "string" } : {},
        pattern: F.source
      }))
    ]);
  }
}, gb = (r, t, o, s) => {
  const u = o, { minimum: f, maximum: p, format: _, multipleOf: S, exclusiveMaximum: N, exclusiveMinimum: w } = r._zod.bag;
  typeof _ == "string" && _.includes("int") ? u.type = "integer" : u.type = "number", typeof w == "number" && (t.target === "draft-04" || t.target === "openapi-3.0" ? (u.minimum = w, u.exclusiveMinimum = !0) : u.exclusiveMinimum = w), typeof f == "number" && (u.minimum = f, typeof w == "number" && t.target !== "draft-04" && (w >= f ? delete u.minimum : delete u.exclusiveMinimum)), typeof N == "number" && (t.target === "draft-04" || t.target === "openapi-3.0" ? (u.maximum = N, u.exclusiveMaximum = !0) : u.exclusiveMaximum = N), typeof p == "number" && (u.maximum = p, typeof N == "number" && t.target !== "draft-04" && (N <= p ? delete u.maximum : delete u.exclusiveMaximum)), typeof S == "number" && (u.multipleOf = S);
}, vb = (r, t, o, s) => {
  o.not = {};
}, Ib = (r, t, o, s) => {
}, bb = (r, t, o, s) => {
  const u = r._zod.def, f = Du(u.entries);
  f.every((p) => typeof p == "number") && (o.type = "number"), f.every((p) => typeof p == "string") && (o.type = "string"), o.enum = f;
}, Sb = (r, t, o, s) => {
  const u = r._zod.def, f = [];
  for (const p of u.values)
    if (p === void 0) {
      if (t.unrepresentable === "throw")
        throw new Error("Literal `undefined` cannot be represented in JSON Schema");
    } else if (typeof p == "bigint") {
      if (t.unrepresentable === "throw")
        throw new Error("BigInt literals cannot be represented in JSON Schema");
      f.push(Number(p));
    } else
      f.push(p);
  if (f.length !== 0) if (f.length === 1) {
    const p = f[0];
    o.type = p === null ? "null" : typeof p, t.target === "draft-04" || t.target === "openapi-3.0" ? o.enum = [p] : o.const = p;
  } else
    f.every((p) => typeof p == "number") && (o.type = "number"), f.every((p) => typeof p == "string") && (o.type = "string"), f.every((p) => typeof p == "boolean") && (o.type = "boolean"), f.every((p) => p === null) && (o.type = "null"), o.enum = f;
}, Ab = (r, t, o, s) => {
  if (t.unrepresentable === "throw")
    throw new Error("Custom types cannot be represented in JSON Schema");
}, Tb = (r, t, o, s) => {
  if (t.unrepresentable === "throw")
    throw new Error("Transforms cannot be represented in JSON Schema");
}, Cb = (r, t, o, s) => {
  const u = o, f = r._zod.def, { minimum: p, maximum: _ } = r._zod.bag;
  typeof p == "number" && (u.minItems = p), typeof _ == "number" && (u.maxItems = _), u.type = "array", u.items = ge(f.element, t, { ...s, path: [...s.path, "items"] });
}, yb = (r, t, o, s) => {
  const u = o, f = r._zod.def;
  u.type = "object", u.properties = {};
  const p = f.shape;
  for (const N in p)
    u.properties[N] = ge(p[N], t, {
      ...s,
      path: [...s.path, "properties", N]
    });
  const _ = new Set(Object.keys(p)), S = new Set([..._].filter((N) => {
    const w = f.shape[N]._zod;
    return t.io === "input" ? w.optin === void 0 : w.optout === void 0;
  }));
  S.size > 0 && (u.required = Array.from(S)), f.catchall?._zod.def.type === "never" ? u.additionalProperties = !1 : f.catchall ? f.catchall && (u.additionalProperties = ge(f.catchall, t, {
    ...s,
    path: [...s.path, "additionalProperties"]
  })) : t.io === "output" && (u.additionalProperties = !1);
}, Nb = (r, t, o, s) => {
  const u = r._zod.def, f = u.inclusive === !1, p = u.options.map((_, S) => ge(_, t, {
    ...s,
    path: [...s.path, f ? "oneOf" : "anyOf", S]
  }));
  f ? o.oneOf = p : o.anyOf = p;
}, xb = (r, t, o, s) => {
  const u = r._zod.def, f = ge(u.left, t, {
    ...s,
    path: [...s.path, "allOf", 0]
  }), p = ge(u.right, t, {
    ...s,
    path: [...s.path, "allOf", 1]
  }), _ = (N) => "allOf" in N && Object.keys(N).length === 1, S = [
    ..._(f) ? f.allOf : [f],
    ..._(p) ? p.allOf : [p]
  ];
  o.allOf = S;
}, Eb = (r, t, o, s) => {
  const u = r._zod.def, f = ge(u.innerType, t, s), p = t.seen.get(r);
  t.target === "openapi-3.0" ? (p.ref = u.innerType, o.nullable = !0) : o.anyOf = [f, { type: "null" }];
}, wb = (r, t, o, s) => {
  const u = r._zod.def;
  ge(u.innerType, t, s);
  const f = t.seen.get(r);
  f.ref = u.innerType;
}, Mb = (r, t, o, s) => {
  const u = r._zod.def;
  ge(u.innerType, t, s);
  const f = t.seen.get(r);
  f.ref = u.innerType, o.default = JSON.parse(JSON.stringify(u.defaultValue));
}, kb = (r, t, o, s) => {
  const u = r._zod.def;
  ge(u.innerType, t, s);
  const f = t.seen.get(r);
  f.ref = u.innerType, t.io === "input" && (o._prefault = JSON.parse(JSON.stringify(u.defaultValue)));
}, Bb = (r, t, o, s) => {
  const u = r._zod.def;
  ge(u.innerType, t, s);
  const f = t.seen.get(r);
  f.ref = u.innerType;
  let p;
  try {
    p = u.catchValue(void 0);
  } catch {
    throw new Error("Dynamic catch values are not supported in JSON Schema");
  }
  o.default = p;
}, Pb = (r, t, o, s) => {
  const u = r._zod.def, f = t.io === "input" ? u.in._zod.def.type === "transform" ? u.out : u.in : u.out;
  ge(f, t, s);
  const p = t.seen.get(r);
  p.ref = f;
}, Rb = (r, t, o, s) => {
  const u = r._zod.def;
  ge(u.innerType, t, s);
  const f = t.seen.get(r);
  f.ref = u.innerType, o.readOnly = !0;
}, lc = (r, t, o, s) => {
  const u = r._zod.def;
  ge(u.innerType, t, s);
  const f = t.seen.get(r);
  f.ref = u.innerType;
}, Ob = /* @__PURE__ */ T("ZodISODateTime", (r, t) => {
  Uv.init(r, t), oe.init(r, t);
});
function zb(r) {
  return /* @__PURE__ */ HI(Ob, r);
}
const Lb = /* @__PURE__ */ T("ZodISODate", (r, t) => {
  $v.init(r, t), oe.init(r, t);
});
function Fb(r) {
  return /* @__PURE__ */ WI(Lb, r);
}
const Gb = /* @__PURE__ */ T("ZodISOTime", (r, t) => {
  Kv.init(r, t), oe.init(r, t);
});
function Db(r) {
  return /* @__PURE__ */ qI(Gb, r);
}
const Zb = /* @__PURE__ */ T("ZodISODuration", (r, t) => {
  Hv.init(r, t), oe.init(r, t);
});
function Ub(r) {
  return /* @__PURE__ */ VI(Zb, r);
}
const $b = (r, t) => {
  Hu.init(r, t), r.name = "ZodError", Object.defineProperties(r, {
    format: {
      value: (o) => Og(r, o)
      // enumerable: false,
    },
    flatten: {
      value: (o) => Rg(r, o)
      // enumerable: false,
    },
    addIssue: {
      value: (o) => {
        r.issues.push(o), r.message = JSON.stringify(r.issues, Ii, 2);
      }
      // enumerable: false,
    },
    addIssues: {
      value: (o) => {
        r.issues.push(...o), r.message = JSON.stringify(r.issues, Ii, 2);
      }
      // enumerable: false,
    },
    isEmpty: {
      get() {
        return r.issues.length === 0;
      }
      // enumerable: false,
    }
  });
}, We = T("ZodError", $b, {
  Parent: Error
}), Kb = /* @__PURE__ */ Ei(We), Hb = /* @__PURE__ */ wi(We), Wb = /* @__PURE__ */ Kt(We), qb = /* @__PURE__ */ Ht(We), Vb = /* @__PURE__ */ Fg(We), Jb = /* @__PURE__ */ Gg(We), jb = /* @__PURE__ */ Dg(We), Yb = /* @__PURE__ */ Zg(We), Xb = /* @__PURE__ */ Ug(We), Qb = /* @__PURE__ */ $g(We), eS = /* @__PURE__ */ Kg(We), nS = /* @__PURE__ */ Hg(We), le = /* @__PURE__ */ T("ZodType", (r, t) => (ce.init(r, t), Object.assign(r["~standard"], {
  jsonSchema: {
    input: Ut(r, "input"),
    output: Ut(r, "output")
  }
}), r.toJSONSchema = hb(r, {}), r.def = t, r.type = t.type, Object.defineProperty(r, "_def", { value: t }), r.check = (...o) => r.clone(Mn(t, {
  checks: [
    ...t.checks ?? [],
    ...o.map((s) => typeof s == "function" ? { _zod: { check: s, def: { check: "custom" }, onattach: [] } } : s)
  ]
}), {
  parent: !0
}), r.with = r.check, r.clone = (o, s) => kn(r, o, s), r.brand = () => r, r.register = ((o, s) => (o.add(r, s), r)), r.parse = (o, s) => Kb(r, o, s, { callee: r.parse }), r.safeParse = (o, s) => Wb(r, o, s), r.parseAsync = async (o, s) => Hb(r, o, s, { callee: r.parseAsync }), r.safeParseAsync = async (o, s) => qb(r, o, s), r.spa = r.safeParseAsync, r.encode = (o, s) => Vb(r, o, s), r.decode = (o, s) => Jb(r, o, s), r.encodeAsync = async (o, s) => jb(r, o, s), r.decodeAsync = async (o, s) => Yb(r, o, s), r.safeEncode = (o, s) => Xb(r, o, s), r.safeDecode = (o, s) => Qb(r, o, s), r.safeEncodeAsync = async (o, s) => eS(r, o, s), r.safeDecodeAsync = async (o, s) => nS(r, o, s), r.refine = (o, s) => r.check(qS(o, s)), r.superRefine = (o) => r.check(VS(o)), r.overwrite = (o) => r.check(/* @__PURE__ */ fr(o)), r.optional = () => Pu(r), r.exactOptional = () => RS(r), r.nullable = () => Ru(r), r.nullish = () => Pu(Ru(r)), r.nonoptional = (o) => DS(r, o), r.array = () => yS(r), r.or = (o) => fc([r, o]), r.and = (o) => wS(r, o), r.transform = (o) => Ou(r, BS(o)), r.default = (o) => LS(r, o), r.prefault = (o) => GS(r, o), r.catch = (o) => US(r, o), r.pipe = (o) => Ou(r, o), r.readonly = () => HS(r), r.describe = (o) => {
  const s = r.clone();
  return Lr.add(s, { description: o }), s;
}, Object.defineProperty(r, "description", {
  get() {
    return Lr.get(r)?.description;
  },
  configurable: !0
}), r.meta = (...o) => {
  if (o.length === 0)
    return Lr.get(r);
  const s = r.clone();
  return Lr.add(s, o[0]), s;
}, r.isOptional = () => r.safeParse(void 0).success, r.isNullable = () => r.safeParse(null).success, r.apply = (o) => o(r), r)), dc = /* @__PURE__ */ T("_ZodString", (r, t) => {
  Mi.init(r, t), le.init(r, t), r._zod.processJSONSchema = (s, u, f) => _b(r, s, u);
  const o = r._zod.bag;
  r.format = o.format ?? null, r.minLength = o.minimum ?? null, r.maxLength = o.maximum ?? null, r.regex = (...s) => r.check(/* @__PURE__ */ QI(...s)), r.includes = (...s) => r.check(/* @__PURE__ */ rb(...s)), r.startsWith = (...s) => r.check(/* @__PURE__ */ tb(...s)), r.endsWith = (...s) => r.check(/* @__PURE__ */ ob(...s)), r.min = (...s) => r.check(/* @__PURE__ */ Zt(...s)), r.max = (...s) => r.check(/* @__PURE__ */ ic(...s)), r.length = (...s) => r.check(/* @__PURE__ */ ac(...s)), r.nonempty = (...s) => r.check(/* @__PURE__ */ Zt(1, ...s)), r.lowercase = (s) => r.check(/* @__PURE__ */ eb(s)), r.uppercase = (s) => r.check(/* @__PURE__ */ nb(s)), r.trim = () => r.check(/* @__PURE__ */ ab()), r.normalize = (...s) => r.check(/* @__PURE__ */ ib(...s)), r.toLowerCase = () => r.check(/* @__PURE__ */ sb()), r.toUpperCase = () => r.check(/* @__PURE__ */ ub()), r.slugify = () => r.check(/* @__PURE__ */ cb());
}), rS = /* @__PURE__ */ T("ZodString", (r, t) => {
  Mi.init(r, t), dc.init(r, t), r.email = (o) => r.check(/* @__PURE__ */ yI(tS, o)), r.url = (o) => r.check(/* @__PURE__ */ wI(oS, o)), r.jwt = (o) => r.check(/* @__PURE__ */ KI(IS, o)), r.emoji = (o) => r.check(/* @__PURE__ */ MI(iS, o)), r.guid = (o) => r.check(/* @__PURE__ */ yu(wu, o)), r.uuid = (o) => r.check(/* @__PURE__ */ oc(Fr, o)), r.uuidv4 = (o) => r.check(/* @__PURE__ */ NI(Fr, o)), r.uuidv6 = (o) => r.check(/* @__PURE__ */ xI(Fr, o)), r.uuidv7 = (o) => r.check(/* @__PURE__ */ EI(Fr, o)), r.nanoid = (o) => r.check(/* @__PURE__ */ kI(aS, o)), r.guid = (o) => r.check(/* @__PURE__ */ yu(wu, o)), r.cuid = (o) => r.check(/* @__PURE__ */ BI(sS, o)), r.cuid2 = (o) => r.check(/* @__PURE__ */ PI(uS, o)), r.ulid = (o) => r.check(/* @__PURE__ */ RI(cS, o)), r.base64 = (o) => r.check(/* @__PURE__ */ ZI(_S, o)), r.base64url = (o) => r.check(/* @__PURE__ */ UI(gS, o)), r.xid = (o) => r.check(/* @__PURE__ */ OI(lS, o)), r.ksuid = (o) => r.check(/* @__PURE__ */ zI(dS, o)), r.ipv4 = (o) => r.check(/* @__PURE__ */ LI(pS, o)), r.ipv6 = (o) => r.check(/* @__PURE__ */ FI(fS, o)), r.cidrv4 = (o) => r.check(/* @__PURE__ */ GI(hS, o)), r.cidrv6 = (o) => r.check(/* @__PURE__ */ DI(mS, o)), r.e164 = (o) => r.check(/* @__PURE__ */ $I(vS, o)), r.datetime = (o) => r.check(zb(o)), r.date = (o) => r.check(Fb(o)), r.time = (o) => r.check(Db(o)), r.duration = (o) => r.check(Ub(o));
});
function Ce(r) {
  return /* @__PURE__ */ CI(rS, r);
}
const oe = /* @__PURE__ */ T("ZodStringFormat", (r, t) => {
  re.init(r, t), dc.init(r, t);
}), tS = /* @__PURE__ */ T("ZodEmail", (r, t) => {
  Pv.init(r, t), oe.init(r, t);
}), wu = /* @__PURE__ */ T("ZodGUID", (r, t) => {
  kv.init(r, t), oe.init(r, t);
}), Fr = /* @__PURE__ */ T("ZodUUID", (r, t) => {
  Bv.init(r, t), oe.init(r, t);
});
function $t(r) {
  return /* @__PURE__ */ oc(Fr, r);
}
const oS = /* @__PURE__ */ T("ZodURL", (r, t) => {
  Rv.init(r, t), oe.init(r, t);
}), iS = /* @__PURE__ */ T("ZodEmoji", (r, t) => {
  Ov.init(r, t), oe.init(r, t);
}), aS = /* @__PURE__ */ T("ZodNanoID", (r, t) => {
  zv.init(r, t), oe.init(r, t);
}), sS = /* @__PURE__ */ T("ZodCUID", (r, t) => {
  Lv.init(r, t), oe.init(r, t);
}), uS = /* @__PURE__ */ T("ZodCUID2", (r, t) => {
  Fv.init(r, t), oe.init(r, t);
}), cS = /* @__PURE__ */ T("ZodULID", (r, t) => {
  Gv.init(r, t), oe.init(r, t);
}), lS = /* @__PURE__ */ T("ZodXID", (r, t) => {
  Dv.init(r, t), oe.init(r, t);
}), dS = /* @__PURE__ */ T("ZodKSUID", (r, t) => {
  Zv.init(r, t), oe.init(r, t);
}), pS = /* @__PURE__ */ T("ZodIPv4", (r, t) => {
  Wv.init(r, t), oe.init(r, t);
}), fS = /* @__PURE__ */ T("ZodIPv6", (r, t) => {
  qv.init(r, t), oe.init(r, t);
}), hS = /* @__PURE__ */ T("ZodCIDRv4", (r, t) => {
  Vv.init(r, t), oe.init(r, t);
}), mS = /* @__PURE__ */ T("ZodCIDRv6", (r, t) => {
  Jv.init(r, t), oe.init(r, t);
}), _S = /* @__PURE__ */ T("ZodBase64", (r, t) => {
  jv.init(r, t), oe.init(r, t);
}), gS = /* @__PURE__ */ T("ZodBase64URL", (r, t) => {
  Xv.init(r, t), oe.init(r, t);
}), vS = /* @__PURE__ */ T("ZodE164", (r, t) => {
  Qv.init(r, t), oe.init(r, t);
}), IS = /* @__PURE__ */ T("ZodJWT", (r, t) => {
  nI.init(r, t), oe.init(r, t);
}), pc = /* @__PURE__ */ T("ZodNumber", (r, t) => {
  ec.init(r, t), le.init(r, t), r._zod.processJSONSchema = (s, u, f) => gb(r, s, u), r.gt = (s, u) => r.check(/* @__PURE__ */ xu(s, u)), r.gte = (s, u) => r.check(/* @__PURE__ */ vi(s, u)), r.min = (s, u) => r.check(/* @__PURE__ */ vi(s, u)), r.lt = (s, u) => r.check(/* @__PURE__ */ Nu(s, u)), r.lte = (s, u) => r.check(/* @__PURE__ */ gi(s, u)), r.max = (s, u) => r.check(/* @__PURE__ */ gi(s, u)), r.int = (s) => r.check(ku(s)), r.safe = (s) => r.check(ku(s)), r.positive = (s) => r.check(/* @__PURE__ */ xu(0, s)), r.nonnegative = (s) => r.check(/* @__PURE__ */ vi(0, s)), r.negative = (s) => r.check(/* @__PURE__ */ Nu(0, s)), r.nonpositive = (s) => r.check(/* @__PURE__ */ gi(0, s)), r.multipleOf = (s, u) => r.check(/* @__PURE__ */ Eu(s, u)), r.step = (s, u) => r.check(/* @__PURE__ */ Eu(s, u)), r.finite = () => r;
  const o = r._zod.bag;
  r.minValue = Math.max(o.minimum ?? Number.NEGATIVE_INFINITY, o.exclusiveMinimum ?? Number.NEGATIVE_INFINITY) ?? null, r.maxValue = Math.min(o.maximum ?? Number.POSITIVE_INFINITY, o.exclusiveMaximum ?? Number.POSITIVE_INFINITY) ?? null, r.isInt = (o.format ?? "").includes("int") || Number.isSafeInteger(o.multipleOf ?? 0.5), r.isFinite = !0, r.format = o.format ?? null;
});
function Mu(r) {
  return /* @__PURE__ */ JI(pc, r);
}
const bS = /* @__PURE__ */ T("ZodNumberFormat", (r, t) => {
  rI.init(r, t), pc.init(r, t);
});
function ku(r) {
  return /* @__PURE__ */ jI(bS, r);
}
const SS = /* @__PURE__ */ T("ZodUnknown", (r, t) => {
  tI.init(r, t), le.init(r, t), r._zod.processJSONSchema = (o, s, u) => Ib();
});
function Bu() {
  return /* @__PURE__ */ YI(SS);
}
const AS = /* @__PURE__ */ T("ZodNever", (r, t) => {
  oI.init(r, t), le.init(r, t), r._zod.processJSONSchema = (o, s, u) => vb(r, o, s);
});
function TS(r) {
  return /* @__PURE__ */ XI(AS, r);
}
const CS = /* @__PURE__ */ T("ZodArray", (r, t) => {
  iI.init(r, t), le.init(r, t), r._zod.processJSONSchema = (o, s, u) => Cb(r, o, s, u), r.element = t.element, r.min = (o, s) => r.check(/* @__PURE__ */ Zt(o, s)), r.nonempty = (o) => r.check(/* @__PURE__ */ Zt(1, o)), r.max = (o, s) => r.check(/* @__PURE__ */ ic(o, s)), r.length = (o, s) => r.check(/* @__PURE__ */ ac(o, s)), r.unwrap = () => r.element;
});
function yS(r, t) {
  return /* @__PURE__ */ lb(CS, r, t);
}
const NS = /* @__PURE__ */ T("ZodObject", (r, t) => {
  sI.init(r, t), le.init(r, t), r._zod.processJSONSchema = (o, s, u) => yb(r, o, s, u), J(r, "shape", () => t.shape), r.keyof = () => hc(Object.keys(r._zod.def.shape)), r.catchall = (o) => r.clone({ ...r._zod.def, catchall: o }), r.passthrough = () => r.clone({ ...r._zod.def, catchall: Bu() }), r.loose = () => r.clone({ ...r._zod.def, catchall: Bu() }), r.strict = () => r.clone({ ...r._zod.def, catchall: TS() }), r.strip = () => r.clone({ ...r._zod.def, catchall: void 0 }), r.extend = (o) => wg(r, o), r.safeExtend = (o) => Mg(r, o), r.merge = (o) => kg(r, o), r.pick = (o) => xg(r, o), r.omit = (o) => Eg(r, o), r.partial = (...o) => Bg(_c, r, o[0]), r.required = (...o) => Pg(gc, r, o[0]);
});
function $r(r, t) {
  const o = {
    type: "object",
    shape: r ?? {},
    ...B(t)
  };
  return new NS(o);
}
const xS = /* @__PURE__ */ T("ZodUnion", (r, t) => {
  uI.init(r, t), le.init(r, t), r._zod.processJSONSchema = (o, s, u) => Nb(r, o, s, u), r.options = t.options;
});
function fc(r, t) {
  return new xS({
    type: "union",
    options: r,
    ...B(t)
  });
}
const ES = /* @__PURE__ */ T("ZodIntersection", (r, t) => {
  cI.init(r, t), le.init(r, t), r._zod.processJSONSchema = (o, s, u) => xb(r, o, s, u);
});
function wS(r, t) {
  return new ES({
    type: "intersection",
    left: r,
    right: t
  });
}
const Si = /* @__PURE__ */ T("ZodEnum", (r, t) => {
  lI.init(r, t), le.init(r, t), r._zod.processJSONSchema = (s, u, f) => bb(r, s, u), r.enum = t.entries, r.options = Object.values(t.entries);
  const o = new Set(Object.keys(t.entries));
  r.extract = (s, u) => {
    const f = {};
    for (const p of s)
      if (o.has(p))
        f[p] = t.entries[p];
      else
        throw new Error(`Key ${p} not found in enum`);
    return new Si({
      ...t,
      checks: [],
      ...B(u),
      entries: f
    });
  }, r.exclude = (s, u) => {
    const f = { ...t.entries };
    for (const p of s)
      if (o.has(p))
        delete f[p];
      else
        throw new Error(`Key ${p} not found in enum`);
    return new Si({
      ...t,
      checks: [],
      ...B(u),
      entries: f
    });
  };
});
function hc(r, t) {
  const o = Array.isArray(r) ? Object.fromEntries(r.map((s) => [s, s])) : r;
  return new Si({
    type: "enum",
    entries: o,
    ...B(t)
  });
}
const MS = /* @__PURE__ */ T("ZodLiteral", (r, t) => {
  dI.init(r, t), le.init(r, t), r._zod.processJSONSchema = (o, s, u) => Sb(r, o, s), r.values = new Set(t.values), Object.defineProperty(r, "value", {
    get() {
      if (t.values.length > 1)
        throw new Error("This schema contains multiple valid literal values. Use `.values` instead.");
      return t.values[0];
    }
  });
});
function mc(r, t) {
  return new MS({
    type: "literal",
    values: Array.isArray(r) ? r : [r],
    ...B(t)
  });
}
const kS = /* @__PURE__ */ T("ZodTransform", (r, t) => {
  pI.init(r, t), le.init(r, t), r._zod.processJSONSchema = (o, s, u) => Tb(r, o), r._zod.parse = (o, s) => {
    if (s.direction === "backward")
      throw new Fu(r.constructor.name);
    o.addIssue = (f) => {
      if (typeof f == "string")
        o.issues.push(Ur(f, o.value, t));
      else {
        const p = f;
        p.fatal && (p.continue = !1), p.code ?? (p.code = "custom"), p.input ?? (p.input = o.value), p.inst ?? (p.inst = r), o.issues.push(Ur(p));
      }
    };
    const u = t.transform(o.value, o);
    return u instanceof Promise ? u.then((f) => (o.value = f, o)) : (o.value = u, o);
  };
});
function BS(r) {
  return new kS({
    type: "transform",
    transform: r
  });
}
const _c = /* @__PURE__ */ T("ZodOptional", (r, t) => {
  tc.init(r, t), le.init(r, t), r._zod.processJSONSchema = (o, s, u) => lc(r, o, s, u), r.unwrap = () => r._zod.def.innerType;
});
function Pu(r) {
  return new _c({
    type: "optional",
    innerType: r
  });
}
const PS = /* @__PURE__ */ T("ZodExactOptional", (r, t) => {
  fI.init(r, t), le.init(r, t), r._zod.processJSONSchema = (o, s, u) => lc(r, o, s, u), r.unwrap = () => r._zod.def.innerType;
});
function RS(r) {
  return new PS({
    type: "optional",
    innerType: r
  });
}
const OS = /* @__PURE__ */ T("ZodNullable", (r, t) => {
  hI.init(r, t), le.init(r, t), r._zod.processJSONSchema = (o, s, u) => Eb(r, o, s, u), r.unwrap = () => r._zod.def.innerType;
});
function Ru(r) {
  return new OS({
    type: "nullable",
    innerType: r
  });
}
const zS = /* @__PURE__ */ T("ZodDefault", (r, t) => {
  mI.init(r, t), le.init(r, t), r._zod.processJSONSchema = (o, s, u) => Mb(r, o, s, u), r.unwrap = () => r._zod.def.innerType, r.removeDefault = r.unwrap;
});
function LS(r, t) {
  return new zS({
    type: "default",
    innerType: r,
    get defaultValue() {
      return typeof t == "function" ? t() : Uu(t);
    }
  });
}
const FS = /* @__PURE__ */ T("ZodPrefault", (r, t) => {
  _I.init(r, t), le.init(r, t), r._zod.processJSONSchema = (o, s, u) => kb(r, o, s, u), r.unwrap = () => r._zod.def.innerType;
});
function GS(r, t) {
  return new FS({
    type: "prefault",
    innerType: r,
    get defaultValue() {
      return typeof t == "function" ? t() : Uu(t);
    }
  });
}
const gc = /* @__PURE__ */ T("ZodNonOptional", (r, t) => {
  gI.init(r, t), le.init(r, t), r._zod.processJSONSchema = (o, s, u) => wb(r, o, s, u), r.unwrap = () => r._zod.def.innerType;
});
function DS(r, t) {
  return new gc({
    type: "nonoptional",
    innerType: r,
    ...B(t)
  });
}
const ZS = /* @__PURE__ */ T("ZodCatch", (r, t) => {
  vI.init(r, t), le.init(r, t), r._zod.processJSONSchema = (o, s, u) => Bb(r, o, s, u), r.unwrap = () => r._zod.def.innerType, r.removeCatch = r.unwrap;
});
function US(r, t) {
  return new ZS({
    type: "catch",
    innerType: r,
    catchValue: typeof t == "function" ? t : () => t
  });
}
const $S = /* @__PURE__ */ T("ZodPipe", (r, t) => {
  II.init(r, t), le.init(r, t), r._zod.processJSONSchema = (o, s, u) => Pb(r, o, s, u), r.in = t.in, r.out = t.out;
});
function Ou(r, t) {
  return new $S({
    type: "pipe",
    in: r,
    out: t
    // ...util.normalizeParams(params),
  });
}
const KS = /* @__PURE__ */ T("ZodReadonly", (r, t) => {
  bI.init(r, t), le.init(r, t), r._zod.processJSONSchema = (o, s, u) => Rb(r, o, s, u), r.unwrap = () => r._zod.def.innerType;
});
function HS(r) {
  return new KS({
    type: "readonly",
    innerType: r
  });
}
const WS = /* @__PURE__ */ T("ZodCustom", (r, t) => {
  SI.init(r, t), le.init(r, t), r._zod.processJSONSchema = (o, s, u) => Ab(r, o);
});
function qS(r, t = {}) {
  return /* @__PURE__ */ db(WS, r, t);
}
function VS(r) {
  return /* @__PURE__ */ pb(r);
}
const vc = $r({
  userId: $t(),
  companyId: $t()
}), JS = vc.extend({
  auctionId: $t()
}), jS = vc.extend({
  directSaleId: $t()
}), b1 = fc([JS, jS]), S1 = 50, A1 = 1, T1 = "bnk_", C1 = {
  // Exteriors
  photo_front: {
    name: "photo_front",
    position: 10,
    position_admin: 30,
    label: "front photo",
    group: "exteriors",
    description: "A photo capturing the front view of the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !0
  },
  photo_3_4_front_side_left: {
    name: "photo_3_4_front_side_left",
    position: 20,
    position_admin: 40,
    label: "3/4 front left",
    group: "exteriors",
    description: "A 3/4 angled photo of the front side of the vehicle from the left.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !0
  },
  photo_side_left: {
    name: "photo_side_left",
    position: 30,
    position_admin: 70,
    label: "left side photo",
    group: "exteriors",
    description: "A photo showing the left side of the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_3_4_side_left_rear: {
    name: "photo_3_4_side_left_rear",
    position: 40,
    position_admin: 120,
    label: "3/4 left rear side",
    group: "exteriors",
    description: "A 3/4 angled photo of the left rear side of the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_rear_hatch_closed: {
    name: "photo_rear_hatch_closed",
    position: 50,
    position_admin: 130,
    label: "rear hatch closed",
    group: "exteriors",
    description: "A photo showing the rear of the vehicle with the hatch closed.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_3_4_side_right_rear_doors_closed: {
    name: "photo_3_4_side_right_rear_doors_closed",
    position: 60,
    position_admin: 190,
    label: "3/4 right rear doors closed",
    group: "exteriors",
    description: "A 3/4 angled photo showing the right rear side with doors closed.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_side_right_doors_closed: {
    name: "photo_side_right_doors_closed",
    position: 70,
    position_admin: 200,
    label: "right side doors closed",
    group: "exteriors",
    description: "A photo showing the right side of the vehicle with doors closed.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  turntable_photo_external_if_present_only_18mt: {
    name: "turntable_photo_external_if_present_only_18mt",
    position: 80,
    position_admin: 210,
    label: "turntable external (18m)",
    group: "exteriors",
    description: "An external photo of the turntable if present (only for 18 meters).",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_3_4_front_side_right_doors_closed: {
    name: "photo_3_4_front_side_right_doors_closed",
    position: 90,
    position_admin: 10,
    label: "3/4 front right doors",
    group: "exteriors",
    description: "A 3/4 angled photo of the front side of the vehicle from the right, with doors closed.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !0
  },
  photo_3_4_side_right_front_doors_open: {
    name: "photo_3_4_side_right_front_doors_open",
    position: 100,
    position_admin: 230,
    label: "3/4 right front doors open",
    group: "exteriors",
    description: "A 3/4 angled photo showing the right front side of the vehicle with doors open.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  front_photo_per_door_doors_open_door_1: {
    name: "front_photo_per_door_doors_open_door_1",
    position: 110,
    position_admin: 300,
    label: "front door 1 open",
    group: "exteriors",
    description: "A photo of the front door 1 in an open position.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_side_right_doors_open: {
    name: "photo_side_right_doors_open",
    position: 120,
    position_admin: 240,
    label: "right side doors open",
    group: "exteriors",
    description: "A photo showing the right side of the vehicle with doors open.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  front_photo_per_door_doors_open_door_2: {
    name: "front_photo_per_door_doors_open_door_2",
    position: 130,
    position_admin: 270,
    label: "front door 2 open",
    group: "exteriors",
    description: "A photo of the front door 2 in an open position.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  front_photo_per_door_doors_open_door_3: {
    name: "front_photo_per_door_doors_open_door_3",
    position: 140,
    position_admin: 260,
    label: "front door 3 open",
    group: "exteriors",
    description: "A photo of the front door 3 in an open position.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_3_4_side_right_rear_doors_open: {
    name: "photo_3_4_side_right_rear_doors_open",
    position: 150,
    position_admin: 250,
    label: "3/4 right rear doors open",
    group: "exteriors",
    description: "A 3/4 angled photo showing the right rear side with doors open.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_luggage: {
    name: "photo_luggage",
    position: 160,
    position_admin: 80,
    label: "luggage rack photo",
    group: "exteriors",
    description: "A photo showing the luggage rack in the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_internal_frame_for_potential_rust: {
    name: "photo_internal_frame_for_potential_rust",
    position: 170,
    position_admin: 90,
    label: "internal frame rust check",
    group: "exteriors",
    description: "A photo showing the internal frame of the vehicle to check for potential rust.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_under_carpet_if_carpet_present: {
    name: "photo_under_carpet_if_carpet_present",
    position: 180,
    position_admin: 95,
    label: "under carpet photo",
    group: "exteriors",
    description: "A photo showing the area under the carpet if present.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_hatch_open: {
    name: "photo_rear_hatch_open",
    position: 190,
    position_admin: 140,
    label: "rear hatch open",
    group: "exteriors",
    description: "A photo showing the rear of the vehicle with the hatch open.",
    requiredForToBeScrapped: !0,
    performTextInpaint: !1
  },
  photo_compressor_air_conditioning: {
    name: "photo_compressor_air_conditioning",
    position: 200,
    position_admin: 150,
    label: "air conditioning compressor",
    group: "exteriors",
    description: "A photo showing the air conditioning compressor.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_preheater_webasto_if_present: {
    name: "photo_preheater_webasto_if_present",
    position: 210,
    position_admin: 170,
    label: "preheater webasto photo",
    group: "exteriors",
    description: "A photo of the preheater (webasto) system if present.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_fire_extinguishing_system: {
    name: "photo_fire_extinguishing_system",
    position: 220,
    position_admin: 160,
    label: "fire extinguishing system",
    group: "exteriors",
    description: "A photo showing the fire extinguishing system of the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_external_compartments_various_internal_photo: {
    name: "photo_external_compartments_various_internal_photo",
    position: 230,
    position_admin: 60,
    label: "external compartments photo",
    group: "exteriors",
    description: "A photo showing various external compartments.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_platform_open_platform: {
    name: "photo_platform_open_platform",
    position: 240,
    position_admin: 215,
    label: "platform open photo",
    group: "exteriors",
    description: "A photo of the platform in an open position.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_platform_code: {
    name: "photo_platform_code",
    position: 250,
    position_admin: 216,
    label: "platform code photo",
    group: "exteriors",
    description: "A photo showing the platform's code.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  engine_plate_photo_if_present: {
    name: "engine_plate_photo_if_present",
    position: 260,
    position_admin: 165,
    label: "engine plate photo",
    group: "exteriors",
    description: "A photo showing the engine plate if present.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_plate_vehicle: {
    name: "photo_plate_vehicle",
    position: 270,
    position_admin: 310,
    label: "vehicle plate photo",
    group: "exteriors",
    description: "A photo showing the vehicle's plate.",
    requiredForToBeScrapped: !0,
    performTextInpaint: !1
  },
  // Interiors
  photo_plate_seats: {
    name: "photo_plate_seats",
    position: 280,
    position_admin: 320,
    label: "seat plate photo",
    group: "interiors",
    description: "A photo showing the seat plate inside the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_accessories_driver_microphone: {
    name: "photo_accessories_driver_microphone",
    position: 290,
    position_admin: 330,
    label: "driver microphone accessories photo",
    group: "interiors",
    description: "A photo showing the driver's microphone accessories in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_drive_seat: {
    name: "photo_drive_seat",
    position: 300,
    position_admin: 340,
    label: "driver's seat photo",
    group: "interiors",
    description: "A photo of the driver's seat.",
    requiredForToBeScrapped: !0,
    performTextInpaint: !1
  },
  photo_steering_wheel: {
    name: "photo_steering_wheel",
    position: 310,
    position_admin: 350,
    label: "steering wheel photo",
    group: "interiors",
    description: "A photo of the steering wheel in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_dashboard_on_for_number_km_and_lights_on: {
    name: "photo_dashboard_on_for_number_km_and_lights_on",
    position: 320,
    position_admin: 360,
    label: "dashboard lights on",
    group: "interiors",
    description: "A photo showing the dashboard with the vehicle's odometer reading and warning lights illuminated.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_buttons_e_panels_on: {
    name: "photo_buttons_e_panels_on",
    position: 330,
    position_admin: 370,
    label: "buttons panels on",
    group: "interiors",
    description: "A photo showing the vehicle's buttons and panels in an 'on' state.",
    requiredForToBeScrapped: !0,
    performTextInpaint: !1
  },
  photo_tachograph: {
    name: "photo_tachograph",
    position: 340,
    position_admin: 380,
    label: "Tachograph",
    group: "interiors",
    description: "A photo of the Tachograph.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_accessories_radio: {
    name: "photo_accessories_radio",
    position: 350,
    position_admin: 390,
    label: "radio accessories photo",
    group: "interiors",
    description: "A photo showing the radio accessories inside the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_any_devices_onboard_1: {
    name: "photo_any_devices_onboard_1",
    position: 360,
    position_admin: 400,
    label: "onboard devices 1",
    group: "interiors",
    description: "A photo of any onboard devices in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_any_devices_onboard_2: {
    name: "photo_any_devices_onboard_2",
    position: 370,
    position_admin: 410,
    label: "onboard devices 2",
    group: "interiors",
    description: "A photo of any onboard devices in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  control_unit_command_signs_indicators: {
    name: "control_unit_command_signs_indicators",
    position: 380,
    position_admin: 430,
    label: "command unit indicators",
    group: "interiors",
    description: "A photo of the control unit for signs and indicators.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_seat_hostess: {
    name: "photo_seat_hostess",
    position: 390,
    position_admin: 440,
    label: "hostess seat photo",
    group: "interiors",
    description: "A photo of the hostess seat in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_accessories_hostes_microphone: {
    name: "photo_accessories_hostes_microphone",
    position: 400,
    position_admin: 450,
    label: "hostes microphone accessories photo",
    group: "interiors",
    description: "A photo showing the hostes's microphone accessories in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_handrails: {
    name: "photo_handrails",
    position: 410,
    position_admin: 460,
    label: "handrails photo",
    group: "interiors",
    description: "A photo showing the handrails inside the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_door_mechanism_internal_photo: {
    name: "photo_door_mechanism_internal_photo",
    position: 420,
    position_admin: 470,
    label: "door mechanism photo",
    group: "interiors",
    description: "A photo of the internal door mechanism.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_interior_contromarcia_inquadrare_tutti_i_seats_height_seat_autista: {
    name: "photo_interior_contromarcia_inquadrare_tutti_i_seats_height_seat_autista",
    position: 430,
    position_admin: 480,
    label: "interior reverse seats driver height",
    group: "interiors",
    description: "A photo showing the interior seats in reverse view, including driver seat height.",
    requiredForToBeScrapped: !0,
    performTextInpaint: !1
  },
  photo_interior_reverse_view_from_middle_aisle: {
    name: "photo_interior_reverse_view_from_middle_aisle",
    position: 440,
    position_admin: 490,
    label: "reverse view middle aisle",
    group: "interiors",
    description: "A reverse view photo from the middle aisle of the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_interior_senso_di_marcia_inquadrare_tutti_i_seats_height_ultima_fila: {
    name: "photo_interior_senso_di_marcia_inquadrare_tutti_i_seats_height_ultima_fila",
    position: 450,
    position_admin: 500,
    label: "forward view all seats last row height",
    group: "interiors",
    description: "A forward view photo showing all seats, focusing on the height of the last row.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_overhead_compartments: {
    name: "photo_overhead_compartments",
    position: 460,
    position_admin: 510,
    label: "overhead compartments photo",
    group: "interiors",
    description: "A photo showing the overhead compartments inside the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_accessories_toilette: {
    name: "photo_accessories_toilette",
    position: 470,
    position_admin: 520,
    label: "toilette accessories photo",
    group: "interiors",
    description: "A photo showing the toilette accessories inside the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_interior_forward_view_from_middle_aisle: {
    name: "photo_interior_forward_view_from_middle_aisle",
    position: 480,
    position_admin: 530,
    label: "forward view middle aisle",
    group: "interiors",
    description: "A forward view photo from the middle aisle of the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_hatches_floor: {
    name: "photo_hatches_floor",
    position: 490,
    position_admin: 535,
    label: "floor hatches photo",
    group: "interiors",
    description: "A photo of the floor hatches in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_central_seat_with_safety_belt_fastened: {
    name: "photo_central_seat_with_safety_belt_fastened",
    position: 500,
    position_admin: 540,
    label: "central seat safety belt",
    group: "interiors",
    description: "A photo showing the central seat with the safety belt fastened.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  turntable_photo_internal_if_present_only_18mt: {
    name: "turntable_photo_internal_if_present_only_18mt",
    position: 510,
    position_admin: 550,
    label: "turntable internal (18m)",
    group: "interiors",
    description: "An internal photo of the turntable if present (only for 18 meters).",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_hatches_roof_1: {
    name: "photo_hatches_roof_1",
    position: 520,
    position_admin: 560,
    label: "roof hatch 1",
    group: "interiors",
    description: "A photo of the roof hatch number 1.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_hatches_roof_2: {
    name: "photo_hatches_roof_2",
    position: 530,
    position_admin: 570,
    label: "roof hatch 2",
    group: "interiors",
    description: "A photo of the roof hatch number 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_hatches_roof_3: {
    name: "photo_hatches_roof_3",
    position: 540,
    position_admin: 575,
    label: "roof hatch 3",
    group: "interiors",
    description: "A photo of the roof hatch number 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_disabled_area: {
    name: "photo_disabled_area",
    position: 550,
    position_admin: 580,
    label: "disabled area photo",
    group: "interiors",
    description: "A photo showing the designated disabled area in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_folding_seat: {
    name: "photo_folding_seat",
    position: 560,
    position_admin: 590,
    label: "folding seat photo",
    group: "interiors",
    description: "A photo showing the folding seat in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_detail_of_single_seat: {
    name: "photo_detail_of_single_seat",
    position: 570,
    position_admin: 620,
    label: "single seat detail",
    group: "interiors",
    description: "A detailed photo of a single seat in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_detail_of_mesh: {
    name: "photo_detail_of_mesh",
    position: 580,
    position_admin: 630,
    label: "mesh detail photo",
    group: "interiors",
    description: "A detailed photo of the mesh inside the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_table_detail: {
    name: "photo_table_detail",
    position: 590,
    position_admin: 640,
    label: "table detail photo",
    group: "interiors",
    description: "A detailed photo of the table inside the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_charging_usb_detail: {
    name: "photo_charging_usb_detail",
    position: 600,
    position_admin: 650,
    label: "usb charging detail",
    group: "interiors",
    description: "A detailed photo showing the USB charging ports.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_armrest_detail: {
    name: "photo_armrest_detail",
    position: 610,
    position_admin: 660,
    label: "armrest detail photo",
    group: "interiors",
    description: "A detailed photo of the armrest in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_footrest_detail: {
    name: "photo_footrest_detail",
    position: 620,
    position_admin: 670,
    label: "footrest detail photo",
    group: "interiors",
    description: "A detailed photo of the footrest in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_monitor_detail: {
    name: "photo_monitor_detail",
    position: 630,
    position_admin: 680,
    label: "monitor detail photo",
    group: "interiors",
    description: "A detailed photo of the monitor in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_outlets_di_current_detail: {
    name: "photo_outlets_di_current_detail",
    position: 640,
    position_admin: 690,
    label: "power outlets detail",
    group: "interiors",
    description: "A detailed photo of the power outlets in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_coffee_machine_accessories: {
    name: "photo_coffee_machine_accessories",
    position: 650,
    position_admin: 710,
    label: "coffee machine accessories",
    group: "interiors",
    description: "A photo of the coffee machine accessories in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_brackets_seats: {
    name: "photo_brackets_seats",
    position: 660,
    position_admin: 710,
    label: "seat brackets photo",
    group: "interiors",
    description: "A photo showing the seat brackets in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_accessories_cameras: {
    name: "photo_accessories_cameras",
    position: 670,
    position_admin: 720,
    label: "camera accessories photo",
    group: "interiors",
    description: "A photo showing the camera accessories inside the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  jack_e_keys_for_driver: {
    name: "jack_e_keys_for_driver",
    position: 680,
    position_admin: 730,
    label: "jack and driver keys",
    group: "interiors",
    description: "A photo showing the jack and keys for the driver.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  // Tire sizes
  spare_wheel: {
    name: "spare_wheel",
    position: 690,
    position_admin: 20,
    label: "spare wheel",
    group: "tire-sizes",
    description: "A photo of the spare wheel in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_tire_front_left_measurements: {
    name: "photo_tire_front_left_measurements",
    position: 700,
    position_admin: 50,
    label: "front left tire measurements",
    group: "tire-sizes",
    description: "A photo showing the measurements of the front left tire.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_tire_rear_left: {
    name: "photo_tire_rear_left",
    position: 710,
    position_admin: 110,
    label: "rear left tire photo",
    group: "tire-sizes",
    description: "A photo showing the rear left tire of the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_of_tires_with_tread_pattern_and_condition_front_right: {
    name: "photo_of_tires_with_tread_pattern_and_condition_front_right",
    position: 720,
    position_admin: 760,
    label: "tread condition front tires right",
    group: "tire-sizes",
    description: "A photo showing the tread pattern and condition of the front tires right.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_of_tires_with_tread_pattern_and_condition_front_left: {
    name: "photo_of_tires_with_tread_pattern_and_condition_front_left",
    position: 730,
    position_admin: 1190,
    label: "tread condition front tires left",
    group: "tire-sizes",
    description: "A photo showing the tread pattern and condition of the front tires left.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_of_tires_with_tread_pattern_and_condition_second_axle_left: {
    name: "photo_of_tires_with_tread_pattern_and_condition_second_axle_left",
    position: 740,
    position_admin: 1190,
    label: "tread condition second axle tires left",
    group: "tire-sizes",
    description: "A photo showing the tread pattern and condition of the second axle tires left.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_of_tires_with_tread_pattern_and_condition_second_axle_right: {
    name: "photo_of_tires_with_tread_pattern_and_condition_second_axle_right",
    position: 750,
    position_admin: 1200,
    label: "tread condition second axle tires right",
    group: "tire-sizes",
    description: "A photo showing the tread pattern and condition of the second axle tires right.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_of_tires_with_tread_pattern_and_condition_third_axle_left: {
    name: "photo_of_tires_with_tread_pattern_and_condition_third_axle_left",
    position: 760,
    position_admin: 1210,
    label: "tread condition third axle tires left",
    group: "tire-sizes",
    description: "A photo showing the tread pattern and condition of the third axle tires left.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_of_tires_with_tread_pattern_and_condition_third_axle_right: {
    name: "photo_of_tires_with_tread_pattern_and_condition_third_axle_right",
    position: 770,
    position_admin: 1220,
    label: "tread condition third axle tires right",
    group: "tire-sizes",
    description: "A photo showing the tread pattern and condition of the third axle tires right.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  // Undercarriage
  photo_undercarriage_front_part_from_front: {
    name: "photo_undercarriage_front_part_from_front",
    position: 780,
    position_admin: 740,
    label: "front undercarriage from front",
    group: "undercarriage",
    description: "A photo showing the front part of the undercarriage from the front.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_axle_front_side_right: {
    name: "photo_undercarriage_axle_front_side_right",
    position: 790,
    position_admin: 770,
    label: "front axle right side",
    group: "undercarriage",
    description: "A photo of the front axle from the right side of the undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_discs_right: {
    name: "photo_front_discs_right",
    position: 800,
    position_admin: 780,
    label: "front discs right",
    group: "undercarriage",
    description: "A photo of the right front brake discs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_brake_calipers_right: {
    name: "photo_front_brake_calipers_right",
    position: 810,
    position_admin: 790,
    label: "front brake calipers right",
    group: "undercarriage",
    description: "A photo of the right front brake calipers.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_shock_absorbers_if_separate_from_springs_right: {
    name: "photo_front_shock_absorbers_if_separate_from_springs_right",
    position: 820,
    position_admin: 800,
    label: "front shock absorbers right",
    group: "undercarriage",
    description: "A photo of the right front shock absorbers, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_air_springs_or_group_of_springs_and_shock_absorbers_right: {
    name: "photo_front_air_springs_or_group_of_springs_and_shock_absorbers_right",
    position: 830,
    position_admin: 810,
    label: "front air springs right",
    group: "undercarriage",
    description: "A photo of the right front air springs or group of springs and shock absorbers.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_axle_front_central: {
    name: "photo_undercarriage_axle_front_central",
    position: 840,
    position_admin: 820,
    label: "front axle central",
    group: "undercarriage",
    description: "A photo of the front axle from the central part of the undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_axle_front_side_left: {
    name: "photo_undercarriage_axle_front_side_left",
    position: 850,
    position_admin: 830,
    label: "front axle left side",
    group: "undercarriage",
    description: "A photo of the front axle from the left side of the undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_discs_left: {
    name: "photo_front_discs_left",
    position: 860,
    position_admin: 840,
    label: "front discs left",
    group: "undercarriage",
    description: "A photo of the left front brake discs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_brake_calipers_left: {
    name: "photo_front_brake_calipers_left",
    position: 870,
    position_admin: 850,
    label: "front brake calipers left",
    group: "undercarriage",
    description: "A photo of the left front brake calipers.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_shock_absorbers_if_separate_from_springs_left: {
    name: "photo_front_shock_absorbers_if_separate_from_springs_left",
    position: 880,
    position_admin: 860,
    label: "front shock absorbers left",
    group: "undercarriage",
    description: "A photo of the left front shock absorbers, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_air_springs_or_group_of_springs_and_shock_absorbers_left: {
    name: "photo_front_air_springs_or_group_of_springs_and_shock_absorbers_left",
    position: 890,
    position_admin: 870,
    label: "front air springs left",
    group: "undercarriage",
    description: "A photo of the left front air springs or group of springs and shock absorbers.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_central: {
    name: "photo_undercarriage_central",
    position: 900,
    position_admin: 880,
    label: "central undercarriage photo",
    group: "undercarriage",
    description: "A photo of the central part of the undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_discs_axle_central_right: {
    name: "photo_discs_axle_central_right",
    position: 910,
    position_admin: 890,
    label: "axle 2 discs right",
    group: "undercarriage",
    description: "A photo of the right brake discs on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_caliper_brakes_axle_central_right: {
    name: "photo_caliper_brakes_axle_central_right",
    position: 920,
    position_admin: 900,
    label: "axle 2 caliper brakes right",
    group: "undercarriage",
    description: "A photo of the right brake calipers on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_shock_absorbers_central_axle_if_separate_from_springs_right_1: {
    name: "photo_shock_absorbers_central_axle_if_separate_from_springs_right_1",
    position: 930,
    position_admin: 910,
    label: "axle 2 shock absorbers 1 right",
    group: "undercarriage",
    description: "A photo of the first right shock absorbers on the axle 2, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_shock_absorbers_central_axle_if_separate_from_springs_right_2: {
    name: "photo_shock_absorbers_central_axle_if_separate_from_springs_right_2",
    position: 940,
    position_admin: 920,
    label: "axle 2 shock absorbers 2 left",
    group: "undercarriage",
    description: "A photo of the second right shock absorbers on the axle 2, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_right_1: {
    name: "photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_right_1",
    position: 950,
    position_admin: 930,
    label: "axel 2 air springs 1 right",
    group: "undercarriage",
    description: "A photo of the first right air springs or group of springs and shock absorbers on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_right_2: {
    name: "photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_right_2",
    position: 960,
    position_admin: 940,
    label: "axel 2 air springs 2 right",
    group: "undercarriage",
    description: "A photo of the second right air springs or group of springs and shock absorbers on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_discs_axle_central_left: {
    name: "photo_discs_axle_central_left",
    position: 970,
    position_admin: 950,
    label: "axle 2 discs left",
    group: "undercarriage",
    description: "A photo of the left brake discs on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_caliper_brakes_axle_central_left: {
    name: "photo_caliper_brakes_axle_central_left",
    position: 980,
    position_admin: 960,
    label: "axle 2 caliper brakes left",
    group: "undercarriage",
    description: "A photo of the left brake calipers on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_shock_absorbers_central_axle_if_separate_from_springs_left_1: {
    name: "photo_shock_absorbers_central_axle_if_separate_from_springs_left_1",
    position: 990,
    position_admin: 970,
    label: "axle 2 shock absorbers 1 left",
    group: "undercarriage",
    description: "A photo of the first left shock absorbers on the axle 2, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_left_1: {
    name: "photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_left_1",
    position: 1e3,
    position_admin: 980,
    label: "axel 2 air springs 1 left",
    group: "undercarriage",
    description: "A photo of the first left air springs or group of springs and shock absorbers on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_shock_absorbers_central_axle_if_separate_from_springs_left_2: {
    name: "photo_shock_absorbers_central_axle_if_separate_from_springs_left_2",
    position: 1010,
    position_admin: 990,
    label: "axle 2 shock absorbers 2 left",
    group: "undercarriage",
    description: "A photo of the second left shock absorbers on the axle 2, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_left_2: {
    name: "photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_left_2",
    position: 1020,
    position_admin: 1e3,
    label: "axel 2 air springs 2 left",
    group: "undercarriage",
    description: "A photo of the second left air springs or group of springs and shock absorbers on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_axle_rear_central: {
    name: "photo_undercarriage_axle_rear_central",
    position: 1030,
    position_admin: 1010,
    label: "axle 3 central",
    group: "undercarriage",
    description: "A photo of the central part of the axle 3 undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_axle_rear_side_right: {
    name: "photo_undercarriage_axle_rear_side_right",
    position: 1040,
    position_admin: 1020,
    label: "axle 3 right side",
    group: "undercarriage",
    description: "A photo of the right side of the axle 3 undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_discs_rear_right: {
    name: "photo_discs_rear_right",
    position: 1050,
    position_admin: 1030,
    label: "axel 3  discs right",
    group: "undercarriage",
    description: "A photo of the right brake discs axle 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_caliper_brakes_rear_right: {
    name: "photo_caliper_brakes_rear_right",
    position: 1060,
    position_admin: 1040,
    label: "axel 3 caliper brakes right",
    group: "undercarriage",
    description: "A photo of the right caliper brakes axle 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_shock_absorbers_right_1: {
    name: "photo_rear_shock_absorbers_right_1",
    position: 1070,
    position_admin: 1050,
    label: "axel 3 shock absorbers 1 right",
    group: "undercarriage",
    description: "A photo of the right shock absorbers (position 1) axel 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_air_springs_if_present_right_1: {
    name: "photo_rear_air_springs_if_present_right_1",
    position: 1080,
    position_admin: 1060,
    label: "axle 3 air springs 1 right",
    group: "undercarriage",
    description: "A photo of the right air springs if present (position 1) axel 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_shock_absorbers_right_2: {
    name: "photo_rear_shock_absorbers_right_2",
    position: 1090,
    position_admin: 1070,
    label: "axel 3 shock absorbers 2 right",
    group: "undercarriage",
    description: "A photo of the right shock absorbers (position 2) axel 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_air_springs_if_present_right_2: {
    name: "photo_rear_air_springs_if_present_right_2",
    position: 1100,
    position_admin: 1080,
    label: "axle 3 air springs 2 right",
    group: "undercarriage",
    description: "A photo of the right air springs if present (position 2) axel 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_leaf_spring_if_present_right: {
    name: "photo_rear_leaf_spring_if_present_right",
    position: 1110,
    position_admin: 1090,
    label: "axel 2 leaf spring right",
    group: "undercarriage",
    description: "A photo of the right leaf spring if present axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_axle_rear_side_left: {
    name: "photo_undercarriage_axle_rear_side_left",
    position: 1120,
    position_admin: 1100,
    label: "axle 3 left side",
    group: "undercarriage",
    description: "A photo of the left side of the axle 3 undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_discs_rear_left: {
    name: "photo_discs_rear_left",
    position: 1130,
    position_admin: 1110,
    label: "axel 3 discs left",
    group: "undercarriage",
    description: "A photo of the left brake discs axle 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_caliper_brakes_rear_left: {
    name: "photo_caliper_brakes_rear_left",
    position: 1140,
    position_admin: 1120,
    label: "axel 3 caliper brakes left",
    group: "undercarriage",
    description: "A photo of the left caliper brakes axle 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_shock_absorbers_left_1: {
    name: "photo_rear_shock_absorbers_left_1",
    position: 1150,
    position_admin: 1130,
    label: "axel 3 shock absorbers 1 left",
    group: "undercarriage",
    description: "A photo of the left shock absorbers (position 1) axel 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_shock_absorbers_left_2: {
    name: "photo_rear_shock_absorbers_left_2",
    position: 1160,
    position_admin: 1140,
    label: "axel 3 shock absorbers 2 left",
    group: "undercarriage",
    description: "A photo of the left shock absorbers (position 2) axel 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_air_springs_if_present_left_1: {
    name: "photo_rear_air_springs_if_present_left_1",
    position: 1170,
    position_admin: 1150,
    label: "axle 3 air springs 1 left",
    group: "undercarriage",
    description: "A photo of the left air springs if present (position 1) axle 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_air_springs_if_present_left_2: {
    name: "photo_rear_air_springs_if_present_left_2",
    position: 1180,
    position_admin: 1160,
    label: "axle 3 air springs 2 left",
    group: "undercarriage",
    description: "A photo of the left rear air springs if present (position 2).",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_leaf_spring_if_present_left: {
    name: "photo_rear_leaf_spring_if_present_left",
    position: 1190,
    position_admin: 1170,
    label: "axel 3 leaf spring left",
    group: "undercarriage",
    description: "A photo of the left leaf spring if present. Axle 3",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_differential: {
    name: "photo_differential",
    position: 1200,
    position_admin: 1180,
    label: "differential photo",
    group: "undercarriage",
    description: "A photo of the vehicle's differential.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_gearbox: {
    name: "photo_gearbox",
    position: 1210,
    position_admin: 1230,
    label: "gearbox photo",
    group: "undercarriage",
    description: "A photo of the vehicle's gearbox.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_plate_gearbox: {
    name: "photo_plate_gearbox",
    position: 1220,
    position_admin: 1240,
    label: "gearbox plate photo",
    group: "undercarriage",
    description: "A photo of the vehicle's gearbox plate.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_driveshaft: {
    name: "photo_driveshaft",
    position: 1230,
    position_admin: 1250,
    label: "driveshaft photo",
    group: "undercarriage",
    description: "A photo of the vehicle's driveshaft.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_engine_below_without_protection: {
    name: "photo_engine_below_without_protection",
    position: 1240,
    position_admin: 1260,
    label: "engine without protection",
    group: "undercarriage",
    description: "A photo showing the engine from below without any protection.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_exhaust: {
    name: "photo_exhaust",
    position: 1250,
    position_admin: 1270,
    label: "exhaust photo",
    group: "undercarriage",
    description: "A photo showing the vehicle's exhaust.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_axle_central_18_meters: {
    name: "photo_axle_central_18_meters",
    position: 1260,
    position_admin: 1280,
    label: "central axle (18m)",
    group: "undercarriage",
    description: "A photo of the central axle for 18-meter vehicles.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_bellows_turntable_18_meters: {
    name: "photo_bellows_turntable_18_meters",
    position: 1270,
    position_admin: 1290,
    label: "bellows turntable (18m)",
    group: "undercarriage",
    description: "A photo showing the bellows of the turntable for 18-meter vehicles.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  // Technical Data
  photo_chassis_vin: {
    name: "photo_chassis_vin",
    position: 1280,
    position_admin: 1300,
    label: "chassis VIN photo",
    group: "technical-data",
    description: "A photo of the vehicle's chassis VIN.",
    requiredForToBeScrapped: !0,
    performTextInpaint: !1
  },
  photo_any_devices_onboard_3: {
    name: "photo_any_devices_onboard_3",
    position: 1290,
    position_admin: 1310,
    label: "onboard devices 3",
    group: "technical-data",
    description: "A photo of any onboard devices in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  }
}, y1 = {
  photo_cover_base: {
    name: "photo_cover_base",
    position: 2e3,
    position_admin: 2e3,
    label: "Base cover photo",
    group: "cover",
    description: "The photo displayed in the listing page (default: photo_3_4_front_side_right_doors_closed)",
    performTextInpaint: !0
  },
  photo_cover_hover: {
    name: "photo_cover_hover",
    position: 2010,
    position_admin: 2010,
    label: "Hover cover photo",
    group: "cover",
    description: "The photo usually on mouse hover in the listing page, (default: photo_front)",
    performTextInpaint: !0
  }
}, YS = [
  {
    name: "Baden-Württemberg",
    code: "DE-BW",
    provinces: [{ name: "Baden-Württemberg", code: "BW" }]
  },
  {
    name: "Bayern",
    code: "DE-BY",
    provinces: [{ name: "Bayern", code: "BY" }]
  },
  {
    name: "Berlin",
    code: "DE-BE",
    provinces: [{ name: "Berlin", code: "BE" }]
  },
  {
    name: "Brandenburg",
    code: "DE-BB",
    provinces: [{ name: "Brandenburg", code: "BB" }]
  },
  {
    name: "Bremen",
    code: "DE-HB",
    provinces: [{ name: "Bremen", code: "HB" }]
  },
  {
    name: "Hamburg",
    code: "DE-HH",
    provinces: [{ name: "Hamburg", code: "HH" }]
  },
  {
    name: "Hessen",
    code: "DE-HE",
    provinces: [{ name: "Hessen", code: "HE" }]
  },
  {
    name: "Mecklenburg-Vorpommern",
    code: "DE-MV",
    provinces: [{ name: "Mecklenburg-Vorpommern", code: "MV" }]
  },
  {
    name: "Niedersachsen",
    code: "DE-NI",
    provinces: [{ name: "Niedersachsen", code: "NI" }]
  },
  {
    name: "Nordrhein-Westfalen",
    code: "DE-NW",
    provinces: [{ name: "Nordrhein-Westfalen", code: "NW" }]
  },
  {
    name: "Rheinland-Pfalz",
    code: "DE-RP",
    provinces: [{ name: "Rheinland-Pfalz", code: "RP" }]
  },
  {
    name: "Saarland",
    code: "DE-SL",
    provinces: [{ name: "Saarland", code: "SL" }]
  },
  {
    name: "Sachsen",
    code: "DE-SN",
    provinces: [{ name: "Sachsen", code: "SN" }]
  },
  {
    name: "Sachsen-Anhalt",
    code: "DE-ST",
    provinces: [{ name: "Sachsen-Anhalt", code: "ST" }]
  },
  {
    name: "Schleswig-Holstein",
    code: "DE-SH",
    provinces: [{ name: "Schleswig-Holstein", code: "SH" }]
  },
  {
    name: "Thüringen",
    code: "DE-TH",
    provinces: [{ name: "Thüringen", code: "TH" }]
  }
], XS = [
  {
    name: "Abruzzo",
    code: "IT-65",
    provinces: [
      { name: "L'Aquila", code: "AQ" },
      { name: "Chieti", code: "CH" },
      { name: "Pescara", code: "PE" },
      { name: "Teramo", code: "TE" }
    ]
  },
  {
    name: "Basilicata",
    code: "IT-77",
    provinces: [
      { name: "Matera", code: "MT" },
      { name: "Potenza", code: "PZ" }
    ]
  },
  {
    name: "Calabria",
    code: "IT-78",
    provinces: [
      { name: "Cosenza", code: "CS" },
      { name: "Catanzaro", code: "CZ" },
      { name: "Crotone", code: "KR" },
      { name: "Reggio Calabria", code: "RC" },
      { name: "Vibo Valentia", code: "VV" }
    ]
  },
  {
    name: "Campania",
    code: "IT-72",
    provinces: [
      { name: "Avellino", code: "AV" },
      { name: "Benevento", code: "BN" },
      { name: "Caserta", code: "CE" },
      { name: "Napoli", code: "NA" },
      { name: "Salerno", code: "SA" }
    ]
  },
  {
    name: "Emilia-Romagna",
    code: "IT-45",
    provinces: [
      { name: "Bologna", code: "BO" },
      { name: "Forlì-Cesena", code: "FC" },
      { name: "Ferrara", code: "FE" },
      { name: "Modena", code: "MO" },
      { name: "Piacenza", code: "PC" },
      { name: "Parma", code: "PR" },
      { name: "Ravenna", code: "RA" },
      { name: "Reggio Emilia", code: "RE" },
      { name: "Rimini", code: "RN" }
    ]
  },
  {
    name: "Friuli-Venezia Giulia",
    code: "IT-36",
    provinces: [
      { name: "Gorizia", code: "GO" },
      { name: "Pordenone", code: "PN" },
      { name: "Trieste", code: "TS" },
      { name: "Udine", code: "UD" }
    ]
  },
  {
    name: "Lazio",
    code: "IT-62",
    provinces: [
      { name: "Frosinone", code: "FR" },
      { name: "Latina", code: "LT" },
      { name: "Rieti", code: "RI" },
      { name: "Roma", code: "RM" },
      { name: "Viterbo", code: "VT" }
    ]
  },
  {
    name: "Liguria",
    code: "IT-42",
    provinces: [
      { name: "Genova", code: "GE" },
      { name: "Imperia", code: "IM" },
      { name: "La Spezia", code: "SP" },
      { name: "Savona", code: "SV" }
    ]
  },
  {
    name: "Lombardia",
    code: "IT-25",
    provinces: [
      { name: "Bergamo", code: "BG" },
      { name: "Brescia", code: "BS" },
      { name: "Como", code: "CO" },
      { name: "Cremona", code: "CR" },
      { name: "Lecco", code: "LC" },
      { name: "Lodi", code: "LO" },
      { name: "Monza e della Brianza", code: "MB" },
      { name: "Milano", code: "MI" },
      { name: "Mantova", code: "MN" },
      { name: "Pavia", code: "PV" },
      { name: "Sondrio", code: "SO" },
      { name: "Varese", code: "VA" }
    ]
  },
  {
    name: "Marche",
    code: "IT-57",
    provinces: [
      { name: "Ancona", code: "AN" },
      { name: "Ascoli Piceno", code: "AP" },
      { name: "Fermo", code: "FM" },
      { name: "Macerata", code: "MC" },
      { name: "Pesaro e Urbino", code: "PU" }
    ]
  },
  {
    name: "Molise",
    code: "IT-67",
    provinces: [
      { name: "Campobasso", code: "CB" },
      { name: "Isernia", code: "IS" }
    ]
  },
  {
    name: "Piemonte",
    code: "IT-21",
    provinces: [
      { name: "Alessandria", code: "AL" },
      { name: "Asti", code: "AT" },
      { name: "Biella", code: "BI" },
      { name: "Cuneo", code: "CN" },
      { name: "Novara", code: "NO" },
      { name: "Torino", code: "TO" },
      { name: "Verbano-Cusio-Ossola", code: "VB" },
      { name: "Vercelli", code: "VC" }
    ]
  },
  {
    name: "Puglia",
    code: "IT-75",
    provinces: [
      { name: "Bari", code: "BA" },
      { name: "Brindisi", code: "BR" },
      { name: "Barletta-Andria-Trani", code: "BT" },
      { name: "Foggia", code: "FG" },
      { name: "Lecce", code: "LE" },
      { name: "Taranto", code: "TA" }
    ]
  },
  {
    name: "Sardegna",
    code: "IT-88",
    provinces: [
      { name: "Cagliari", code: "CA" },
      { name: "Nuoro", code: "NU" },
      { name: "Oristano", code: "OR" },
      { name: "Sassari", code: "SS" },
      { name: "Carbonia-Iglesias", code: "CI" },
      { name: "Olbia-Tempio", code: "OT" },
      { name: "Medio Campidano", code: "VS" },
      { name: "Ogliastra", code: "OG" }
    ]
  },
  {
    name: "Sicilia",
    code: "IT-82",
    provinces: [
      { name: "Agrigento", code: "AG" },
      { name: "Caltanissetta", code: "CL" },
      { name: "Catania", code: "CT" },
      { name: "Enna", code: "EN" },
      { name: "Messina", code: "ME" },
      { name: "Palermo", code: "PA" },
      { name: "Ragusa", code: "RG" },
      { name: "Siracusa", code: "SR" },
      { name: "Trapani", code: "TP" }
    ]
  },
  {
    name: "Toscana",
    code: "IT-52",
    provinces: [
      { name: "Arezzo", code: "AR" },
      { name: "Firenze", code: "FI" },
      { name: "Grosseto", code: "GR" },
      { name: "Livorno", code: "LI" },
      { name: "Lucca", code: "LU" },
      { name: "Massa-Carrara", code: "MS" },
      { name: "Pisa", code: "PI" },
      { name: "Prato", code: "PO" },
      { name: "Pistoia", code: "PT" },
      { name: "Siena", code: "SI" }
    ]
  },
  {
    name: "Trentino-Alto Adige, Trentino-Südtirol",
    code: "IT-32",
    provinces: [
      { name: "Bolzano", code: "BZ" },
      { name: "Trento", code: "TN" }
    ]
  },
  {
    name: "Umbria",
    code: "IT-55",
    provinces: [
      { name: "Perugia", code: "PG" },
      { name: "Terni", code: "TR" }
    ]
  },
  { name: "Valle d'Aosta, Vallée d'Aoste", code: "IT-23", provinces: [{ name: "Aosta", code: "AO" }] },
  {
    name: "Veneto",
    code: "IT-34",
    provinces: [
      { name: "Belluno", code: "BL" },
      { name: "Padova", code: "PD" },
      { name: "Rovigo", code: "RO" },
      { name: "Treviso", code: "TV" },
      { name: "Venezia", code: "VE" },
      { name: "Vicenza", code: "VI" },
      { name: "Verona", code: "VR" }
    ]
  }
], QS = [
  {
    name: "Dolnośląskie",
    code: "PL-02",
    provinces: [{ name: "Dolnośląskie", code: "DS" }]
  },
  {
    name: "Kujawsko-Pomorskie",
    code: "PL-04",
    provinces: [{ name: "Kujawsko-Pomorskie", code: "KP" }]
  },
  {
    name: "Lubelskie",
    code: "PL-06",
    provinces: [{ name: "Lubelskie", code: "LU" }]
  },
  {
    name: "Lubuskie",
    code: "PL-08",
    provinces: [{ name: "Lubuskie", code: "LB" }]
  },
  {
    name: "Łódzkie",
    code: "PL-10",
    provinces: [{ name: "Łódzkie", code: "LD" }]
  },
  {
    name: "Małopolskie",
    code: "PL-12",
    provinces: [{ name: "Małopolskie", code: "MP" }]
  },
  {
    name: "Mazowieckie",
    code: "PL-14",
    provinces: [{ name: "Mazowieckie", code: "MZ" }]
  },
  {
    name: "Opolskie",
    code: "PL-16",
    provinces: [{ name: "Opolskie", code: "OP" }]
  },
  {
    name: "Podkarpackie",
    code: "PL-18",
    provinces: [{ name: "Podkarpackie", code: "PK" }]
  },
  {
    name: "Podlaskie",
    code: "PL-20",
    provinces: [{ name: "Podlaskie", code: "PD" }]
  },
  {
    name: "Pomorskie",
    code: "PL-22",
    provinces: [{ name: "Pomorskie", code: "PM" }]
  },
  {
    name: "Śląskie",
    code: "PL-24",
    provinces: [{ name: "Śląskie", code: "SL" }]
  },
  {
    name: "Świętokrzyskie",
    code: "PL-26",
    provinces: [{ name: "Świętokrzyskie", code: "SK" }]
  },
  {
    name: "Warmińsko-Mazurskie",
    code: "PL-28",
    provinces: [{ name: "Warmińsko-Mazurskie", code: "WM" }]
  },
  {
    name: "Wielkopolskie",
    code: "PL-30",
    provinces: [{ name: "Wielkopolskie", code: "WP" }]
  },
  {
    name: "Zachodniopomorskie",
    code: "PL-32",
    provinces: [{ name: "Zachodniopomorskie", code: "ZP" }]
  }
], e1 = [
  {
    name: "Andalucía",
    code: "ES-AN",
    provinces: [
      { name: "Almería", code: "AL" },
      { name: "Cádiz", code: "CA" },
      { name: "Córdoba", code: "CO" },
      { name: "Granada", code: "GR" },
      { name: "Huelva", code: "H" },
      { name: "Jaén", code: "J" },
      { name: "Málaga", code: "MA" },
      { name: "Sevilla", code: "SE" }
    ]
  },
  {
    name: "Aragón",
    code: "ES-AR",
    provinces: [
      { name: "Huesca", code: "HU" },
      { name: "Teruel", code: "TE" },
      { name: "Zaragoza", code: "Z" }
    ]
  },
  {
    name: "Asturias",
    code: "ES-AS",
    provinces: [{ name: "Asturias", code: "AS" }]
  },
  {
    name: "Islas Baleares",
    code: "ES-IB",
    provinces: [{ name: "Islas Baleares", code: "IB" }]
  },
  {
    name: "País Vasco",
    code: "ES-PV",
    provinces: [
      { name: "Álava", code: "VI" },
      { name: "Bizkaia", code: "BI" },
      { name: "Gipuzkoa", code: "SS" }
    ]
  },
  {
    name: "Canarias",
    code: "ES-CN",
    provinces: [
      { name: "Las Palmas", code: "GC" },
      { name: "Santa Cruz de Tenerife", code: "TF" }
    ]
  },
  {
    name: "Cantabria",
    code: "ES-CB",
    provinces: [{ name: "Cantabria", code: "CB" }]
  },
  {
    name: "Castilla y León",
    code: "ES-CL",
    provinces: [
      { name: "Ávila", code: "AV" },
      { name: "Burgos", code: "BU" },
      { name: "León", code: "LE" },
      { name: "Palencia", code: "P" },
      { name: "Salamanca", code: "SA" },
      { name: "Segovia", code: "SG" },
      { name: "Soria", code: "SO" },
      { name: "Valladolid", code: "VA" },
      { name: "Zamora", code: "ZA" }
    ]
  },
  {
    name: "Castilla-La Mancha",
    code: "ES-CM",
    provinces: [
      { name: "Albacete", code: "AB" },
      { name: "Ciudad Real", code: "CR" },
      { name: "Cuenca", code: "CU" },
      { name: "Guadalajara", code: "GU" },
      { name: "Toledo", code: "TO" }
    ]
  },
  {
    name: "Cataluña",
    code: "ES-CT",
    provinces: [
      { name: "Barcelona", code: "B" },
      { name: "Girona", code: "GI" },
      { name: "Lleida", code: "L" },
      { name: "Tarragona", code: "T" }
    ]
  },
  {
    name: "Extremadura",
    code: "ES-EX",
    provinces: [
      { name: "Badajoz", code: "BA" },
      { name: "Cáceres", code: "CC" }
    ]
  },
  {
    name: "Galicia",
    code: "ES-GA",
    provinces: [
      { name: "A Coruña", code: "C" },
      { name: "Lugo", code: "LU" },
      { name: "Ourense", code: "OR" },
      { name: "Pontevedra", code: "PO" }
    ]
  },
  {
    name: "La Rioja",
    code: "ES-RI",
    provinces: [{ name: "La Rioja", code: "RI" }]
  },
  {
    name: "Comunidad de Madrid",
    code: "ES-MD",
    provinces: [{ name: "Madrid", code: "MD" }]
  },
  {
    name: "Región de Murcia",
    code: "ES-MC",
    provinces: [{ name: "Murcia", code: "MC" }]
  },
  {
    name: "Navarra",
    code: "ES-NC",
    provinces: [{ name: "Navarra", code: "NC" }]
  },
  {
    name: "Comunidad Valenciana",
    code: "ES-VC",
    provinces: [
      { name: "Alicante", code: "A" },
      { name: "Castellón", code: "CS" },
      { name: "Valencia", code: "V" }
    ]
  },
  {
    name: "Ceuta",
    code: "ES-CE",
    provinces: [{ name: "Ceuta", code: "CE" }]
  },
  {
    name: "Melilla",
    code: "ES-ML",
    provinces: [{ name: "Melilla", code: "ML" }]
  }
], ki = {
  AD: {
    i18nNames: {
      en: "Andorra",
      it: "Andorra",
      es: "Andorra",
      de: "Andorra",
      pl: "Andora",
      fr: "Andorre",
      nl: "Andorra",
      pt: "Andorra",
      cs: "Andorra",
      ro: "Andorra",
      ru: "Андорра"
    },
    rootIddCode: "+376",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^[A-Z]-\\d{6}-[A-Z]$",
    taxIdExample: "X-123456-Y"
  },
  AE: {
    i18nNames: {
      en: "United Arab Emirates",
      es: "Emiratos Árabes Unidos",
      it: "Emirati Arabi Uniti",
      de: "Vereinigte Arabische Emirate",
      pl: "Zjednoczone Emiraty Arabskie",
      fr: "Émirats arabes unis",
      nl: "Verenigde Arabische Emiraten",
      pt: "Emirados Árabes Unidos",
      cs: "Spojené arabské emiráty",
      ro: "Emiratele Arabe Unite",
      ru: "Объединённые Арабские Эмираты"
    },
    rootIddCode: "+971",
    continent: "Asia",
    taxIdMandatory: !1,
    taxIdPattern: "^\\d{15}$",
    taxIdExample: "123456789012345"
  },
  AF: {
    i18nNames: {
      en: "Afghanistan",
      it: "Afghanistan",
      es: "Afganistán",
      de: "Afghanistan",
      pl: "Afganistan",
      fr: "Afghanistan",
      nl: "Afghanistan",
      pt: "Afeganistão",
      cs: "Afghánistán",
      ro: "Afganistan",
      ru: "Афганистан"
    },
    rootIddCode: "+93",
    continent: "Asia"
  },
  AG: {
    i18nNames: {
      en: "Antigua and Barbuda",
      es: "Antigua y Barbuda",
      it: "Antigua e Barbuda",
      de: "Antigua und Barbuda",
      pl: "Antigua i Barbuda",
      fr: "Antigua-et-Barbuda",
      nl: "Antigua en Barbuda",
      pt: "Antígua e Barbuda",
      cs: "Antigua a Barbuda",
      ro: "Antigua și Barbuda",
      ru: "Антигуа и Барбуда"
    },
    rootIddCode: "+1268",
    continent: "NorthAmerica"
  },
  AI: {
    i18nNames: {
      en: "Anguilla",
      it: "Anguilla",
      es: "Anguila",
      de: "Anguilla",
      pl: "Anguilla",
      fr: "Anguilla",
      nl: "Anguilla",
      pt: "Anguila",
      cs: "Anguilla",
      ro: "Anguilla",
      ru: "Ангилья"
    },
    rootIddCode: "+1264",
    continent: "NorthAmerica"
  },
  AL: {
    i18nNames: {
      en: "Albania",
      it: "Albania",
      es: "Albania",
      de: "Albanien",
      pl: "Albania",
      fr: "Albanie",
      nl: "Albanië",
      pt: "Albânia",
      cs: "Albánie",
      ro: "Albania",
      ru: "Албания"
    },
    rootIddCode: "+355",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^[JKLM]\\d{8}[A-Z]$",
    taxIdExample: "J12345678K"
  },
  AM: {
    i18nNames: {
      en: "Armenia",
      it: "Armenia",
      es: "Armenia",
      de: "Armenien",
      pl: "Armenia",
      fr: "Arménie",
      nl: "Armenië",
      pt: "Arménia",
      cs: "Arménie",
      ro: "Armenia",
      ru: "Армения"
    },
    rootIddCode: "+374",
    continent: "Asia"
  },
  AO: {
    i18nNames: {
      en: "Angola",
      it: "Angola",
      es: "Angola",
      de: "Angola",
      pl: "Angola",
      fr: "Angola",
      nl: "Angola",
      pt: "Angola",
      cs: "Angola",
      ro: "Angola",
      ru: "Ангола"
    },
    rootIddCode: "+244",
    continent: "Africa"
  },
  AQ: {
    i18nNames: {
      en: "Antarctica",
      it: "Antartide",
      es: "Antártida",
      de: "Antarktis",
      pl: "Antarktyka",
      fr: "Antarctique",
      nl: "Antarctica",
      pt: "Antártica",
      cs: "Antarktida",
      ro: "Antarctica",
      ru: "Антарктида"
    },
    rootIddCode: "undefined",
    continent: "Antarctica"
  },
  AR: {
    i18nNames: {
      en: "Argentina",
      it: "Argentina",
      es: "Argentina",
      de: "Argentinien",
      pl: "Argentyna",
      fr: "Argentine",
      nl: "Argentinië",
      pt: "Argentina",
      cs: "Argentina",
      ro: "Argentina",
      ru: "Аргентина"
    },
    rootIddCode: "+54",
    continent: "SouthAmerica"
  },
  AS: {
    i18nNames: {
      en: "American Samoa",
      it: "Samoa Americane",
      es: "Samoa Americana",
      de: "Amerikanisch-Samoa",
      pl: "Samoa Amerykańskie",
      fr: "Samoa américaines",
      nl: "Amerikaans-Samoa",
      pt: "Samoa Americana",
      cs: "Americká Samoa",
      ro: "Samoa Americană",
      ru: "Американское Самоа"
    },
    rootIddCode: "+1684",
    continent: "Oceania"
  },
  AT: {
    i18nNames: {
      en: "Austria",
      it: "Austria",
      es: "Austria",
      de: "Österreich",
      pl: "Austria",
      fr: "Autriche",
      nl: "Oostenrijk",
      pt: "Áustria",
      cs: "Rakousko",
      ro: "Austria",
      ru: "Австрия"
    },
    rootIddCode: "+43",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !1,
    taxIdPattern: "^ATU\\d{8}$",
    taxIdExample: "ATU12345678"
  },
  AU: {
    i18nNames: {
      en: "Australia",
      it: "Australia",
      es: "Australia",
      de: "Australien",
      pl: "Australia",
      fr: "Australie",
      nl: "Australië",
      pt: "Austrália",
      cs: "Austrálie",
      ro: "Australia",
      ru: "Австралия"
    },
    rootIddCode: "+61",
    continent: "Oceania"
  },
  AW: {
    i18nNames: {
      en: "Aruba",
      it: "Aruba",
      es: "Aruba",
      de: "Aruba",
      pl: "Aruba",
      fr: "Aruba",
      nl: "Aruba",
      pt: "Aruba",
      cs: "Aruba",
      ro: "Aruba",
      ru: "Аруба"
    },
    rootIddCode: "+297",
    continent: "NorthAmerica"
  },
  AX: {
    i18nNames: {
      en: "Åland Islands",
      it: "Isole Aland",
      es: "Islas Åland",
      de: "Ålandinseln",
      pl: "Wyspy Alandzkie",
      fr: "Îles Åland",
      nl: "Ålandeilanden",
      pt: "Ilhas Åland",
      cs: "Ålandské ostrovy",
      ro: "Insulele Åland",
      ru: "Аландские острова"
    },
    rootIddCode: "+35818",
    continent: "Europe",
    blocMemberships: ["EU"]
  },
  AZ: {
    i18nNames: {
      en: "Azerbaijan",
      it: "Azerbaijan",
      es: "Azerbaiyán",
      de: "Aserbaidschan",
      pl: "Azerbejdżan",
      fr: "Azerbaïdjan",
      nl: "Azerbeidzjan",
      pt: "Azerbaijão",
      cs: "Ázerbájdžán",
      ro: "Azerbaidjan",
      ru: "Азербайджан"
    },
    rootIddCode: "+994",
    continent: "Asia"
  },
  BB: {
    i18nNames: {
      en: "Barbados",
      it: "Barbados",
      es: "Barbados",
      de: "Barbados",
      pl: "Barbados",
      fr: "Barbade",
      nl: "Barbados",
      pt: "Barbados",
      cs: "Barbados",
      ro: "Barbados",
      ru: "Барбадос"
    },
    rootIddCode: "+1246",
    continent: "NorthAmerica"
  },
  BD: {
    i18nNames: {
      en: "Bangladesh",
      it: "Bangladesh",
      es: "Bangladés",
      de: "Bangladesch",
      pl: "Bangladesz",
      fr: "Bangladesh",
      nl: "Bangladesh",
      pt: "Bangladesh",
      cs: "Bangladéš",
      ro: "Bangladesh",
      ru: "Бангладеш"
    },
    rootIddCode: "+880",
    continent: "Asia"
  },
  BE: {
    i18nNames: {
      en: "Belgium",
      it: "Belgio",
      es: "Bélgica",
      de: "Belgien",
      pl: "Belgia",
      fr: "Belgique",
      nl: "België",
      pt: "Bélgica",
      cs: "Belgie",
      ro: "Belgia",
      ru: "Бельгия"
    },
    rootIddCode: "+32",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^BE\\d{10}$",
    taxIdExample: "BE0123456789"
  },
  BF: {
    i18nNames: {
      en: "Burkina Faso",
      it: "Burkina Faso",
      es: "Burkina Faso",
      de: "Burkina Faso",
      pl: "Burkina Faso",
      fr: "Burkina Faso",
      nl: "Burkina Faso",
      pt: "Burquina Faso",
      cs: "Burkina Faso",
      ro: "Burkina Faso",
      ru: "Буркина-Фасо"
    },
    rootIddCode: "+226",
    continent: "Africa"
  },
  BG: {
    i18nNames: {
      en: "Bulgaria",
      it: "Bulgaria",
      es: "Bulgaria",
      de: "Bulgarien",
      pl: "Bułgaria",
      fr: "Bulgarie",
      nl: "Bulgarije",
      pt: "Bulgária",
      cs: "Bulharsko",
      ro: "Bulgaria",
      ru: "Болгария"
    },
    rootIddCode: "+359",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^BG(\\d{9}|\\d{10})$",
    taxIdExample: "BG123456789"
  },
  BH: {
    i18nNames: {
      en: "Bahrain",
      it: "Bahrein",
      es: "Baréin",
      de: "Bahrain",
      pl: "Bahrajn",
      fr: "Bahreïn",
      nl: "Bahrein",
      pt: "Bahrein",
      cs: "Bahrajn",
      ro: "Bahrein",
      ru: "Бахрейн"
    },
    rootIddCode: "+973",
    continent: "Asia",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{15}$",
    taxIdExample: "123456789012345"
  },
  BI: {
    i18nNames: {
      en: "Burundi",
      it: "Burundi",
      es: "Burundi",
      de: "Burundi",
      pl: "Burundi",
      fr: "Burundi",
      nl: "Burundi",
      pt: "Burundi",
      cs: "Burundi",
      ro: "Burundi",
      ru: "Бурунди"
    },
    rootIddCode: "+257",
    continent: "Africa"
  },
  BJ: {
    i18nNames: {
      en: "Benin",
      it: "Benin",
      es: "Benín",
      de: "Benin",
      pl: "Benin",
      fr: "Bénin",
      nl: "Benin",
      pt: "Benim",
      cs: "Benin",
      ro: "Benin",
      ru: "Бенин"
    },
    rootIddCode: "+229",
    continent: "Africa"
  },
  BL: {
    i18nNames: {
      en: "Saint Barthélemy",
      es: "San Bartolomé",
      it: "Antille Francesi",
      de: "Saint-Barthélemy",
      pl: "Saint-Barthélemy",
      fr: "Saint-Barthélemy",
      nl: "Saint-Barthélemy",
      pt: "São Bartolomeu",
      cs: "Svatý Bartoloměj",
      ro: "Sfântul Bartolomeu",
      ru: "Сен-Бартелеми"
    },
    rootIddCode: "+590",
    continent: "NorthAmerica"
  },
  BM: {
    i18nNames: {
      en: "Bermuda",
      it: "Bermuda",
      es: "Bermudas",
      de: "Bermuda",
      pl: "Bermudy",
      fr: "Bermudes",
      nl: "Bermuda",
      pt: "Bermudas",
      cs: "Bermudy",
      ro: "Bermuda",
      ru: "Бермуды"
    },
    rootIddCode: "+1441",
    continent: "NorthAmerica"
  },
  BN: {
    i18nNames: {
      en: "Brunei",
      it: "Brunei",
      es: "Brunéi",
      de: "Brunei",
      pl: "Brunei",
      fr: "Brunei",
      nl: "Brunei",
      pt: "Brunei",
      cs: "Brunej",
      ro: "Brunei",
      ru: "Бруней"
    },
    rootIddCode: "+673",
    continent: "Asia"
  },
  BO: {
    i18nNames: {
      en: "Bolivia",
      it: "Bolivia",
      es: "Bolivia",
      de: "Bolivien",
      pl: "Boliwia",
      fr: "Bolivie",
      nl: "Bolivia",
      pt: "Bolívia",
      cs: "Bolívie",
      ro: "Bolivia",
      ru: "Боливия"
    },
    rootIddCode: "+591",
    continent: "SouthAmerica"
  },
  BQ: {
    i18nNames: {
      en: "Caribbean Netherlands",
      es: "Bonaire, San Eustaquio y Saba",
      it: "Paesi Bassi caraibici",
      de: "Karibische Niederlande",
      pl: "Niderlandy Karaibskie",
      fr: "Pays-Bas caribéens",
      nl: "Caribisch Nederland",
      pt: "Países Baixos Caribenhos",
      cs: "Karibské Nizozemsko",
      ro: "Antilele Olandeze",
      ru: "Карибские Нидерланды"
    },
    rootIddCode: "+599",
    continent: "NorthAmerica"
  },
  BR: {
    i18nNames: {
      en: "Brazil",
      it: "Brasile",
      es: "Brasil",
      de: "Brasilien",
      pl: "Brazylia",
      fr: "Brésil",
      nl: "Brazilië",
      pt: "Brasil",
      cs: "Brazílie",
      ro: "Brazilia",
      ru: "Бразилия"
    },
    rootIddCode: "+55",
    continent: "SouthAmerica"
  },
  BS: {
    i18nNames: {
      en: "Bahamas",
      it: "Bahamas",
      es: "Bahamas",
      de: "Bahamas",
      pl: "Bahamy",
      fr: "Bahamas",
      nl: "Bahama's",
      pt: "Bahamas",
      cs: "Bahamy",
      ro: "Bahamas",
      ru: "Багамы"
    },
    rootIddCode: "+1242",
    continent: "NorthAmerica"
  },
  BT: {
    i18nNames: {
      en: "Bhutan",
      it: "Bhutan",
      es: "Bután",
      de: "Bhutan",
      pl: "Bhutan",
      fr: "Bhoutan",
      nl: "Bhutan",
      pt: "Butão",
      cs: "Bhútán",
      ro: "Bhutan",
      ru: "Бутан"
    },
    rootIddCode: "+975",
    continent: "Asia"
  },
  BV: {
    i18nNames: {
      en: "Bouvet Island",
      it: "Isola Bouvet",
      es: "Isla Bouvet",
      de: "Bouvetinsel",
      pl: "Wyspa Bouveta",
      fr: "Île Bouvet",
      nl: "Bouveteiland",
      pt: "Ilha Bouvet",
      cs: "Bouvetův ostrov",
      ro: "Insula Bouvet",
      ru: "Остров Буве"
    },
    rootIddCode: "+47",
    continent: "Antarctica"
  },
  BW: {
    i18nNames: {
      en: "Botswana",
      it: "Botswana",
      es: "Botsuana",
      de: "Botswana",
      pl: "Botswana",
      fr: "Botswana",
      nl: "Botswana",
      pt: "Botsuana",
      cs: "Botswana",
      ro: "Botswana",
      ru: "Ботсвана"
    },
    rootIddCode: "+267",
    continent: "Africa"
  },
  BY: {
    i18nNames: {
      en: "Belarus",
      it: "Bielorussia",
      es: "Bielorrusia",
      de: "Weißrussland",
      pl: "Białoruś",
      fr: "Biélorussie",
      nl: "Wit-Rusland",
      pt: "Bielorrússia",
      cs: "Bělorusko",
      ro: "Belarus",
      ru: "Беларусь"
    },
    rootIddCode: "+375",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{9}$",
    taxIdExample: "123456789"
  },
  BZ: {
    i18nNames: {
      en: "Belize",
      it: "Belize",
      es: "Belice",
      de: "Belize",
      pl: "Belize",
      fr: "Belize",
      nl: "Belize",
      pt: "Belize",
      cs: "Belize",
      ro: "Belize",
      ru: "Белиз"
    },
    rootIddCode: "+501",
    continent: "NorthAmerica"
  },
  CA: {
    i18nNames: {
      en: "Canada",
      it: "Canada",
      es: "Canadá",
      de: "Kanada",
      pl: "Kanada",
      fr: "Canada",
      nl: "Canada",
      pt: "Canadá",
      cs: "Kanada",
      ro: "Canada",
      ru: "Канада"
    },
    //quando verrà mappata aggiungere taxIdMandatory: false, in quanto non obbligatorio
    rootIddCode: "+1",
    continent: "NorthAmerica"
  },
  CC: {
    i18nNames: {
      en: "Cocos (Keeling) Islands",
      es: "Islas Cocos",
      it: "Isole Cocos e Keeling",
      de: "Kokosinseln",
      pl: "Wyspy Kokosowe",
      fr: "Îles Cocos",
      nl: "Cocoseilanden",
      pt: "Ilhas Cocos (Keeling)",
      cs: "Kokosové ostrovy",
      ro: "Insulele Cocos (Keeling)",
      ru: "Кокосовые (Килинг) острова"
    },
    rootIddCode: "+61",
    continent: "Oceania"
  },
  CD: {
    i18nNames: {
      en: "DR Congo",
      it: "Congo (Rep. Dem.)",
      es: "República Democrática del Congo",
      de: "Demokratische Republik Kongo",
      pl: "Demokratyczna Republika Konga",
      fr: "RDC (République Démocratique du Congo)",
      nl: "Congo (DRC)",
      pt: "RD Congo",
      cs: "Demokratická republika Kongo",
      ro: "Congo (R.D.)",
      ru: "Демократическая Республика Конго"
    },
    rootIddCode: "+243",
    continent: "Africa"
  },
  CF: {
    i18nNames: {
      en: "Central African Republic",
      es: "República Centroafricana",
      it: "Repubblica Centrafricana",
      de: "Zentralafrikanische Republik",
      pl: "Republika Środkowoafrykańska",
      fr: "République centrafricaine",
      nl: "Centraal-Afrikaanse Republiek",
      pt: "República Centro-Africana",
      cs: "Středoafrická republika",
      ro: "Republica Centrafricană",
      ru: "Центральноафриканская Республика"
    },
    rootIddCode: "+236",
    continent: "Africa"
  },
  CG: {
    i18nNames: {
      en: "Republic of the Congo",
      it: "Congo",
      es: "República del Congo",
      de: "Republik Kongo",
      pl: "Kongo",
      fr: "République du Congo",
      nl: "Republiek Congo",
      pt: "República do Congo",
      cs: "Republika Kongo",
      ro: "Republica Congo",
      ru: "Республика Конго"
    },
    rootIddCode: "+242",
    continent: "Africa"
  },
  CH: {
    i18nNames: {
      en: "Switzerland",
      it: "Svizzera",
      es: "Suiza",
      de: "Schweiz",
      pl: "Szwajcaria",
      fr: "Suisse",
      nl: "Zwitserland",
      pt: "Suíça",
      cs: "Švýcarsko",
      ro: "Elveția",
      ru: "Швейцария"
    },
    rootIddCode: "+41",
    continent: "Europe",
    taxIdMandatory: !1,
    taxIdPattern: "^CHE\\d{9}(MWST|TVA|IVA)?$",
    taxIdExample: "CHE123456789MWST"
  },
  CI: {
    i18nNames: {
      en: "Ivory Coast",
      it: "Costa d'Avorio",
      es: "Costa de Marfil",
      de: "Elfenbeinküste",
      pl: "Wybrzeże Kości Słoniowej",
      fr: "Côte d'Ivoire",
      nl: "Ivoorkust",
      pt: "Costa do Marfim",
      cs: "Pobřeží slonoviny",
      ro: "Coasta de Fildeș",
      ru: "Кот-д’Ивуар"
    },
    rootIddCode: "+225",
    continent: "Africa"
  },
  CK: {
    i18nNames: {
      en: "Cook Islands",
      it: "Isole Cook",
      es: "Islas Cook",
      de: "Cookinseln",
      pl: "Wyspy Cooka",
      fr: "Îles Cook",
      nl: "Cookeilanden",
      pt: "Ilhas Cook",
      cs: "Cookovy ostrovy",
      ro: "Insulele Cook",
      ru: "Острова Кука"
    },
    rootIddCode: "+682",
    continent: "Oceania"
  },
  CL: {
    i18nNames: {
      en: "Chile",
      it: "Cile",
      es: "Chile",
      de: "Chile",
      pl: "Chile",
      fr: "Chili",
      nl: "Chili",
      pt: "Chile",
      cs: "Chile",
      ro: "Chile",
      ru: "Чили"
    },
    rootIddCode: "+56",
    continent: "SouthAmerica"
  },
  CM: {
    i18nNames: {
      en: "Cameroon",
      it: "Camerun",
      es: "Camerún",
      de: "Kamerun",
      pl: "Kamerun",
      fr: "Cameroun",
      nl: "Kameroen",
      pt: "Camarões",
      cs: "Kamerun",
      ro: "Camerun",
      ru: "Камерун"
    },
    rootIddCode: "+237",
    continent: "Africa"
  },
  CN: {
    i18nNames: {
      en: "China",
      it: "Cina",
      es: "China",
      de: "China",
      pl: "Chiny",
      fr: "Chine",
      nl: "China",
      pt: "China",
      cs: "Čína",
      ro: "China",
      ru: "Китай"
    },
    rootIddCode: "+86",
    continent: "Asia"
  },
  CO: {
    i18nNames: {
      en: "Colombia",
      it: "Colombia",
      es: "Colombia",
      de: "Kolumbien",
      pl: "Kolumbia",
      fr: "Colombie",
      nl: "Colombia",
      pt: "Colômbia",
      cs: "Kolumbie",
      ro: "Columbia",
      ru: "Колумбия"
    },
    rootIddCode: "+57",
    continent: "SouthAmerica"
  },
  CR: {
    i18nNames: {
      en: "Costa Rica",
      it: "Costa Rica",
      es: "Costa Rica",
      de: "Costa Rica",
      pl: "Kostaryka",
      fr: "Costa Rica",
      nl: "Costa Rica",
      pt: "Costa Rica",
      cs: "Kostarika",
      ro: "Costa Rica",
      ru: "Коста-Рика"
    },
    rootIddCode: "+506",
    continent: "NorthAmerica"
  },
  CU: {
    i18nNames: {
      en: "Cuba",
      it: "Cuba",
      es: "Cuba",
      de: "Kuba",
      pl: "Kuba",
      fr: "Cuba",
      nl: "Cuba",
      pt: "Cuba",
      cs: "Kuba",
      ro: "Cuba",
      ru: "Куба"
    },
    rootIddCode: "+53",
    continent: "NorthAmerica"
  },
  CV: {
    i18nNames: {
      en: "Cape Verde",
      it: "Capo Verde",
      es: "Cabo Verde",
      de: "Kap Verde",
      pl: "Republika Zielonego Przylądka",
      fr: "Cap-Vert",
      nl: "Kaapverdië",
      pt: "Cabo Verde",
      cs: "Kapverdy",
      ro: "Capul Verde",
      ru: "Кабо-Верде"
    },
    rootIddCode: "+238",
    continent: "Africa"
  },
  CW: {
    i18nNames: {
      en: "Curaçao",
      it: "Curaçao",
      es: "Curazao",
      de: "Curaçao",
      pl: "Curaçao",
      fr: "Curaçao",
      nl: "Curaçao",
      pt: "Curaçau",
      cs: "Curaçao",
      ro: "Curaçao",
      ru: "Кюрасао"
    },
    rootIddCode: "+599",
    continent: "NorthAmerica"
  },
  CX: {
    i18nNames: {
      en: "Christmas Island",
      es: "Isla Christmas",
      it: "Isola di Natale",
      de: "Weihnachtsinsel",
      pl: "Wyspa Bożego Narodzenia",
      fr: "Île Christmas",
      nl: "Christmaseiland",
      pt: "Ilha Christmas",
      cs: "Vánoční ostrov",
      ro: "Insula Christmas",
      ru: "Остров Рождества"
    },
    rootIddCode: "+61",
    continent: "Oceania"
  },
  CY: {
    i18nNames: {
      en: "Cyprus",
      it: "Cipro",
      es: "Chipre",
      de: "Zypern",
      pl: "Cypr",
      fr: "Chypre",
      nl: "Cyprus",
      pt: "Chipre",
      cs: "Kypr",
      ro: "Cipru",
      ru: "Кипр"
    },
    rootIddCode: "+357",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^CY\\d{8}[A-Z]$",
    taxIdExample: "CY12345678A"
  },
  CZ: {
    i18nNames: {
      en: "Czechia",
      it: "Cechia",
      es: "Chequia",
      de: "Tschechien",
      pl: "Czechy",
      fr: "Tchéquie",
      nl: "Tsjechië",
      pt: "Chéquia",
      cs: "Česko",
      ro: "Cehia",
      ru: "Чехия"
    },
    rootIddCode: "+420",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^CZ(\\d{8}|\\d{9}|\\d{10})$",
    taxIdExample: "CZ12345678"
  },
  DE: {
    i18nNames: {
      en: "Germany",
      it: "Germania",
      es: "Alemania",
      de: "Deutschland",
      pl: "Niemcy",
      fr: "Allemagne",
      nl: "Duitsland",
      pt: "Alemanha",
      cs: "Německo",
      ro: "Germania",
      ru: "Германия"
    },
    rootIddCode: "+49",
    continent: "Europe",
    blocMemberships: ["EU"],
    regions: YS,
    taxIdMandatory: !1,
    taxIdPattern: "^DE\\d{9}$",
    taxIdExample: "DE123456789"
  },
  DJ: {
    i18nNames: {
      en: "Djibouti",
      it: "Gibuti",
      es: "Yibuti",
      de: "Dschibuti",
      pl: "Dżibuti",
      fr: "Djibouti",
      nl: "Djibouti",
      pt: "Djibuti",
      cs: "Džibutsko",
      ro: "Djibouti",
      ru: "Джибути"
    },
    rootIddCode: "+253",
    continent: "Africa"
  },
  DK: {
    i18nNames: {
      en: "Denmark",
      it: "Danimarca",
      es: "Dinamarca",
      de: "Dänemark",
      pl: "Dania",
      fr: "Danemark",
      nl: "Denemarken",
      pt: "Dinamarca",
      cs: "Dánsko",
      ro: "Danemarca",
      ru: "Дания"
    },
    rootIddCode: "+45",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^DK\\d{8}$",
    taxIdExample: "DK12345678"
  },
  DM: {
    i18nNames: {
      en: "Dominica",
      it: "Dominica",
      es: "Dominica",
      de: "Dominica",
      pl: "Dominika",
      fr: "Dominique",
      nl: "Dominica",
      pt: "Dominica",
      cs: "Dominika",
      ro: "Dominica",
      ru: "Доминика"
    },
    rootIddCode: "+1767",
    continent: "NorthAmerica"
  },
  DO: {
    i18nNames: {
      en: "Dominican Republic",
      es: "República Dominicana",
      it: "Repubblica Dominicana",
      de: "Dominikanische Republik",
      pl: "Dominikana",
      fr: "République dominicaine",
      nl: "Dominicaanse Republiek",
      pt: "República Dominicana",
      cs: "Dominikánská republika",
      ro: "Republica Dominicană",
      ru: "Доминиканская Республика"
    },
    rootIddCode: "+1849",
    continent: "NorthAmerica"
  },
  DZ: {
    i18nNames: {
      en: "Algeria",
      it: "Algeria",
      es: "Argelia",
      de: "Algerien",
      pl: "Algieria",
      fr: "Algérie",
      nl: "Algerije",
      pt: "Argélia",
      cs: "Alžírsko",
      ro: "Algeria",
      ru: "Алжир"
    },
    rootIddCode: "+213",
    continent: "Africa",
    taxIdMandatory: !0,
    taxIdPattern: "^(\\d{15}|\\d{20})$",
    taxIdExample: "123456789012345"
  },
  EC: {
    i18nNames: {
      en: "Ecuador",
      it: "Ecuador",
      es: "Ecuador",
      de: "Ecuador",
      pl: "Ekwador",
      fr: "Équateur",
      nl: "Ecuador",
      pt: "Equador",
      cs: "Ekvádor",
      ro: "Ecuador",
      ru: "Эквадор"
    },
    rootIddCode: "+593",
    continent: "SouthAmerica"
  },
  EE: {
    i18nNames: {
      en: "Estonia",
      it: "Estonia",
      es: "Estonia",
      de: "Estland",
      pl: "Estonia",
      fr: "Estonie",
      nl: "Estland",
      pt: "Estónia",
      cs: "Estonsko",
      ro: "Estonia",
      ru: "Эстония"
    },
    rootIddCode: "+372",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^EE\\d{9}$",
    taxIdExample: "EE123456789"
  },
  EG: {
    i18nNames: {
      en: "Egypt",
      it: "Egitto",
      es: "Egipto",
      de: "Ägypten",
      pl: "Egipt",
      fr: "Égypte",
      nl: "Egypte",
      pt: "Egito",
      cs: "Egypt",
      ro: "Egipt",
      ru: "Египет"
    },
    rootIddCode: "+20",
    continent: "Africa",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{9}$",
    taxIdExample: "123456789"
  },
  EH: {
    i18nNames: {
      en: "Western Sahara",
      it: "Sahara Occidentale",
      es: "Sáhara Occidental",
      de: "Westsahara",
      pl: "Sahara Zachodnia",
      fr: "Sahara occidental",
      nl: "Westelijke Sahara",
      pt: "Saara Ocidental",
      cs: "Západní Sahara",
      ro: "Sahara Occidentală",
      ru: "Западная Сахара"
    },
    rootIddCode: "+2125289",
    continent: "Africa"
  },
  ER: {
    i18nNames: {
      en: "Eritrea",
      it: "Eritrea",
      es: "Eritrea",
      de: "Eritrea",
      pl: "Erytrea",
      fr: "Érythrée",
      nl: "Eritrea",
      pt: "Eritreia",
      cs: "Eritrea",
      ro: "Eritreea",
      ru: "Эритрея"
    },
    rootIddCode: "+291",
    continent: "Africa"
  },
  ES: {
    i18nNames: {
      en: "Spain",
      it: "Spagna",
      es: "España",
      de: "Spanien",
      pl: "Hiszpania",
      fr: "Espagne",
      nl: "Spanje",
      pt: "Espanha",
      cs: "Španělsko",
      ro: "Spania",
      ru: "Испания"
    },
    rootIddCode: "+34",
    continent: "Europe",
    blocMemberships: ["EU"],
    regions: e1,
    taxIdMandatory: !0,
    taxIdPattern: "^ES[A-Z0-9]\\d{7}[A-Z0-9]$",
    taxIdExample: "ESX1234567Y"
  },
  ET: {
    i18nNames: {
      en: "Ethiopia",
      it: "Etiopia",
      es: "Etiopía",
      de: "Äthiopien",
      pl: "Etiopia",
      fr: "Éthiopie",
      nl: "Ethiopië",
      pt: "Etiópia",
      cs: "Etiopie",
      ro: "Etiopia",
      ru: "Эфиопия"
    },
    rootIddCode: "+251",
    continent: "Africa"
  },
  FI: {
    i18nNames: {
      en: "Finland",
      it: "Finlandia",
      es: "Finlandia",
      de: "Finnland",
      pl: "Finlandia",
      fr: "Finlande",
      nl: "Finland",
      pt: "Finlândia",
      cs: "Finsko",
      ro: "Finlanda",
      ru: "Финляндия"
    },
    rootIddCode: "+358",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^FI\\d{8}$",
    taxIdExample: "FI12345678"
  },
  FJ: {
    i18nNames: {
      en: "Fiji",
      it: "Figi",
      es: "Fiyi",
      de: "Fidschi",
      pl: "Fidżi",
      fr: "Fidji",
      nl: "Fiji",
      pt: "Fiji",
      cs: "Fidži",
      ro: "Fiji",
      ru: "Фиджи"
    },
    rootIddCode: "+679",
    continent: "Oceania"
  },
  FK: {
    i18nNames: {
      en: "Falkland Islands",
      es: "Islas Malvinas",
      it: "Isole Falkland o Isole Malvine",
      de: "Falklandinseln",
      pl: "Wyspy Falklandzkie",
      fr: "Îles Falkland",
      nl: "Falklandeilanden",
      pt: "Ilhas Malvinas",
      cs: "Falklandské ostrovy",
      ro: "Insulele Falkland",
      ru: "Фолклендские острова"
    },
    rootIddCode: "+500",
    continent: "SouthAmerica"
  },
  FM: {
    i18nNames: {
      en: "Micronesia",
      it: "Micronesia",
      es: "Estados Federados de Micronesia",
      de: "Mikronesien",
      pl: "Mikronezja",
      fr: "Micronésie",
      nl: "Micronesië",
      pt: "Micronésia",
      cs: "Mikronésie",
      ro: "Micronezia",
      ru: "Микронезия"
    },
    rootIddCode: "+691",
    continent: "Oceania"
  },
  FO: {
    i18nNames: {
      en: "Faroe Islands",
      it: "Isole Far Oer",
      es: "Islas Feroe",
      de: "Färöer-Inseln",
      pl: "Wyspy Owcze",
      fr: "Îles Féroé",
      nl: "Faeröer",
      pt: "Ilhas Faroé",
      cs: "Faerské ostrovy",
      ro: "Insulele Feroe",
      ru: "Фарерские острова"
    },
    rootIddCode: "+298",
    continent: "Europe"
  },
  FR: {
    i18nNames: {
      en: "France",
      it: "Francia",
      es: "Francia",
      de: "Frankreich",
      pl: "Francja",
      fr: "France",
      nl: "Frankrijk",
      pt: "França",
      cs: "Francie",
      ro: "Franța",
      ru: "Франция"
    },
    rootIddCode: "+33",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^FR[A-Z0-9]{2}\\d{9}$",
    taxIdExample: "FR1A123456789"
  },
  GA: {
    i18nNames: {
      en: "Gabon",
      it: "Gabon",
      es: "Gabón",
      de: "Gabun",
      pl: "Gabon",
      fr: "Gabon",
      nl: "Gabon",
      pt: "Gabão",
      cs: "Gabon",
      ro: "Gabon",
      ru: "Габон"
    },
    rootIddCode: "+241",
    continent: "Africa"
  },
  GB: {
    i18nNames: {
      en: "United Kingdom",
      it: "Regno Unito",
      es: "Reino Unido",
      de: "Vereinigtes Königreich",
      pl: "Zjednoczone Królestwo",
      fr: "Royaume-Uni",
      nl: "Verenigd Koninkrijk",
      pt: "Reino Unido",
      cs: "Spojené království",
      ro: "Regatul Unit",
      ru: "Великобритания"
    },
    rootIddCode: "+44",
    continent: "Europe",
    taxIdMandatory: !1,
    taxIdPattern: "^GB(\\d{9}|\\d{12}|GD(0\\d{2}|[1-4]\\d{2})|HA([5-9]\\d{2}))$",
    taxIdExample: "GB123456789"
  },
  GD: {
    i18nNames: {
      en: "Grenada",
      it: "Grenada",
      es: "Granada",
      de: "Grenada",
      pl: "Grenada",
      fr: "Grenade",
      nl: "Grenada",
      pt: "Granada",
      cs: "Grenada",
      ro: "Grenada",
      ru: "Гренада"
    },
    rootIddCode: "+1473",
    continent: "NorthAmerica"
  },
  GE: {
    i18nNames: {
      en: "Georgia",
      it: "Georgia",
      es: "Georgia",
      de: "Georgien",
      pl: "Gruzja",
      fr: "Géorgie",
      nl: "Georgië",
      pt: "Geórgia",
      cs: "Gruzie",
      ro: "Georgia",
      ru: "Грузия"
    },
    rootIddCode: "+995",
    continent: "Europe"
  },
  GF: {
    i18nNames: {
      en: "French Guiana",
      it: "Guyana francese",
      es: "Guayana Francesa",
      de: "Französisch-Guayana",
      pl: "Gujana Francuska",
      fr: "Guyane française",
      nl: "Frans-Guyana",
      pt: "Guiana Francesa",
      cs: "Francouzská Guyana",
      ro: "Guyana Franceză",
      ru: "Французская Гвиана"
    },
    rootIddCode: "+594",
    continent: "SouthAmerica",
    blocMemberships: ["EU"]
  },
  GG: {
    i18nNames: {
      en: "Guernsey",
      it: "Guernsey",
      es: "Guernsey",
      de: "Guernsey",
      pl: "Guernsey",
      fr: "Guernesey",
      nl: "Guernsey",
      pt: "Guernsey",
      cs: "Guernsey",
      ro: "Guernsey",
      ru: "Гернси"
    },
    rootIddCode: "+44",
    continent: "Europe"
  },
  GH: {
    i18nNames: {
      en: "Ghana",
      it: "Ghana",
      es: "Ghana",
      de: "Ghana",
      pl: "Ghana",
      fr: "Ghana",
      nl: "Ghana",
      pt: "Gana",
      cs: "Ghana",
      ro: "Ghana",
      ru: "Гана"
    },
    rootIddCode: "+233",
    continent: "Africa"
  },
  GI: {
    i18nNames: {
      en: "Gibraltar",
      it: "Gibilterra",
      es: "Gibraltar",
      de: "Gibraltar",
      pl: "Gibraltar",
      fr: "Gibraltar",
      nl: "Gibraltar",
      pt: "Gibraltar",
      cs: "Gibraltar",
      ro: "Gibraltar",
      ru: "Гибралтар"
    },
    rootIddCode: "+350",
    continent: "Europe"
  },
  GL: {
    i18nNames: {
      en: "Greenland",
      it: "Groenlandia",
      es: "Groenlandia",
      de: "Grönland",
      pl: "Grenlandia",
      fr: "Groenland",
      nl: "Groenland",
      pt: "Gronelândia",
      cs: "Grónsko",
      ro: "Groenlanda",
      ru: "Гренландия"
    },
    rootIddCode: "+299",
    continent: "NorthAmerica"
  },
  GM: {
    i18nNames: {
      en: "Gambia",
      it: "Gambia",
      es: "Gambia",
      de: "Gambia",
      pl: "Gambia",
      fr: "Gambie",
      nl: "Gambia",
      pt: "Gâmbia",
      cs: "Gambie",
      ro: "Gambia",
      ru: "Гамбия"
    },
    rootIddCode: "+220",
    continent: "Africa"
  },
  GN: {
    i18nNames: {
      en: "Guinea",
      it: "Guinea",
      es: "Guinea",
      de: "Guinea",
      pl: "Gwinea",
      fr: "Guinée",
      nl: "Guinee",
      pt: "Guiné",
      cs: "Guinea",
      ro: "Guineea",
      ru: "Гвинея"
    },
    rootIddCode: "+224",
    continent: "Africa"
  },
  GP: {
    i18nNames: {
      en: "Guadeloupe",
      it: "Guadeloupa",
      es: "Guadalupe",
      de: "Guadeloupe",
      pl: "Gwadelupa",
      fr: "Guadeloupe",
      nl: "Guadeloupe",
      pt: "Guadalupe",
      cs: "Guadeloupe",
      ro: "Guadelupa",
      ru: "Гваделупа"
    },
    rootIddCode: "+590",
    continent: "NorthAmerica"
  },
  GQ: {
    i18nNames: {
      en: "Equatorial Guinea",
      es: "Guinea Ecuatorial",
      it: "Guinea Equatoriale",
      de: "Äquatorialguinea",
      pl: "Gwinea Równikowa",
      fr: "Guinée équatoriale",
      nl: "Equatoriaal-Guinea",
      pt: "Guiné Equatorial",
      cs: "Rovníková Guinea",
      ro: "Guineea Ecuatorială",
      ru: "Экваториальная Гвинея"
    },
    rootIddCode: "+240",
    continent: "Africa"
  },
  GR: {
    i18nNames: {
      en: "Greece",
      it: "Grecia",
      es: "Grecia",
      de: "Griechenland",
      pl: "Grecja",
      fr: "Grèce",
      nl: "Griekenland",
      pt: "Grécia",
      cs: "Řecko",
      ro: "Grecia",
      ru: "Греция"
    },
    rootIddCode: "+30",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^EL\\d{9}$",
    taxIdExample: "EL123456789"
  },
  GS: {
    i18nNames: {
      en: "South Georgia",
      it: "Georgia del Sud e Isole Sandwich Meridionali",
      es: "Islas Georgias del Sur y Sandwich del Sur",
      de: "Südgeorgien",
      pl: "Georgia Południowa",
      fr: "Géorgie du Sud et îles Sandwich du Sud",
      nl: "Zuid-Georgië en Zuidelijke Sandwicheilanden",
      pt: "Geórgia do Sul e Ilhas Sandwich do Sul",
      cs: "Jižní Georgie a Jižní Sandwichovy ostrovy",
      ro: "Georgia de Sud și Insulele Sandwich de Sud",
      ru: "Южная Георгия и Южные Сандвичевы острова"
    },
    rootIddCode: "+500",
    continent: "Oceania"
  },
  GT: {
    i18nNames: {
      en: "Guatemala",
      it: "Guatemala",
      es: "Guatemala",
      de: "Guatemala",
      pl: "Gwatemala",
      fr: "Guatemala",
      nl: "Guatemala",
      pt: "Guatemala",
      cs: "Guatemala",
      ro: "Guatemala",
      ru: "Гватемала"
    },
    rootIddCode: "+502",
    continent: "NorthAmerica"
  },
  GU: {
    i18nNames: {
      en: "Guam",
      it: "Guam",
      es: "Guam",
      de: "Guam",
      pl: "Guam",
      fr: "Guam",
      nl: "Guam",
      pt: "Guam",
      cs: "Guam",
      ro: "Guam",
      ru: "Гуам"
    },
    rootIddCode: "+1671",
    continent: "NorthAmerica"
  },
  GW: {
    i18nNames: {
      en: "Guinea-Bissau",
      it: "Guinea-Bissau",
      es: "Guinea-Bisáu",
      de: "Guinea-Bissau",
      pl: "Gwinea-Bissau",
      fr: "Guinée-Bissau",
      nl: "Guinee-Bissau",
      pt: "Guiné-Bissau",
      cs: "Guinea-Bissau",
      ro: "Guineea-Bissau",
      ru: "Гвинея-Бисау"
    },
    rootIddCode: "+245",
    continent: "Africa"
  },
  GY: {
    i18nNames: {
      en: "Guyana",
      it: "Guyana",
      es: "Guyana",
      de: "Guyana",
      pl: "Gujana",
      fr: "Guyana",
      nl: "Guyana",
      pt: "Guiana",
      cs: "Guyana",
      ro: "Guyana",
      ru: "Гайана"
    },
    rootIddCode: "+592",
    continent: "NorthAmerica"
  },
  HK: {
    i18nNames: {
      en: "Hong Kong",
      it: "Hong Kong",
      es: "Hong Kong",
      de: "Hongkong",
      pl: "Hongkong",
      fr: "Hong Kong",
      nl: "Hongkong",
      pt: "Hong Kong",
      cs: "Hongkong",
      ro: "Hong Kong",
      ru: "Гонконг"
    },
    rootIddCode: "+852",
    continent: "Asia"
  },
  HM: {
    i18nNames: {
      en: "Heard Island and McDonald Islands",
      es: "Islas Heard y McDonald",
      it: "Isole Heard e McDonald",
      de: "Heard und McDonaldinseln",
      pl: "Wyspy Heard i McDonalda",
      fr: "Îles Heard et McDonald",
      nl: "Heard en McDonaldeilanden",
      pt: "Ilhas Heard e McDonald",
      cs: "Heardův ostrov a McDonaldovy ostrovy",
      ro: "Insula Heard și Insulele McDonald",
      ru: "Остров Херд и острова Макдональд"
    },
    rootIddCode: "undefined",
    continent: "Oceania"
  },
  HN: {
    i18nNames: {
      en: "Honduras",
      it: "Honduras",
      es: "Honduras",
      de: "Honduras",
      pl: "Honduras",
      fr: "Honduras",
      nl: "Honduras",
      pt: "Honduras",
      cs: "Honduras",
      ro: "Honduras",
      ru: "Гондурас"
    },
    rootIddCode: "+504",
    continent: "NorthAmerica"
  },
  HR: {
    i18nNames: {
      en: "Croatia",
      it: "Croazia",
      es: "Croacia",
      de: "Kroatien",
      pl: "Chorwacja",
      fr: "Croatie",
      nl: "Kroatië",
      pt: "Croácia",
      cs: "Chorvatsko",
      ro: "Croația",
      ru: "Хорватия"
    },
    rootIddCode: "+385",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^HR\\d{11}$",
    taxIdExample: "HR12345678901"
  },
  HT: {
    i18nNames: {
      en: "Haiti",
      it: "Haiti",
      es: "Haití",
      de: "Haiti",
      pl: "Haiti",
      fr: "Haïti",
      nl: "Haïti",
      pt: "Haiti",
      cs: "Haiti",
      ro: "Haiti",
      ru: "Гаити"
    },
    rootIddCode: "+509",
    continent: "NorthAmerica"
  },
  HU: {
    i18nNames: {
      en: "Hungary",
      it: "Ungheria",
      es: "Hungría",
      de: "Ungarn",
      pl: "Węgry",
      fr: "Hongrie",
      nl: "Hongarije",
      pt: "Hungria",
      cs: "Maďarsko",
      ro: "Ungaria",
      ru: "Венгрия"
    },
    rootIddCode: "+36",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^HU\\d{8}$",
    taxIdExample: "HU12345678"
  },
  ID: {
    i18nNames: {
      en: "Indonesia",
      it: "Indonesia",
      es: "Indonesia",
      de: "Indonesien",
      pl: "Indonezja",
      fr: "Indonésie",
      nl: "Indonesië",
      pt: "Indonésia",
      cs: "Indonésie",
      ro: "Indonezia",
      ru: "Индонезия"
    },
    rootIddCode: "+62",
    continent: "Asia"
  },
  IE: {
    i18nNames: {
      en: "Ireland",
      it: "Irlanda",
      es: "Irlanda",
      de: "Irland",
      pl: "Irlandia",
      fr: "Irlande",
      nl: "Ierland",
      pt: "Irlanda",
      cs: "Irsko",
      ro: "Irlanda",
      ru: "Ирландия"
    },
    rootIddCode: "+353",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^IE\\d{7}[A-Z]{1,2}$",
    taxIdExample: "IE1234567A"
  },
  IL: {
    i18nNames: {
      en: "Israel",
      it: "Israele",
      es: "Israel",
      de: "Israel",
      pl: "Израиль",
      fr: "Israël",
      nl: "Israël",
      pt: "Israel",
      cs: "Izrael",
      ro: "Israel",
      ru: "Израиль"
    },
    rootIddCode: "+972",
    continent: "Asia",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{9}$",
    taxIdExample: "123456789"
  },
  IM: {
    i18nNames: {
      en: "Isle of Man",
      it: "Isola di Man",
      es: "Isla de Man",
      de: "Isle of Man",
      pl: "Wyspa Man",
      fr: "Île de Man",
      nl: "Isle of Man",
      pt: "Ilha de Man",
      cs: "Ostrov Man",
      ro: "Insula Man",
      ru: "Остров Мэн"
    },
    rootIddCode: "+44",
    continent: "Europe"
  },
  IN: {
    i18nNames: {
      en: "India",
      it: "India",
      es: "India",
      de: "Indien",
      pl: "Indie",
      fr: "Inde",
      nl: "India",
      pt: "Índia",
      cs: "Indie",
      ro: "India",
      ru: "Индия"
    },
    rootIddCode: "+91",
    continent: "Asia"
  },
  IO: {
    i18nNames: {
      en: "British Indian Ocean Territory",
      es: "Territorio Británico del Océano Índico",
      it: "Territorio britannico dell'oceano indiano",
      de: "Britisches Territorium im Indischen Ozean",
      pl: "Brytyjskie Terytorium Oceanu Indyjskiego",
      fr: "Territoire britannique de l'océan Indien",
      nl: "Brits Indische Oceaanterritorium",
      pt: "Território Britânico do Oceano Índico",
      cs: "Britské indickooceánské území",
      ro: "Teritoriul Britanic din Oceanul Indian",
      ru: "Британская территория в Индийском океане"
    },
    rootIddCode: "+246",
    continent: "Asia"
  },
  IQ: {
    i18nNames: {
      en: "Iraq",
      it: "Iraq",
      es: "Irak",
      de: "Ирак",
      pl: "Irak",
      fr: "Irak",
      nl: "Irak",
      pt: "Iraque",
      cs: "Irák",
      ro: "Irak",
      ru: "Ирак"
    },
    rootIddCode: "+964",
    continent: "Asia"
  },
  IR: {
    i18nNames: {
      en: "Iran",
      it: "Iran",
      es: "Irán",
      de: "Iran",
      pl: "Iran",
      fr: "Iran",
      nl: "Iran",
      pt: "Irã",
      cs: "Írán",
      ro: "Iran",
      ru: "Иран"
    },
    rootIddCode: "+98",
    continent: "Asia"
  },
  IS: {
    i18nNames: {
      en: "Iceland",
      it: "Islanda",
      es: "Islandia",
      de: "Island",
      pl: "Islandia",
      fr: "Islande",
      nl: "IJsland",
      pt: "Islândia",
      cs: "Island",
      ro: "Islanda",
      ru: "Исландия"
    },
    rootIddCode: "+354",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^IS\\d{5,6}$",
    taxIdExample: "IS123456"
  },
  IT: {
    i18nNames: {
      en: "Italy",
      it: "Italia",
      es: "Italia",
      de: "Italien",
      pl: "Włochy",
      fr: "Italie",
      nl: "Italie",
      pt: "Itália",
      cs: "Itálie",
      ro: "Italia",
      ru: "Италия"
    },
    rootIddCode: "+39",
    continent: "Europe",
    blocMemberships: ["EU"],
    regions: XS,
    taxIdMandatory: !0,
    taxIdPattern: "^IT\\d{11}$",
    taxIdExample: "IT12345678901"
  },
  JE: {
    i18nNames: {
      en: "Jersey",
      it: "Isola di Jersey",
      es: "Jersey",
      de: "Jersey",
      pl: "Jersey",
      fr: "Jersey",
      nl: "Jersey",
      pt: "Jersey",
      cs: "Jersey",
      ro: "Jersey",
      ru: "Джерси"
    },
    rootIddCode: "+44",
    continent: "Europe"
  },
  JM: {
    i18nNames: {
      en: "Jamaica",
      it: "Giamaica",
      es: "Jamaica",
      de: "Jamaika",
      pl: "Jamajka",
      fr: "Jamaïque",
      nl: "Jamaica",
      pt: "Jamaica",
      cs: "Jamajka",
      ro: "Jamaica",
      ru: "Ямайка"
    },
    rootIddCode: "+1876",
    continent: "NorthAmerica"
  },
  JO: {
    i18nNames: {
      en: "Jordan",
      it: "Giordania",
      es: "Jordania",
      de: "Jordanien",
      pl: "Jordania",
      fr: "Jordanie",
      nl: "Jordanië",
      pt: "Jordânia",
      cs: "Jordánsko",
      ro: "Iordania",
      ru: "Иордания"
    },
    rootIddCode: "+962",
    continent: "Asia",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{7}$",
    taxIdExample: "1234567"
  },
  JP: {
    i18nNames: {
      en: "Japan",
      it: "Giappone",
      es: "Japón",
      de: "Japan",
      pl: "Japonia",
      fr: "Japon",
      nl: "Japan",
      pt: "Japão",
      cs: "Japonsko",
      ro: "Japonia",
      ru: "Япония"
    },
    rootIddCode: "+81",
    continent: "Asia"
  },
  KE: {
    i18nNames: {
      en: "Kenya",
      it: "Kenya",
      es: "Kenia",
      de: "Kenia",
      pl: "Kenia",
      fr: "Kenya",
      nl: "Kenia",
      pt: "Quênia",
      cs: "Keňa",
      ro: "Kenya",
      ru: "Кения"
    },
    rootIddCode: "+254",
    continent: "Africa"
  },
  KG: {
    i18nNames: {
      en: "Kyrgyzstan",
      it: "Kirghizistan",
      es: "Kirguistán",
      de: "Kirgisistan",
      pl: "Kirgistan",
      fr: "Kirghizistan",
      nl: "Kirgizië",
      pt: "Quirguistão",
      cs: "Kyrgyzstán",
      ro: "Kârgâzstan",
      ru: "Киргизия"
    },
    rootIddCode: "+996",
    continent: "Asia"
  },
  KH: {
    i18nNames: {
      en: "Cambodia",
      it: "Cambogia",
      es: "Camboya",
      de: "Kambodscha",
      pl: "Kambodża",
      fr: "Cambodge",
      nl: "Cambodja",
      pt: "Camboja",
      cs: "Kambodža",
      ro: "Cambodgia",
      ru: "Камбоджа"
    },
    rootIddCode: "+855",
    continent: "Asia"
  },
  KI: {
    i18nNames: {
      en: "Kiribati",
      it: "Kiribati",
      es: "Kiribati",
      de: "Kiribati",
      pl: "Kiribati",
      fr: "Kiribati",
      nl: "Kiribati",
      pt: "Kiribati",
      cs: "Kiribati",
      ro: "Kiribati",
      ru: "Кирибати"
    },
    rootIddCode: "+686",
    continent: "Oceania"
  },
  KM: {
    i18nNames: {
      en: "Comoros",
      it: "Comore",
      es: "Comoras",
      de: "Komoren",
      pl: "Komory",
      fr: "Comores",
      nl: "Comoren",
      pt: "Comores",
      cs: "Komory",
      ro: "Comore",
      ru: "Коморы"
    },
    rootIddCode: "+269",
    continent: "Africa"
  },
  KN: {
    i18nNames: {
      en: "Saint Kitts and Nevis",
      es: "San Cristóbal y Nieves",
      it: "Saint Kitts e Nevis",
      de: "St. Kitts und Nevis",
      pl: "Saint Kitts i Nevis",
      fr: "Saint-Christophe-et-Niévès",
      nl: "Saint Kitts en Nevis",
      pt: "São Cristóvão e Névis",
      cs: "Svatý Kryštof a Nevis",
      ro: "Sfântul Kitts și Nevis",
      ru: "Сент-Китс и Невис"
    },
    rootIddCode: "+1869",
    continent: "NorthAmerica"
  },
  KP: {
    i18nNames: {
      en: "North Korea",
      it: "Corea del Nord",
      es: "Corea del Norte",
      de: "Nordkorea",
      pl: "Korea Północna",
      fr: "Corée du Nord",
      nl: "Noord-Korea",
      pt: "Coreia do Norte",
      cs: "Severní Korea",
      ro: "Coreea de Nord",
      ru: "Северная Корея"
    },
    rootIddCode: "+850",
    continent: "Asia"
  },
  KR: {
    i18nNames: {
      en: "South Korea",
      it: "Corea del Sud",
      es: "Corea del Sur",
      de: "Südkorea",
      pl: "Korea Południowa",
      fr: "Corée du Sud",
      nl: "Zuid-Korea",
      pt: "Coreia do Sul",
      cs: "Jižní Korea",
      ro: "Coreea de Sud",
      ru: "Южная Корея"
    },
    rootIddCode: "+82",
    continent: "Asia"
  },
  KW: {
    i18nNames: {
      en: "Kuwait",
      it: "Kuwait",
      es: "Kuwait",
      de: "Kuwait",
      pl: "Kuwejt",
      fr: "Koweït",
      nl: "Кувейт",
      pt: "Kuwait",
      cs: "Kuvajt",
      ro: "Kuweit",
      ru: "Кувейт"
    },
    rootIddCode: "+965",
    continent: "Asia"
  },
  KY: {
    i18nNames: {
      en: "Cayman Islands",
      it: "Isole Cayman",
      es: "Islas Caimán",
      de: "Kaimaninseln",
      pl: "Kajmany",
      fr: "Îles Caïmans",
      nl: "Kaaimaneilanden",
      pt: "Ilhas Cayman",
      cs: "Kajmanské ostrovy",
      ro: "Insulele Cayman",
      ru: "Каймановы острова"
    },
    rootIddCode: "+1345",
    continent: "NorthAmerica"
  },
  KZ: {
    i18nNames: {
      en: "Kazakhstan",
      it: "Kazakistan",
      es: "Kazajistán",
      de: "Kasachstan",
      pl: "Kazachstan",
      fr: "Kazakhstan",
      nl: "Kazachstan",
      pt: "Cazaquistão",
      cs: "Kazachstán",
      ro: "Kazahstan",
      ru: "Казахстан"
    },
    rootIddCode: "+77",
    continent: "Asia"
  },
  LA: {
    i18nNames: {
      en: "Laos",
      it: "Laos",
      es: "Laos",
      de: "Laos",
      pl: "Laos",
      fr: "Laos",
      nl: "Laos",
      pt: "Laos",
      cs: "Laos",
      ro: "Laos",
      ru: "Лаос"
    },
    rootIddCode: "+856",
    continent: "Asia"
  },
  LB: {
    i18nNames: {
      en: "Lebanon",
      it: "Libano",
      es: "Líbano",
      de: "Libanon",
      pl: "Liban",
      fr: "Liban",
      nl: "Libanon",
      pt: "Líbano",
      cs: "Libanon",
      ro: "Liban",
      ru: "Ливан"
    },
    rootIddCode: "+961",
    continent: "Asia",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{1,15}(-(601|603|604))?$",
    taxIdExample: "123456789-601"
  },
  LC: {
    i18nNames: {
      en: "Saint Lucia",
      it: "Santa Lucia",
      es: "Santa Lucía",
      de: "St. Lucia",
      pl: "Saint Lucia",
      fr: "Sainte-Lucie",
      nl: "Saint Lucia",
      pt: "Santa Lúcia",
      cs: "Svatá Lucie",
      ro: "Sfânta Lucia",
      ru: "Сент-Люсия"
    },
    rootIddCode: "+1758",
    continent: "NorthAmerica"
  },
  LI: {
    i18nNames: {
      en: "Liechtenstein",
      it: "Liechtenstein",
      es: "Liechtenstein",
      de: "Liechtenstein",
      pl: "Liechtenstein",
      fr: "Liechtenstein",
      nl: "Liechtenstein",
      pt: "Liechtenstein",
      cs: "Lichtenštejnsko",
      ro: "Liechtenstein",
      ru: "Лихтенштейн"
    },
    rootIddCode: "+423",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{5}$",
    taxIdExample: "12345"
  },
  LK: {
    i18nNames: {
      en: "Sri Lanka",
      it: "Sri Lanka",
      es: "Sri Lanka",
      de: "Sri Lanka",
      pl: "Sri Lanka",
      fr: "Sri Lanka",
      nl: "Sri Lanka",
      pt: "Sri Lanka",
      cs: "Srí Lanka",
      ro: "Sri Lanka",
      ru: "Шри-Ланка"
    },
    rootIddCode: "+94",
    continent: "Asia"
  },
  LR: {
    i18nNames: {
      en: "Liberia",
      it: "Liberia",
      es: "Liberia",
      de: "Liberia",
      pl: "Liberia",
      fr: "Libéria",
      nl: "Liberia",
      pt: "Libéria",
      cs: "Libérie",
      ro: "Liberia",
      ru: "Либерия"
    },
    rootIddCode: "+231",
    continent: "Africa"
  },
  LS: {
    i18nNames: {
      en: "Lesotho",
      it: "Lesotho",
      es: "Lesoto",
      de: "Lesotho",
      pl: "Lesotho",
      fr: "Lesotho",
      nl: "Lesotho",
      pt: "Lesoto",
      cs: "Lesotho",
      ro: "Lesotho",
      ru: "Лесото"
    },
    rootIddCode: "+266",
    continent: "Africa"
  },
  LT: {
    i18nNames: {
      en: "Lithuania",
      it: "Lituania",
      es: "Lituania",
      de: "Litauen",
      pl: "Litwa",
      fr: "Lituanie",
      nl: "Litouwen",
      pt: "Lituânia",
      cs: "Litva",
      ro: "Lituania",
      ru: "Литва"
    },
    rootIddCode: "+370",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^LT(\\d{9}|\\d{12})$",
    taxIdExample: "LT123456789"
  },
  LU: {
    i18nNames: {
      en: "Luxembourg",
      it: "Lussemburgo",
      es: "Luxemburgo",
      de: "Luxemburg",
      pl: "Luksemburg",
      fr: "Luxembourg",
      nl: "Luxemburg",
      pt: "Luxemburgo",
      cs: "Lucembursko",
      ro: "Luxemburg",
      ru: "Люксембург"
    },
    rootIddCode: "+352",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^LU\\d{8}$",
    taxIdExample: "LU12345678"
  },
  LV: {
    i18nNames: {
      en: "Latvia",
      it: "Lettonia",
      es: "Letonia",
      de: "Lettland",
      pl: "Łotwa",
      fr: "Lettonie",
      nl: "Letland",
      pt: "Letónia",
      cs: "Lotyšsko",
      ro: "Letonia",
      ru: "Латвия"
    },
    rootIddCode: "+371",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^LV\\d{11}$",
    taxIdExample: "LV12345678901"
  },
  LY: {
    i18nNames: {
      en: "Libya",
      it: "Libia",
      es: "Libia",
      de: "Libyen",
      pl: "Libia",
      fr: "Libye",
      nl: "Libië",
      pt: "Líbia",
      cs: "Libye",
      ro: "Libia",
      ru: "Ливия"
    },
    rootIddCode: "+218",
    continent: "Africa"
  },
  MA: {
    i18nNames: {
      en: "Morocco",
      it: "Marocco",
      es: "Marruecos",
      de: "Marokko",
      pl: "Maroko",
      fr: "Maroc",
      nl: "Marokko",
      pt: "Marrocos",
      cs: "Maroko",
      ro: "Maroc",
      ru: "Марокко"
    },
    rootIddCode: "+212",
    continent: "Africa",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{8}$",
    taxIdExample: "12345678"
  },
  MC: {
    i18nNames: {
      en: "Monaco",
      it: "Principato di Monaco",
      es: "Mónaco",
      de: "Monaco",
      pl: "Monako",
      fr: "Monaco",
      nl: "Monaco",
      pt: "Mônaco",
      cs: "Monako",
      ro: "Monaco",
      ru: "Монако"
    },
    rootIddCode: "+377",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^FR[A-Z0-9]{2}\\d{9}$",
    taxIdExample: "FR9Z123456789"
  },
  MD: {
    i18nNames: {
      en: "Moldova",
      it: "Moldavia",
      es: "Moldavia",
      de: "Moldawien",
      pl: "Mołdawia",
      fr: "Moldavie",
      nl: "Moldavië",
      pt: "Moldávia",
      cs: "Moldavsko",
      ro: "Moldova",
      ru: "Молдова"
    },
    rootIddCode: "+373",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^MD\\d{7}$",
    taxIdExample: "MD1234567"
  },
  ME: {
    i18nNames: {
      en: "Montenegro",
      it: "Montenegro",
      es: "Montenegro",
      de: "Montenegro",
      pl: "Czarnogóra",
      fr: "Monténégro",
      nl: "Montenegro",
      pt: "Montenegro",
      cs: "Černá Hora",
      ro: "Muntenegru",
      ru: "Черногория"
    },
    rootIddCode: "+382",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{8}$",
    taxIdExample: "12345678"
  },
  MF: {
    i18nNames: {
      en: "Saint Martin",
      it: "Saint Martin",
      es: "San Martín (parte francesa)",
      de: "Saint-Martin",
      pl: "Saint-Martin",
      fr: "Saint-Martin",
      nl: "Saint Martin",
      pt: "São Martinho",
      cs: "Saint-Martin",
      ro: "Sfântul Martin",
      ru: "Сен-Мартен"
    },
    rootIddCode: "+590",
    continent: "NorthAmerica"
  },
  MG: {
    i18nNames: {
      en: "Madagascar",
      it: "Madagascar",
      es: "Madagascar",
      de: "Madagaskar",
      pl: "Madagaskar",
      fr: "Madagascar",
      nl: "Madagaskar",
      pt: "Madagáscar",
      cs: "Madagaskar",
      ro: "Madagascar",
      ru: "Мадагаскар"
    },
    rootIddCode: "+261",
    continent: "Africa"
  },
  MH: {
    i18nNames: {
      en: "Marshall Islands",
      es: "Islas Marshall",
      it: "Isole Marshall",
      de: "Marshallinseln",
      pl: "Wyspy Marshalla",
      fr: "Îles Marshall",
      nl: "Marshalleilanden",
      pt: "Ilhas Marshall",
      cs: "Marshallovy ostrovy",
      ro: "Insulele Marshall",
      ru: "Маршалловы Острова"
    },
    rootIddCode: "+692",
    continent: "Oceania"
  },
  MK: {
    i18nNames: {
      en: "North Macedonia",
      it: "Macedonia del Nord",
      es: "Macedonia del Norte",
      de: "Nordmazedonien",
      pl: "Macedonia Północna",
      fr: "Macédoine du Nord",
      nl: "Noord-Macedonië",
      pt: "Macedônia do Norte",
      cs: "Severní Makedonie",
      ro: "Macedonia de Nord",
      ru: "Северная Македония"
    },
    rootIddCode: "+389",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{13}$",
    taxIdExample: "1234567890123"
  },
  ML: {
    i18nNames: {
      en: "Mali",
      it: "Mali",
      es: "Malí",
      de: "Mali",
      pl: "Mali",
      fr: "Mali",
      nl: "Mali",
      pt: "Mali",
      cs: "Mali",
      ro: "Mali",
      ru: "Мали"
    },
    rootIddCode: "+223",
    continent: "Africa"
  },
  MM: {
    i18nNames: {
      en: "Myanmar",
      it: "Birmania",
      es: "Birmania",
      de: "Myanmar",
      pl: "Mjanma",
      fr: "Birmanie",
      nl: "Myanmar",
      pt: "Mianmar",
      cs: "Myanmar",
      ro: "Myanmar",
      ru: "Мьянма"
    },
    rootIddCode: "+95",
    continent: "Asia"
  },
  MN: {
    i18nNames: {
      en: "Mongolia",
      it: "Mongolia",
      es: "Mongolia",
      de: "Mongolei",
      pl: "Mongolia",
      fr: "Mongolie",
      nl: "Mongolië",
      pt: "Mongólia",
      cs: "Mongolsko",
      ro: "Mongolia",
      ru: "Монголия"
    },
    rootIddCode: "+976",
    continent: "Asia"
  },
  MO: {
    i18nNames: {
      en: "Macau",
      it: "Macao",
      es: "Macao",
      de: "Macau",
      pl: "Makau",
      fr: "Macao",
      nl: "Macau",
      pt: "Macau",
      cs: "Macao",
      ro: "Macao",
      ru: "Макао"
    },
    rootIddCode: "+853",
    continent: "Asia"
  },
  MP: {
    i18nNames: {
      en: "Northern Mariana Islands",
      es: "Islas Marianas del Norte",
      it: "Isole Marianne Settentrionali",
      de: "Nördliche Marianen",
      pl: "Mariany Północne",
      fr: "Îles Mariannes du Nord",
      nl: "Noordelijke Marianen",
      pt: "Ilhas Marianas do Norte",
      cs: "Severní Mariany",
      ro: "Insulele Mariane de Nord",
      ru: "Северные Марианские острова"
    },
    rootIddCode: "+1670",
    continent: "NorthAmerica"
  },
  MQ: {
    i18nNames: {
      en: "Martinique",
      it: "Martinica",
      es: "Martinica",
      de: "Martinique",
      pl: "Martynika",
      fr: "Martinique",
      nl: "Martinique",
      pt: "Martinica",
      cs: "Martinik",
      ro: "Martinica",
      ru: "Мартиника"
    },
    rootIddCode: "+596",
    continent: "NorthAmerica"
  },
  MR: {
    i18nNames: {
      en: "Mauritania",
      it: "Mauritania",
      es: "Mauritania",
      de: "Mauretanien",
      pl: "Mauretania",
      fr: "Mauritanie",
      nl: "Mauritanië",
      pt: "Mauritânia",
      cs: "Mauritánie",
      ro: "Mauritania",
      ru: "Мавритания"
    },
    rootIddCode: "+222",
    continent: "Africa"
  },
  MS: {
    i18nNames: {
      en: "Montserrat",
      it: "Montserrat",
      es: "Montserrat",
      de: "Montserrat",
      pl: "Montserrat",
      fr: "Montserrat",
      nl: "Montserrat",
      pt: "Montserrat",
      cs: "Montserrat",
      ro: "Montserrat",
      ru: "Монтсеррат"
    },
    rootIddCode: "+1664",
    continent: "NorthAmerica"
  },
  MT: {
    i18nNames: {
      en: "Malta",
      it: "Malta",
      es: "Malta",
      de: "Malta",
      pl: "Malta",
      fr: "Malte",
      nl: "Malta",
      pt: "Malta",
      cs: "Malta",
      ro: "Malta",
      ru: "Мальта"
    },
    rootIddCode: "+356",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^MT\\d{8}$",
    taxIdExample: "MT12345678"
  },
  MU: {
    i18nNames: {
      en: "Mauritius",
      it: "Mauritius",
      es: "Mauricio",
      de: "Mauritius",
      pl: "Mauritius",
      fr: "Île Maurice",
      nl: "Mauritius",
      pt: "Maurício",
      cs: "Mauricius",
      ro: "Mauritius",
      ru: "Маврикий"
    },
    rootIddCode: "+230",
    continent: "Africa"
  },
  MV: {
    i18nNames: {
      en: "Maldives",
      it: "Maldive",
      es: "Maldivas",
      de: "Malediven",
      pl: "Malediwy",
      fr: "Maldives",
      nl: "Maldiven",
      pt: "Maldivas",
      cs: "Maledivy",
      ro: "Maldive",
      ru: "Мальдивы"
    },
    rootIddCode: "+960",
    continent: "Asia"
  },
  MW: {
    i18nNames: {
      en: "Malawi",
      it: "Malawi",
      es: "Malaui",
      de: "Malawi",
      pl: "Malawi",
      fr: "Malawi",
      nl: "Malawi",
      pt: "Maláui",
      cs: "Malawi",
      ro: "Malawi",
      ru: "Малави"
    },
    rootIddCode: "+265",
    continent: "Africa"
  },
  MX: {
    i18nNames: {
      en: "Mexico",
      it: "Messico",
      es: "México",
      de: "Mexiko",
      pl: "Meksyk",
      fr: "Mexique",
      nl: "Mexico",
      pt: "México",
      cs: "Mexiko",
      ro: "Mexic",
      ru: "Мексика"
    },
    rootIddCode: "+52",
    continent: "NorthAmerica"
  },
  MY: {
    i18nNames: {
      en: "Malaysia",
      it: "Malesia",
      es: "Malasia",
      de: "Malaysia",
      pl: "Malezja",
      fr: "Malaisie",
      nl: "Maleisië",
      pt: "Malásia",
      cs: "Malajsie",
      ro: "Malaezia",
      ru: "Малайзия"
    },
    rootIddCode: "+60",
    continent: "Asia"
  },
  MZ: {
    i18nNames: {
      en: "Mozambique",
      it: "Mozambico",
      es: "Mozambique",
      de: "Mosambik",
      pl: "Mozambik",
      fr: "Mozambique",
      nl: "Mozambique",
      pt: "Moçambique",
      cs: "Mosambik",
      ro: "Mozambic",
      ru: "Мозамбик"
    },
    rootIddCode: "+258",
    continent: "Africa"
  },
  NA: {
    i18nNames: {
      en: "Namibia",
      it: "Namibia",
      es: "Namibia",
      de: "Namibia",
      pl: "Namibia",
      fr: "Namibie",
      nl: "Namibië",
      pt: "Namíbia",
      cs: "Namibie",
      ro: "Namibia",
      ru: "Намибия"
    },
    rootIddCode: "+264",
    continent: "Africa"
  },
  NC: {
    i18nNames: {
      en: "New Caledonia",
      it: "Nuova Caledonia",
      es: "Nueva Caledonia",
      de: "Neukaledonien",
      pl: "Nowa Kaledonia",
      fr: "Nouvelle-Calédonie",
      nl: "Nieuw-Caledonië",
      pt: "Nova Caledônia",
      cs: "Nová Kaledonie",
      ro: "Noua Caledonie",
      ru: "Новая Каледония"
    },
    rootIddCode: "+687",
    continent: "Oceania"
  },
  NE: {
    i18nNames: {
      en: "Niger",
      it: "Niger",
      es: "Níger",
      de: "Niger",
      pl: "Niger",
      fr: "Niger",
      nl: "Niger",
      pt: "Níger",
      cs: "Niger",
      ro: "Niger",
      ru: "Нигер"
    },
    rootIddCode: "+227",
    continent: "Africa"
  },
  NF: {
    i18nNames: {
      en: "Norfolk Island",
      it: "Isola Norfolk",
      es: "Isla Norfolk",
      de: "Norfolkinsel",
      pl: "Wyspa Norfolk",
      fr: "Île Norfolk",
      nl: "Norfolkeiland",
      pt: "Ilha Norfolk",
      cs: "Ostrov Norfolk",
      ro: "Insula Norfolk",
      ru: "Остров Норфолк"
    },
    rootIddCode: "+672",
    continent: "Oceania"
  },
  NG: {
    i18nNames: {
      en: "Nigeria",
      it: "Nigeria",
      es: "Nigeria",
      de: "Nigeria",
      pl: "Nigeria",
      fr: "Nigeria",
      nl: "Nigeria",
      pt: "Nigéria",
      cs: "Nigérie",
      ro: "Nigeria",
      ru: "Нигерия"
    },
    rootIddCode: "+234",
    continent: "Africa"
  },
  NI: {
    i18nNames: {
      en: "Nicaragua",
      it: "Nicaragua",
      es: "Nicaragua",
      de: "Nicaragua",
      pl: "Nikaragua",
      fr: "Nicaragua",
      nl: "Nicaragua",
      pt: "Nicarágua",
      cs: "Nikaragua",
      ro: "Nicaragua",
      ru: "Никарагуа"
    },
    rootIddCode: "+505",
    continent: "NorthAmerica"
  },
  NL: {
    i18nNames: {
      en: "Netherlands",
      it: "Paesi Bassi",
      es: "Países Bajos",
      de: "Niederlande",
      pl: "Holandia",
      fr: "Pays-Bas",
      nl: "Nederland",
      pt: "Países Baixos",
      cs: "Nizozemsko",
      ro: "Țările de Jos",
      ru: "Нидерланды"
    },
    rootIddCode: "+31",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !1,
    taxIdPattern: "^NL\\d{9}B\\d{2}$",
    taxIdExample: "NL123456789B01"
  },
  NO: {
    i18nNames: {
      en: "Norway",
      it: "Norvegia",
      es: "Noruega",
      de: "Norwegen",
      pl: "Norwegia",
      fr: "Norvège",
      nl: "Noorwegen",
      pt: "Noruega",
      cs: "Norsko",
      ro: "Norvegia",
      ru: "Норвегия"
    },
    rootIddCode: "+47",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^NO\\d{9}MVA$",
    taxIdExample: "NO123456789MVA"
  },
  NP: {
    i18nNames: {
      en: "Nepal",
      it: "Nepal",
      es: "Nepal",
      de: "Nepal",
      pl: "Nepal",
      fr: "Népal",
      nl: "Nepal",
      pt: "Nepal",
      cs: "Nepál",
      ro: "Nepal",
      ru: "Непал"
    },
    rootIddCode: "+977",
    continent: "Asia"
  },
  NR: {
    i18nNames: {
      en: "Nauru",
      it: "Nauru",
      es: "Nauru",
      de: "Nauru",
      pl: "Nauru",
      fr: "Nauru",
      nl: "Nauru",
      pt: "Nauru",
      cs: "Nauru",
      ro: "Nauru",
      ru: "Науру"
    },
    rootIddCode: "+674",
    continent: "Oceania"
  },
  NU: {
    i18nNames: {
      en: "Niue",
      it: "Niue",
      es: "Niue",
      de: "Niue",
      pl: "Niue",
      fr: "Niue",
      nl: "Niue",
      pt: "Niue",
      cs: "Niue",
      ro: "Niue",
      ru: "Ниуэ"
    },
    rootIddCode: "+683",
    continent: "Oceania"
  },
  NZ: {
    i18nNames: {
      en: "New Zealand",
      it: "Nuova Zelanda",
      es: "Nueva Zelanda",
      de: "Neuseeland",
      pl: "Nowa Zelandia",
      fr: "Nouvelle-Zélande",
      nl: "Nieuw-Zeeland",
      pt: "Nova Zelândia",
      cs: "Nový Zéland",
      ro: "Noua Zeelandă",
      ru: "Новая Зеландия"
    },
    rootIddCode: "+64",
    continent: "Oceania"
  },
  OM: {
    i18nNames: {
      en: "Oman",
      it: "Oman",
      es: "Omán",
      de: "Oman",
      pl: "Oman",
      fr: "Oman",
      nl: "Oman",
      pt: "Omã",
      cs: "Omán",
      ro: "Oman",
      ru: "Оман"
    },
    rootIddCode: "+968",
    continent: "Asia",
    taxIdMandatory: !0,
    taxIdPattern: "^OM\\d{10}$",
    taxIdExample: "OM1234567890"
  },
  PA: {
    i18nNames: {
      en: "Panama",
      it: "Panama",
      es: "Panamá",
      de: "Panama",
      pl: "Panama",
      fr: "Panama",
      nl: "Panama",
      pt: "Panamá",
      cs: "Panama",
      ro: "Panama",
      ru: "Панама"
    },
    rootIddCode: "+507",
    continent: "NorthAmerica"
  },
  PE: {
    i18nNames: {
      en: "Peru",
      it: "Perù",
      es: "Perú",
      de: "Peru",
      pl: "Peru",
      fr: "Pérou",
      nl: "Peru",
      pt: "Peru",
      cs: "Peru",
      ro: "Peru",
      ru: "Перу"
    },
    rootIddCode: "+51",
    continent: "SouthAmerica"
  },
  PF: {
    i18nNames: {
      en: "French Polynesia",
      es: "Polinesia Francesa",
      it: "Polinesia Francese",
      de: "Französisch-Polynesien",
      pl: "Polinezja Francuska",
      fr: "Polynésie française",
      nl: "Frans-Polynesië",
      pt: "Polinésia Francesa",
      cs: "Francouzská Polynésie",
      ro: "Polinezia Franceză",
      ru: "Французская Полинезия"
    },
    rootIddCode: "+689",
    continent: "Oceania"
  },
  PG: {
    i18nNames: {
      en: "Papua New Guinea",
      es: "Papúa Nueva Guinea",
      it: "Papua Nuova Guinea",
      de: "Papua-Neuguinea",
      pl: "Papua-Nowa Gwinea",
      fr: "Papouasie-Nouvelle-Guinée",
      nl: "Papoea-Nieuw-Guinea",
      pt: "Papua-Nova Guiné",
      cs: "Papua-Nová Guinea",
      ro: "Papua Noua Guinee",
      ru: "Папуа — Новая Гвинея"
    },
    rootIddCode: "+675",
    continent: "Oceania"
  },
  PH: {
    i18nNames: {
      en: "Philippines",
      it: "Filippine",
      es: "Filipinas",
      de: "Philippinen",
      pl: "Filipiny",
      fr: "Philippines",
      nl: "Filipijnen",
      pt: "Filipinas",
      cs: "Filipíny",
      ro: "Filipine",
      ru: "Филиппины"
    },
    rootIddCode: "+63",
    continent: "Asia"
  },
  PK: {
    i18nNames: {
      en: "Pakistan",
      it: "Pakistan",
      es: "Pakistán",
      de: "Pakistan",
      pl: "Pakistan",
      fr: "Pakistan",
      nl: "Pakistan",
      pt: "Paquistão",
      cs: "Pákistán",
      ro: "Pakistan",
      ru: "Пакистан"
    },
    rootIddCode: "+92",
    continent: "Asia"
  },
  PL: {
    i18nNames: {
      en: "Poland",
      it: "Polonia",
      es: "Polonia",
      de: "Polen",
      pl: "Polska",
      fr: "Pologne",
      nl: "Polen",
      pt: "Polónia",
      cs: "Polsko",
      ro: "Polonia",
      ru: "Польша"
    },
    rootIddCode: "+48",
    continent: "Europe",
    blocMemberships: ["EU"],
    regions: QS,
    taxIdMandatory: !0,
    taxIdPattern: "^PL\\d{10}$",
    taxIdExample: "PL1234567890"
  },
  PM: {
    i18nNames: {
      en: "Saint Pierre and Miquelon",
      es: "San Pedro y Miquelón",
      it: "Saint-Pierre e Miquelon",
      de: "Saint-Pierre und Miquelon",
      pl: "Saint-Pierre i Miquelon",
      fr: "Saint-Pierre-et-Miquelon",
      nl: "Saint-Pierre en Miquelon",
      pt: "Saint Pierre e Miquelon",
      cs: "Saint Pierre a Miquelon",
      ro: "Saint Pierre și Miquelon",
      ru: "Сен-Пьер и Микелон"
    },
    rootIddCode: "+508",
    continent: "NorthAmerica"
  },
  PN: {
    i18nNames: {
      en: "Pitcairn Islands",
      es: "Islas Pitcairn",
      it: "Isole Pitcairn",
      de: "Pitcairninseln",
      pl: "Wyspy Pitcairn",
      fr: "Îles Pitcairn",
      nl: "Pitcairneilanden",
      pt: "Ilhas Pitcairn",
      cs: "Pitcairnovy ostrovy",
      ro: "Insulele Pitcairn",
      ru: "Острова Питкэрн"
    },
    rootIddCode: "+64",
    continent: "Oceania"
  },
  PR: {
    i18nNames: {
      en: "Puerto Rico",
      it: "Porto Rico",
      es: "Puerto Rico",
      de: "Puerto Rico",
      pl: "Portoryko",
      fr: "Porto Rico",
      nl: "Puerto Rico",
      pt: "Porto Rico",
      cs: "Portoriko",
      ro: "Puerto Rico",
      ru: "Пуэрто-Рико"
    },
    rootIddCode: "+1939",
    continent: "NorthAmerica"
  },
  PS: {
    i18nNames: {
      en: "Palestine",
      it: "Palestina",
      es: "Palestina",
      de: "Palästina",
      pl: "Palestyna",
      fr: "Palestine",
      nl: "Palestina",
      pt: "Palestina",
      cs: "Palestina",
      ro: "Palestina",
      ru: "Палестина"
    },
    rootIddCode: "+970",
    continent: "Asia",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{9}$",
    taxIdExample: "123456789"
  },
  PT: {
    i18nNames: {
      en: "Portugal",
      it: "Portogallo",
      es: "Portugal",
      de: "Portugal",
      pl: "Portugalia",
      fr: "Portugal",
      nl: "Portugal",
      pt: "Portugal",
      cs: "Portugalsko",
      ro: "Portugalia",
      ru: "Португалия"
    },
    rootIddCode: "+351",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^PT\\d{9}$",
    taxIdExample: "PT123456789"
  },
  PW: {
    i18nNames: {
      en: "Palau",
      it: "Palau",
      es: "Palaos",
      de: "Palau",
      pl: "Palau",
      fr: "Palaos",
      nl: "Palau",
      pt: "Palau",
      cs: "Palau",
      ro: "Palau",
      ru: "Палау"
    },
    rootIddCode: "+680",
    continent: "Oceania"
  },
  PY: {
    i18nNames: {
      en: "Paraguay",
      it: "Paraguay",
      es: "Paraguay",
      de: "Paraguay",
      pl: "Paragwaj",
      fr: "Paraguay",
      nl: "Paraguay",
      pt: "Paraguai",
      cs: "Paraguay",
      ro: "Paraguay",
      ru: "Парагвай"
    },
    rootIddCode: "+595",
    continent: "SouthAmerica"
  },
  QA: {
    i18nNames: {
      en: "Qatar",
      it: "Qatar",
      es: "Catar",
      de: "Katar",
      pl: "Katar",
      fr: "Qatar",
      nl: "Qatar",
      pt: "Catar",
      cs: "Katar",
      ro: "Qatar",
      ru: "Катар"
    },
    rootIddCode: "+974",
    continent: "Asia"
  },
  RE: {
    i18nNames: {
      en: "Réunion",
      it: "Riunione",
      es: "Reunión",
      de: "Réunion",
      pl: "Reunion",
      fr: "Réunion",
      nl: "Réunion",
      pt: "Reunião",
      cs: "Réunion",
      ro: "Réunion",
      ru: "Реюньон"
    },
    rootIddCode: "+262",
    continent: "Africa"
  },
  RO: {
    i18nNames: {
      en: "Romania",
      it: "Romania",
      es: "Rumanía",
      de: "Rumänien",
      pl: "Rumunia",
      fr: "Roumanie",
      nl: "Roemenië",
      pt: "Romênia",
      cs: "Rumunsko",
      ro: "România",
      ru: "Румыния"
    },
    rootIddCode: "+40",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^RO\\d{2,10}$",
    taxIdExample: "RO123456"
  },
  RS: {
    i18nNames: {
      en: "Serbia",
      it: "Serbia",
      es: "Serbia",
      de: "Serbien",
      pl: "Serbia",
      fr: "Serbie",
      nl: "Servië",
      pt: "Sérvia",
      cs: "Srbsko",
      ro: "Serbia",
      ru: "Сербия"
    },
    rootIddCode: "+381",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{9}$",
    taxIdExample: "123456789"
  },
  RU: {
    i18nNames: {
      en: "Russia",
      it: "Russia",
      es: "Rusia",
      de: "Russland",
      pl: "Rosja",
      fr: "Russie",
      nl: "Rusland",
      pt: "Rússia",
      cs: "Rusko",
      ro: "Rusia",
      ru: "Россия"
    },
    rootIddCode: "+79",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{10}$",
    taxIdExample: "1234567890"
  },
  RW: {
    i18nNames: {
      en: "Rwanda",
      it: "Ruanda",
      es: "Ruanda",
      de: "Ruanda",
      pl: "Rwanda",
      fr: "Rwanda",
      nl: "Rwanda",
      pt: "Ruanda",
      cs: "Rwanda",
      ro: "Rwanda",
      ru: "Руанда"
    },
    rootIddCode: "+250",
    continent: "Africa"
  },
  SA: {
    i18nNames: {
      en: "Saudi Arabia",
      it: "Arabia Saudita",
      es: "Arabia Saudita",
      de: "Saudi-Arabien",
      pl: "Arabia Saudyjska",
      fr: "Arabie Saoudite",
      nl: "Saoedi-Arabië",
      pt: "Arábia Saudita",
      cs: "Saúdská Arábie",
      ro: "Arabia Saudită",
      ru: "Саудовская Аравия"
    },
    rootIddCode: "+966",
    continent: "Asia",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{15}$",
    taxIdExample: "123456789012345"
  },
  BA: {
    i18nNames: {
      en: "Bosnia and Herzegovina",
      es: "Bosnia y Herzegovina",
      it: "Bosnia ed Erzegovina",
      de: "Bosnien und Herzegовина",
      pl: "Bośnia i Hercegowina",
      fr: "Bosnie-Herzégovine",
      nl: "Bosnië en Herzegovina",
      pt: "Bósnia e Herzegovina",
      cs: "Bosna a Hercegovina",
      ro: "Bosnia și Herțegovina",
      ru: "Босния и Герцеговина"
    },
    rootIddCode: "+387",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^(\\d{12}|\\d{13})$",
    taxIdExample: "123456789012"
  },
  SB: {
    i18nNames: {
      en: "Solomon Islands",
      it: "Isole Salomone",
      es: "Islas Salomón",
      de: "Salomonen",
      pl: "Wyspy Salomona",
      fr: "Îles Salomon",
      nl: "Salomonseilanden",
      pt: "Ilhas Salomão",
      cs: "Šalamounovy ostrovy",
      ro: "Insulele Solomon",
      ru: "Соломоновы Острова"
    },
    rootIddCode: "+677",
    continent: "Oceania"
  },
  SC: {
    i18nNames: {
      en: "Seychelles",
      it: "Seychelles",
      es: "Seychelles",
      de: "Seychellen",
      pl: "Seszele",
      fr: "Seychelles",
      nl: "Seychellen",
      pt: "Seicheles",
      cs: "Seychely",
      ro: "Seychelles",
      ru: "Сейшельские Острова"
    },
    rootIddCode: "+248",
    continent: "Africa"
  },
  SD: {
    i18nNames: {
      en: "Sudan",
      it: "Sudan",
      es: "Sudán",
      de: "Sudan",
      pl: "Sudan",
      fr: "Soudan",
      nl: "Soedan",
      pt: "Sudão",
      cs: "Súdán",
      ro: "Sudan",
      ru: "Судан"
    },
    rootIddCode: "+249",
    continent: "Africa",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{12}$",
    taxIdExample: "123456789012"
  },
  SE: {
    i18nNames: {
      en: "Sweden",
      it: "Svezia",
      es: "Suecia",
      de: "Schweden",
      pl: "Szwecja",
      fr: "Suède",
      nl: "Zweden",
      pt: "Suécia",
      cs: "Švédsko",
      ro: "Suedia",
      ru: "Швеция"
    },
    rootIddCode: "+46",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^SE\\d{12}$",
    taxIdExample: "SE123456789012"
  },
  SG: {
    i18nNames: {
      en: "Singapore",
      it: "Singapore",
      es: "Singapur",
      de: "Singapur",
      pl: "Singapur",
      fr: "Singapour",
      nl: "Singapore",
      pt: "Singapura",
      cs: "Singapur",
      ro: "Singapore",
      ru: "Сингапур"
    },
    rootIddCode: "+65",
    continent: "Asia"
    //quando verrà mappata aggiungere taxIdMandatory: false, in quanto non obbligatorio
  },
  SH: {
    i18nNames: {
      en: "Saint Helena, Ascension and Tristan da Cunha",
      es: "Santa Elena",
      it: "Sant'Elena, Ascensione e Tristan da Cunha",
      de: "Sankt Helena, Ascension und Tristan da Cunha",
      pl: "Wyspa Świętej Heleny, Wniebowstąpienia i Tristan da Cunha",
      fr: "Sainte-Hélène, Ascension et Tristan da Cunha",
      nl: "Sint-Helena, Ascension en Tristan da Cunha",
      pt: "Santa Helena, Ascensão e Tristão da Cunha",
      cs: "Svatá Helena, Ascension a Tristan da Cunha",
      ro: "Sfânta Elena, Ascension și Tristan da Cunha",
      ru: "Остров Святой Елены, Вознесения и Тристан-да-Кунья"
    },
    rootIddCode: "+247",
    continent: "Africa"
  },
  SI: {
    i18nNames: {
      en: "Slovenia",
      it: "Slovenia",
      es: "Eslovenia",
      de: "Slowenien",
      pl: "Słowenia",
      fr: "Slovénie",
      nl: "Slovenië",
      pt: "Eslovênia",
      cs: "Slovinsko",
      ro: "Slovenia",
      ru: "Словения"
    },
    rootIddCode: "+386",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^SI\\d{8}$",
    taxIdExample: "SI12345678"
  },
  SJ: {
    i18nNames: {
      en: "Svalbard and Jan Mayen",
      es: "Svalbard y Jan Mayen",
      it: "Svalbard e Jan Mayen",
      de: "Svalbard und Jan Mayen",
      pl: "Svalbard i Jan Mayen",
      fr: "Svalbard et Jan Mayen",
      nl: "Spitsbergen en Jan Mayen",
      pt: "Svalbard e Jan Mayen",
      cs: "Špicberky a Jan Mayen",
      ro: "Svalbard și Jan Mayen",
      ru: "Шпицберген и Ян-Майен"
    },
    rootIddCode: "+4779",
    continent: "Europe"
  },
  SK: {
    i18nNames: {
      en: "Slovakia",
      it: "Slovacchia",
      es: "Eslovaquia",
      de: "Slowakei",
      pl: "Słowacja",
      fr: "Slovaquie",
      nl: "Slowakije",
      pt: "Eslováquia",
      cs: "Slovensko",
      ro: "Slovacia",
      ru: "Словакия"
    },
    rootIddCode: "+421",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^SK\\d{10}$",
    taxIdExample: "SK1234567890"
  },
  SL: {
    i18nNames: {
      en: "Sierra Leone",
      it: "Sierra Leone",
      es: "Sierra Leona",
      de: "Sierra Leone",
      pl: "Sierra Leone",
      fr: "Sierra Leone",
      nl: "Sierra Leone",
      pt: "Serra Leoa",
      cs: "Sierra Leone",
      ro: "Sierra Leone",
      ru: "Сьерра-Леоне"
    },
    rootIddCode: "+232",
    continent: "Africa"
  },
  SM: {
    i18nNames: {
      en: "San Marino",
      it: "San Marino",
      es: "San Marino",
      de: "San Marino",
      pl: "San Marino",
      fr: "Saint-Marin",
      nl: "San Marino",
      pt: "San Marino",
      cs: "San Marino",
      ro: "San Marino",
      ru: "Сан-Марино"
    },
    rootIddCode: "+378",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^SM\\d{5}$",
    taxIdExample: "SM12345"
  },
  SN: {
    i18nNames: {
      en: "Senegal",
      it: "Senegal",
      es: "Senegal",
      de: "Senegal",
      pl: "Senegal",
      fr: "Sénégal",
      nl: "Senegal",
      pt: "Senegal",
      cs: "Senegal",
      ro: "Senegal",
      ru: "Сенегал"
    },
    rootIddCode: "+221",
    continent: "Africa"
  },
  SO: {
    i18nNames: {
      en: "Somalia",
      it: "Somalia",
      es: "Somalia",
      de: "Somalia",
      pl: "Somalia",
      fr: "Somalie",
      nl: "Somalië",
      pt: "Somália",
      cs: "Somálsko",
      ro: "Somalia",
      ru: "Сомали"
    },
    rootIddCode: "+252",
    continent: "Africa"
  },
  SR: {
    i18nNames: {
      en: "Suriname",
      it: "Suriname",
      es: "Surinam",
      de: "Suriname",
      pl: "Surinam",
      fr: "Suriname",
      nl: "Suriname",
      pt: "Suriname",
      cs: "Surinam",
      ro: "Surinam",
      ru: "Суринам"
    },
    rootIddCode: "+597",
    continent: "SouthAmerica"
  },
  SS: {
    i18nNames: {
      en: "South Sudan",
      it: "Sudan del sud",
      es: "Sudán del Sur",
      de: "Südsudan",
      pl: "Sudan Południowy",
      fr: "Soudan du Sud",
      nl: "Zuid-Soedan",
      pt: "Sudão do Sul",
      cs: "Jižní Súdán",
      ro: "Sudanul de Sud",
      ru: "Южный Судан"
    },
    rootIddCode: "+211",
    continent: "Africa"
  },
  ST: {
    i18nNames: {
      en: "São Tomé and Príncipe",
      es: "Santo Tomé y Príncipe",
      it: "São Tomé e Príncipe",
      de: "São Tomé und Príncipe",
      pl: "Wyspy Świętego Tomasza i Książęca",
      fr: "Sao Tomé-et-Principe",
      nl: "Sao Tomé en Principe",
      pt: "São Tomé e Príncipe",
      cs: "Svatý Tomáš a Princův ostrov",
      ro: "São Tomé și Príncipe",
      ru: "Сан-Томе и Принсипи"
    },
    rootIddCode: "+239",
    continent: "Africa"
  },
  SV: {
    i18nNames: {
      en: "El Salvador",
      it: "El Salvador",
      es: "El Salvador",
      de: "El Salvador",
      pl: "Salwador",
      fr: "Le Salvador",
      nl: "El Salvador",
      pt: "El Salvador",
      cs: "Salvador",
      ro: "El Salvador",
      ru: "Сальвадор"
    },
    rootIddCode: "+503",
    continent: "NorthAmerica"
  },
  SX: {
    i18nNames: {
      en: "Sint Maarten",
      it: "Sint Maarten",
      es: "San Martín (parte neerlandesa)",
      de: "Sint Maarten",
      pl: "Sint Maarten",
      fr: "Saint-Martin (partie néerlandaise)",
      nl: "Sint Maarten",
      pt: "Sint Maarten",
      cs: "Svatý Martin (nizozemská část)",
      ro: "Sint Maarten",
      ru: "Синт-Мартен"
    },
    rootIddCode: "+1721",
    continent: "NorthAmerica"
  },
  SY: {
    i18nNames: {
      en: "Syria",
      it: "Siria",
      es: "Siria",
      de: "Сирия",
      pl: "Syria",
      fr: "Syrie",
      nl: "Syrië",
      pt: "Síria",
      cs: "Sýrie",
      ro: "Siria",
      ru: "Сирия"
    },
    rootIddCode: "+963",
    continent: "Asia"
  },
  SZ: {
    i18nNames: {
      en: "Eswatini",
      it: "Swaziland",
      es: "Suazilandia",
      de: "Eswatini",
      pl: "Eswatini",
      fr: "Eswatini",
      nl: "Eswatini",
      pt: "Essuatíni",
      cs: "Eswatini",
      ro: "Eswatini",
      ru: "Эсватини"
    },
    rootIddCode: "+268",
    continent: "Africa"
  },
  TC: {
    i18nNames: {
      en: "Turks and Caicos Islands",
      es: "Islas Turcas y Caicos",
      it: "Isole Turks e Caicos",
      de: "Turks- und Caicosinseln",
      pl: "Turks i Caicos",
      fr: "Îles Turques-et-Caïques",
      nl: "Turks- en Caicoseilanden",
      pt: "Ilhas Turcas e Caicos",
      cs: "Ostrovy Turks a Caicos",
      ro: "Insulele Turks și Caicos",
      ru: "Теркс и Кайкос"
    },
    rootIddCode: "+1649",
    continent: "NorthAmerica"
  },
  TD: {
    i18nNames: {
      en: "Chad",
      it: "Ciad",
      es: "Chad",
      de: "Tschad",
      pl: "Czad",
      fr: "Tchad",
      nl: "Tsjaad",
      pt: "Chade",
      cs: "Čад",
      ro: "Ciad",
      ru: "Чад"
    },
    rootIddCode: "+235",
    continent: "Africa"
  },
  TF: {
    i18nNames: {
      en: "French Southern and Antarctic Lands",
      es: "Territorios Australes Franceses",
      it: "Territori Francesi del Sud",
      de: "Französische Süd- und Antarktisgebiete",
      pl: "Francuskie Terytoria Południowe i Antarktyczne",
      fr: "Terres australes et antarctiques françaises",
      nl: "Franse Zuidelijke en Antarctische Gebieden",
      pt: "Terras Austrais e Antárticas Francesas",
      cs: "Francouzská jižní a antarktická území",
      ro: "Teritoriile Australe și Antarctice Franceze",
      ru: "Французские южные и антарктические территории"
    },
    rootIddCode: "+262",
    continent: "Oceania"
  },
  TG: {
    i18nNames: {
      en: "Togo",
      it: "Togo",
      es: "Togo",
      de: "Togo",
      pl: "Togo",
      fr: "Togo",
      nl: "Togo",
      pt: "Togo",
      cs: "Togo",
      ro: "Togo",
      ru: "Того"
    },
    rootIddCode: "+228",
    continent: "Africa"
  },
  TH: {
    i18nNames: {
      en: "Thailand",
      it: "Tailandia",
      es: "Tailandia",
      de: "Thailand",
      pl: "Tajlandia",
      fr: "Thaïlande",
      nl: "Thailand",
      pt: "Tailândia",
      cs: "Thajsko",
      ro: "Thailanda",
      ru: "Таиланд"
    },
    rootIddCode: "+66",
    continent: "Asia"
  },
  TJ: {
    i18nNames: {
      en: "Tajikistan",
      it: "Tagikistan",
      es: "Tayikistán",
      de: "Tadschikistan",
      pl: "Tadżykistan",
      fr: "Tadjikistan",
      nl: "Tadzjikistan",
      pt: "Tajiquistão",
      cs: "Tádžikistán",
      ro: "Tadjikistan",
      ru: "Таджикистан"
    },
    rootIddCode: "+992",
    continent: "Asia"
  },
  TK: {
    i18nNames: {
      en: "Tokelau",
      it: "Isole Tokelau",
      es: "Tokelau",
      de: "Tokelau",
      pl: "Tokelau",
      fr: "Tokelau",
      nl: "Tokelau",
      pt: "Tokelau",
      cs: "Tokelau",
      ro: "Tokelau",
      ru: "Токелау"
    },
    rootIddCode: "+690",
    continent: "Oceania"
  },
  TL: {
    i18nNames: {
      en: "Timor-Leste",
      it: "Timor Est",
      es: "Timor-Leste",
      de: "Osttimor",
      pl: "Timor Wschodni",
      fr: "Timor oriental",
      nl: "Oost-Timor",
      pt: "Timor-Leste",
      cs: "Východní Timor",
      ro: "Timorul de Est",
      ru: "Восточный Тимор"
    },
    rootIddCode: "+670",
    continent: "Asia"
  },
  TM: {
    i18nNames: {
      en: "Turkmenistan",
      it: "Turkmenistan",
      es: "Turkmenistán",
      de: "Turkmenistan",
      pl: "Turkmenistan",
      fr: "Turkménistan",
      nl: "Turkmenistan",
      pt: "Turquemenistão",
      cs: "Turkmenistán",
      ro: "Turkmenistan",
      ru: "Туркменистан"
    },
    rootIddCode: "+993",
    continent: "Asia"
  },
  TN: {
    i18nNames: {
      en: "Tunisia",
      it: "Tunisia",
      es: "Túnez",
      de: "Tunesien",
      pl: "Tunezja",
      fr: "Tunisie",
      nl: "Tunesië",
      pt: "Tunísia",
      cs: "Tunisko",
      ro: "Tunisia",
      ru: "Тунис"
    },
    rootIddCode: "+216",
    continent: "Africa",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{8}$",
    taxIdExample: "12345678"
  },
  TO: {
    i18nNames: {
      en: "Tonga",
      it: "Tonga",
      es: "Tonga",
      de: "Tonga",
      pl: "Tonga",
      fr: "Tonga",
      nl: "Tonga",
      pt: "Tonga",
      cs: "Tonga",
      ro: "Tonga",
      ru: "Тонга"
    },
    rootIddCode: "+676",
    continent: "Oceania"
  },
  TR: {
    i18nNames: {
      en: "Turkey",
      it: "Turchia",
      es: "Turquía",
      de: "Türkei",
      pl: "Turcja",
      fr: "Turquie",
      nl: "Turkije",
      pt: "Turquia",
      cs: "Turecko",
      ro: "Turcia",
      ru: "Турция"
    },
    rootIddCode: "+90",
    continent: "Europe"
  },
  TT: {
    i18nNames: {
      en: "Trinidad and Tobago",
      es: "Trinidad y Tobago",
      it: "Trinidad e Tobago",
      de: "Trinidad und Tobago",
      pl: "Trynidad i Tobago",
      fr: "Trinité-et-Tobago",
      nl: "Trinidad en Tobago",
      pt: "Trinidad e Tobago",
      cs: "Trinidad a Tobago",
      ro: "Trinidad și Tobago",
      ru: "Тринидад и Тобаго"
    },
    rootIddCode: "+1868",
    continent: "NorthAmerica"
  },
  TV: {
    i18nNames: {
      en: "Tuvalu",
      it: "Tuvalu",
      es: "Tuvalu",
      de: "Tuvalu",
      pl: "Tuvalu",
      fr: "Tuvalu",
      nl: "Tuvalu",
      pt: "Tuvalu",
      cs: "Tuvalu",
      ro: "Tuvalu",
      ru: "Тувалу"
    },
    rootIddCode: "+688",
    continent: "Oceania"
  },
  TW: {
    i18nNames: {
      en: "Taiwan",
      it: "Taiwan",
      es: "Taiwán",
      de: "Taiwan",
      pl: "Tajwan",
      fr: "Taïwan",
      nl: "Taiwan",
      pt: "Taiwan",
      cs: "Tchaj-wan",
      ro: "Taiwan",
      ru: "Тайвань"
    },
    rootIddCode: "+886",
    continent: "Asia"
  },
  TZ: {
    i18nNames: {
      en: "Tanzania",
      it: "Tanzania",
      es: "Tanzania",
      de: "Tansania",
      pl: "Tanzania",
      fr: "Tanzanie",
      nl: "Tanzania",
      pt: "Tanzânia",
      cs: "Tanzanie",
      ro: "Tanzania",
      ru: "Танзания"
    },
    rootIddCode: "+255",
    continent: "Africa"
  },
  UA: {
    i18nNames: {
      en: "Ukraine",
      it: "Ucraina",
      es: "Ucrania",
      de: "Ukraine",
      pl: "Ukraina",
      fr: "Ukraine",
      nl: "Oekraïne",
      pt: "Ucrânia",
      cs: "Ukrajina",
      ro: "Ucraina",
      ru: "Украина"
    },
    rootIddCode: "+380",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^(\\d{8}|\\d{12})$",
    taxIdExample: "12345678"
  },
  UG: {
    i18nNames: {
      en: "Uganda",
      it: "Uganda",
      es: "Uganda",
      de: "Uganda",
      pl: "Uganda",
      fr: "Ouganda",
      nl: "Oeganda",
      pt: "Uganda",
      cs: "Uganda",
      ro: "Uganda",
      ru: "Уганда"
    },
    rootIddCode: "+256",
    continent: "Africa"
  },
  UM: {
    i18nNames: {
      en: "United States Minor Outlying Islands",
      es: "Islas menores alejadas de los Estados Unidos",
      it: "Isole minori esterne degli Stati Uniti d'America",
      de: "Kleinere Inselbesitzungen der Vereinigten Staaten",
      pl: "Dalekie Wyspy Mniejsze Stanów Zjednoczonych",
      fr: "Îles mineures éloignées des États-Unis",
      nl: "Kleine afgelegen eilanden van de Verenigde Staten",
      pt: "Ilhas Menores Distantes dos EUA",
      cs: "Menší odlehlé ostrovy USA",
      ro: "Insulele S.U.A. din Oceanul Pacific",
      ru: "Внешние малые острова США"
    },
    rootIddCode: "+268",
    continent: "NorthAmerica"
  },
  US: {
    i18nNames: {
      en: "United States",
      it: "Stati Uniti d'America",
      es: "Estados Unidos",
      de: "Vereinigte Staaten",
      pl: "Stany Zjednoczone",
      fr: "États-Unis",
      nl: "Verenigde Staten",
      pt: "Estados Unidos",
      cs: "Spojené státy americké",
      ro: "Statele Unite ale Americii",
      ru: "Соединённые Штаты"
    },
    rootIddCode: "+1989",
    continent: "NorthAmerica"
    //quando verrà mappata aggiungere taxIdMandatory: false, in quanto non obbligatorio
  },
  UY: {
    i18nNames: {
      en: "Uruguay",
      it: "Uruguay",
      es: "Uruguay",
      de: "Uruguay",
      pl: "Urugwaj",
      fr: "Uruguay",
      nl: "Uruguay",
      pt: "Uruguai",
      cs: "Uruguay",
      ro: "Uruguay",
      ru: "Уругвай"
    },
    rootIddCode: "+598",
    continent: "SouthAmerica"
  },
  UZ: {
    i18nNames: {
      en: "Uzbekistan",
      it: "Uzbekistan",
      es: "Uzbekistán",
      de: "Usbekistan",
      pl: "Uzbekistan",
      fr: "Ouzbékistan",
      nl: "Oezbekistan",
      pt: "Uzbequistão",
      cs: "Uzbekistán",
      ro: "Uzbekistan",
      ru: "Узбекистан"
    },
    rootIddCode: "+998",
    continent: "Asia"
  },
  VA: {
    i18nNames: {
      en: "Vatican City",
      it: "Città del Vaticano",
      es: "Ciudad del Vaticano",
      de: "Vatikanstadt",
      pl: "Watykan",
      fr: "Cité du Vatican",
      nl: "Vaticaanstad",
      pt: "Cidade do Vaticano",
      cs: "Vatikán",
      ro: "Vatican",
      ru: "Ватикан"
    },
    rootIddCode: "+379",
    continent: "Europe"
  },
  VC: {
    i18nNames: {
      en: "Saint Vincent and the Grenadines",
      es: "San Vicente y las Granadinas",
      it: "Saint Vincent e Grenadine",
      de: "St. Vincent und die Grenadinen",
      pl: "Saint Vincent i Grenadyny",
      fr: "Saint-Vincent-et-les-Grenadines",
      nl: "Saint Vincent en de Grenadines",
      pt: "São Vicente e Granadinas",
      cs: "Svatý Vincenc a Grenadiny",
      ro: "Sfântul Vincent și Grenadine",
      ru: "Сент-Винсент и Гренадины"
    },
    rootIddCode: "+1784",
    continent: "NorthAmerica"
  },
  VE: {
    i18nNames: {
      en: "Venezuela",
      it: "Venezuela",
      es: "Venezuela",
      de: "Venezuela",
      pl: "Wenezuela",
      fr: "Venezuela",
      nl: "Venezuela",
      pt: "Venezuela",
      cs: "Venezuela",
      ro: "Venezuela",
      ru: "Венесуэла"
    },
    rootIddCode: "+58",
    continent: "SouthAmerica"
  },
  VG: {
    i18nNames: {
      en: "British Virgin Islands",
      es: "Islas Vírgenes Británicas",
      it: "Isole Vergini Britanniche",
      de: "Britische Jungferninseln",
      pl: "Brytyjskie Wyspy Dziewicze",
      fr: "Îles Vierges britanniques",
      nl: "Britse Maagdeneilanden",
      pt: "Ilhas Virgens Britânicas",
      cs: "Britské Panenské ostrovy",
      ro: "Insulele Virgine Britanice",
      ru: "Британские Виргинские острова"
    },
    rootIddCode: "+1284",
    continent: "NorthAmerica"
  },
  VI: {
    i18nNames: {
      en: "United States Virgin Islands",
      es: "Islas Vírgenes de los Estados Unidos",
      it: "Isole Vergini americane",
      de: "Amerikanische Jungferninseln",
      pl: "Wyspy Dziewицze Stanów Зjednoczonych",
      fr: "Îles Vierges des États-Unis",
      nl: "Amerikaanse Maagdeneilanden",
      pt: "Ilhas Virgens dos Estados Unidos",
      cs: "Americké Panenské остроvy",
      ro: "Insulele Virgine Americane",
      ru: "Виргинские острова США"
    },
    rootIddCode: "+1340",
    continent: "NorthAmerica"
  },
  VN: {
    i18nNames: {
      en: "Vietnam",
      it: "Vietnam",
      es: "Vietnam",
      de: "Vietnam",
      pl: "Wietnam",
      fr: "Vietnam",
      nl: "Vietnam",
      pt: "Vietnã",
      cs: "Vietnam",
      ro: "Vietnam",
      ru: "Вьетнам"
    },
    rootIddCode: "+84",
    continent: "Asia"
  },
  VU: {
    i18nNames: {
      en: "Vanuatu",
      it: "Vanuatu",
      es: "Vanuatu",
      de: "Vanuatu",
      pl: "Vanuatu",
      fr: "Vanuatu",
      nl: "Vanuatu",
      pt: "Vanuatu",
      cs: "Vanuatu",
      ro: "Vanuatu",
      ru: "Вануату"
    },
    rootIddCode: "+678",
    continent: "Oceania"
  },
  WF: {
    i18nNames: {
      en: "Wallis and Futuna",
      es: "Wallis y Futuna",
      it: "Wallis e Futuna",
      de: "Wallis und Futuna",
      pl: "Wallis i Futuna",
      fr: "Wallis-et-Futuna",
      nl: "Wallis en Futuna",
      pt: "Wallis e Futuna",
      cs: "Wallis a Futuna",
      ro: "Wallis și Futuna",
      ru: "Уоллис и Футуна"
    },
    rootIddCode: "+681",
    continent: "Oceania"
  },
  WS: {
    i18nNames: {
      en: "Samoa",
      it: "Samoa",
      es: "Samoa",
      de: "Samoa",
      pl: "Samoa",
      fr: "Samoa",
      nl: "Samoa",
      pt: "Samoa",
      cs: "Samoa",
      ro: "Samoa",
      ru: "Самоа"
    },
    rootIddCode: "+685",
    continent: "Oceania"
  },
  XK: {
    i18nNames: {
      en: "Kosovo",
      it: "Kosovo",
      es: "Kosovo",
      de: "Kosovo",
      pl: "Kosowo",
      fr: "Kosovo",
      nl: "Kosovo",
      pt: "Kosovo",
      cs: "Kosovo",
      ro: "Kosovo",
      ru: "Косово"
    },
    rootIddCode: "+383",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{9}$",
    taxIdExample: "123456789"
  },
  YE: {
    i18nNames: {
      en: "Yemen",
      it: "Yemen",
      es: "Yemen",
      de: "Jemen",
      pl: "Jemen",
      fr: "Yémen",
      nl: "Jemen",
      pt: "Iémen",
      cs: "Jemen",
      ro: "Yemen",
      ru: "Йемен"
    },
    rootIddCode: "+967",
    continent: "Asia"
  },
  YT: {
    i18nNames: {
      en: "Mayotte",
      it: "Mayotte",
      es: "Mayotte",
      de: "Mayotte",
      pl: "Majotta",
      fr: "Mayotte",
      nl: "Mayotte",
      pt: "Mayotte",
      cs: "Mayotte",
      ro: "Mayotte",
      ru: "Майотта"
    },
    rootIddCode: "+262",
    continent: "Africa"
  },
  ZA: {
    i18nNames: {
      en: "South Africa",
      it: "Sud Africa",
      es: "Sudáfrica",
      de: "Südafrika",
      pl: "Republika Południowej Afryki",
      fr: "Afrique du Sud",
      nl: "Zuid-Afrika",
      pt: "África do Sul",
      cs: "Jihoafrická republika",
      ro: "Africa de Sud",
      ru: "Южная Африка"
    },
    rootIddCode: "+27",
    continent: "Africa"
  },
  ZM: {
    i18nNames: {
      en: "Zambia",
      it: "Zambia",
      es: "Zambia",
      de: "Sambia",
      pl: "Zambia",
      fr: "Zambie",
      nl: "Zambia",
      pt: "Zâmbia",
      cs: "Zambie",
      ro: "Zambia",
      ru: "Замбия"
    },
    rootIddCode: "+260",
    continent: "Africa"
  },
  ZW: {
    i18nNames: {
      en: "Zimbabwe",
      it: "Zimbabwe",
      es: "Zimbabue",
      de: "Simbabwe",
      pl: "Zimbabwe",
      fr: "Zimbabwe",
      nl: "Zimbabwe",
      pt: "Zimbábue",
      cs: "Zimbabwe",
      ro: "Zimbabwe",
      ru: "Зимбабве"
    },
    rootIddCode: "+263",
    continent: "Africa"
  }
}, N1 = (r) => ki[r].i18nNames.en;
function x1(...r) {
  const t = /* @__PURE__ */ new Set();
  for (const [o, s] of Object.entries(ki))
    r.includes(s.continent) && t.add(o);
  return t;
}
const Ic = [
  "AD",
  "AE",
  "AF",
  "AG",
  "AI",
  "AL",
  "AM",
  "AO",
  "AQ",
  "AR",
  "AS",
  "AT",
  "AU",
  "AW",
  "AX",
  "AZ",
  "BA",
  "BB",
  "BD",
  "BE",
  "BF",
  "BG",
  "BH",
  "BI",
  "BJ",
  "BL",
  "BM",
  "BN",
  "BO",
  "BQ",
  "BR",
  "BS",
  "BT",
  "BV",
  "BW",
  "BY",
  "BZ",
  "CA",
  "CC",
  "CD",
  "CF",
  "CG",
  "CH",
  "CI",
  "CK",
  "CL",
  "CM",
  "CN",
  "CO",
  "CR",
  "CU",
  "CV",
  "CW",
  "CX",
  "CY",
  "CZ",
  "DE",
  "DJ",
  "DK",
  "DM",
  "DO",
  "DZ",
  "EC",
  "EE",
  "EG",
  "EH",
  "ER",
  "ES",
  "ET",
  "FI",
  "FJ",
  "FK",
  "FM",
  "FO",
  "FR",
  "GA",
  "GB",
  "GD",
  "GE",
  "GF",
  "GG",
  "GH",
  "GI",
  "GL",
  "GM",
  "GN",
  "GP",
  "GQ",
  "GR",
  "GS",
  "GT",
  "GU",
  "GW",
  "GY",
  "HK",
  "HM",
  "HN",
  "HR",
  "HT",
  "HU",
  "ID",
  "IE",
  "IL",
  "IM",
  "IN",
  "IO",
  "IQ",
  "IR",
  "IS",
  "IT",
  "JE",
  "JM",
  "JO",
  "JP",
  "KE",
  "KG",
  "KH",
  "KI",
  "KM",
  "KN",
  "KP",
  "KR",
  "KW",
  "KY",
  "KZ",
  "LA",
  "LB",
  "LC",
  "LI",
  "LK",
  "LR",
  "LS",
  "LT",
  "LU",
  "LV",
  "LY",
  "MA",
  "MC",
  "MD",
  "ME",
  "MF",
  "MG",
  "MH",
  "MK",
  "ML",
  "MM",
  "MN",
  "MO",
  "MP",
  "MQ",
  "MR",
  "MS",
  "MT",
  "MU",
  "MV",
  "MW",
  "MX",
  "MY",
  "MZ",
  "NA",
  "NC",
  "NE",
  "NF",
  "NG",
  "NI",
  "NL",
  "NO",
  "NP",
  "NR",
  "NU",
  "NZ",
  "OM",
  "PA",
  "PE",
  "PF",
  "PG",
  "PH",
  "PK",
  "PL",
  "PM",
  "PN",
  "PR",
  "PS",
  "PT",
  "PW",
  "PY",
  "QA",
  "RE",
  "RO",
  "RS",
  "RU",
  "RW",
  "SA",
  "SB",
  "SC",
  "SD",
  "SE",
  "SG",
  "SH",
  "SI",
  "SJ",
  "SK",
  "SL",
  "SM",
  "SN",
  "SO",
  "SR",
  "SS",
  "ST",
  "SV",
  "SX",
  "SY",
  "SZ",
  "TC",
  "TD",
  "TF",
  "TG",
  "TH",
  "TJ",
  "TK",
  "TL",
  "TM",
  "TN",
  "TO",
  "TR",
  "TT",
  "TV",
  "TW",
  "TZ",
  "UA",
  "UG",
  "UM",
  "US",
  "UY",
  "UZ",
  "VA",
  "VC",
  "VE",
  "VG",
  "VI",
  "VN",
  "VU",
  "WF",
  "WS",
  "XK",
  // Kosovo
  "YE",
  "YT",
  "ZA",
  "ZM",
  "ZW"
];
function E1(r) {
  if (n1(r) !== !0)
    throw new Error(`'${r}' is not a valid ISO 3166-1 alpha-2 Country code`);
  return r;
}
function n1(r) {
  return typeof r == "string" && Ic.includes(r);
}
const bc = {
  AD: "AND",
  AE: "ARE",
  AF: "AFG",
  AG: "ATG",
  AI: "AIA",
  AL: "ALB",
  AM: "ARM",
  AO: "AGO",
  AQ: "ATA",
  AR: "ARG",
  AS: "ASM",
  AT: "AUT",
  AU: "AUS",
  AW: "ABW",
  AX: "ALA",
  AZ: "AZE",
  BB: "BRB",
  BD: "BGD",
  BE: "BEL",
  BF: "BFA",
  BG: "BGR",
  BH: "BHR",
  BI: "BDI",
  BJ: "BEN",
  BL: "BLM",
  BM: "BMU",
  BN: "BRN",
  BO: "BOL",
  BQ: "BES",
  BR: "BRA",
  BS: "BHS",
  BT: "BTN",
  BV: "BVT",
  BW: "BWA",
  BY: "BLR",
  BZ: "BLZ",
  CA: "CAN",
  CC: "CCK",
  CD: "COD",
  CF: "CAF",
  CG: "COG",
  CH: "CHE",
  CI: "CIV",
  CK: "COK",
  CL: "CHL",
  CM: "CMR",
  CN: "CHN",
  CO: "COL",
  CR: "CRI",
  CU: "CUB",
  CV: "CPV",
  CW: "CUW",
  CX: "CXR",
  CY: "CYP",
  CZ: "CZE",
  DE: "DEU",
  DJ: "DJI",
  DK: "DNK",
  DM: "DMA",
  DO: "DOM",
  DZ: "DZA",
  EC: "ECU",
  EE: "EST",
  EG: "EGY",
  EH: "ESH",
  ER: "ERI",
  ES: "ESP",
  ET: "ETH",
  FI: "FIN",
  FJ: "FJI",
  FK: "FLK",
  FM: "FSM",
  FO: "FRO",
  FR: "FRA",
  GA: "GAB",
  GB: "GBR",
  GD: "GRD",
  GE: "GEO",
  GF: "GUF",
  GG: "GGY",
  GH: "GHA",
  GI: "GIB",
  GL: "GRL",
  GM: "GMB",
  GN: "GIN",
  GP: "GLP",
  GQ: "GNQ",
  GR: "GRC",
  GS: "SGS",
  GT: "GTM",
  GU: "GUM",
  GW: "GNB",
  GY: "GUY",
  HK: "HKG",
  HM: "HMD",
  HN: "HND",
  HR: "HRV",
  HT: "HTI",
  HU: "HUN",
  ID: "IDN",
  IE: "IRL",
  IL: "ISR",
  IM: "IMN",
  IN: "IND",
  IO: "IOT",
  IQ: "IRQ",
  IR: "IRN",
  IS: "ISL",
  IT: "ITA",
  JE: "JEY",
  JM: "JAM",
  JO: "JOR",
  JP: "JPN",
  KE: "KEN",
  KG: "KGZ",
  KH: "KHM",
  KI: "KIR",
  KM: "COM",
  KN: "KNA",
  KP: "PRK",
  KR: "KOR",
  KW: "KWT",
  KY: "CYM",
  KZ: "KAZ",
  LA: "LAO",
  LB: "LBN",
  LC: "LCA",
  LI: "LIE",
  LK: "LKA",
  LR: "LBR",
  LS: "LSO",
  LT: "LTU",
  LU: "LUX",
  LV: "LVA",
  LY: "LBY",
  MA: "MAR",
  MC: "MCO",
  MD: "MDA",
  ME: "MNE",
  MF: "MAF",
  MG: "MDG",
  MH: "MHL",
  MK: "MKD",
  ML: "MLI",
  MM: "MMR",
  MN: "MNG",
  MO: "MAC",
  MP: "MNP",
  MQ: "MTQ",
  MR: "MRT",
  MS: "MSR",
  MT: "MLT",
  MU: "MUS",
  MV: "MDV",
  MW: "MWI",
  MX: "MEX",
  MY: "MYS",
  MZ: "MOZ",
  NA: "NAM",
  NC: "NCL",
  NE: "NER",
  NF: "NFK",
  NG: "NGA",
  NI: "NIC",
  NL: "NLD",
  NO: "NOR",
  NP: "NPL",
  NR: "NRU",
  NU: "NIU",
  NZ: "NZL",
  OM: "OMN",
  PA: "PAN",
  PE: "PER",
  PF: "PYF",
  PG: "PNG",
  PH: "PHL",
  PK: "PAK",
  PL: "POL",
  PM: "SPM",
  PN: "PCN",
  PR: "PRI",
  PS: "PSE",
  PT: "PRT",
  PW: "PLW",
  PY: "PRY",
  QA: "QAT",
  RE: "REU",
  RO: "ROU",
  RS: "SRB",
  RU: "RUS",
  RW: "RWA",
  SA: "SAU",
  BA: "BIH",
  SB: "SLB",
  SC: "SYC",
  SD: "SDN",
  SE: "SWE",
  SG: "SGP",
  SH: "SHN",
  SI: "SVN",
  SJ: "SJM",
  SK: "SVK",
  SL: "SLE",
  SM: "SMR",
  SN: "SEN",
  SO: "SOM",
  SR: "SUR",
  SS: "SSD",
  ST: "STP",
  SV: "SLV",
  SX: "SXM",
  SY: "SYR",
  SZ: "SWZ",
  TC: "TCA",
  TD: "TCD",
  TF: "ATF",
  TG: "TGO",
  TH: "THA",
  TJ: "TJK",
  TK: "TKL",
  TL: "TLS",
  TM: "TKM",
  TN: "TUN",
  TO: "TON",
  TR: "TUR",
  TT: "TTO",
  TV: "TUV",
  TW: "TWN",
  TZ: "TZA",
  UA: "UKR",
  UG: "UGA",
  UM: "UMI",
  US: "USA",
  UY: "URY",
  UZ: "UZB",
  VA: "VAT",
  VC: "VCT",
  VE: "VEN",
  VG: "VGB",
  VI: "VIR",
  VN: "VNM",
  VU: "VUT",
  WF: "WLF",
  WS: "WSM",
  XK: "UNK",
  YE: "YEM",
  YT: "MYT",
  ZA: "ZAF",
  ZM: "ZMB",
  ZW: "ZWE"
};
function r1(r) {
  return typeof r == "string" && Object.values(bc).includes(r);
}
function w1(r) {
  if (r1(r) !== !0)
    throw new Error(`'${r}' is not a valid ISO 3166-1 alpha-3 Country code`);
  return r;
}
function M1(r) {
  return bc[r];
}
const k1 = 10 * 1024 * 1024, B1 = "pdf", P1 = Object.fromEntries(
  Object.entries(ki).map(([r, t]) => [
    r,
    ("regions" in t ? t.regions : []).flatMap(
      (o) => ("provinces" in o ? o.provinces : []).map((s) => s)
    )
  ])
), t1 = [
  "aa",
  "ab",
  "ae",
  "af",
  "ak",
  "am",
  "an",
  "ar",
  "as",
  "av",
  "ay",
  "az",
  "ba",
  "be",
  "bg",
  "bh",
  "bi",
  "bm",
  "bn",
  "bo",
  "br",
  "bs",
  "ca",
  "ce",
  "ch",
  "co",
  "cr",
  "cs",
  "cu",
  "cv",
  "cy",
  "da",
  "de",
  "dv",
  "dz",
  "ee",
  "el",
  "en",
  "eo",
  "es",
  "et",
  "eu",
  "fa",
  "ff",
  "fi",
  "fj",
  "fo",
  "fr",
  "fy",
  "ga",
  "gd",
  "gl",
  "gn",
  "gu",
  "gv",
  "ha",
  "he",
  "hi",
  "ho",
  "hr",
  "ht",
  "hu",
  "hy",
  "hz",
  "ia",
  "id",
  "ie",
  "ig",
  "ii",
  "ik",
  "io",
  "is",
  "it",
  "iu",
  "ja",
  "jv",
  "ka",
  "kg",
  "ki",
  "kj",
  "kk",
  "kl",
  "km",
  "kn",
  "ko",
  "kr",
  "ks",
  "ku",
  "kv",
  "kw",
  "ky",
  "la",
  "lb",
  "lg",
  "li",
  "ln",
  "lo",
  "lt",
  "lu",
  "lv",
  "mg",
  "mh",
  "mi",
  "mk",
  "ml",
  "mn",
  "mr",
  "ms",
  "mt",
  "my",
  "na",
  "nb",
  "nd",
  "ne",
  "ng",
  "nl",
  "nn",
  "no",
  "nr",
  "nv",
  "ny",
  "oc",
  "oj",
  "om",
  "or",
  "os",
  "pa",
  "pi",
  "pl",
  "ps",
  "pt",
  "qu",
  "rm",
  "rn",
  "ro",
  "ru",
  "rw",
  "sa",
  "sc",
  "sd",
  "se",
  "sg",
  "si",
  "sk",
  "sl",
  "sm",
  "sn",
  "so",
  "sq",
  "sr",
  "ss",
  "st",
  "su",
  "sv",
  "sw",
  "ta",
  "te",
  "tg",
  "th",
  "ti",
  "tk",
  "tl",
  "tn",
  "to",
  "tr",
  "ts",
  "tt",
  "tw",
  "ty",
  "ug",
  "uk",
  "ur",
  "uz",
  "ve",
  "vi",
  "vo",
  "wa",
  "wo",
  "xh",
  "yi",
  "yo",
  "za",
  "zh",
  "zu"
], o1 = hc(t1), R1 = (r) => o1.parse(r), O1 = {
  aa: "Afar",
  ab: "Abkhazian",
  ae: "Avestan",
  af: "Afrikaans",
  ak: "Akan",
  am: "Amharic",
  an: "Aragonese",
  ar: "Arabic",
  as: "Assamese",
  av: "Avaric",
  ay: "Aymara",
  az: "Azerbaijani",
  ba: "Bashkir",
  be: "Belarusian",
  bg: "Bulgarian",
  bh: "Bihari languages",
  bi: "Bislama",
  bm: "Bambara",
  bn: "Bengali",
  bo: "Tibetan",
  br: "Breton",
  bs: "Bosnian",
  ca: "Catalan",
  ce: "Chechen",
  ch: "Chamorro",
  co: "Corsican",
  cr: "Cree",
  cs: "Czech",
  cu: "Church Slavic",
  cv: "Chuvash",
  cy: "Welsh",
  da: "Danish",
  de: "German",
  dv: "Dhivehi",
  dz: "Dzongkha",
  ee: "Ewe",
  el: "Greek",
  en: "English",
  eo: "Esperanto",
  es: "Spanish",
  et: "Estonian",
  eu: "Basque",
  fa: "Persian",
  ff: "Fulah",
  fi: "Finnish",
  fj: "Fijian",
  fo: "Faroese",
  fr: "French",
  fy: "Western Frisian",
  ga: "Irish",
  gd: "Scottish Gaelic",
  gl: "Galician",
  gn: "Guarani",
  gu: "Gujarati",
  gv: "Manx",
  ha: "Hausa",
  he: "Hebrew",
  hi: "Hindi",
  ho: "Hiri Motu",
  hr: "Croatian",
  ht: "Haitian Creole",
  hu: "Hungarian",
  hy: "Armenian",
  hz: "Herero",
  ia: "Interlingua",
  id: "Indonesian",
  ie: "Interlingue",
  ig: "Igbo",
  ii: "Sichuan Yi (Nuosu)",
  ik: "Inupiaq",
  io: "Ido",
  is: "Icelandic",
  it: "Italian",
  iu: "Inuktitut",
  ja: "Japanese",
  jv: "Javanese",
  ka: "Georgian",
  kg: "Kongo",
  ki: "Kikuyu",
  kj: "Kuanyama",
  kk: "Kazakh",
  kl: "Kalaallisut",
  km: "Khmer",
  kn: "Kannada",
  ko: "Korean",
  kr: "Kanuri",
  ks: "Kashmiri",
  ku: "Kurdish",
  kv: "Komi",
  kw: "Cornish",
  ky: "Kyrgyz",
  la: "Latin",
  lb: "Luxembourgish",
  lg: "Ganda",
  li: "Limburgish",
  ln: "Lingala",
  lo: "Lao",
  lt: "Lithuanian",
  lu: "Luba-Katanga",
  lv: "Latvian",
  mg: "Malagasy",
  mh: "Marshallese",
  mi: "Māori",
  mk: "Macedonian",
  ml: "Malayalam",
  mn: "Mongolian",
  mr: "Marathi",
  ms: "Malay",
  mt: "Maltese",
  my: "Burmese",
  na: "Nauru",
  nb: "Norwegian Bokmål",
  nd: "North Ndebele",
  ne: "Nepali",
  ng: "Ndonga",
  nl: "Dutch",
  nn: "Norwegian Nynorsk",
  no: "Norwegian",
  nr: "South Ndebele",
  nv: "Navajo",
  ny: "Chichewa",
  oc: "Occitan",
  oj: "Ojibwa",
  om: "Oromo",
  or: "Odia",
  os: "Ossetian",
  pa: "Punjabi",
  pi: "Pali",
  pl: "Polish",
  ps: "Pashto",
  pt: "Portuguese",
  qu: "Quechua",
  rm: "Romansh",
  rn: "Rundi",
  ro: "Romanian",
  ru: "Russian",
  rw: "Kinyarwanda",
  sa: "Sanskrit",
  sc: "Sardinian",
  sd: "Sindhi",
  se: "Northern Sami",
  sg: "Sango",
  si: "Sinhala",
  sk: "Slovak",
  sl: "Slovenian",
  sm: "Samoan",
  sn: "Shona",
  so: "Somali",
  sq: "Albanian",
  sr: "Serbian",
  ss: "Swati",
  st: "Southern Sotho",
  su: "Sundanese",
  sv: "Swedish",
  sw: "Swahili",
  ta: "Tamil",
  te: "Telugu",
  tg: "Tajik",
  th: "Thai",
  ti: "Tigrinya",
  tk: "Turkmen",
  tl: "Tagalog",
  tn: "Tswana",
  to: "Tongan",
  tr: "Turkish",
  ts: "Tsonga",
  tt: "Tatar",
  tw: "Twi",
  ty: "Tahitian",
  ug: "Uyghur",
  uk: "Ukrainian",
  ur: "Urdu",
  uz: "Uzbek",
  ve: "Venda",
  vi: "Vietnamese",
  vo: "Volapük",
  wa: "Walloon",
  wo: "Wolof",
  xh: "Xhosa",
  yi: "Yiddish",
  yo: "Yoruba",
  za: "Zhuang",
  zh: "Chinese",
  zu: "Zulu"
}, i1 = [...Ic, "EU", "EXTRA_EU"];
function a1(r) {
  return typeof r == "string" && i1.includes(r);
}
function z1(r) {
  if (a1(r) !== !0)
    throw new Error(`'${r}' is not a valid tax code origin`);
  return r;
}
const L1 = "backoffice@fleequid.com", F1 = "+39 0287176063", G1 = {
  geocodeForward: {
    url: "https://api.mapbox.com/search/geocode/v6/forward",
    params: { types: "place,street,address" }
  }
}, s1 = {
  AD: "ca",
  AE: "ar",
  AF: "ps",
  AG: "en",
  AI: "en",
  AL: "sq",
  AM: "hy",
  AO: "pt",
  AQ: "en",
  AR: "es",
  AS: "sm",
  AT: "de",
  AU: "en",
  AW: "nl",
  AX: "sv",
  AZ: "az",
  BA: "bs",
  BB: "en",
  BD: "bn",
  BE: "fr",
  BF: "fr",
  BG: "bg",
  BH: "ar",
  BI: "rn",
  BJ: "fr",
  BL: "fr",
  BM: "en",
  BN: "ms",
  BO: "es",
  BQ: "nl",
  BR: "pt",
  BS: "en",
  BT: "dz",
  BV: "no",
  BW: "en",
  BY: "ru",
  BZ: "en",
  CA: "fr",
  CC: "en",
  CD: "fr",
  CF: "fr",
  CG: "fr",
  CH: "de",
  CI: "fr",
  CK: "en",
  CL: "es",
  CM: "fr",
  CN: "zh",
  CO: "es",
  CR: "es",
  CU: "es",
  CV: "pt",
  CW: "nl",
  CX: "en",
  CY: "el",
  CZ: "cs",
  DE: "de",
  DJ: "fr",
  DK: "da",
  DM: "en",
  DO: "es",
  DZ: "ar",
  EC: "es",
  EE: "et",
  EG: "ar",
  EH: "ar",
  ER: "ti",
  ES: "es",
  ET: "am",
  FI: "fi",
  FJ: "en",
  FK: "en",
  FM: "en",
  FO: "fo",
  FR: "fr",
  GA: "fr",
  GB: "en",
  GD: "en",
  GE: "ka",
  GF: "fr",
  GG: "en",
  GH: "en",
  GI: "en",
  GL: "kl",
  GM: "en",
  GN: "fr",
  GP: "fr",
  GQ: "es",
  GR: "el",
  GS: "en",
  GT: "es",
  GU: "en",
  GW: "pt",
  GY: "en",
  HK: "zh",
  HM: "en",
  HN: "es",
  HR: "hr",
  HT: "fr",
  HU: "hu",
  ID: "id",
  IE: "en",
  IL: "he",
  IM: "en",
  IN: "hi",
  IO: "en",
  IQ: "ar",
  IR: "fa",
  IS: "is",
  IT: "it",
  JE: "en",
  JM: "en",
  JO: "ar",
  JP: "ja",
  KE: "sw",
  KG: "ru",
  KH: "km",
  KI: "en",
  KM: "ar",
  KN: "en",
  KP: "ko",
  KR: "ko",
  KW: "ar",
  KY: "en",
  KZ: "ru",
  LA: "lo",
  LB: "ar",
  LC: "en",
  LI: "de",
  LK: "si",
  LR: "en",
  LS: "st",
  LT: "lt",
  LU: "de",
  LV: "lv",
  LY: "ar",
  MA: "ar",
  MC: "fr",
  MD: "ro",
  ME: "sr",
  MF: "fr",
  MG: "fr",
  MH: "en",
  MK: "mk",
  ML: "fr",
  MM: "my",
  MN: "mn",
  MO: "zh",
  MP: "en",
  MQ: "fr",
  MR: "ar",
  MS: "en",
  MT: "mt",
  MU: "en",
  MV: "dv",
  MW: "ny",
  MX: "es",
  MY: "ms",
  MZ: "pt",
  NA: "en",
  NC: "fr",
  NE: "fr",
  NF: "en",
  NG: "en",
  NI: "es",
  NL: "nl",
  NO: "no",
  NP: "ne",
  NR: "en",
  NU: "en",
  NZ: "en",
  OM: "ar",
  PA: "es",
  PE: "es",
  PF: "fr",
  PG: "en",
  PH: "tl",
  PK: "ur",
  PL: "pl",
  PM: "fr",
  PN: "en",
  PR: "es",
  PS: "ar",
  PT: "pt",
  PW: "en",
  PY: "es",
  QA: "ar",
  RE: "fr",
  RO: "ro",
  RS: "sr",
  RU: "ru",
  RW: "fr",
  SA: "ar",
  SB: "en",
  SC: "en",
  SD: "ar",
  SE: "sv",
  SG: "en",
  SH: "en",
  SI: "sl",
  SJ: "no",
  SK: "sk",
  SL: "en",
  SM: "it",
  SN: "fr",
  SO: "so",
  SR: "nl",
  SS: "en",
  ST: "pt",
  SV: "es",
  SX: "nl",
  SY: "ar",
  SZ: "ss",
  TC: "en",
  TD: "fr",
  TF: "fr",
  TG: "fr",
  TH: "th",
  TJ: "tg",
  TK: "en",
  TL: "pt",
  TM: "tk",
  TN: "ar",
  TO: "to",
  TR: "tr",
  TT: "en",
  TV: "en",
  TW: "zh",
  TZ: "sw",
  UA: "uk",
  UG: "en",
  UM: "en",
  US: "en",
  UY: "es",
  UZ: "uz",
  VA: "it",
  VC: "en",
  VE: "es",
  VG: "en",
  VI: "en",
  VN: "vi",
  VU: "bi",
  WF: "fr",
  WS: "sm",
  XK: "sq",
  YE: "ar",
  YT: "fr",
  ZA: "en",
  ZM: "en",
  ZW: "en"
};
function D1(r) {
  return s1[r];
}
const Z1 = {
  cs: "CZ",
  de: "DE",
  en: "GB",
  es: "ES",
  fr: "FR",
  it: "IT",
  nl: "NL",
  pl: "PL",
  pt: "PT",
  ro: "RO",
  ru: "RU"
}, Sc = {
  addressNumber: Ce().optional().nullable(),
  alternate: Ce().optional().nullable(),
  country: Ce(),
  countryCode: Ce(),
  fullAddress: Ce(),
  latitude: Mu(),
  longitude: Mu(),
  mapboxId: Ce(),
  place: Ce(),
  postcode: Ce().optional().nullable(),
  region: Ce(),
  streetName: Ce().optional().nullable()
}, U1 = $r(Sc), $1 = (r) => $r(Sc, { error: r }), u1 = "AdminUserPasswordResetToken", K1 = $r({
  type: mc(u1),
  adminUserId: Ce(),
  /**
   * NB: this field is consumed by the client only, only has a presentational purposes
   */
  email: Ce()
}), c1 = "CustomerUserPasswordResetToken", H1 = $r({
  type: mc(c1),
  userId: Ce()
}), W1 = () => Ce().regex(/^\+[1-9]\d{1,14}$/, { message: "Phone must be in E.164 format (e.g. +393331234567)" }), Ac = Ce().min(5).brand("Tin");
function q1(r) {
  return Ac.safeParse(r).success;
}
function l1(r) {
  const t = Ac.safeParse(r);
  if (t.success)
    return t.data;
  throw new Error(`Could not parse '${r}' as Tin: ${t.error.issues.map(({ message: o }) => o).join(", ")}`);
}
function V1(r) {
  return l1(r.replace(/[^a-zA-Z0-9]/g, ""));
}
const J1 = (r, ...t) => r ? t.map((o) => typeof o == "function" ? o() : o) : [];
function d1(r) {
  return r.length > 0 && !!r[0] && typeof r[0] == "object";
}
const j1 = (r) => {
  if (!r)
    return {};
  const o = Object.keys(r).map((s) => Array.isArray(r[s]) && r[s].length > 0 ? d1(r[s]) ? r[s].map(
    (u, f) => Object.keys(u).map((p) => [`${s}[${f}][${p}]`, u[p]])
  ).flat() : [[`${s}[]`, r[s]]] : [[s, r[s]]]).flat();
  return Object.fromEntries(o);
};
var Ft = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Gr = { exports: {} };
var p1 = Gr.exports, zu;
function f1() {
  return zu || (zu = 1, (function(r, t) {
    (function() {
      var o, s = "4.18.1", u = 200, f = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", p = "Expected a function", _ = "Invalid `variable` option passed into `_.template`", S = "Invalid `imports` option passed into `_.template`", N = "__lodash_hash_undefined__", w = 500, F = "__lodash_placeholder__", k = 1, z = 2, ie = 4, Q = 1, un = 2, Me = 1, In = 2, ke = 4, ee = 8, he = 16, en = 32, Bn = 64, cn = 128, hr = 256, qt = 512, xc = 30, Ec = "...", wc = 800, Mc = 16, Pi = 1, kc = 2, Bc = 3, Pn = 1 / 0, bn = 9007199254740991, Pc = 17976931348623157e292, Kr = NaN, nn = 4294967295, Rc = nn - 1, Oc = nn >>> 1, zc = [
        ["ary", cn],
        ["bind", Me],
        ["bindKey", In],
        ["curry", ee],
        ["curryRight", he],
        ["flip", qt],
        ["partial", en],
        ["partialRight", Bn],
        ["rearg", hr]
      ], Wn = "[object Arguments]", Hr = "[object Array]", Lc = "[object AsyncFunction]", mr = "[object Boolean]", _r = "[object Date]", Fc = "[object DOMException]", Wr = "[object Error]", qr = "[object Function]", Ri = "[object GeneratorFunction]", qe = "[object Map]", gr = "[object Number]", Gc = "[object Null]", ln = "[object Object]", Oi = "[object Promise]", Dc = "[object Proxy]", vr = "[object RegExp]", Ve = "[object Set]", Ir = "[object String]", Vr = "[object Symbol]", Zc = "[object Undefined]", br = "[object WeakMap]", Uc = "[object WeakSet]", Sr = "[object ArrayBuffer]", qn = "[object DataView]", Vt = "[object Float32Array]", Jt = "[object Float64Array]", jt = "[object Int8Array]", Yt = "[object Int16Array]", Xt = "[object Int32Array]", Qt = "[object Uint8Array]", eo = "[object Uint8ClampedArray]", no = "[object Uint16Array]", ro = "[object Uint32Array]", $c = /\b__p \+= '';/g, Kc = /\b(__p \+=) '' \+/g, Hc = /(__e\(.*?\)|\b__t\)) \+\n'';/g, zi = /&(?:amp|lt|gt|quot|#39);/g, Li = /[&<>"']/g, Wc = RegExp(zi.source), qc = RegExp(Li.source), Vc = /<%-([\s\S]+?)%>/g, Jc = /<%([\s\S]+?)%>/g, Fi = /<%=([\s\S]+?)%>/g, jc = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Yc = /^\w*$/, Xc = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, to = /[\\^$.*+?()[\]{}|]/g, Qc = RegExp(to.source), oo = /^\s+/, el = /\s/, nl = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, rl = /\{\n\/\* \[wrapped with (.+)\] \*/, tl = /,? & /, ol = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Gi = /[()=,{}\[\]\/\s]/, il = /\\(\\)?/g, al = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Di = /\w*$/, sl = /^[-+]0x[0-9a-f]+$/i, ul = /^0b[01]+$/i, cl = /^\[object .+?Constructor\]$/, ll = /^0o[0-7]+$/i, dl = /^(?:0|[1-9]\d*)$/, pl = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Jr = /($^)/, fl = /['\n\r\u2028\u2029\\]/g, jr = "\\ud800-\\udfff", hl = "\\u0300-\\u036f", ml = "\\ufe20-\\ufe2f", _l = "\\u20d0-\\u20ff", Zi = hl + ml + _l, Ui = "\\u2700-\\u27bf", $i = "a-z\\xdf-\\xf6\\xf8-\\xff", gl = "\\xac\\xb1\\xd7\\xf7", vl = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Il = "\\u2000-\\u206f", bl = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Ki = "A-Z\\xc0-\\xd6\\xd8-\\xde", Hi = "\\ufe0e\\ufe0f", Wi = gl + vl + Il + bl, io = "['’]", Sl = "[" + jr + "]", qi = "[" + Wi + "]", Yr = "[" + Zi + "]", Vi = "\\d+", Al = "[" + Ui + "]", Ji = "[" + $i + "]", ji = "[^" + jr + Wi + Vi + Ui + $i + Ki + "]", ao = "\\ud83c[\\udffb-\\udfff]", Tl = "(?:" + Yr + "|" + ao + ")", Yi = "[^" + jr + "]", so = "(?:\\ud83c[\\udde6-\\uddff]){2}", uo = "[\\ud800-\\udbff][\\udc00-\\udfff]", Vn = "[" + Ki + "]", Xi = "\\u200d", Qi = "(?:" + Ji + "|" + ji + ")", Cl = "(?:" + Vn + "|" + ji + ")", ea = "(?:" + io + "(?:d|ll|m|re|s|t|ve))?", na = "(?:" + io + "(?:D|LL|M|RE|S|T|VE))?", ra = Tl + "?", ta = "[" + Hi + "]?", yl = "(?:" + Xi + "(?:" + [Yi, so, uo].join("|") + ")" + ta + ra + ")*", Nl = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", xl = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", oa = ta + ra + yl, El = "(?:" + [Al, so, uo].join("|") + ")" + oa, wl = "(?:" + [Yi + Yr + "?", Yr, so, uo, Sl].join("|") + ")", Ml = RegExp(io, "g"), kl = RegExp(Yr, "g"), co = RegExp(ao + "(?=" + ao + ")|" + wl + oa, "g"), Bl = RegExp([
        Vn + "?" + Ji + "+" + ea + "(?=" + [qi, Vn, "$"].join("|") + ")",
        Cl + "+" + na + "(?=" + [qi, Vn + Qi, "$"].join("|") + ")",
        Vn + "?" + Qi + "+" + ea,
        Vn + "+" + na,
        xl,
        Nl,
        Vi,
        El
      ].join("|"), "g"), Pl = RegExp("[" + Xi + jr + Zi + Hi + "]"), Rl = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Ol = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ], zl = -1, X = {};
      X[Vt] = X[Jt] = X[jt] = X[Yt] = X[Xt] = X[Qt] = X[eo] = X[no] = X[ro] = !0, X[Wn] = X[Hr] = X[Sr] = X[mr] = X[qn] = X[_r] = X[Wr] = X[qr] = X[qe] = X[gr] = X[ln] = X[vr] = X[Ve] = X[Ir] = X[br] = !1;
      var Y = {};
      Y[Wn] = Y[Hr] = Y[Sr] = Y[qn] = Y[mr] = Y[_r] = Y[Vt] = Y[Jt] = Y[jt] = Y[Yt] = Y[Xt] = Y[qe] = Y[gr] = Y[ln] = Y[vr] = Y[Ve] = Y[Ir] = Y[Vr] = Y[Qt] = Y[eo] = Y[no] = Y[ro] = !0, Y[Wr] = Y[qr] = Y[br] = !1;
      var Ll = {
        // Latin-1 Supplement block.
        À: "A",
        Á: "A",
        Â: "A",
        Ã: "A",
        Ä: "A",
        Å: "A",
        à: "a",
        á: "a",
        â: "a",
        ã: "a",
        ä: "a",
        å: "a",
        Ç: "C",
        ç: "c",
        Ð: "D",
        ð: "d",
        È: "E",
        É: "E",
        Ê: "E",
        Ë: "E",
        è: "e",
        é: "e",
        ê: "e",
        ë: "e",
        Ì: "I",
        Í: "I",
        Î: "I",
        Ï: "I",
        ì: "i",
        í: "i",
        î: "i",
        ï: "i",
        Ñ: "N",
        ñ: "n",
        Ò: "O",
        Ó: "O",
        Ô: "O",
        Õ: "O",
        Ö: "O",
        Ø: "O",
        ò: "o",
        ó: "o",
        ô: "o",
        õ: "o",
        ö: "o",
        ø: "o",
        Ù: "U",
        Ú: "U",
        Û: "U",
        Ü: "U",
        ù: "u",
        ú: "u",
        û: "u",
        ü: "u",
        Ý: "Y",
        ý: "y",
        ÿ: "y",
        Æ: "Ae",
        æ: "ae",
        Þ: "Th",
        þ: "th",
        ß: "ss",
        // Latin Extended-A block.
        Ā: "A",
        Ă: "A",
        Ą: "A",
        ā: "a",
        ă: "a",
        ą: "a",
        Ć: "C",
        Ĉ: "C",
        Ċ: "C",
        Č: "C",
        ć: "c",
        ĉ: "c",
        ċ: "c",
        č: "c",
        Ď: "D",
        Đ: "D",
        ď: "d",
        đ: "d",
        Ē: "E",
        Ĕ: "E",
        Ė: "E",
        Ę: "E",
        Ě: "E",
        ē: "e",
        ĕ: "e",
        ė: "e",
        ę: "e",
        ě: "e",
        Ĝ: "G",
        Ğ: "G",
        Ġ: "G",
        Ģ: "G",
        ĝ: "g",
        ğ: "g",
        ġ: "g",
        ģ: "g",
        Ĥ: "H",
        Ħ: "H",
        ĥ: "h",
        ħ: "h",
        Ĩ: "I",
        Ī: "I",
        Ĭ: "I",
        Į: "I",
        İ: "I",
        ĩ: "i",
        ī: "i",
        ĭ: "i",
        į: "i",
        ı: "i",
        Ĵ: "J",
        ĵ: "j",
        Ķ: "K",
        ķ: "k",
        ĸ: "k",
        Ĺ: "L",
        Ļ: "L",
        Ľ: "L",
        Ŀ: "L",
        Ł: "L",
        ĺ: "l",
        ļ: "l",
        ľ: "l",
        ŀ: "l",
        ł: "l",
        Ń: "N",
        Ņ: "N",
        Ň: "N",
        Ŋ: "N",
        ń: "n",
        ņ: "n",
        ň: "n",
        ŋ: "n",
        Ō: "O",
        Ŏ: "O",
        Ő: "O",
        ō: "o",
        ŏ: "o",
        ő: "o",
        Ŕ: "R",
        Ŗ: "R",
        Ř: "R",
        ŕ: "r",
        ŗ: "r",
        ř: "r",
        Ś: "S",
        Ŝ: "S",
        Ş: "S",
        Š: "S",
        ś: "s",
        ŝ: "s",
        ş: "s",
        š: "s",
        Ţ: "T",
        Ť: "T",
        Ŧ: "T",
        ţ: "t",
        ť: "t",
        ŧ: "t",
        Ũ: "U",
        Ū: "U",
        Ŭ: "U",
        Ů: "U",
        Ű: "U",
        Ų: "U",
        ũ: "u",
        ū: "u",
        ŭ: "u",
        ů: "u",
        ű: "u",
        ų: "u",
        Ŵ: "W",
        ŵ: "w",
        Ŷ: "Y",
        ŷ: "y",
        Ÿ: "Y",
        Ź: "Z",
        Ż: "Z",
        Ž: "Z",
        ź: "z",
        ż: "z",
        ž: "z",
        Ĳ: "IJ",
        ĳ: "ij",
        Œ: "Oe",
        œ: "oe",
        ŉ: "'n",
        ſ: "s"
      }, Fl = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }, Gl = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      }, Dl = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      }, Zl = parseFloat, Ul = parseInt, ia = typeof Ft == "object" && Ft && Ft.Object === Object && Ft, $l = typeof self == "object" && self && self.Object === Object && self, me = ia || $l || Function("return this")(), lo = t && !t.nodeType && t, Rn = lo && !0 && r && !r.nodeType && r, aa = Rn && Rn.exports === lo, po = aa && ia.process, Ge = (function() {
        try {
          var g = Rn && Rn.require && Rn.require("util").types;
          return g || po && po.binding && po.binding("util");
        } catch {
        }
      })(), sa = Ge && Ge.isArrayBuffer, ua = Ge && Ge.isDate, ca = Ge && Ge.isMap, la = Ge && Ge.isRegExp, da = Ge && Ge.isSet, pa = Ge && Ge.isTypedArray;
      function Be(g, b, I) {
        switch (I.length) {
          case 0:
            return g.call(b);
          case 1:
            return g.call(b, I[0]);
          case 2:
            return g.call(b, I[0], I[1]);
          case 3:
            return g.call(b, I[0], I[1], I[2]);
        }
        return g.apply(b, I);
      }
      function Kl(g, b, I, E) {
        for (var L = -1, W = g == null ? 0 : g.length; ++L < W; ) {
          var de = g[L];
          b(E, de, I(de), g);
        }
        return E;
      }
      function Pe(g, b) {
        for (var I = -1, E = g == null ? 0 : g.length; ++I < E && b(g[I], I, g) !== !1; )
          ;
        return g;
      }
      function Hl(g, b) {
        for (var I = g == null ? 0 : g.length; I-- && b(g[I], I, g) !== !1; )
          ;
        return g;
      }
      function fa(g, b) {
        for (var I = -1, E = g == null ? 0 : g.length; ++I < E; )
          if (!b(g[I], I, g))
            return !1;
        return !0;
      }
      function Sn(g, b) {
        for (var I = -1, E = g == null ? 0 : g.length, L = 0, W = []; ++I < E; ) {
          var de = g[I];
          b(de, I, g) && (W[L++] = de);
        }
        return W;
      }
      function Xr(g, b) {
        var I = g == null ? 0 : g.length;
        return !!I && Jn(g, b, 0) > -1;
      }
      function fo(g, b, I) {
        for (var E = -1, L = g == null ? 0 : g.length; ++E < L; )
          if (I(b, g[E]))
            return !0;
        return !1;
      }
      function ne(g, b) {
        for (var I = -1, E = g == null ? 0 : g.length, L = Array(E); ++I < E; )
          L[I] = b(g[I], I, g);
        return L;
      }
      function An(g, b) {
        for (var I = -1, E = b.length, L = g.length; ++I < E; )
          g[L + I] = b[I];
        return g;
      }
      function ho(g, b, I, E) {
        var L = -1, W = g == null ? 0 : g.length;
        for (E && W && (I = g[++L]); ++L < W; )
          I = b(I, g[L], L, g);
        return I;
      }
      function Wl(g, b, I, E) {
        var L = g == null ? 0 : g.length;
        for (E && L && (I = g[--L]); L--; )
          I = b(I, g[L], L, g);
        return I;
      }
      function mo(g, b) {
        for (var I = -1, E = g == null ? 0 : g.length; ++I < E; )
          if (b(g[I], I, g))
            return !0;
        return !1;
      }
      var ql = _o("length");
      function Vl(g) {
        return g.split("");
      }
      function Jl(g) {
        return g.match(ol) || [];
      }
      function ha(g, b, I) {
        var E;
        return I(g, function(L, W, de) {
          if (b(L, W, de))
            return E = W, !1;
        }), E;
      }
      function Qr(g, b, I, E) {
        for (var L = g.length, W = I + (E ? 1 : -1); E ? W-- : ++W < L; )
          if (b(g[W], W, g))
            return W;
        return -1;
      }
      function Jn(g, b, I) {
        return b === b ? sd(g, b, I) : Qr(g, ma, I);
      }
      function jl(g, b, I, E) {
        for (var L = I - 1, W = g.length; ++L < W; )
          if (E(g[L], b))
            return L;
        return -1;
      }
      function ma(g) {
        return g !== g;
      }
      function _a(g, b) {
        var I = g == null ? 0 : g.length;
        return I ? vo(g, b) / I : Kr;
      }
      function _o(g) {
        return function(b) {
          return b == null ? o : b[g];
        };
      }
      function go(g) {
        return function(b) {
          return g == null ? o : g[b];
        };
      }
      function ga(g, b, I, E, L) {
        return L(g, function(W, de, j) {
          I = E ? (E = !1, W) : b(I, W, de, j);
        }), I;
      }
      function Yl(g, b) {
        var I = g.length;
        for (g.sort(b); I--; )
          g[I] = g[I].value;
        return g;
      }
      function vo(g, b) {
        for (var I, E = -1, L = g.length; ++E < L; ) {
          var W = b(g[E]);
          W !== o && (I = I === o ? W : I + W);
        }
        return I;
      }
      function Io(g, b) {
        for (var I = -1, E = Array(g); ++I < g; )
          E[I] = b(I);
        return E;
      }
      function Xl(g, b) {
        return ne(b, function(I) {
          return [I, g[I]];
        });
      }
      function va(g) {
        return g && g.slice(0, Aa(g) + 1).replace(oo, "");
      }
      function Re(g) {
        return function(b) {
          return g(b);
        };
      }
      function bo(g, b) {
        return ne(b, function(I) {
          return g[I];
        });
      }
      function Ar(g, b) {
        return g.has(b);
      }
      function Ia(g, b) {
        for (var I = -1, E = g.length; ++I < E && Jn(b, g[I], 0) > -1; )
          ;
        return I;
      }
      function ba(g, b) {
        for (var I = g.length; I-- && Jn(b, g[I], 0) > -1; )
          ;
        return I;
      }
      function Ql(g, b) {
        for (var I = g.length, E = 0; I--; )
          g[I] === b && ++E;
        return E;
      }
      var ed = go(Ll), nd = go(Fl);
      function rd(g) {
        return "\\" + Dl[g];
      }
      function td(g, b) {
        return g == null ? o : g[b];
      }
      function jn(g) {
        return Pl.test(g);
      }
      function od(g) {
        return Rl.test(g);
      }
      function id(g) {
        for (var b, I = []; !(b = g.next()).done; )
          I.push(b.value);
        return I;
      }
      function So(g) {
        var b = -1, I = Array(g.size);
        return g.forEach(function(E, L) {
          I[++b] = [L, E];
        }), I;
      }
      function Sa(g, b) {
        return function(I) {
          return g(b(I));
        };
      }
      function Tn(g, b) {
        for (var I = -1, E = g.length, L = 0, W = []; ++I < E; ) {
          var de = g[I];
          (de === b || de === F) && (g[I] = F, W[L++] = I);
        }
        return W;
      }
      function et(g) {
        var b = -1, I = Array(g.size);
        return g.forEach(function(E) {
          I[++b] = E;
        }), I;
      }
      function ad(g) {
        var b = -1, I = Array(g.size);
        return g.forEach(function(E) {
          I[++b] = [E, E];
        }), I;
      }
      function sd(g, b, I) {
        for (var E = I - 1, L = g.length; ++E < L; )
          if (g[E] === b)
            return E;
        return -1;
      }
      function ud(g, b, I) {
        for (var E = I + 1; E--; )
          if (g[E] === b)
            return E;
        return E;
      }
      function Yn(g) {
        return jn(g) ? ld(g) : ql(g);
      }
      function Je(g) {
        return jn(g) ? dd(g) : Vl(g);
      }
      function Aa(g) {
        for (var b = g.length; b-- && el.test(g.charAt(b)); )
          ;
        return b;
      }
      var cd = go(Gl);
      function ld(g) {
        for (var b = co.lastIndex = 0; co.test(g); )
          ++b;
        return b;
      }
      function dd(g) {
        return g.match(co) || [];
      }
      function pd(g) {
        return g.match(Bl) || [];
      }
      var fd = (function g(b) {
        b = b == null ? me : Xn.defaults(me.Object(), b, Xn.pick(me, Ol));
        var I = b.Array, E = b.Date, L = b.Error, W = b.Function, de = b.Math, j = b.Object, Ao = b.RegExp, hd = b.String, De = b.TypeError, nt = I.prototype, md = W.prototype, Qn = j.prototype, rt = b["__core-js_shared__"], tt = md.toString, q = Qn.hasOwnProperty, _d = 0, Ta = (function() {
          var e = /[^.]+$/.exec(rt && rt.keys && rt.keys.IE_PROTO || "");
          return e ? "Symbol(src)_1." + e : "";
        })(), ot = Qn.toString, gd = tt.call(j), vd = me._, Id = Ao(
          "^" + tt.call(q).replace(to, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        ), it = aa ? b.Buffer : o, Cn = b.Symbol, at = b.Uint8Array, Ca = it ? it.allocUnsafe : o, st = Sa(j.getPrototypeOf, j), ya = j.create, Na = Qn.propertyIsEnumerable, ut = nt.splice, xa = Cn ? Cn.isConcatSpreadable : o, Tr = Cn ? Cn.iterator : o, On = Cn ? Cn.toStringTag : o, ct = (function() {
          try {
            var e = Dn(j, "defineProperty");
            return e({}, "", {}), e;
          } catch {
          }
        })(), bd = b.clearTimeout !== me.clearTimeout && b.clearTimeout, Sd = E && E.now !== me.Date.now && E.now, Ad = b.setTimeout !== me.setTimeout && b.setTimeout, lt = de.ceil, dt = de.floor, To = j.getOwnPropertySymbols, Td = it ? it.isBuffer : o, Ea = b.isFinite, Cd = nt.join, yd = Sa(j.keys, j), pe = de.max, ve = de.min, Nd = E.now, xd = b.parseInt, wa = de.random, Ed = nt.reverse, Co = Dn(b, "DataView"), Cr = Dn(b, "Map"), yo = Dn(b, "Promise"), er = Dn(b, "Set"), yr = Dn(b, "WeakMap"), Nr = Dn(j, "create"), pt = yr && new yr(), nr = {}, wd = Zn(Co), Md = Zn(Cr), kd = Zn(yo), Bd = Zn(er), Pd = Zn(yr), ft = Cn ? Cn.prototype : o, xr = ft ? ft.valueOf : o, Ma = ft ? ft.toString : o;
        function l(e) {
          if (ae(e) && !G(e) && !(e instanceof K)) {
            if (e instanceof Ze)
              return e;
            if (q.call(e, "__wrapped__"))
              return ks(e);
          }
          return new Ze(e);
        }
        var rr = /* @__PURE__ */ (function() {
          function e() {
          }
          return function(n) {
            if (!te(n))
              return {};
            if (ya)
              return ya(n);
            e.prototype = n;
            var i = new e();
            return e.prototype = o, i;
          };
        })();
        function ht() {
        }
        function Ze(e, n) {
          this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!n, this.__index__ = 0, this.__values__ = o;
        }
        l.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          escape: Vc,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          evaluate: Jc,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          interpolate: Fi,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          variable: "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          imports: {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            _: l
          }
        }, l.prototype = ht.prototype, l.prototype.constructor = l, Ze.prototype = rr(ht.prototype), Ze.prototype.constructor = Ze;
        function K(e) {
          this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = nn, this.__views__ = [];
        }
        function Rd() {
          var e = new K(this.__wrapped__);
          return e.__actions__ = ye(this.__actions__), e.__dir__ = this.__dir__, e.__filtered__ = this.__filtered__, e.__iteratees__ = ye(this.__iteratees__), e.__takeCount__ = this.__takeCount__, e.__views__ = ye(this.__views__), e;
        }
        function Od() {
          if (this.__filtered__) {
            var e = new K(this);
            e.__dir__ = -1, e.__filtered__ = !0;
          } else
            e = this.clone(), e.__dir__ *= -1;
          return e;
        }
        function zd() {
          var e = this.__wrapped__.value(), n = this.__dir__, i = G(e), a = n < 0, c = i ? e.length : 0, d = Vp(0, c, this.__views__), h = d.start, m = d.end, v = m - h, A = a ? m : h - 1, C = this.__iteratees__, y = C.length, x = 0, M = ve(v, this.__takeCount__);
          if (!i || !a && c == v && M == v)
            return es(e, this.__actions__);
          var O = [];
          e:
            for (; v-- && x < M; ) {
              A += n;
              for (var Z = -1, P = e[A]; ++Z < y; ) {
                var $ = C[Z], H = $.iteratee, Le = $.type, Ae = H(P);
                if (Le == kc)
                  P = Ae;
                else if (!Ae) {
                  if (Le == Pi)
                    continue e;
                  break e;
                }
              }
              O[x++] = P;
            }
          return O;
        }
        K.prototype = rr(ht.prototype), K.prototype.constructor = K;
        function zn(e) {
          var n = -1, i = e == null ? 0 : e.length;
          for (this.clear(); ++n < i; ) {
            var a = e[n];
            this.set(a[0], a[1]);
          }
        }
        function Ld() {
          this.__data__ = Nr ? Nr(null) : {}, this.size = 0;
        }
        function Fd(e) {
          var n = this.has(e) && delete this.__data__[e];
          return this.size -= n ? 1 : 0, n;
        }
        function Gd(e) {
          var n = this.__data__;
          if (Nr) {
            var i = n[e];
            return i === N ? o : i;
          }
          return q.call(n, e) ? n[e] : o;
        }
        function Dd(e) {
          var n = this.__data__;
          return Nr ? n[e] !== o : q.call(n, e);
        }
        function Zd(e, n) {
          var i = this.__data__;
          return this.size += this.has(e) ? 0 : 1, i[e] = Nr && n === o ? N : n, this;
        }
        zn.prototype.clear = Ld, zn.prototype.delete = Fd, zn.prototype.get = Gd, zn.prototype.has = Dd, zn.prototype.set = Zd;
        function dn(e) {
          var n = -1, i = e == null ? 0 : e.length;
          for (this.clear(); ++n < i; ) {
            var a = e[n];
            this.set(a[0], a[1]);
          }
        }
        function Ud() {
          this.__data__ = [], this.size = 0;
        }
        function $d(e) {
          var n = this.__data__, i = mt(n, e);
          if (i < 0)
            return !1;
          var a = n.length - 1;
          return i == a ? n.pop() : ut.call(n, i, 1), --this.size, !0;
        }
        function Kd(e) {
          var n = this.__data__, i = mt(n, e);
          return i < 0 ? o : n[i][1];
        }
        function Hd(e) {
          return mt(this.__data__, e) > -1;
        }
        function Wd(e, n) {
          var i = this.__data__, a = mt(i, e);
          return a < 0 ? (++this.size, i.push([e, n])) : i[a][1] = n, this;
        }
        dn.prototype.clear = Ud, dn.prototype.delete = $d, dn.prototype.get = Kd, dn.prototype.has = Hd, dn.prototype.set = Wd;
        function pn(e) {
          var n = -1, i = e == null ? 0 : e.length;
          for (this.clear(); ++n < i; ) {
            var a = e[n];
            this.set(a[0], a[1]);
          }
        }
        function qd() {
          this.size = 0, this.__data__ = {
            hash: new zn(),
            map: new (Cr || dn)(),
            string: new zn()
          };
        }
        function Vd(e) {
          var n = xt(this, e).delete(e);
          return this.size -= n ? 1 : 0, n;
        }
        function Jd(e) {
          return xt(this, e).get(e);
        }
        function jd(e) {
          return xt(this, e).has(e);
        }
        function Yd(e, n) {
          var i = xt(this, e), a = i.size;
          return i.set(e, n), this.size += i.size == a ? 0 : 1, this;
        }
        pn.prototype.clear = qd, pn.prototype.delete = Vd, pn.prototype.get = Jd, pn.prototype.has = jd, pn.prototype.set = Yd;
        function Ln(e) {
          var n = -1, i = e == null ? 0 : e.length;
          for (this.__data__ = new pn(); ++n < i; )
            this.add(e[n]);
        }
        function Xd(e) {
          return this.__data__.set(e, N), this;
        }
        function Qd(e) {
          return this.__data__.has(e);
        }
        Ln.prototype.add = Ln.prototype.push = Xd, Ln.prototype.has = Qd;
        function je(e) {
          var n = this.__data__ = new dn(e);
          this.size = n.size;
        }
        function ep() {
          this.__data__ = new dn(), this.size = 0;
        }
        function np(e) {
          var n = this.__data__, i = n.delete(e);
          return this.size = n.size, i;
        }
        function rp(e) {
          return this.__data__.get(e);
        }
        function tp(e) {
          return this.__data__.has(e);
        }
        function op(e, n) {
          var i = this.__data__;
          if (i instanceof dn) {
            var a = i.__data__;
            if (!Cr || a.length < u - 1)
              return a.push([e, n]), this.size = ++i.size, this;
            i = this.__data__ = new pn(a);
          }
          return i.set(e, n), this.size = i.size, this;
        }
        je.prototype.clear = ep, je.prototype.delete = np, je.prototype.get = rp, je.prototype.has = tp, je.prototype.set = op;
        function ka(e, n) {
          var i = G(e), a = !i && Un(e), c = !i && !a && wn(e), d = !i && !a && !c && ar(e), h = i || a || c || d, m = h ? Io(e.length, hd) : [], v = m.length;
          for (var A in e)
            (n || q.call(e, A)) && !(h && // Safari 9 has enumerable `arguments.length` in strict mode.
            (A == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            c && (A == "offset" || A == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            d && (A == "buffer" || A == "byteLength" || A == "byteOffset") || // Skip index properties.
            mn(A, v))) && m.push(A);
          return m;
        }
        function Ba(e) {
          var n = e.length;
          return n ? e[zo(0, n - 1)] : o;
        }
        function ip(e, n) {
          return Et(ye(e), Fn(n, 0, e.length));
        }
        function ap(e) {
          return Et(ye(e));
        }
        function No(e, n, i) {
          (i !== o && !Xe(e[n], i) || i === o && !(n in e)) && rn(e, n, i);
        }
        function Er(e, n, i) {
          var a = e[n];
          (!(q.call(e, n) && Xe(a, i)) || i === o && !(n in e)) && rn(e, n, i);
        }
        function mt(e, n) {
          for (var i = e.length; i--; )
            if (Xe(e[i][0], n))
              return i;
          return -1;
        }
        function sp(e, n, i, a) {
          return yn(e, function(c, d, h) {
            n(a, c, i(c), h);
          }), a;
        }
        function Pa(e, n) {
          return e && on(n, fe(n), e);
        }
        function up(e, n) {
          return e && on(n, xe(n), e);
        }
        function rn(e, n, i) {
          n == "__proto__" && ct ? ct(e, n, {
            configurable: !0,
            enumerable: !0,
            value: i,
            writable: !0
          }) : e[n] = i;
        }
        function xo(e, n) {
          for (var i = -1, a = n.length, c = I(a), d = e == null; ++i < a; )
            c[i] = d ? o : ui(e, n[i]);
          return c;
        }
        function Fn(e, n, i) {
          return e === e && (i !== o && (e = e <= i ? e : i), n !== o && (e = e >= n ? e : n)), e;
        }
        function Ue(e, n, i, a, c, d) {
          var h, m = n & k, v = n & z, A = n & ie;
          if (i && (h = c ? i(e, a, c, d) : i(e)), h !== o)
            return h;
          if (!te(e))
            return e;
          var C = G(e);
          if (C) {
            if (h = jp(e), !m)
              return ye(e, h);
          } else {
            var y = Ie(e), x = y == qr || y == Ri;
            if (wn(e))
              return ts(e, m);
            if (y == ln || y == Wn || x && !c) {
              if (h = v || x ? {} : As(e), !m)
                return v ? Gp(e, up(h, e)) : Fp(e, Pa(h, e));
            } else {
              if (!Y[y])
                return c ? e : {};
              h = Yp(e, y, m);
            }
          }
          d || (d = new je());
          var M = d.get(e);
          if (M)
            return M;
          d.set(e, h), Ys(e) ? e.forEach(function(P) {
            h.add(Ue(P, n, i, P, e, d));
          }) : Js(e) && e.forEach(function(P, $) {
            h.set($, Ue(P, n, i, $, e, d));
          });
          var O = A ? v ? qo : Wo : v ? xe : fe, Z = C ? o : O(e);
          return Pe(Z || e, function(P, $) {
            Z && ($ = P, P = e[$]), Er(h, $, Ue(P, n, i, $, e, d));
          }), h;
        }
        function cp(e) {
          var n = fe(e);
          return function(i) {
            return Ra(i, e, n);
          };
        }
        function Ra(e, n, i) {
          var a = i.length;
          if (e == null)
            return !a;
          for (e = j(e); a--; ) {
            var c = i[a], d = n[c], h = e[c];
            if (h === o && !(c in e) || !d(h))
              return !1;
          }
          return !0;
        }
        function Oa(e, n, i) {
          if (typeof e != "function")
            throw new De(p);
          return Or(function() {
            e.apply(o, i);
          }, n);
        }
        function wr(e, n, i, a) {
          var c = -1, d = Xr, h = !0, m = e.length, v = [], A = n.length;
          if (!m)
            return v;
          i && (n = ne(n, Re(i))), a ? (d = fo, h = !1) : n.length >= u && (d = Ar, h = !1, n = new Ln(n));
          e:
            for (; ++c < m; ) {
              var C = e[c], y = i == null ? C : i(C);
              if (C = a || C !== 0 ? C : 0, h && y === y) {
                for (var x = A; x--; )
                  if (n[x] === y)
                    continue e;
                v.push(C);
              } else d(n, y, a) || v.push(C);
            }
          return v;
        }
        var yn = us(tn), za = us(wo, !0);
        function lp(e, n) {
          var i = !0;
          return yn(e, function(a, c, d) {
            return i = !!n(a, c, d), i;
          }), i;
        }
        function _t(e, n, i) {
          for (var a = -1, c = e.length; ++a < c; ) {
            var d = e[a], h = n(d);
            if (h != null && (m === o ? h === h && !ze(h) : i(h, m)))
              var m = h, v = d;
          }
          return v;
        }
        function dp(e, n, i, a) {
          var c = e.length;
          for (i = D(i), i < 0 && (i = -i > c ? 0 : c + i), a = a === o || a > c ? c : D(a), a < 0 && (a += c), a = i > a ? 0 : Qs(a); i < a; )
            e[i++] = n;
          return e;
        }
        function La(e, n) {
          var i = [];
          return yn(e, function(a, c, d) {
            n(a, c, d) && i.push(a);
          }), i;
        }
        function _e(e, n, i, a, c) {
          var d = -1, h = e.length;
          for (i || (i = Qp), c || (c = []); ++d < h; ) {
            var m = e[d];
            n > 0 && i(m) ? n > 1 ? _e(m, n - 1, i, a, c) : An(c, m) : a || (c[c.length] = m);
          }
          return c;
        }
        var Eo = cs(), Fa = cs(!0);
        function tn(e, n) {
          return e && Eo(e, n, fe);
        }
        function wo(e, n) {
          return e && Fa(e, n, fe);
        }
        function gt(e, n) {
          return Sn(n, function(i) {
            return _n(e[i]);
          });
        }
        function Gn(e, n) {
          n = xn(n, e);
          for (var i = 0, a = n.length; e != null && i < a; )
            e = e[Ye(n[i++])];
          return i && i == a ? e : o;
        }
        function Ga(e, n, i) {
          var a = n(e);
          return G(e) ? a : An(a, i(e));
        }
        function be(e) {
          return e == null ? e === o ? Zc : Gc : On && On in j(e) ? qp(e) : sf(e);
        }
        function Mo(e, n) {
          return e > n;
        }
        function pp(e, n) {
          return e != null && q.call(e, n);
        }
        function fp(e, n) {
          return e != null && n in j(e);
        }
        function hp(e, n, i) {
          return e >= ve(n, i) && e < pe(n, i);
        }
        function ko(e, n, i) {
          for (var a = i ? fo : Xr, c = e[0].length, d = e.length, h = d, m = I(d), v = 1 / 0, A = []; h--; ) {
            var C = e[h];
            h && n && (C = ne(C, Re(n))), v = ve(C.length, v), m[h] = !i && (n || c >= 120 && C.length >= 120) ? new Ln(h && C) : o;
          }
          C = e[0];
          var y = -1, x = m[0];
          e:
            for (; ++y < c && A.length < v; ) {
              var M = C[y], O = n ? n(M) : M;
              if (M = i || M !== 0 ? M : 0, !(x ? Ar(x, O) : a(A, O, i))) {
                for (h = d; --h; ) {
                  var Z = m[h];
                  if (!(Z ? Ar(Z, O) : a(e[h], O, i)))
                    continue e;
                }
                x && x.push(O), A.push(M);
              }
            }
          return A;
        }
        function mp(e, n, i, a) {
          return tn(e, function(c, d, h) {
            n(a, i(c), d, h);
          }), a;
        }
        function Mr(e, n, i) {
          n = xn(n, e), e = Ns(e, n);
          var a = e == null ? e : e[Ye(Ke(n))];
          return a == null ? o : Be(a, e, i);
        }
        function Da(e) {
          return ae(e) && be(e) == Wn;
        }
        function _p(e) {
          return ae(e) && be(e) == Sr;
        }
        function gp(e) {
          return ae(e) && be(e) == _r;
        }
        function kr(e, n, i, a, c) {
          return e === n ? !0 : e == null || n == null || !ae(e) && !ae(n) ? e !== e && n !== n : vp(e, n, i, a, kr, c);
        }
        function vp(e, n, i, a, c, d) {
          var h = G(e), m = G(n), v = h ? Hr : Ie(e), A = m ? Hr : Ie(n);
          v = v == Wn ? ln : v, A = A == Wn ? ln : A;
          var C = v == ln, y = A == ln, x = v == A;
          if (x && wn(e)) {
            if (!wn(n))
              return !1;
            h = !0, C = !1;
          }
          if (x && !C)
            return d || (d = new je()), h || ar(e) ? Is(e, n, i, a, c, d) : Hp(e, n, v, i, a, c, d);
          if (!(i & Q)) {
            var M = C && q.call(e, "__wrapped__"), O = y && q.call(n, "__wrapped__");
            if (M || O) {
              var Z = M ? e.value() : e, P = O ? n.value() : n;
              return d || (d = new je()), c(Z, P, i, a, d);
            }
          }
          return x ? (d || (d = new je()), Wp(e, n, i, a, c, d)) : !1;
        }
        function Ip(e) {
          return ae(e) && Ie(e) == qe;
        }
        function Bo(e, n, i, a) {
          var c = i.length, d = c, h = !a;
          if (e == null)
            return !d;
          for (e = j(e); c--; ) {
            var m = i[c];
            if (h && m[2] ? m[1] !== e[m[0]] : !(m[0] in e))
              return !1;
          }
          for (; ++c < d; ) {
            m = i[c];
            var v = m[0], A = e[v], C = m[1];
            if (h && m[2]) {
              if (A === o && !(v in e))
                return !1;
            } else {
              var y = new je();
              if (a)
                var x = a(A, C, v, e, n, y);
              if (!(x === o ? kr(C, A, Q | un, a, y) : x))
                return !1;
            }
          }
          return !0;
        }
        function Za(e) {
          if (!te(e) || nf(e))
            return !1;
          var n = _n(e) ? Id : cl;
          return n.test(Zn(e));
        }
        function bp(e) {
          return ae(e) && be(e) == vr;
        }
        function Sp(e) {
          return ae(e) && Ie(e) == Ve;
        }
        function Ap(e) {
          return ae(e) && Rt(e.length) && !!X[be(e)];
        }
        function Ua(e) {
          return typeof e == "function" ? e : e == null ? Ee : typeof e == "object" ? G(e) ? Ha(e[0], e[1]) : Ka(e) : du(e);
        }
        function Po(e) {
          if (!Rr(e))
            return yd(e);
          var n = [];
          for (var i in j(e))
            q.call(e, i) && i != "constructor" && n.push(i);
          return n;
        }
        function Tp(e) {
          if (!te(e))
            return af(e);
          var n = Rr(e), i = [];
          for (var a in e)
            a == "constructor" && (n || !q.call(e, a)) || i.push(a);
          return i;
        }
        function Ro(e, n) {
          return e < n;
        }
        function $a(e, n) {
          var i = -1, a = Ne(e) ? I(e.length) : [];
          return yn(e, function(c, d, h) {
            a[++i] = n(c, d, h);
          }), a;
        }
        function Ka(e) {
          var n = Jo(e);
          return n.length == 1 && n[0][2] ? Cs(n[0][0], n[0][1]) : function(i) {
            return i === e || Bo(i, e, n);
          };
        }
        function Ha(e, n) {
          return Yo(e) && Ts(n) ? Cs(Ye(e), n) : function(i) {
            var a = ui(i, e);
            return a === o && a === n ? ci(i, e) : kr(n, a, Q | un);
          };
        }
        function vt(e, n, i, a, c) {
          e !== n && Eo(n, function(d, h) {
            if (c || (c = new je()), te(d))
              Cp(e, n, h, i, vt, a, c);
            else {
              var m = a ? a(Qo(e, h), d, h + "", e, n, c) : o;
              m === o && (m = d), No(e, h, m);
            }
          }, xe);
        }
        function Cp(e, n, i, a, c, d, h) {
          var m = Qo(e, i), v = Qo(n, i), A = h.get(v);
          if (A) {
            No(e, i, A);
            return;
          }
          var C = d ? d(m, v, i + "", e, n, h) : o, y = C === o;
          if (y) {
            var x = G(v), M = !x && wn(v), O = !x && !M && ar(v);
            C = v, x || M || O ? G(m) ? C = m : se(m) ? C = ye(m) : M ? (y = !1, C = ts(v, !0)) : O ? (y = !1, C = os(v, !0)) : C = [] : zr(v) || Un(v) ? (C = m, Un(m) ? C = eu(m) : (!te(m) || _n(m)) && (C = As(v))) : y = !1;
          }
          y && (h.set(v, C), c(C, v, a, d, h), h.delete(v)), No(e, i, C);
        }
        function Wa(e, n) {
          var i = e.length;
          if (i)
            return n += n < 0 ? i : 0, mn(n, i) ? e[n] : o;
        }
        function qa(e, n, i) {
          n.length ? n = ne(n, function(d) {
            return G(d) ? function(h) {
              return Gn(h, d.length === 1 ? d[0] : d);
            } : d;
          }) : n = [Ee];
          var a = -1;
          n = ne(n, Re(R()));
          var c = $a(e, function(d, h, m) {
            var v = ne(n, function(A) {
              return A(d);
            });
            return { criteria: v, index: ++a, value: d };
          });
          return Yl(c, function(d, h) {
            return Lp(d, h, i);
          });
        }
        function yp(e, n) {
          return Va(e, n, function(i, a) {
            return ci(e, a);
          });
        }
        function Va(e, n, i) {
          for (var a = -1, c = n.length, d = {}; ++a < c; ) {
            var h = n[a], m = Gn(e, h);
            i(m, h) && Br(d, xn(h, e), m);
          }
          return d;
        }
        function Np(e) {
          return function(n) {
            return Gn(n, e);
          };
        }
        function Oo(e, n, i, a) {
          var c = a ? jl : Jn, d = -1, h = n.length, m = e;
          for (e === n && (n = ye(n)), i && (m = ne(e, Re(i))); ++d < h; )
            for (var v = 0, A = n[d], C = i ? i(A) : A; (v = c(m, C, v, a)) > -1; )
              m !== e && ut.call(m, v, 1), ut.call(e, v, 1);
          return e;
        }
        function Ja(e, n) {
          for (var i = e ? n.length : 0, a = i - 1; i--; ) {
            var c = n[i];
            if (i == a || c !== d) {
              var d = c;
              mn(c) ? ut.call(e, c, 1) : Go(e, c);
            }
          }
          return e;
        }
        function zo(e, n) {
          return e + dt(wa() * (n - e + 1));
        }
        function xp(e, n, i, a) {
          for (var c = -1, d = pe(lt((n - e) / (i || 1)), 0), h = I(d); d--; )
            h[a ? d : ++c] = e, e += i;
          return h;
        }
        function Lo(e, n) {
          var i = "";
          if (!e || n < 1 || n > bn)
            return i;
          do
            n % 2 && (i += e), n = dt(n / 2), n && (e += e);
          while (n);
          return i;
        }
        function U(e, n) {
          return ei(ys(e, n, Ee), e + "");
        }
        function Ep(e) {
          return Ba(sr(e));
        }
        function wp(e, n) {
          var i = sr(e);
          return Et(i, Fn(n, 0, i.length));
        }
        function Br(e, n, i, a) {
          if (!te(e))
            return e;
          n = xn(n, e);
          for (var c = -1, d = n.length, h = d - 1, m = e; m != null && ++c < d; ) {
            var v = Ye(n[c]), A = i;
            if (v === "__proto__" || v === "constructor" || v === "prototype")
              return e;
            if (c != h) {
              var C = m[v];
              A = a ? a(C, v, m) : o, A === o && (A = te(C) ? C : mn(n[c + 1]) ? [] : {});
            }
            Er(m, v, A), m = m[v];
          }
          return e;
        }
        var ja = pt ? function(e, n) {
          return pt.set(e, n), e;
        } : Ee, Mp = ct ? function(e, n) {
          return ct(e, "toString", {
            configurable: !0,
            enumerable: !1,
            value: di(n),
            writable: !0
          });
        } : Ee;
        function kp(e) {
          return Et(sr(e));
        }
        function $e(e, n, i) {
          var a = -1, c = e.length;
          n < 0 && (n = -n > c ? 0 : c + n), i = i > c ? c : i, i < 0 && (i += c), c = n > i ? 0 : i - n >>> 0, n >>>= 0;
          for (var d = I(c); ++a < c; )
            d[a] = e[a + n];
          return d;
        }
        function Bp(e, n) {
          var i;
          return yn(e, function(a, c, d) {
            return i = n(a, c, d), !i;
          }), !!i;
        }
        function It(e, n, i) {
          var a = 0, c = e == null ? a : e.length;
          if (typeof n == "number" && n === n && c <= Oc) {
            for (; a < c; ) {
              var d = a + c >>> 1, h = e[d];
              h !== null && !ze(h) && (i ? h <= n : h < n) ? a = d + 1 : c = d;
            }
            return c;
          }
          return Fo(e, n, Ee, i);
        }
        function Fo(e, n, i, a) {
          var c = 0, d = e == null ? 0 : e.length;
          if (d === 0)
            return 0;
          n = i(n);
          for (var h = n !== n, m = n === null, v = ze(n), A = n === o; c < d; ) {
            var C = dt((c + d) / 2), y = i(e[C]), x = y !== o, M = y === null, O = y === y, Z = ze(y);
            if (h)
              var P = a || O;
            else A ? P = O && (a || x) : m ? P = O && x && (a || !M) : v ? P = O && x && !M && (a || !Z) : M || Z ? P = !1 : P = a ? y <= n : y < n;
            P ? c = C + 1 : d = C;
          }
          return ve(d, Rc);
        }
        function Ya(e, n) {
          for (var i = -1, a = e.length, c = 0, d = []; ++i < a; ) {
            var h = e[i], m = n ? n(h) : h;
            if (!i || !Xe(m, v)) {
              var v = m;
              d[c++] = h === 0 ? 0 : h;
            }
          }
          return d;
        }
        function Xa(e) {
          return typeof e == "number" ? e : ze(e) ? Kr : +e;
        }
        function Oe(e) {
          if (typeof e == "string")
            return e;
          if (G(e))
            return ne(e, Oe) + "";
          if (ze(e))
            return Ma ? Ma.call(e) : "";
          var n = e + "";
          return n == "0" && 1 / e == -Pn ? "-0" : n;
        }
        function Nn(e, n, i) {
          var a = -1, c = Xr, d = e.length, h = !0, m = [], v = m;
          if (i)
            h = !1, c = fo;
          else if (d >= u) {
            var A = n ? null : $p(e);
            if (A)
              return et(A);
            h = !1, c = Ar, v = new Ln();
          } else
            v = n ? [] : m;
          e:
            for (; ++a < d; ) {
              var C = e[a], y = n ? n(C) : C;
              if (C = i || C !== 0 ? C : 0, h && y === y) {
                for (var x = v.length; x--; )
                  if (v[x] === y)
                    continue e;
                n && v.push(y), m.push(C);
              } else c(v, y, i) || (v !== m && v.push(y), m.push(C));
            }
          return m;
        }
        function Go(e, n) {
          n = xn(n, e);
          var i = -1, a = n.length;
          if (!a)
            return !0;
          for (; ++i < a; ) {
            var c = Ye(n[i]);
            if (c === "__proto__" && !q.call(e, "__proto__") || (c === "constructor" || c === "prototype") && i < a - 1)
              return !1;
          }
          var d = Ns(e, n);
          return d == null || delete d[Ye(Ke(n))];
        }
        function Qa(e, n, i, a) {
          return Br(e, n, i(Gn(e, n)), a);
        }
        function bt(e, n, i, a) {
          for (var c = e.length, d = a ? c : -1; (a ? d-- : ++d < c) && n(e[d], d, e); )
            ;
          return i ? $e(e, a ? 0 : d, a ? d + 1 : c) : $e(e, a ? d + 1 : 0, a ? c : d);
        }
        function es(e, n) {
          var i = e;
          return i instanceof K && (i = i.value()), ho(n, function(a, c) {
            return c.func.apply(c.thisArg, An([a], c.args));
          }, i);
        }
        function Do(e, n, i) {
          var a = e.length;
          if (a < 2)
            return a ? Nn(e[0]) : [];
          for (var c = -1, d = I(a); ++c < a; )
            for (var h = e[c], m = -1; ++m < a; )
              m != c && (d[c] = wr(d[c] || h, e[m], n, i));
          return Nn(_e(d, 1), n, i);
        }
        function ns(e, n, i) {
          for (var a = -1, c = e.length, d = n.length, h = {}; ++a < c; ) {
            var m = a < d ? n[a] : o;
            i(h, e[a], m);
          }
          return h;
        }
        function Zo(e) {
          return se(e) ? e : [];
        }
        function Uo(e) {
          return typeof e == "function" ? e : Ee;
        }
        function xn(e, n) {
          return G(e) ? e : Yo(e, n) ? [e] : Ms(V(e));
        }
        var Pp = U;
        function En(e, n, i) {
          var a = e.length;
          return i = i === o ? a : i, !n && i >= a ? e : $e(e, n, i);
        }
        var rs = bd || function(e) {
          return me.clearTimeout(e);
        };
        function ts(e, n) {
          if (n)
            return e.slice();
          var i = e.length, a = Ca ? Ca(i) : new e.constructor(i);
          return e.copy(a), a;
        }
        function $o(e) {
          var n = new e.constructor(e.byteLength);
          return new at(n).set(new at(e)), n;
        }
        function Rp(e, n) {
          var i = n ? $o(e.buffer) : e.buffer;
          return new e.constructor(i, e.byteOffset, e.byteLength);
        }
        function Op(e) {
          var n = new e.constructor(e.source, Di.exec(e));
          return n.lastIndex = e.lastIndex, n;
        }
        function zp(e) {
          return xr ? j(xr.call(e)) : {};
        }
        function os(e, n) {
          var i = n ? $o(e.buffer) : e.buffer;
          return new e.constructor(i, e.byteOffset, e.length);
        }
        function is(e, n) {
          if (e !== n) {
            var i = e !== o, a = e === null, c = e === e, d = ze(e), h = n !== o, m = n === null, v = n === n, A = ze(n);
            if (!m && !A && !d && e > n || d && h && v && !m && !A || a && h && v || !i && v || !c)
              return 1;
            if (!a && !d && !A && e < n || A && i && c && !a && !d || m && i && c || !h && c || !v)
              return -1;
          }
          return 0;
        }
        function Lp(e, n, i) {
          for (var a = -1, c = e.criteria, d = n.criteria, h = c.length, m = i.length; ++a < h; ) {
            var v = is(c[a], d[a]);
            if (v) {
              if (a >= m)
                return v;
              var A = i[a];
              return v * (A == "desc" ? -1 : 1);
            }
          }
          return e.index - n.index;
        }
        function as(e, n, i, a) {
          for (var c = -1, d = e.length, h = i.length, m = -1, v = n.length, A = pe(d - h, 0), C = I(v + A), y = !a; ++m < v; )
            C[m] = n[m];
          for (; ++c < h; )
            (y || c < d) && (C[i[c]] = e[c]);
          for (; A--; )
            C[m++] = e[c++];
          return C;
        }
        function ss(e, n, i, a) {
          for (var c = -1, d = e.length, h = -1, m = i.length, v = -1, A = n.length, C = pe(d - m, 0), y = I(C + A), x = !a; ++c < C; )
            y[c] = e[c];
          for (var M = c; ++v < A; )
            y[M + v] = n[v];
          for (; ++h < m; )
            (x || c < d) && (y[M + i[h]] = e[c++]);
          return y;
        }
        function ye(e, n) {
          var i = -1, a = e.length;
          for (n || (n = I(a)); ++i < a; )
            n[i] = e[i];
          return n;
        }
        function on(e, n, i, a) {
          var c = !i;
          i || (i = {});
          for (var d = -1, h = n.length; ++d < h; ) {
            var m = n[d], v = a ? a(i[m], e[m], m, i, e) : o;
            v === o && (v = e[m]), c ? rn(i, m, v) : Er(i, m, v);
          }
          return i;
        }
        function Fp(e, n) {
          return on(e, jo(e), n);
        }
        function Gp(e, n) {
          return on(e, bs(e), n);
        }
        function St(e, n) {
          return function(i, a) {
            var c = G(i) ? Kl : sp, d = n ? n() : {};
            return c(i, e, R(a, 2), d);
          };
        }
        function tr(e) {
          return U(function(n, i) {
            var a = -1, c = i.length, d = c > 1 ? i[c - 1] : o, h = c > 2 ? i[2] : o;
            for (d = e.length > 3 && typeof d == "function" ? (c--, d) : o, h && Se(i[0], i[1], h) && (d = c < 3 ? o : d, c = 1), n = j(n); ++a < c; ) {
              var m = i[a];
              m && e(n, m, a, d);
            }
            return n;
          });
        }
        function us(e, n) {
          return function(i, a) {
            if (i == null)
              return i;
            if (!Ne(i))
              return e(i, a);
            for (var c = i.length, d = n ? c : -1, h = j(i); (n ? d-- : ++d < c) && a(h[d], d, h) !== !1; )
              ;
            return i;
          };
        }
        function cs(e) {
          return function(n, i, a) {
            for (var c = -1, d = j(n), h = a(n), m = h.length; m--; ) {
              var v = h[e ? m : ++c];
              if (i(d[v], v, d) === !1)
                break;
            }
            return n;
          };
        }
        function Dp(e, n, i) {
          var a = n & Me, c = Pr(e);
          function d() {
            var h = this && this !== me && this instanceof d ? c : e;
            return h.apply(a ? i : this, arguments);
          }
          return d;
        }
        function ls(e) {
          return function(n) {
            n = V(n);
            var i = jn(n) ? Je(n) : o, a = i ? i[0] : n.charAt(0), c = i ? En(i, 1).join("") : n.slice(1);
            return a[e]() + c;
          };
        }
        function or(e) {
          return function(n) {
            return ho(cu(uu(n).replace(Ml, "")), e, "");
          };
        }
        function Pr(e) {
          return function() {
            var n = arguments;
            switch (n.length) {
              case 0:
                return new e();
              case 1:
                return new e(n[0]);
              case 2:
                return new e(n[0], n[1]);
              case 3:
                return new e(n[0], n[1], n[2]);
              case 4:
                return new e(n[0], n[1], n[2], n[3]);
              case 5:
                return new e(n[0], n[1], n[2], n[3], n[4]);
              case 6:
                return new e(n[0], n[1], n[2], n[3], n[4], n[5]);
              case 7:
                return new e(n[0], n[1], n[2], n[3], n[4], n[5], n[6]);
            }
            var i = rr(e.prototype), a = e.apply(i, n);
            return te(a) ? a : i;
          };
        }
        function Zp(e, n, i) {
          var a = Pr(e);
          function c() {
            for (var d = arguments.length, h = I(d), m = d, v = ir(c); m--; )
              h[m] = arguments[m];
            var A = d < 3 && h[0] !== v && h[d - 1] !== v ? [] : Tn(h, v);
            if (d -= A.length, d < i)
              return ms(
                e,
                n,
                At,
                c.placeholder,
                o,
                h,
                A,
                o,
                o,
                i - d
              );
            var C = this && this !== me && this instanceof c ? a : e;
            return Be(C, this, h);
          }
          return c;
        }
        function ds(e) {
          return function(n, i, a) {
            var c = j(n);
            if (!Ne(n)) {
              var d = R(i, 3);
              n = fe(n), i = function(m) {
                return d(c[m], m, c);
              };
            }
            var h = e(n, i, a);
            return h > -1 ? c[d ? n[h] : h] : o;
          };
        }
        function ps(e) {
          return hn(function(n) {
            var i = n.length, a = i, c = Ze.prototype.thru;
            for (e && n.reverse(); a--; ) {
              var d = n[a];
              if (typeof d != "function")
                throw new De(p);
              if (c && !h && Nt(d) == "wrapper")
                var h = new Ze([], !0);
            }
            for (a = h ? a : i; ++a < i; ) {
              d = n[a];
              var m = Nt(d), v = m == "wrapper" ? Vo(d) : o;
              v && Xo(v[0]) && v[1] == (cn | ee | en | hr) && !v[4].length && v[9] == 1 ? h = h[Nt(v[0])].apply(h, v[3]) : h = d.length == 1 && Xo(d) ? h[m]() : h.thru(d);
            }
            return function() {
              var A = arguments, C = A[0];
              if (h && A.length == 1 && G(C))
                return h.plant(C).value();
              for (var y = 0, x = i ? n[y].apply(this, A) : C; ++y < i; )
                x = n[y].call(this, x);
              return x;
            };
          });
        }
        function At(e, n, i, a, c, d, h, m, v, A) {
          var C = n & cn, y = n & Me, x = n & In, M = n & (ee | he), O = n & qt, Z = x ? o : Pr(e);
          function P() {
            for (var $ = arguments.length, H = I($), Le = $; Le--; )
              H[Le] = arguments[Le];
            if (M)
              var Ae = ir(P), Fe = Ql(H, Ae);
            if (a && (H = as(H, a, c, M)), d && (H = ss(H, d, h, M)), $ -= Fe, M && $ < A) {
              var ue = Tn(H, Ae);
              return ms(
                e,
                n,
                At,
                P.placeholder,
                i,
                H,
                ue,
                m,
                v,
                A - $
              );
            }
            var Qe = y ? i : this, vn = x ? Qe[e] : e;
            return $ = H.length, m ? H = uf(H, m) : O && $ > 1 && H.reverse(), C && v < $ && (H.length = v), this && this !== me && this instanceof P && (vn = Z || Pr(vn)), vn.apply(Qe, H);
          }
          return P;
        }
        function fs(e, n) {
          return function(i, a) {
            return mp(i, e, n(a), {});
          };
        }
        function Tt(e, n) {
          return function(i, a) {
            var c;
            if (i === o && a === o)
              return n;
            if (i !== o && (c = i), a !== o) {
              if (c === o)
                return a;
              typeof i == "string" || typeof a == "string" ? (i = Oe(i), a = Oe(a)) : (i = Xa(i), a = Xa(a)), c = e(i, a);
            }
            return c;
          };
        }
        function Ko(e) {
          return hn(function(n) {
            return n = ne(n, Re(R())), U(function(i) {
              var a = this;
              return e(n, function(c) {
                return Be(c, a, i);
              });
            });
          });
        }
        function Ct(e, n) {
          n = n === o ? " " : Oe(n);
          var i = n.length;
          if (i < 2)
            return i ? Lo(n, e) : n;
          var a = Lo(n, lt(e / Yn(n)));
          return jn(n) ? En(Je(a), 0, e).join("") : a.slice(0, e);
        }
        function Up(e, n, i, a) {
          var c = n & Me, d = Pr(e);
          function h() {
            for (var m = -1, v = arguments.length, A = -1, C = a.length, y = I(C + v), x = this && this !== me && this instanceof h ? d : e; ++A < C; )
              y[A] = a[A];
            for (; v--; )
              y[A++] = arguments[++m];
            return Be(x, c ? i : this, y);
          }
          return h;
        }
        function hs(e) {
          return function(n, i, a) {
            return a && typeof a != "number" && Se(n, i, a) && (i = a = o), n = gn(n), i === o ? (i = n, n = 0) : i = gn(i), a = a === o ? n < i ? 1 : -1 : gn(a), xp(n, i, a, e);
          };
        }
        function yt(e) {
          return function(n, i) {
            return typeof n == "string" && typeof i == "string" || (n = He(n), i = He(i)), e(n, i);
          };
        }
        function ms(e, n, i, a, c, d, h, m, v, A) {
          var C = n & ee, y = C ? h : o, x = C ? o : h, M = C ? d : o, O = C ? o : d;
          n |= C ? en : Bn, n &= ~(C ? Bn : en), n & ke || (n &= -4);
          var Z = [
            e,
            n,
            c,
            M,
            y,
            O,
            x,
            m,
            v,
            A
          ], P = i.apply(o, Z);
          return Xo(e) && xs(P, Z), P.placeholder = a, Es(P, e, n);
        }
        function Ho(e) {
          var n = de[e];
          return function(i, a) {
            if (i = He(i), a = a == null ? 0 : ve(D(a), 292), a && Ea(i)) {
              var c = (V(i) + "e").split("e"), d = n(c[0] + "e" + (+c[1] + a));
              return c = (V(d) + "e").split("e"), +(c[0] + "e" + (+c[1] - a));
            }
            return n(i);
          };
        }
        var $p = er && 1 / et(new er([, -0]))[1] == Pn ? function(e) {
          return new er(e);
        } : hi;
        function _s(e) {
          return function(n) {
            var i = Ie(n);
            return i == qe ? So(n) : i == Ve ? ad(n) : Xl(n, e(n));
          };
        }
        function fn(e, n, i, a, c, d, h, m) {
          var v = n & In;
          if (!v && typeof e != "function")
            throw new De(p);
          var A = a ? a.length : 0;
          if (A || (n &= -97, a = c = o), h = h === o ? h : pe(D(h), 0), m = m === o ? m : D(m), A -= c ? c.length : 0, n & Bn) {
            var C = a, y = c;
            a = c = o;
          }
          var x = v ? o : Vo(e), M = [
            e,
            n,
            i,
            a,
            c,
            C,
            y,
            d,
            h,
            m
          ];
          if (x && of(M, x), e = M[0], n = M[1], i = M[2], a = M[3], c = M[4], m = M[9] = M[9] === o ? v ? 0 : e.length : pe(M[9] - A, 0), !m && n & (ee | he) && (n &= -25), !n || n == Me)
            var O = Dp(e, n, i);
          else n == ee || n == he ? O = Zp(e, n, m) : (n == en || n == (Me | en)) && !c.length ? O = Up(e, n, i, a) : O = At.apply(o, M);
          var Z = x ? ja : xs;
          return Es(Z(O, M), e, n);
        }
        function gs(e, n, i, a) {
          return e === o || Xe(e, Qn[i]) && !q.call(a, i) ? n : e;
        }
        function vs(e, n, i, a, c, d) {
          return te(e) && te(n) && (d.set(n, e), vt(e, n, o, vs, d), d.delete(n)), e;
        }
        function Kp(e) {
          return zr(e) ? o : e;
        }
        function Is(e, n, i, a, c, d) {
          var h = i & Q, m = e.length, v = n.length;
          if (m != v && !(h && v > m))
            return !1;
          var A = d.get(e), C = d.get(n);
          if (A && C)
            return A == n && C == e;
          var y = -1, x = !0, M = i & un ? new Ln() : o;
          for (d.set(e, n), d.set(n, e); ++y < m; ) {
            var O = e[y], Z = n[y];
            if (a)
              var P = h ? a(Z, O, y, n, e, d) : a(O, Z, y, e, n, d);
            if (P !== o) {
              if (P)
                continue;
              x = !1;
              break;
            }
            if (M) {
              if (!mo(n, function($, H) {
                if (!Ar(M, H) && (O === $ || c(O, $, i, a, d)))
                  return M.push(H);
              })) {
                x = !1;
                break;
              }
            } else if (!(O === Z || c(O, Z, i, a, d))) {
              x = !1;
              break;
            }
          }
          return d.delete(e), d.delete(n), x;
        }
        function Hp(e, n, i, a, c, d, h) {
          switch (i) {
            case qn:
              if (e.byteLength != n.byteLength || e.byteOffset != n.byteOffset)
                return !1;
              e = e.buffer, n = n.buffer;
            case Sr:
              return !(e.byteLength != n.byteLength || !d(new at(e), new at(n)));
            case mr:
            case _r:
            case gr:
              return Xe(+e, +n);
            case Wr:
              return e.name == n.name && e.message == n.message;
            case vr:
            case Ir:
              return e == n + "";
            case qe:
              var m = So;
            case Ve:
              var v = a & Q;
              if (m || (m = et), e.size != n.size && !v)
                return !1;
              var A = h.get(e);
              if (A)
                return A == n;
              a |= un, h.set(e, n);
              var C = Is(m(e), m(n), a, c, d, h);
              return h.delete(e), C;
            case Vr:
              if (xr)
                return xr.call(e) == xr.call(n);
          }
          return !1;
        }
        function Wp(e, n, i, a, c, d) {
          var h = i & Q, m = Wo(e), v = m.length, A = Wo(n), C = A.length;
          if (v != C && !h)
            return !1;
          for (var y = v; y--; ) {
            var x = m[y];
            if (!(h ? x in n : q.call(n, x)))
              return !1;
          }
          var M = d.get(e), O = d.get(n);
          if (M && O)
            return M == n && O == e;
          var Z = !0;
          d.set(e, n), d.set(n, e);
          for (var P = h; ++y < v; ) {
            x = m[y];
            var $ = e[x], H = n[x];
            if (a)
              var Le = h ? a(H, $, x, n, e, d) : a($, H, x, e, n, d);
            if (!(Le === o ? $ === H || c($, H, i, a, d) : Le)) {
              Z = !1;
              break;
            }
            P || (P = x == "constructor");
          }
          if (Z && !P) {
            var Ae = e.constructor, Fe = n.constructor;
            Ae != Fe && "constructor" in e && "constructor" in n && !(typeof Ae == "function" && Ae instanceof Ae && typeof Fe == "function" && Fe instanceof Fe) && (Z = !1);
          }
          return d.delete(e), d.delete(n), Z;
        }
        function hn(e) {
          return ei(ys(e, o, Rs), e + "");
        }
        function Wo(e) {
          return Ga(e, fe, jo);
        }
        function qo(e) {
          return Ga(e, xe, bs);
        }
        var Vo = pt ? function(e) {
          return pt.get(e);
        } : hi;
        function Nt(e) {
          for (var n = e.name + "", i = nr[n], a = q.call(nr, n) ? i.length : 0; a--; ) {
            var c = i[a], d = c.func;
            if (d == null || d == e)
              return c.name;
          }
          return n;
        }
        function ir(e) {
          var n = q.call(l, "placeholder") ? l : e;
          return n.placeholder;
        }
        function R() {
          var e = l.iteratee || pi;
          return e = e === pi ? Ua : e, arguments.length ? e(arguments[0], arguments[1]) : e;
        }
        function xt(e, n) {
          var i = e.__data__;
          return ef(n) ? i[typeof n == "string" ? "string" : "hash"] : i.map;
        }
        function Jo(e) {
          for (var n = fe(e), i = n.length; i--; ) {
            var a = n[i], c = e[a];
            n[i] = [a, c, Ts(c)];
          }
          return n;
        }
        function Dn(e, n) {
          var i = td(e, n);
          return Za(i) ? i : o;
        }
        function qp(e) {
          var n = q.call(e, On), i = e[On];
          try {
            e[On] = o;
            var a = !0;
          } catch {
          }
          var c = ot.call(e);
          return a && (n ? e[On] = i : delete e[On]), c;
        }
        var jo = To ? function(e) {
          return e == null ? [] : (e = j(e), Sn(To(e), function(n) {
            return Na.call(e, n);
          }));
        } : mi, bs = To ? function(e) {
          for (var n = []; e; )
            An(n, jo(e)), e = st(e);
          return n;
        } : mi, Ie = be;
        (Co && Ie(new Co(new ArrayBuffer(1))) != qn || Cr && Ie(new Cr()) != qe || yo && Ie(yo.resolve()) != Oi || er && Ie(new er()) != Ve || yr && Ie(new yr()) != br) && (Ie = function(e) {
          var n = be(e), i = n == ln ? e.constructor : o, a = i ? Zn(i) : "";
          if (a)
            switch (a) {
              case wd:
                return qn;
              case Md:
                return qe;
              case kd:
                return Oi;
              case Bd:
                return Ve;
              case Pd:
                return br;
            }
          return n;
        });
        function Vp(e, n, i) {
          for (var a = -1, c = i.length; ++a < c; ) {
            var d = i[a], h = d.size;
            switch (d.type) {
              case "drop":
                e += h;
                break;
              case "dropRight":
                n -= h;
                break;
              case "take":
                n = ve(n, e + h);
                break;
              case "takeRight":
                e = pe(e, n - h);
                break;
            }
          }
          return { start: e, end: n };
        }
        function Jp(e) {
          var n = e.match(rl);
          return n ? n[1].split(tl) : [];
        }
        function Ss(e, n, i) {
          n = xn(n, e);
          for (var a = -1, c = n.length, d = !1; ++a < c; ) {
            var h = Ye(n[a]);
            if (!(d = e != null && i(e, h)))
              break;
            e = e[h];
          }
          return d || ++a != c ? d : (c = e == null ? 0 : e.length, !!c && Rt(c) && mn(h, c) && (G(e) || Un(e)));
        }
        function jp(e) {
          var n = e.length, i = new e.constructor(n);
          return n && typeof e[0] == "string" && q.call(e, "index") && (i.index = e.index, i.input = e.input), i;
        }
        function As(e) {
          return typeof e.constructor == "function" && !Rr(e) ? rr(st(e)) : {};
        }
        function Yp(e, n, i) {
          var a = e.constructor;
          switch (n) {
            case Sr:
              return $o(e);
            case mr:
            case _r:
              return new a(+e);
            case qn:
              return Rp(e, i);
            case Vt:
            case Jt:
            case jt:
            case Yt:
            case Xt:
            case Qt:
            case eo:
            case no:
            case ro:
              return os(e, i);
            case qe:
              return new a();
            case gr:
            case Ir:
              return new a(e);
            case vr:
              return Op(e);
            case Ve:
              return new a();
            case Vr:
              return zp(e);
          }
        }
        function Xp(e, n) {
          var i = n.length;
          if (!i)
            return e;
          var a = i - 1;
          return n[a] = (i > 1 ? "& " : "") + n[a], n = n.join(i > 2 ? ", " : " "), e.replace(nl, `{
/* [wrapped with ` + n + `] */
`);
        }
        function Qp(e) {
          return G(e) || Un(e) || !!(xa && e && e[xa]);
        }
        function mn(e, n) {
          var i = typeof e;
          return n = n ?? bn, !!n && (i == "number" || i != "symbol" && dl.test(e)) && e > -1 && e % 1 == 0 && e < n;
        }
        function Se(e, n, i) {
          if (!te(i))
            return !1;
          var a = typeof n;
          return (a == "number" ? Ne(i) && mn(n, i.length) : a == "string" && n in i) ? Xe(i[n], e) : !1;
        }
        function Yo(e, n) {
          if (G(e))
            return !1;
          var i = typeof e;
          return i == "number" || i == "symbol" || i == "boolean" || e == null || ze(e) ? !0 : Yc.test(e) || !jc.test(e) || n != null && e in j(n);
        }
        function ef(e) {
          var n = typeof e;
          return n == "string" || n == "number" || n == "symbol" || n == "boolean" ? e !== "__proto__" : e === null;
        }
        function Xo(e) {
          var n = Nt(e), i = l[n];
          if (typeof i != "function" || !(n in K.prototype))
            return !1;
          if (e === i)
            return !0;
          var a = Vo(i);
          return !!a && e === a[0];
        }
        function nf(e) {
          return !!Ta && Ta in e;
        }
        var rf = rt ? _n : _i;
        function Rr(e) {
          var n = e && e.constructor, i = typeof n == "function" && n.prototype || Qn;
          return e === i;
        }
        function Ts(e) {
          return e === e && !te(e);
        }
        function Cs(e, n) {
          return function(i) {
            return i == null ? !1 : i[e] === n && (n !== o || e in j(i));
          };
        }
        function tf(e) {
          var n = Bt(e, function(a) {
            return i.size === w && i.clear(), a;
          }), i = n.cache;
          return n;
        }
        function of(e, n) {
          var i = e[1], a = n[1], c = i | a, d = c < (Me | In | cn), h = a == cn && i == ee || a == cn && i == hr && e[7].length <= n[8] || a == (cn | hr) && n[7].length <= n[8] && i == ee;
          if (!(d || h))
            return e;
          a & Me && (e[2] = n[2], c |= i & Me ? 0 : ke);
          var m = n[3];
          if (m) {
            var v = e[3];
            e[3] = v ? as(v, m, n[4]) : m, e[4] = v ? Tn(e[3], F) : n[4];
          }
          return m = n[5], m && (v = e[5], e[5] = v ? ss(v, m, n[6]) : m, e[6] = v ? Tn(e[5], F) : n[6]), m = n[7], m && (e[7] = m), a & cn && (e[8] = e[8] == null ? n[8] : ve(e[8], n[8])), e[9] == null && (e[9] = n[9]), e[0] = n[0], e[1] = c, e;
        }
        function af(e) {
          var n = [];
          if (e != null)
            for (var i in j(e))
              n.push(i);
          return n;
        }
        function sf(e) {
          return ot.call(e);
        }
        function ys(e, n, i) {
          return n = pe(n === o ? e.length - 1 : n, 0), function() {
            for (var a = arguments, c = -1, d = pe(a.length - n, 0), h = I(d); ++c < d; )
              h[c] = a[n + c];
            c = -1;
            for (var m = I(n + 1); ++c < n; )
              m[c] = a[c];
            return m[n] = i(h), Be(e, this, m);
          };
        }
        function Ns(e, n) {
          return n.length < 2 ? e : Gn(e, $e(n, 0, -1));
        }
        function uf(e, n) {
          for (var i = e.length, a = ve(n.length, i), c = ye(e); a--; ) {
            var d = n[a];
            e[a] = mn(d, i) ? c[d] : o;
          }
          return e;
        }
        function Qo(e, n) {
          if (!(n === "constructor" && typeof e[n] == "function") && n != "__proto__")
            return e[n];
        }
        var xs = ws(ja), Or = Ad || function(e, n) {
          return me.setTimeout(e, n);
        }, ei = ws(Mp);
        function Es(e, n, i) {
          var a = n + "";
          return ei(e, Xp(a, cf(Jp(a), i)));
        }
        function ws(e) {
          var n = 0, i = 0;
          return function() {
            var a = Nd(), c = Mc - (a - i);
            if (i = a, c > 0) {
              if (++n >= wc)
                return arguments[0];
            } else
              n = 0;
            return e.apply(o, arguments);
          };
        }
        function Et(e, n) {
          var i = -1, a = e.length, c = a - 1;
          for (n = n === o ? a : n; ++i < n; ) {
            var d = zo(i, c), h = e[d];
            e[d] = e[i], e[i] = h;
          }
          return e.length = n, e;
        }
        var Ms = tf(function(e) {
          var n = [];
          return e.charCodeAt(0) === 46 && n.push(""), e.replace(Xc, function(i, a, c, d) {
            n.push(c ? d.replace(il, "$1") : a || i);
          }), n;
        });
        function Ye(e) {
          if (typeof e == "string" || ze(e))
            return e;
          var n = e + "";
          return n == "0" && 1 / e == -Pn ? "-0" : n;
        }
        function Zn(e) {
          if (e != null) {
            try {
              return tt.call(e);
            } catch {
            }
            try {
              return e + "";
            } catch {
            }
          }
          return "";
        }
        function cf(e, n) {
          return Pe(zc, function(i) {
            var a = "_." + i[0];
            n & i[1] && !Xr(e, a) && e.push(a);
          }), e.sort();
        }
        function ks(e) {
          if (e instanceof K)
            return e.clone();
          var n = new Ze(e.__wrapped__, e.__chain__);
          return n.__actions__ = ye(e.__actions__), n.__index__ = e.__index__, n.__values__ = e.__values__, n;
        }
        function lf(e, n, i) {
          (i ? Se(e, n, i) : n === o) ? n = 1 : n = pe(D(n), 0);
          var a = e == null ? 0 : e.length;
          if (!a || n < 1)
            return [];
          for (var c = 0, d = 0, h = I(lt(a / n)); c < a; )
            h[d++] = $e(e, c, c += n);
          return h;
        }
        function df(e) {
          for (var n = -1, i = e == null ? 0 : e.length, a = 0, c = []; ++n < i; ) {
            var d = e[n];
            d && (c[a++] = d);
          }
          return c;
        }
        function pf() {
          var e = arguments.length;
          if (!e)
            return [];
          for (var n = I(e - 1), i = arguments[0], a = e; a--; )
            n[a - 1] = arguments[a];
          return An(G(i) ? ye(i) : [i], _e(n, 1));
        }
        var ff = U(function(e, n) {
          return se(e) ? wr(e, _e(n, 1, se, !0)) : [];
        }), hf = U(function(e, n) {
          var i = Ke(n);
          return se(i) && (i = o), se(e) ? wr(e, _e(n, 1, se, !0), R(i, 2)) : [];
        }), mf = U(function(e, n) {
          var i = Ke(n);
          return se(i) && (i = o), se(e) ? wr(e, _e(n, 1, se, !0), o, i) : [];
        });
        function _f(e, n, i) {
          var a = e == null ? 0 : e.length;
          return a ? (n = i || n === o ? 1 : D(n), $e(e, n < 0 ? 0 : n, a)) : [];
        }
        function gf(e, n, i) {
          var a = e == null ? 0 : e.length;
          return a ? (n = i || n === o ? 1 : D(n), n = a - n, $e(e, 0, n < 0 ? 0 : n)) : [];
        }
        function vf(e, n) {
          return e && e.length ? bt(e, R(n, 3), !0, !0) : [];
        }
        function If(e, n) {
          return e && e.length ? bt(e, R(n, 3), !0) : [];
        }
        function bf(e, n, i, a) {
          var c = e == null ? 0 : e.length;
          return c ? (i && typeof i != "number" && Se(e, n, i) && (i = 0, a = c), dp(e, n, i, a)) : [];
        }
        function Bs(e, n, i) {
          var a = e == null ? 0 : e.length;
          if (!a)
            return -1;
          var c = i == null ? 0 : D(i);
          return c < 0 && (c = pe(a + c, 0)), Qr(e, R(n, 3), c);
        }
        function Ps(e, n, i) {
          var a = e == null ? 0 : e.length;
          if (!a)
            return -1;
          var c = a - 1;
          return i !== o && (c = D(i), c = i < 0 ? pe(a + c, 0) : ve(c, a - 1)), Qr(e, R(n, 3), c, !0);
        }
        function Rs(e) {
          var n = e == null ? 0 : e.length;
          return n ? _e(e, 1) : [];
        }
        function Sf(e) {
          var n = e == null ? 0 : e.length;
          return n ? _e(e, Pn) : [];
        }
        function Af(e, n) {
          var i = e == null ? 0 : e.length;
          return i ? (n = n === o ? 1 : D(n), _e(e, n)) : [];
        }
        function Tf(e) {
          for (var n = -1, i = e == null ? 0 : e.length, a = {}; ++n < i; ) {
            var c = e[n];
            rn(a, c[0], c[1]);
          }
          return a;
        }
        function Os(e) {
          return e && e.length ? e[0] : o;
        }
        function Cf(e, n, i) {
          var a = e == null ? 0 : e.length;
          if (!a)
            return -1;
          var c = i == null ? 0 : D(i);
          return c < 0 && (c = pe(a + c, 0)), Jn(e, n, c);
        }
        function yf(e) {
          var n = e == null ? 0 : e.length;
          return n ? $e(e, 0, -1) : [];
        }
        var Nf = U(function(e) {
          var n = ne(e, Zo);
          return n.length && n[0] === e[0] ? ko(n) : [];
        }), xf = U(function(e) {
          var n = Ke(e), i = ne(e, Zo);
          return n === Ke(i) ? n = o : i.pop(), i.length && i[0] === e[0] ? ko(i, R(n, 2)) : [];
        }), Ef = U(function(e) {
          var n = Ke(e), i = ne(e, Zo);
          return n = typeof n == "function" ? n : o, n && i.pop(), i.length && i[0] === e[0] ? ko(i, o, n) : [];
        });
        function wf(e, n) {
          return e == null ? "" : Cd.call(e, n);
        }
        function Ke(e) {
          var n = e == null ? 0 : e.length;
          return n ? e[n - 1] : o;
        }
        function Mf(e, n, i) {
          var a = e == null ? 0 : e.length;
          if (!a)
            return -1;
          var c = a;
          return i !== o && (c = D(i), c = c < 0 ? pe(a + c, 0) : ve(c, a - 1)), n === n ? ud(e, n, c) : Qr(e, ma, c, !0);
        }
        function kf(e, n) {
          return e && e.length ? Wa(e, D(n)) : o;
        }
        var Bf = U(zs);
        function zs(e, n) {
          return e && e.length && n && n.length ? Oo(e, n) : e;
        }
        function Pf(e, n, i) {
          return e && e.length && n && n.length ? Oo(e, n, R(i, 2)) : e;
        }
        function Rf(e, n, i) {
          return e && e.length && n && n.length ? Oo(e, n, o, i) : e;
        }
        var Of = hn(function(e, n) {
          var i = e == null ? 0 : e.length, a = xo(e, n);
          return Ja(e, ne(n, function(c) {
            return mn(c, i) ? +c : c;
          }).sort(is)), a;
        });
        function zf(e, n) {
          var i = [];
          if (!(e && e.length))
            return i;
          var a = -1, c = [], d = e.length;
          for (n = R(n, 3); ++a < d; ) {
            var h = e[a];
            n(h, a, e) && (i.push(h), c.push(a));
          }
          return Ja(e, c), i;
        }
        function ni(e) {
          return e == null ? e : Ed.call(e);
        }
        function Lf(e, n, i) {
          var a = e == null ? 0 : e.length;
          return a ? (i && typeof i != "number" && Se(e, n, i) ? (n = 0, i = a) : (n = n == null ? 0 : D(n), i = i === o ? a : D(i)), $e(e, n, i)) : [];
        }
        function Ff(e, n) {
          return It(e, n);
        }
        function Gf(e, n, i) {
          return Fo(e, n, R(i, 2));
        }
        function Df(e, n) {
          var i = e == null ? 0 : e.length;
          if (i) {
            var a = It(e, n);
            if (a < i && Xe(e[a], n))
              return a;
          }
          return -1;
        }
        function Zf(e, n) {
          return It(e, n, !0);
        }
        function Uf(e, n, i) {
          return Fo(e, n, R(i, 2), !0);
        }
        function $f(e, n) {
          var i = e == null ? 0 : e.length;
          if (i) {
            var a = It(e, n, !0) - 1;
            if (Xe(e[a], n))
              return a;
          }
          return -1;
        }
        function Kf(e) {
          return e && e.length ? Ya(e) : [];
        }
        function Hf(e, n) {
          return e && e.length ? Ya(e, R(n, 2)) : [];
        }
        function Wf(e) {
          var n = e == null ? 0 : e.length;
          return n ? $e(e, 1, n) : [];
        }
        function qf(e, n, i) {
          return e && e.length ? (n = i || n === o ? 1 : D(n), $e(e, 0, n < 0 ? 0 : n)) : [];
        }
        function Vf(e, n, i) {
          var a = e == null ? 0 : e.length;
          return a ? (n = i || n === o ? 1 : D(n), n = a - n, $e(e, n < 0 ? 0 : n, a)) : [];
        }
        function Jf(e, n) {
          return e && e.length ? bt(e, R(n, 3), !1, !0) : [];
        }
        function jf(e, n) {
          return e && e.length ? bt(e, R(n, 3)) : [];
        }
        var Yf = U(function(e) {
          return Nn(_e(e, 1, se, !0));
        }), Xf = U(function(e) {
          var n = Ke(e);
          return se(n) && (n = o), Nn(_e(e, 1, se, !0), R(n, 2));
        }), Qf = U(function(e) {
          var n = Ke(e);
          return n = typeof n == "function" ? n : o, Nn(_e(e, 1, se, !0), o, n);
        });
        function eh(e) {
          return e && e.length ? Nn(e) : [];
        }
        function nh(e, n) {
          return e && e.length ? Nn(e, R(n, 2)) : [];
        }
        function rh(e, n) {
          return n = typeof n == "function" ? n : o, e && e.length ? Nn(e, o, n) : [];
        }
        function ri(e) {
          if (!(e && e.length))
            return [];
          var n = 0;
          return e = Sn(e, function(i) {
            if (se(i))
              return n = pe(i.length, n), !0;
          }), Io(n, function(i) {
            return ne(e, _o(i));
          });
        }
        function Ls(e, n) {
          if (!(e && e.length))
            return [];
          var i = ri(e);
          return n == null ? i : ne(i, function(a) {
            return Be(n, o, a);
          });
        }
        var th = U(function(e, n) {
          return se(e) ? wr(e, n) : [];
        }), oh = U(function(e) {
          return Do(Sn(e, se));
        }), ih = U(function(e) {
          var n = Ke(e);
          return se(n) && (n = o), Do(Sn(e, se), R(n, 2));
        }), ah = U(function(e) {
          var n = Ke(e);
          return n = typeof n == "function" ? n : o, Do(Sn(e, se), o, n);
        }), sh = U(ri);
        function uh(e, n) {
          return ns(e || [], n || [], Er);
        }
        function ch(e, n) {
          return ns(e || [], n || [], Br);
        }
        var lh = U(function(e) {
          var n = e.length, i = n > 1 ? e[n - 1] : o;
          return i = typeof i == "function" ? (e.pop(), i) : o, Ls(e, i);
        });
        function Fs(e) {
          var n = l(e);
          return n.__chain__ = !0, n;
        }
        function dh(e, n) {
          return n(e), e;
        }
        function wt(e, n) {
          return n(e);
        }
        var ph = hn(function(e) {
          var n = e.length, i = n ? e[0] : 0, a = this.__wrapped__, c = function(d) {
            return xo(d, e);
          };
          return n > 1 || this.__actions__.length || !(a instanceof K) || !mn(i) ? this.thru(c) : (a = a.slice(i, +i + (n ? 1 : 0)), a.__actions__.push({
            func: wt,
            args: [c],
            thisArg: o
          }), new Ze(a, this.__chain__).thru(function(d) {
            return n && !d.length && d.push(o), d;
          }));
        });
        function fh() {
          return Fs(this);
        }
        function hh() {
          return new Ze(this.value(), this.__chain__);
        }
        function mh() {
          this.__values__ === o && (this.__values__ = Xs(this.value()));
          var e = this.__index__ >= this.__values__.length, n = e ? o : this.__values__[this.__index__++];
          return { done: e, value: n };
        }
        function _h() {
          return this;
        }
        function gh(e) {
          for (var n, i = this; i instanceof ht; ) {
            var a = ks(i);
            a.__index__ = 0, a.__values__ = o, n ? c.__wrapped__ = a : n = a;
            var c = a;
            i = i.__wrapped__;
          }
          return c.__wrapped__ = e, n;
        }
        function vh() {
          var e = this.__wrapped__;
          if (e instanceof K) {
            var n = e;
            return this.__actions__.length && (n = new K(this)), n = n.reverse(), n.__actions__.push({
              func: wt,
              args: [ni],
              thisArg: o
            }), new Ze(n, this.__chain__);
          }
          return this.thru(ni);
        }
        function Ih() {
          return es(this.__wrapped__, this.__actions__);
        }
        var bh = St(function(e, n, i) {
          q.call(e, i) ? ++e[i] : rn(e, i, 1);
        });
        function Sh(e, n, i) {
          var a = G(e) ? fa : lp;
          return i && Se(e, n, i) && (n = o), a(e, R(n, 3));
        }
        function Ah(e, n) {
          var i = G(e) ? Sn : La;
          return i(e, R(n, 3));
        }
        var Th = ds(Bs), Ch = ds(Ps);
        function yh(e, n) {
          return _e(Mt(e, n), 1);
        }
        function Nh(e, n) {
          return _e(Mt(e, n), Pn);
        }
        function xh(e, n, i) {
          return i = i === o ? 1 : D(i), _e(Mt(e, n), i);
        }
        function Gs(e, n) {
          var i = G(e) ? Pe : yn;
          return i(e, R(n, 3));
        }
        function Ds(e, n) {
          var i = G(e) ? Hl : za;
          return i(e, R(n, 3));
        }
        var Eh = St(function(e, n, i) {
          q.call(e, i) ? e[i].push(n) : rn(e, i, [n]);
        });
        function wh(e, n, i, a) {
          e = Ne(e) ? e : sr(e), i = i && !a ? D(i) : 0;
          var c = e.length;
          return i < 0 && (i = pe(c + i, 0)), Ot(e) ? i <= c && e.indexOf(n, i) > -1 : !!c && Jn(e, n, i) > -1;
        }
        var Mh = U(function(e, n, i) {
          var a = -1, c = typeof n == "function", d = Ne(e) ? I(e.length) : [];
          return yn(e, function(h) {
            d[++a] = c ? Be(n, h, i) : Mr(h, n, i);
          }), d;
        }), kh = St(function(e, n, i) {
          rn(e, i, n);
        });
        function Mt(e, n) {
          var i = G(e) ? ne : $a;
          return i(e, R(n, 3));
        }
        function Bh(e, n, i, a) {
          return e == null ? [] : (G(n) || (n = n == null ? [] : [n]), i = a ? o : i, G(i) || (i = i == null ? [] : [i]), qa(e, n, i));
        }
        var Ph = St(function(e, n, i) {
          e[i ? 0 : 1].push(n);
        }, function() {
          return [[], []];
        });
        function Rh(e, n, i) {
          var a = G(e) ? ho : ga, c = arguments.length < 3;
          return a(e, R(n, 4), i, c, yn);
        }
        function Oh(e, n, i) {
          var a = G(e) ? Wl : ga, c = arguments.length < 3;
          return a(e, R(n, 4), i, c, za);
        }
        function zh(e, n) {
          var i = G(e) ? Sn : La;
          return i(e, Pt(R(n, 3)));
        }
        function Lh(e) {
          var n = G(e) ? Ba : Ep;
          return n(e);
        }
        function Fh(e, n, i) {
          (i ? Se(e, n, i) : n === o) ? n = 1 : n = D(n);
          var a = G(e) ? ip : wp;
          return a(e, n);
        }
        function Gh(e) {
          var n = G(e) ? ap : kp;
          return n(e);
        }
        function Dh(e) {
          if (e == null)
            return 0;
          if (Ne(e))
            return Ot(e) ? Yn(e) : e.length;
          var n = Ie(e);
          return n == qe || n == Ve ? e.size : Po(e).length;
        }
        function Zh(e, n, i) {
          var a = G(e) ? mo : Bp;
          return i && Se(e, n, i) && (n = o), a(e, R(n, 3));
        }
        var Uh = U(function(e, n) {
          if (e == null)
            return [];
          var i = n.length;
          return i > 1 && Se(e, n[0], n[1]) ? n = [] : i > 2 && Se(n[0], n[1], n[2]) && (n = [n[0]]), qa(e, _e(n, 1), []);
        }), kt = Sd || function() {
          return me.Date.now();
        };
        function $h(e, n) {
          if (typeof n != "function")
            throw new De(p);
          return e = D(e), function() {
            if (--e < 1)
              return n.apply(this, arguments);
          };
        }
        function Zs(e, n, i) {
          return n = i ? o : n, n = e && n == null ? e.length : n, fn(e, cn, o, o, o, o, n);
        }
        function Us(e, n) {
          var i;
          if (typeof n != "function")
            throw new De(p);
          return e = D(e), function() {
            return --e > 0 && (i = n.apply(this, arguments)), e <= 1 && (n = o), i;
          };
        }
        var ti = U(function(e, n, i) {
          var a = Me;
          if (i.length) {
            var c = Tn(i, ir(ti));
            a |= en;
          }
          return fn(e, a, n, i, c);
        }), $s = U(function(e, n, i) {
          var a = Me | In;
          if (i.length) {
            var c = Tn(i, ir($s));
            a |= en;
          }
          return fn(n, a, e, i, c);
        });
        function Ks(e, n, i) {
          n = i ? o : n;
          var a = fn(e, ee, o, o, o, o, o, n);
          return a.placeholder = Ks.placeholder, a;
        }
        function Hs(e, n, i) {
          n = i ? o : n;
          var a = fn(e, he, o, o, o, o, o, n);
          return a.placeholder = Hs.placeholder, a;
        }
        function Ws(e, n, i) {
          var a, c, d, h, m, v, A = 0, C = !1, y = !1, x = !0;
          if (typeof e != "function")
            throw new De(p);
          n = He(n) || 0, te(i) && (C = !!i.leading, y = "maxWait" in i, d = y ? pe(He(i.maxWait) || 0, n) : d, x = "trailing" in i ? !!i.trailing : x);
          function M(ue) {
            var Qe = a, vn = c;
            return a = c = o, A = ue, h = e.apply(vn, Qe), h;
          }
          function O(ue) {
            return A = ue, m = Or($, n), C ? M(ue) : h;
          }
          function Z(ue) {
            var Qe = ue - v, vn = ue - A, pu = n - Qe;
            return y ? ve(pu, d - vn) : pu;
          }
          function P(ue) {
            var Qe = ue - v, vn = ue - A;
            return v === o || Qe >= n || Qe < 0 || y && vn >= d;
          }
          function $() {
            var ue = kt();
            if (P(ue))
              return H(ue);
            m = Or($, Z(ue));
          }
          function H(ue) {
            return m = o, x && a ? M(ue) : (a = c = o, h);
          }
          function Le() {
            m !== o && rs(m), A = 0, a = v = c = m = o;
          }
          function Ae() {
            return m === o ? h : H(kt());
          }
          function Fe() {
            var ue = kt(), Qe = P(ue);
            if (a = arguments, c = this, v = ue, Qe) {
              if (m === o)
                return O(v);
              if (y)
                return rs(m), m = Or($, n), M(v);
            }
            return m === o && (m = Or($, n)), h;
          }
          return Fe.cancel = Le, Fe.flush = Ae, Fe;
        }
        var Kh = U(function(e, n) {
          return Oa(e, 1, n);
        }), Hh = U(function(e, n, i) {
          return Oa(e, He(n) || 0, i);
        });
        function Wh(e) {
          return fn(e, qt);
        }
        function Bt(e, n) {
          if (typeof e != "function" || n != null && typeof n != "function")
            throw new De(p);
          var i = function() {
            var a = arguments, c = n ? n.apply(this, a) : a[0], d = i.cache;
            if (d.has(c))
              return d.get(c);
            var h = e.apply(this, a);
            return i.cache = d.set(c, h) || d, h;
          };
          return i.cache = new (Bt.Cache || pn)(), i;
        }
        Bt.Cache = pn;
        function Pt(e) {
          if (typeof e != "function")
            throw new De(p);
          return function() {
            var n = arguments;
            switch (n.length) {
              case 0:
                return !e.call(this);
              case 1:
                return !e.call(this, n[0]);
              case 2:
                return !e.call(this, n[0], n[1]);
              case 3:
                return !e.call(this, n[0], n[1], n[2]);
            }
            return !e.apply(this, n);
          };
        }
        function qh(e) {
          return Us(2, e);
        }
        var Vh = Pp(function(e, n) {
          n = n.length == 1 && G(n[0]) ? ne(n[0], Re(R())) : ne(_e(n, 1), Re(R()));
          var i = n.length;
          return U(function(a) {
            for (var c = -1, d = ve(a.length, i); ++c < d; )
              a[c] = n[c].call(this, a[c]);
            return Be(e, this, a);
          });
        }), oi = U(function(e, n) {
          var i = Tn(n, ir(oi));
          return fn(e, en, o, n, i);
        }), qs = U(function(e, n) {
          var i = Tn(n, ir(qs));
          return fn(e, Bn, o, n, i);
        }), Jh = hn(function(e, n) {
          return fn(e, hr, o, o, o, n);
        });
        function jh(e, n) {
          if (typeof e != "function")
            throw new De(p);
          return n = n === o ? n : D(n), U(e, n);
        }
        function Yh(e, n) {
          if (typeof e != "function")
            throw new De(p);
          return n = n == null ? 0 : pe(D(n), 0), U(function(i) {
            var a = i[n], c = En(i, 0, n);
            return a && An(c, a), Be(e, this, c);
          });
        }
        function Xh(e, n, i) {
          var a = !0, c = !0;
          if (typeof e != "function")
            throw new De(p);
          return te(i) && (a = "leading" in i ? !!i.leading : a, c = "trailing" in i ? !!i.trailing : c), Ws(e, n, {
            leading: a,
            maxWait: n,
            trailing: c
          });
        }
        function Qh(e) {
          return Zs(e, 1);
        }
        function em(e, n) {
          return oi(Uo(n), e);
        }
        function nm() {
          if (!arguments.length)
            return [];
          var e = arguments[0];
          return G(e) ? e : [e];
        }
        function rm(e) {
          return Ue(e, ie);
        }
        function tm(e, n) {
          return n = typeof n == "function" ? n : o, Ue(e, ie, n);
        }
        function om(e) {
          return Ue(e, k | ie);
        }
        function im(e, n) {
          return n = typeof n == "function" ? n : o, Ue(e, k | ie, n);
        }
        function am(e, n) {
          return n == null || Ra(e, n, fe(n));
        }
        function Xe(e, n) {
          return e === n || e !== e && n !== n;
        }
        var sm = yt(Mo), um = yt(function(e, n) {
          return e >= n;
        }), Un = Da(/* @__PURE__ */ (function() {
          return arguments;
        })()) ? Da : function(e) {
          return ae(e) && q.call(e, "callee") && !Na.call(e, "callee");
        }, G = I.isArray, cm = sa ? Re(sa) : _p;
        function Ne(e) {
          return e != null && Rt(e.length) && !_n(e);
        }
        function se(e) {
          return ae(e) && Ne(e);
        }
        function lm(e) {
          return e === !0 || e === !1 || ae(e) && be(e) == mr;
        }
        var wn = Td || _i, dm = ua ? Re(ua) : gp;
        function pm(e) {
          return ae(e) && e.nodeType === 1 && !zr(e);
        }
        function fm(e) {
          if (e == null)
            return !0;
          if (Ne(e) && (G(e) || typeof e == "string" || typeof e.splice == "function" || wn(e) || ar(e) || Un(e)))
            return !e.length;
          var n = Ie(e);
          if (n == qe || n == Ve)
            return !e.size;
          if (Rr(e))
            return !Po(e).length;
          for (var i in e)
            if (q.call(e, i))
              return !1;
          return !0;
        }
        function hm(e, n) {
          return kr(e, n);
        }
        function mm(e, n, i) {
          i = typeof i == "function" ? i : o;
          var a = i ? i(e, n) : o;
          return a === o ? kr(e, n, o, i) : !!a;
        }
        function ii(e) {
          if (!ae(e))
            return !1;
          var n = be(e);
          return n == Wr || n == Fc || typeof e.message == "string" && typeof e.name == "string" && !zr(e);
        }
        function _m(e) {
          return typeof e == "number" && Ea(e);
        }
        function _n(e) {
          if (!te(e))
            return !1;
          var n = be(e);
          return n == qr || n == Ri || n == Lc || n == Dc;
        }
        function Vs(e) {
          return typeof e == "number" && e == D(e);
        }
        function Rt(e) {
          return typeof e == "number" && e > -1 && e % 1 == 0 && e <= bn;
        }
        function te(e) {
          var n = typeof e;
          return e != null && (n == "object" || n == "function");
        }
        function ae(e) {
          return e != null && typeof e == "object";
        }
        var Js = ca ? Re(ca) : Ip;
        function gm(e, n) {
          return e === n || Bo(e, n, Jo(n));
        }
        function vm(e, n, i) {
          return i = typeof i == "function" ? i : o, Bo(e, n, Jo(n), i);
        }
        function Im(e) {
          return js(e) && e != +e;
        }
        function bm(e) {
          if (rf(e))
            throw new L(f);
          return Za(e);
        }
        function Sm(e) {
          return e === null;
        }
        function Am(e) {
          return e == null;
        }
        function js(e) {
          return typeof e == "number" || ae(e) && be(e) == gr;
        }
        function zr(e) {
          if (!ae(e) || be(e) != ln)
            return !1;
          var n = st(e);
          if (n === null)
            return !0;
          var i = q.call(n, "constructor") && n.constructor;
          return typeof i == "function" && i instanceof i && tt.call(i) == gd;
        }
        var ai = la ? Re(la) : bp;
        function Tm(e) {
          return Vs(e) && e >= -bn && e <= bn;
        }
        var Ys = da ? Re(da) : Sp;
        function Ot(e) {
          return typeof e == "string" || !G(e) && ae(e) && be(e) == Ir;
        }
        function ze(e) {
          return typeof e == "symbol" || ae(e) && be(e) == Vr;
        }
        var ar = pa ? Re(pa) : Ap;
        function Cm(e) {
          return e === o;
        }
        function ym(e) {
          return ae(e) && Ie(e) == br;
        }
        function Nm(e) {
          return ae(e) && be(e) == Uc;
        }
        var xm = yt(Ro), Em = yt(function(e, n) {
          return e <= n;
        });
        function Xs(e) {
          if (!e)
            return [];
          if (Ne(e))
            return Ot(e) ? Je(e) : ye(e);
          if (Tr && e[Tr])
            return id(e[Tr]());
          var n = Ie(e), i = n == qe ? So : n == Ve ? et : sr;
          return i(e);
        }
        function gn(e) {
          if (!e)
            return e === 0 ? e : 0;
          if (e = He(e), e === Pn || e === -Pn) {
            var n = e < 0 ? -1 : 1;
            return n * Pc;
          }
          return e === e ? e : 0;
        }
        function D(e) {
          var n = gn(e), i = n % 1;
          return n === n ? i ? n - i : n : 0;
        }
        function Qs(e) {
          return e ? Fn(D(e), 0, nn) : 0;
        }
        function He(e) {
          if (typeof e == "number")
            return e;
          if (ze(e))
            return Kr;
          if (te(e)) {
            var n = typeof e.valueOf == "function" ? e.valueOf() : e;
            e = te(n) ? n + "" : n;
          }
          if (typeof e != "string")
            return e === 0 ? e : +e;
          e = va(e);
          var i = ul.test(e);
          return i || ll.test(e) ? Ul(e.slice(2), i ? 2 : 8) : sl.test(e) ? Kr : +e;
        }
        function eu(e) {
          return on(e, xe(e));
        }
        function wm(e) {
          return e ? Fn(D(e), -bn, bn) : e === 0 ? e : 0;
        }
        function V(e) {
          return e == null ? "" : Oe(e);
        }
        var Mm = tr(function(e, n) {
          if (Rr(n) || Ne(n)) {
            on(n, fe(n), e);
            return;
          }
          for (var i in n)
            q.call(n, i) && Er(e, i, n[i]);
        }), nu = tr(function(e, n) {
          on(n, xe(n), e);
        }), ru = tr(function(e, n, i, a) {
          on(n, xe(n), e, a);
        }), si = tr(function(e, n, i, a) {
          on(n, fe(n), e, a);
        }), km = hn(xo);
        function Bm(e, n) {
          var i = rr(e);
          return n == null ? i : Pa(i, n);
        }
        var Pm = U(function(e, n) {
          e = j(e);
          var i = -1, a = n.length, c = a > 2 ? n[2] : o;
          for (c && Se(n[0], n[1], c) && (a = 1); ++i < a; )
            for (var d = n[i], h = xe(d), m = -1, v = h.length; ++m < v; ) {
              var A = h[m], C = e[A];
              (C === o || Xe(C, Qn[A]) && !q.call(e, A)) && (e[A] = d[A]);
            }
          return e;
        }), Rm = U(function(e) {
          return e.push(o, vs), Be(tu, o, e);
        });
        function Om(e, n) {
          return ha(e, R(n, 3), tn);
        }
        function zm(e, n) {
          return ha(e, R(n, 3), wo);
        }
        function Lm(e, n) {
          return e == null ? e : Eo(e, R(n, 3), xe);
        }
        function Fm(e, n) {
          return e == null ? e : Fa(e, R(n, 3), xe);
        }
        function Gm(e, n) {
          return e && tn(e, R(n, 3));
        }
        function Dm(e, n) {
          return e && wo(e, R(n, 3));
        }
        function Zm(e) {
          return e == null ? [] : gt(e, fe(e));
        }
        function Um(e) {
          return e == null ? [] : gt(e, xe(e));
        }
        function ui(e, n, i) {
          var a = e == null ? o : Gn(e, n);
          return a === o ? i : a;
        }
        function $m(e, n) {
          return e != null && Ss(e, n, pp);
        }
        function ci(e, n) {
          return e != null && Ss(e, n, fp);
        }
        var Km = fs(function(e, n, i) {
          n != null && typeof n.toString != "function" && (n = ot.call(n)), e[n] = i;
        }, di(Ee)), Hm = fs(function(e, n, i) {
          n != null && typeof n.toString != "function" && (n = ot.call(n)), q.call(e, n) ? e[n].push(i) : e[n] = [i];
        }, R), Wm = U(Mr);
        function fe(e) {
          return Ne(e) ? ka(e) : Po(e);
        }
        function xe(e) {
          return Ne(e) ? ka(e, !0) : Tp(e);
        }
        function qm(e, n) {
          var i = {};
          return n = R(n, 3), tn(e, function(a, c, d) {
            rn(i, n(a, c, d), a);
          }), i;
        }
        function Vm(e, n) {
          var i = {};
          return n = R(n, 3), tn(e, function(a, c, d) {
            rn(i, c, n(a, c, d));
          }), i;
        }
        var Jm = tr(function(e, n, i) {
          vt(e, n, i);
        }), tu = tr(function(e, n, i, a) {
          vt(e, n, i, a);
        }), jm = hn(function(e, n) {
          var i = {};
          if (e == null)
            return i;
          var a = !1;
          n = ne(n, function(d) {
            return d = xn(d, e), a || (a = d.length > 1), d;
          }), on(e, qo(e), i), a && (i = Ue(i, k | z | ie, Kp));
          for (var c = n.length; c--; )
            Go(i, n[c]);
          return i;
        });
        function Ym(e, n) {
          return ou(e, Pt(R(n)));
        }
        var Xm = hn(function(e, n) {
          return e == null ? {} : yp(e, n);
        });
        function ou(e, n) {
          if (e == null)
            return {};
          var i = ne(qo(e), function(a) {
            return [a];
          });
          return n = R(n), Va(e, i, function(a, c) {
            return n(a, c[0]);
          });
        }
        function Qm(e, n, i) {
          n = xn(n, e);
          var a = -1, c = n.length;
          for (c || (c = 1, e = o); ++a < c; ) {
            var d = e == null ? o : e[Ye(n[a])];
            d === o && (a = c, d = i), e = _n(d) ? d.call(e) : d;
          }
          return e;
        }
        function e_(e, n, i) {
          return e == null ? e : Br(e, n, i);
        }
        function n_(e, n, i, a) {
          return a = typeof a == "function" ? a : o, e == null ? e : Br(e, n, i, a);
        }
        var iu = _s(fe), au = _s(xe);
        function r_(e, n, i) {
          var a = G(e), c = a || wn(e) || ar(e);
          if (n = R(n, 4), i == null) {
            var d = e && e.constructor;
            c ? i = a ? new d() : [] : te(e) ? i = _n(d) ? rr(st(e)) : {} : i = {};
          }
          return (c ? Pe : tn)(e, function(h, m, v) {
            return n(i, h, m, v);
          }), i;
        }
        function t_(e, n) {
          return e == null ? !0 : Go(e, n);
        }
        function o_(e, n, i) {
          return e == null ? e : Qa(e, n, Uo(i));
        }
        function i_(e, n, i, a) {
          return a = typeof a == "function" ? a : o, e == null ? e : Qa(e, n, Uo(i), a);
        }
        function sr(e) {
          return e == null ? [] : bo(e, fe(e));
        }
        function a_(e) {
          return e == null ? [] : bo(e, xe(e));
        }
        function s_(e, n, i) {
          return i === o && (i = n, n = o), i !== o && (i = He(i), i = i === i ? i : 0), n !== o && (n = He(n), n = n === n ? n : 0), Fn(He(e), n, i);
        }
        function u_(e, n, i) {
          return n = gn(n), i === o ? (i = n, n = 0) : i = gn(i), e = He(e), hp(e, n, i);
        }
        function c_(e, n, i) {
          if (i && typeof i != "boolean" && Se(e, n, i) && (n = i = o), i === o && (typeof n == "boolean" ? (i = n, n = o) : typeof e == "boolean" && (i = e, e = o)), e === o && n === o ? (e = 0, n = 1) : (e = gn(e), n === o ? (n = e, e = 0) : n = gn(n)), e > n) {
            var a = e;
            e = n, n = a;
          }
          if (i || e % 1 || n % 1) {
            var c = wa();
            return ve(e + c * (n - e + Zl("1e-" + ((c + "").length - 1))), n);
          }
          return zo(e, n);
        }
        var l_ = or(function(e, n, i) {
          return n = n.toLowerCase(), e + (i ? su(n) : n);
        });
        function su(e) {
          return li(V(e).toLowerCase());
        }
        function uu(e) {
          return e = V(e), e && e.replace(pl, ed).replace(kl, "");
        }
        function d_(e, n, i) {
          e = V(e), n = Oe(n);
          var a = e.length;
          i = i === o ? a : Fn(D(i), 0, a);
          var c = i;
          return i -= n.length, i >= 0 && e.slice(i, c) == n;
        }
        function p_(e) {
          return e = V(e), e && qc.test(e) ? e.replace(Li, nd) : e;
        }
        function f_(e) {
          return e = V(e), e && Qc.test(e) ? e.replace(to, "\\$&") : e;
        }
        var h_ = or(function(e, n, i) {
          return e + (i ? "-" : "") + n.toLowerCase();
        }), m_ = or(function(e, n, i) {
          return e + (i ? " " : "") + n.toLowerCase();
        }), __ = ls("toLowerCase");
        function g_(e, n, i) {
          e = V(e), n = D(n);
          var a = n ? Yn(e) : 0;
          if (!n || a >= n)
            return e;
          var c = (n - a) / 2;
          return Ct(dt(c), i) + e + Ct(lt(c), i);
        }
        function v_(e, n, i) {
          e = V(e), n = D(n);
          var a = n ? Yn(e) : 0;
          return n && a < n ? e + Ct(n - a, i) : e;
        }
        function I_(e, n, i) {
          e = V(e), n = D(n);
          var a = n ? Yn(e) : 0;
          return n && a < n ? Ct(n - a, i) + e : e;
        }
        function b_(e, n, i) {
          return i || n == null ? n = 0 : n && (n = +n), xd(V(e).replace(oo, ""), n || 0);
        }
        function S_(e, n, i) {
          return (i ? Se(e, n, i) : n === o) ? n = 1 : n = D(n), Lo(V(e), n);
        }
        function A_() {
          var e = arguments, n = V(e[0]);
          return e.length < 3 ? n : n.replace(e[1], e[2]);
        }
        var T_ = or(function(e, n, i) {
          return e + (i ? "_" : "") + n.toLowerCase();
        });
        function C_(e, n, i) {
          return i && typeof i != "number" && Se(e, n, i) && (n = i = o), i = i === o ? nn : i >>> 0, i ? (e = V(e), e && (typeof n == "string" || n != null && !ai(n)) && (n = Oe(n), !n && jn(e)) ? En(Je(e), 0, i) : e.split(n, i)) : [];
        }
        var y_ = or(function(e, n, i) {
          return e + (i ? " " : "") + li(n);
        });
        function N_(e, n, i) {
          return e = V(e), i = i == null ? 0 : Fn(D(i), 0, e.length), n = Oe(n), e.slice(i, i + n.length) == n;
        }
        function x_(e, n, i) {
          var a = l.templateSettings;
          i && Se(e, n, i) && (n = o), e = V(e), n = si({}, n, a, gs);
          var c = si({}, n.imports, a.imports, gs), d = fe(c), h = bo(c, d);
          Pe(d, function(P) {
            if (Gi.test(P))
              throw new L(S);
          });
          var m, v, A = 0, C = n.interpolate || Jr, y = "__p += '", x = Ao(
            (n.escape || Jr).source + "|" + C.source + "|" + (C === Fi ? al : Jr).source + "|" + (n.evaluate || Jr).source + "|$",
            "g"
          ), M = "//# sourceURL=" + (q.call(n, "sourceURL") ? (n.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++zl + "]") + `
`;
          e.replace(x, function(P, $, H, Le, Ae, Fe) {
            return H || (H = Le), y += e.slice(A, Fe).replace(fl, rd), $ && (m = !0, y += `' +
__e(` + $ + `) +
'`), Ae && (v = !0, y += `';
` + Ae + `;
__p += '`), H && (y += `' +
((__t = (` + H + `)) == null ? '' : __t) +
'`), A = Fe + P.length, P;
          }), y += `';
`;
          var O = q.call(n, "variable") && n.variable;
          if (!O)
            y = `with (obj) {
` + y + `
}
`;
          else if (Gi.test(O))
            throw new L(_);
          y = (v ? y.replace($c, "") : y).replace(Kc, "$1").replace(Hc, "$1;"), y = "function(" + (O || "obj") + `) {
` + (O ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (m ? ", __e = _.escape" : "") + (v ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + y + `return __p
}`;
          var Z = lu(function() {
            return W(d, M + "return " + y).apply(o, h);
          });
          if (Z.source = y, ii(Z))
            throw Z;
          return Z;
        }
        function E_(e) {
          return V(e).toLowerCase();
        }
        function w_(e) {
          return V(e).toUpperCase();
        }
        function M_(e, n, i) {
          if (e = V(e), e && (i || n === o))
            return va(e);
          if (!e || !(n = Oe(n)))
            return e;
          var a = Je(e), c = Je(n), d = Ia(a, c), h = ba(a, c) + 1;
          return En(a, d, h).join("");
        }
        function k_(e, n, i) {
          if (e = V(e), e && (i || n === o))
            return e.slice(0, Aa(e) + 1);
          if (!e || !(n = Oe(n)))
            return e;
          var a = Je(e), c = ba(a, Je(n)) + 1;
          return En(a, 0, c).join("");
        }
        function B_(e, n, i) {
          if (e = V(e), e && (i || n === o))
            return e.replace(oo, "");
          if (!e || !(n = Oe(n)))
            return e;
          var a = Je(e), c = Ia(a, Je(n));
          return En(a, c).join("");
        }
        function P_(e, n) {
          var i = xc, a = Ec;
          if (te(n)) {
            var c = "separator" in n ? n.separator : c;
            i = "length" in n ? D(n.length) : i, a = "omission" in n ? Oe(n.omission) : a;
          }
          e = V(e);
          var d = e.length;
          if (jn(e)) {
            var h = Je(e);
            d = h.length;
          }
          if (i >= d)
            return e;
          var m = i - Yn(a);
          if (m < 1)
            return a;
          var v = h ? En(h, 0, m).join("") : e.slice(0, m);
          if (c === o)
            return v + a;
          if (h && (m += v.length - m), ai(c)) {
            if (e.slice(m).search(c)) {
              var A, C = v;
              for (c.global || (c = Ao(c.source, V(Di.exec(c)) + "g")), c.lastIndex = 0; A = c.exec(C); )
                var y = A.index;
              v = v.slice(0, y === o ? m : y);
            }
          } else if (e.indexOf(Oe(c), m) != m) {
            var x = v.lastIndexOf(c);
            x > -1 && (v = v.slice(0, x));
          }
          return v + a;
        }
        function R_(e) {
          return e = V(e), e && Wc.test(e) ? e.replace(zi, cd) : e;
        }
        var O_ = or(function(e, n, i) {
          return e + (i ? " " : "") + n.toUpperCase();
        }), li = ls("toUpperCase");
        function cu(e, n, i) {
          return e = V(e), n = i ? o : n, n === o ? od(e) ? pd(e) : Jl(e) : e.match(n) || [];
        }
        var lu = U(function(e, n) {
          try {
            return Be(e, o, n);
          } catch (i) {
            return ii(i) ? i : new L(i);
          }
        }), z_ = hn(function(e, n) {
          return Pe(n, function(i) {
            i = Ye(i), rn(e, i, ti(e[i], e));
          }), e;
        });
        function L_(e) {
          var n = e == null ? 0 : e.length, i = R();
          return e = n ? ne(e, function(a) {
            if (typeof a[1] != "function")
              throw new De(p);
            return [i(a[0]), a[1]];
          }) : [], U(function(a) {
            for (var c = -1; ++c < n; ) {
              var d = e[c];
              if (Be(d[0], this, a))
                return Be(d[1], this, a);
            }
          });
        }
        function F_(e) {
          return cp(Ue(e, k));
        }
        function di(e) {
          return function() {
            return e;
          };
        }
        function G_(e, n) {
          return e == null || e !== e ? n : e;
        }
        var D_ = ps(), Z_ = ps(!0);
        function Ee(e) {
          return e;
        }
        function pi(e) {
          return Ua(typeof e == "function" ? e : Ue(e, k));
        }
        function U_(e) {
          return Ka(Ue(e, k));
        }
        function $_(e, n) {
          return Ha(e, Ue(n, k));
        }
        var K_ = U(function(e, n) {
          return function(i) {
            return Mr(i, e, n);
          };
        }), H_ = U(function(e, n) {
          return function(i) {
            return Mr(e, i, n);
          };
        });
        function fi(e, n, i) {
          var a = fe(n), c = gt(n, a);
          i == null && !(te(n) && (c.length || !a.length)) && (i = n, n = e, e = this, c = gt(n, fe(n)));
          var d = !(te(i) && "chain" in i) || !!i.chain, h = _n(e);
          return Pe(c, function(m) {
            var v = n[m];
            e[m] = v, h && (e.prototype[m] = function() {
              var A = this.__chain__;
              if (d || A) {
                var C = e(this.__wrapped__), y = C.__actions__ = ye(this.__actions__);
                return y.push({ func: v, args: arguments, thisArg: e }), C.__chain__ = A, C;
              }
              return v.apply(e, An([this.value()], arguments));
            });
          }), e;
        }
        function W_() {
          return me._ === this && (me._ = vd), this;
        }
        function hi() {
        }
        function q_(e) {
          return e = D(e), U(function(n) {
            return Wa(n, e);
          });
        }
        var V_ = Ko(ne), J_ = Ko(fa), j_ = Ko(mo);
        function du(e) {
          return Yo(e) ? _o(Ye(e)) : Np(e);
        }
        function Y_(e) {
          return function(n) {
            return e == null ? o : Gn(e, n);
          };
        }
        var X_ = hs(), Q_ = hs(!0);
        function mi() {
          return [];
        }
        function _i() {
          return !1;
        }
        function eg() {
          return {};
        }
        function ng() {
          return "";
        }
        function rg() {
          return !0;
        }
        function tg(e, n) {
          if (e = D(e), e < 1 || e > bn)
            return [];
          var i = nn, a = ve(e, nn);
          n = R(n), e -= nn;
          for (var c = Io(a, n); ++i < e; )
            n(i);
          return c;
        }
        function og(e) {
          return G(e) ? ne(e, Ye) : ze(e) ? [e] : ye(Ms(V(e)));
        }
        function ig(e) {
          var n = ++_d;
          return V(e) + n;
        }
        var ag = Tt(function(e, n) {
          return e + n;
        }, 0), sg = Ho("ceil"), ug = Tt(function(e, n) {
          return e / n;
        }, 1), cg = Ho("floor");
        function lg(e) {
          return e && e.length ? _t(e, Ee, Mo) : o;
        }
        function dg(e, n) {
          return e && e.length ? _t(e, R(n, 2), Mo) : o;
        }
        function pg(e) {
          return _a(e, Ee);
        }
        function fg(e, n) {
          return _a(e, R(n, 2));
        }
        function hg(e) {
          return e && e.length ? _t(e, Ee, Ro) : o;
        }
        function mg(e, n) {
          return e && e.length ? _t(e, R(n, 2), Ro) : o;
        }
        var _g = Tt(function(e, n) {
          return e * n;
        }, 1), gg = Ho("round"), vg = Tt(function(e, n) {
          return e - n;
        }, 0);
        function Ig(e) {
          return e && e.length ? vo(e, Ee) : 0;
        }
        function bg(e, n) {
          return e && e.length ? vo(e, R(n, 2)) : 0;
        }
        return l.after = $h, l.ary = Zs, l.assign = Mm, l.assignIn = nu, l.assignInWith = ru, l.assignWith = si, l.at = km, l.before = Us, l.bind = ti, l.bindAll = z_, l.bindKey = $s, l.castArray = nm, l.chain = Fs, l.chunk = lf, l.compact = df, l.concat = pf, l.cond = L_, l.conforms = F_, l.constant = di, l.countBy = bh, l.create = Bm, l.curry = Ks, l.curryRight = Hs, l.debounce = Ws, l.defaults = Pm, l.defaultsDeep = Rm, l.defer = Kh, l.delay = Hh, l.difference = ff, l.differenceBy = hf, l.differenceWith = mf, l.drop = _f, l.dropRight = gf, l.dropRightWhile = vf, l.dropWhile = If, l.fill = bf, l.filter = Ah, l.flatMap = yh, l.flatMapDeep = Nh, l.flatMapDepth = xh, l.flatten = Rs, l.flattenDeep = Sf, l.flattenDepth = Af, l.flip = Wh, l.flow = D_, l.flowRight = Z_, l.fromPairs = Tf, l.functions = Zm, l.functionsIn = Um, l.groupBy = Eh, l.initial = yf, l.intersection = Nf, l.intersectionBy = xf, l.intersectionWith = Ef, l.invert = Km, l.invertBy = Hm, l.invokeMap = Mh, l.iteratee = pi, l.keyBy = kh, l.keys = fe, l.keysIn = xe, l.map = Mt, l.mapKeys = qm, l.mapValues = Vm, l.matches = U_, l.matchesProperty = $_, l.memoize = Bt, l.merge = Jm, l.mergeWith = tu, l.method = K_, l.methodOf = H_, l.mixin = fi, l.negate = Pt, l.nthArg = q_, l.omit = jm, l.omitBy = Ym, l.once = qh, l.orderBy = Bh, l.over = V_, l.overArgs = Vh, l.overEvery = J_, l.overSome = j_, l.partial = oi, l.partialRight = qs, l.partition = Ph, l.pick = Xm, l.pickBy = ou, l.property = du, l.propertyOf = Y_, l.pull = Bf, l.pullAll = zs, l.pullAllBy = Pf, l.pullAllWith = Rf, l.pullAt = Of, l.range = X_, l.rangeRight = Q_, l.rearg = Jh, l.reject = zh, l.remove = zf, l.rest = jh, l.reverse = ni, l.sampleSize = Fh, l.set = e_, l.setWith = n_, l.shuffle = Gh, l.slice = Lf, l.sortBy = Uh, l.sortedUniq = Kf, l.sortedUniqBy = Hf, l.split = C_, l.spread = Yh, l.tail = Wf, l.take = qf, l.takeRight = Vf, l.takeRightWhile = Jf, l.takeWhile = jf, l.tap = dh, l.throttle = Xh, l.thru = wt, l.toArray = Xs, l.toPairs = iu, l.toPairsIn = au, l.toPath = og, l.toPlainObject = eu, l.transform = r_, l.unary = Qh, l.union = Yf, l.unionBy = Xf, l.unionWith = Qf, l.uniq = eh, l.uniqBy = nh, l.uniqWith = rh, l.unset = t_, l.unzip = ri, l.unzipWith = Ls, l.update = o_, l.updateWith = i_, l.values = sr, l.valuesIn = a_, l.without = th, l.words = cu, l.wrap = em, l.xor = oh, l.xorBy = ih, l.xorWith = ah, l.zip = sh, l.zipObject = uh, l.zipObjectDeep = ch, l.zipWith = lh, l.entries = iu, l.entriesIn = au, l.extend = nu, l.extendWith = ru, fi(l, l), l.add = ag, l.attempt = lu, l.camelCase = l_, l.capitalize = su, l.ceil = sg, l.clamp = s_, l.clone = rm, l.cloneDeep = om, l.cloneDeepWith = im, l.cloneWith = tm, l.conformsTo = am, l.deburr = uu, l.defaultTo = G_, l.divide = ug, l.endsWith = d_, l.eq = Xe, l.escape = p_, l.escapeRegExp = f_, l.every = Sh, l.find = Th, l.findIndex = Bs, l.findKey = Om, l.findLast = Ch, l.findLastIndex = Ps, l.findLastKey = zm, l.floor = cg, l.forEach = Gs, l.forEachRight = Ds, l.forIn = Lm, l.forInRight = Fm, l.forOwn = Gm, l.forOwnRight = Dm, l.get = ui, l.gt = sm, l.gte = um, l.has = $m, l.hasIn = ci, l.head = Os, l.identity = Ee, l.includes = wh, l.indexOf = Cf, l.inRange = u_, l.invoke = Wm, l.isArguments = Un, l.isArray = G, l.isArrayBuffer = cm, l.isArrayLike = Ne, l.isArrayLikeObject = se, l.isBoolean = lm, l.isBuffer = wn, l.isDate = dm, l.isElement = pm, l.isEmpty = fm, l.isEqual = hm, l.isEqualWith = mm, l.isError = ii, l.isFinite = _m, l.isFunction = _n, l.isInteger = Vs, l.isLength = Rt, l.isMap = Js, l.isMatch = gm, l.isMatchWith = vm, l.isNaN = Im, l.isNative = bm, l.isNil = Am, l.isNull = Sm, l.isNumber = js, l.isObject = te, l.isObjectLike = ae, l.isPlainObject = zr, l.isRegExp = ai, l.isSafeInteger = Tm, l.isSet = Ys, l.isString = Ot, l.isSymbol = ze, l.isTypedArray = ar, l.isUndefined = Cm, l.isWeakMap = ym, l.isWeakSet = Nm, l.join = wf, l.kebabCase = h_, l.last = Ke, l.lastIndexOf = Mf, l.lowerCase = m_, l.lowerFirst = __, l.lt = xm, l.lte = Em, l.max = lg, l.maxBy = dg, l.mean = pg, l.meanBy = fg, l.min = hg, l.minBy = mg, l.stubArray = mi, l.stubFalse = _i, l.stubObject = eg, l.stubString = ng, l.stubTrue = rg, l.multiply = _g, l.nth = kf, l.noConflict = W_, l.noop = hi, l.now = kt, l.pad = g_, l.padEnd = v_, l.padStart = I_, l.parseInt = b_, l.random = c_, l.reduce = Rh, l.reduceRight = Oh, l.repeat = S_, l.replace = A_, l.result = Qm, l.round = gg, l.runInContext = g, l.sample = Lh, l.size = Dh, l.snakeCase = T_, l.some = Zh, l.sortedIndex = Ff, l.sortedIndexBy = Gf, l.sortedIndexOf = Df, l.sortedLastIndex = Zf, l.sortedLastIndexBy = Uf, l.sortedLastIndexOf = $f, l.startCase = y_, l.startsWith = N_, l.subtract = vg, l.sum = Ig, l.sumBy = bg, l.template = x_, l.times = tg, l.toFinite = gn, l.toInteger = D, l.toLength = Qs, l.toLower = E_, l.toNumber = He, l.toSafeInteger = wm, l.toString = V, l.toUpper = w_, l.trim = M_, l.trimEnd = k_, l.trimStart = B_, l.truncate = P_, l.unescape = R_, l.uniqueId = ig, l.upperCase = O_, l.upperFirst = li, l.each = Gs, l.eachRight = Ds, l.first = Os, fi(l, (function() {
          var e = {};
          return tn(l, function(n, i) {
            q.call(l.prototype, i) || (e[i] = n);
          }), e;
        })(), { chain: !1 }), l.VERSION = s, Pe(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(e) {
          l[e].placeholder = l;
        }), Pe(["drop", "take"], function(e, n) {
          K.prototype[e] = function(i) {
            i = i === o ? 1 : pe(D(i), 0);
            var a = this.__filtered__ && !n ? new K(this) : this.clone();
            return a.__filtered__ ? a.__takeCount__ = ve(i, a.__takeCount__) : a.__views__.push({
              size: ve(i, nn),
              type: e + (a.__dir__ < 0 ? "Right" : "")
            }), a;
          }, K.prototype[e + "Right"] = function(i) {
            return this.reverse()[e](i).reverse();
          };
        }), Pe(["filter", "map", "takeWhile"], function(e, n) {
          var i = n + 1, a = i == Pi || i == Bc;
          K.prototype[e] = function(c) {
            var d = this.clone();
            return d.__iteratees__.push({
              iteratee: R(c, 3),
              type: i
            }), d.__filtered__ = d.__filtered__ || a, d;
          };
        }), Pe(["head", "last"], function(e, n) {
          var i = "take" + (n ? "Right" : "");
          K.prototype[e] = function() {
            return this[i](1).value()[0];
          };
        }), Pe(["initial", "tail"], function(e, n) {
          var i = "drop" + (n ? "" : "Right");
          K.prototype[e] = function() {
            return this.__filtered__ ? new K(this) : this[i](1);
          };
        }), K.prototype.compact = function() {
          return this.filter(Ee);
        }, K.prototype.find = function(e) {
          return this.filter(e).head();
        }, K.prototype.findLast = function(e) {
          return this.reverse().find(e);
        }, K.prototype.invokeMap = U(function(e, n) {
          return typeof e == "function" ? new K(this) : this.map(function(i) {
            return Mr(i, e, n);
          });
        }), K.prototype.reject = function(e) {
          return this.filter(Pt(R(e)));
        }, K.prototype.slice = function(e, n) {
          e = D(e);
          var i = this;
          return i.__filtered__ && (e > 0 || n < 0) ? new K(i) : (e < 0 ? i = i.takeRight(-e) : e && (i = i.drop(e)), n !== o && (n = D(n), i = n < 0 ? i.dropRight(-n) : i.take(n - e)), i);
        }, K.prototype.takeRightWhile = function(e) {
          return this.reverse().takeWhile(e).reverse();
        }, K.prototype.toArray = function() {
          return this.take(nn);
        }, tn(K.prototype, function(e, n) {
          var i = /^(?:filter|find|map|reject)|While$/.test(n), a = /^(?:head|last)$/.test(n), c = l[a ? "take" + (n == "last" ? "Right" : "") : n], d = a || /^find/.test(n);
          c && (l.prototype[n] = function() {
            var h = this.__wrapped__, m = a ? [1] : arguments, v = h instanceof K, A = m[0], C = v || G(h), y = function($) {
              var H = c.apply(l, An([$], m));
              return a && x ? H[0] : H;
            };
            C && i && typeof A == "function" && A.length != 1 && (v = C = !1);
            var x = this.__chain__, M = !!this.__actions__.length, O = d && !x, Z = v && !M;
            if (!d && C) {
              h = Z ? h : new K(this);
              var P = e.apply(h, m);
              return P.__actions__.push({ func: wt, args: [y], thisArg: o }), new Ze(P, x);
            }
            return O && Z ? e.apply(this, m) : (P = this.thru(y), O ? a ? P.value()[0] : P.value() : P);
          });
        }), Pe(["pop", "push", "shift", "sort", "splice", "unshift"], function(e) {
          var n = nt[e], i = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru", a = /^(?:pop|shift)$/.test(e);
          l.prototype[e] = function() {
            var c = arguments;
            if (a && !this.__chain__) {
              var d = this.value();
              return n.apply(G(d) ? d : [], c);
            }
            return this[i](function(h) {
              return n.apply(G(h) ? h : [], c);
            });
          };
        }), tn(K.prototype, function(e, n) {
          var i = l[n];
          if (i) {
            var a = i.name + "";
            q.call(nr, a) || (nr[a] = []), nr[a].push({ name: n, func: i });
          }
        }), nr[At(o, In).name] = [{
          name: "wrapper",
          func: o
        }], K.prototype.clone = Rd, K.prototype.reverse = Od, K.prototype.value = zd, l.prototype.at = ph, l.prototype.chain = fh, l.prototype.commit = hh, l.prototype.next = mh, l.prototype.plant = gh, l.prototype.reverse = vh, l.prototype.toJSON = l.prototype.valueOf = l.prototype.value = Ih, l.prototype.first = l.prototype.head, Tr && (l.prototype[Tr] = _h), l;
      }), Xn = fd();
      Rn ? ((Rn.exports = Xn)._ = Xn, lo._ = Xn) : me._ = Xn;
    }).call(p1);
  })(Gr, Gr.exports)), Gr.exports;
}
var Dr = f1();
const Y1 = (r, t) => {
  const o = Dr.mapValues(r, (u) => u === "" || u === void 0 ? null : u);
  return Dr.omit(o, t);
}, X1 = (r, t, o) => {
  const s = o ? Dr.omitBy(o, (u) => u === null) : {};
  Dr.assign(r, t, Dr.pick(s, Object.keys(r)));
}, Q1 = (r) => {
  const { properties: t } = r, { context: o } = t;
  return {
    addressNumber: o.address?.address_number,
    alternate: o.region?.alternate?.name,
    country: o.country?.name,
    countryCode: o.country?.country_code,
    fullAddress: t.full_address,
    latitude: t.coordinates.latitude,
    longitude: t.coordinates.longitude,
    mapboxId: t.mapbox_id,
    place: o.place?.name,
    postcode: o.postcode?.name,
    region: o.region?.name,
    streetName: o.street?.name
  };
}, e0 = (r) => /^[+]?[\s0-9]{6,}$/.test(r), n0 = (r) => {
  if (typeof r != "string") return !1;
  const t = r.replace(/-\d{1,2}$/, ""), o = /^\d+$/.test(t), s = /^[a-zA-Z0-9]+$/.test(t), u = t.length;
  return o && u >= 8 && u <= 10 || s && u === 17;
}, r0 = (r, t) => {
  if (typeof r != "number" || !Number.isInteger(r)) return !1;
  const o = -(2 ** (t - 1)), s = 2 ** (t - 1) - 1;
  return r >= o && r <= s;
};
class t0 {
  constructor(t, o, s) {
    this.minBidStepAmount = t, this.maxBidStepAmount = s, this.effectiveThreshold = Math.ceil(o / t) * t;
  }
  validateAmount(t) {
    const [o, s] = t < this.effectiveThreshold ? [t, this.minBidStepAmount] : [t - this.effectiveThreshold, this.maxBidStepAmount];
    return o % s === 0;
  }
  getStepRoundedAmount(t) {
    return this.getStepRoundedValue(t, Math.floor);
  }
  getStepRoundedReservePrice(t) {
    return this.getStepRoundedValue(t, Math.ceil);
  }
  getDeltaStepsAmount(t, o) {
    if (!this.validateAmount(t))
      throw new Error("Error in AuctionSteppedPrice.getDeltaStepsAmount, base is not a valid amount");
    return this.computeDeltaStepsAmount(t, o);
  }
  /*
   * Implementation of the starting price computation formula defined in
   * https://adorea.atlassian.net/browse/BSD-3693
   */
  getAuctionStartingPriceDefaultValue(t) {
    const s = t - 25e3 * (1 - Math.exp(-25e-6 * t));
    return this.getStepRoundedAmount(s);
  }
  getDirectSaleMinNegotiationOfferDefaultValue(t) {
    return this.getStepRoundedAmount(t * 0.3);
  }
  getDirectSaleSuggestedPriceDefaultValue(t) {
    const u = 1 - 0.24 * Math.exp(-2245e-9 * t);
    return this.getStepRoundedAmount(t * u);
  }
  getStepRoundedValue(t, o) {
    const [s, u, f] = t < this.effectiveThreshold ? [t, this.minBidStepAmount, 0] : [t - this.effectiveThreshold, this.maxBidStepAmount, this.effectiveThreshold];
    return o(s / u) * u + f;
  }
  computeDeltaStepsAmount(t, o) {
    const s = o / Math.abs(o);
    return o === 0 ? t : this.computeDeltaStepsAmount(
      t + ((o > 0 ? t < this.effectiveThreshold : t <= this.effectiveThreshold) ? this.minBidStepAmount : this.maxBidStepAmount) * s,
      o - s
    );
  }
}
const o0 = ({ reservePrice: r, isToBeScraped: t }) => {
  const o = t || r < 5e3 ? 50 : r < 1e4 ? 100 : r < 5e4 ? 500 : 1e3, s = t ? 50 : r < 5e3 ? 100 : r < 1e4 ? 500 : (r < 5e4, 1e3), u = t ? 1e3 : r < 5e3 ? 5e3 : r < 1e4 ? 1e4 : 5e4, f = t ? 250 : r < 5e4 ? 1e3 : r < 1e5 ? 1500 : 2e3;
  return {
    minStepDefaultValue: o,
    maxStepDefaultValue: s,
    thresholdDefaultValue: u,
    bailDefaultValue: f
  };
};
function pr(r) {
  const t = Object.prototype.toString.call(r);
  return r instanceof Date || typeof r == "object" && t === "[object Date]" ? new r.constructor(+r) : typeof r == "number" || t === "[object Number]" || typeof r == "string" || t === "[object String]" ? new Date(r) : /* @__PURE__ */ new Date(NaN);
}
function h1(r, t) {
  const o = pr(r), s = pr(t);
  return o.getTime() > s.getTime();
}
function m1(r, t) {
  const o = pr(r), s = pr(t);
  return +o < +s;
}
function Lu(r, t) {
  const o = pr(r), s = pr(t);
  return +o == +s;
}
function Bi(r) {
  throw new Error("Should not have reached this line");
}
var an = /* @__PURE__ */ ((r) => (r.Seller = "Seller", r.Buyer = "Buyer", r))(an || {}), sn = /* @__PURE__ */ ((r) => (r.FixedPercentage = "FixedPercentage", r.FixedAmount = "FixedAmount", r.Standard = "Standard", r))(sn || {});
const _1 = /* @__PURE__ */ new Date("2025-11-24"), g1 = /* @__PURE__ */ new Date("2025-11-28"), cr = 250, Ai = 0.0875, Tc = 0.0375, Cc = 5250, Ti = 1e5, yc = 2500, v1 = (r, [t, o]) => (Lu(r, t) || h1(r, t)) && (m1(r, o) || Lu(r, o)), Nc = ({
  feeTarget: r,
  baseAmount: t,
  assetsCount: o,
  feeConfiguration: s
}) => {
  const u = {
    [an.Seller]: 1,
    [an.Buyer]: -1
  }[r], f = t / o;
  return (() => {
    if (!s || s.type === sn.Standard) {
      const _ = yc - cr * u;
      if (f <= _) return f + cr * u;
      const S = Ti - cr * u - Ai * Ti * u;
      return f <= S ? (f + cr * u) / (1 - Ai * u) : (f + Cc * u) / (1 - Tc * u);
    }
    if (s.type === sn.FixedPercentage)
      return f / (1 - s.feeOverrideValue * u);
    if (s.type === sn.FixedAmount)
      return f + s.feeOverrideValue * u;
    Bi(s.type);
  })() * o;
}, i0 = ({
  feeTarget: r,
  baseAmount: t,
  assetsCount: o,
  referenceDate: s,
  feeConfiguration: u
}) => {
  const f = t / o, _ = (() => {
    if (!u || u.type === sn.Standard)
      return f <= yc ? cr : f <= Ti ? cr + Ai * f : Cc + Tc * f;
    if (u.type === sn.FixedPercentage)
      return f * u.feeOverrideValue;
    if (u.type === sn.FixedAmount)
      return u.feeOverrideValue;
    Bi(u.type);
  })() * o, N = r === an.Buyer && s && v1(s, [_1, g1]) ? _ * 0.5 : _;
  return {
    grossTotal: Math.ceil(r === an.Buyer ? t + _ : t),
    grossNet: Math.ceil(r === an.Buyer ? t : t - _),
    grossFees: Math.ceil(_),
    total: Math.ceil(r === an.Buyer ? t + N : t),
    net: Math.ceil(r === an.Buyer ? t : t - N),
    fees: Math.ceil(N)
  };
}, a0 = ({
  sellerReservePrice: r,
  assetsCount: t,
  feeConfiguration: o
}) => {
  const s = Math.ceil(
    Nc({
      feeTarget: an.Seller,
      baseAmount: r,
      assetsCount: t,
      feeConfiguration: o
    })
  );
  return {
    sellerReservePrice: r,
    fees: s - r,
    reservePrice: s
  };
}, s0 = ({
  buyerBudget: r,
  assetsCount: t,
  feeConfiguration: o
}) => {
  const s = Math.ceil(
    Nc({
      feeTarget: an.Buyer,
      baseAmount: r,
      assetsCount: t,
      feeConfiguration: o
    })
  );
  return {
    buyerBudget: r,
    fees: r - s,
    buyerMaxOffer: s
  };
}, u0 = ({
  sellerReservePrice: r,
  feeConfiguration: t
}) => {
  const o = (() => {
    if (!t || t.type === sn.Standard)
      return r <= 2250 ? 250 : r <= 91e3 ? (r + 250) / 0.9125 : (r + 5250) / 0.9625;
    if (t.type === sn.FixedPercentage)
      return r / (1 - t.feeOverrideValue);
    if (t.type === sn.FixedAmount)
      return r + t.feeOverrideValue;
    Bi(t.type);
  })();
  return Math.ceil(o);
};
var I1 = /* @__PURE__ */ ((r) => (r.VEHICLE_TOO_OLD = "VEHICLE_TOO_OLD", r.ELECTRIC_OR_HYBRID = "ELECTRIC_OR_HYBRID", r.MILEAGE_OR_MAINTENANCE_EXCEEDED = "MILEAGE_OR_MAINTENANCE_EXCEEDED", r.NOT_SUPPORTED_VEHICLE_CLASS = "NOT_SUPPORTED_VEHICLE_CLASS", r.MISSING_REQUIRED_DATA = "MISSING_REQUIRED_DATA", r))(I1 || {});
const c0 = {
  FleequidCare: {
    coverageCap: 1e4,
    warrantyDurationMonths: 3,
    creditPercentageGuidelines: [
      { maxAmount: 3e3, minCreditPercentage: 50 },
      { maxAmount: 5e3, minCreditPercentage: 45 },
      { maxAmount: 7e3, minCreditPercentage: 40 },
      { maxAmount: 9e3, minCreditPercentage: 35 },
      { maxAmount: 1e4, minCreditPercentage: 30 }
    ]
  },
  PowertrainWarranty: {
    coverageCap: 25e3,
    mileageLimits: [
      { durationMonths: 3, maxKm: 15e3 },
      { durationMonths: 6, maxKm: 3e4 },
      { durationMonths: 9, maxKm: 45e3 },
      { durationMonths: 12, maxKm: 6e4 }
    ],
    creditPercentageGuidelines: [
      { maxAmount: 1e4, minCreditPercentage: 30 },
      { maxAmount: 15e3, minCreditPercentage: 25 },
      { maxAmount: 2e4, minCreditPercentage: 20 },
      { maxAmount: 25e3, minCreditPercentage: 10 }
    ]
  }
};
export {
  u1 as ADMIN_USER_PASSWORD_RESET_TOKEN_PAYLOAD_TYPE,
  K1 as AdminUserPasswordResetTokenPayloadSchema,
  T1 as BANK_TRANSFER_BAIL_AUTHORIZATION_ID_PREFIX,
  C1 as BUS_ASSET_BASE_IMAGES,
  y1 as BUS_ASSET_COVER_IMAGES,
  c1 as CUSTOMER_USER_PASSWORD_RESET_TOKEN_PAYLOAD_TYPE,
  b1 as CalcomBookingMetadataSchema,
  H1 as CustomerUserPasswordResetTokenPayloadSchema,
  B1 as FILE_UPLOAD_EXTENSIONS,
  k1 as FILE_UPLOAD_PDF_MAX_SIZE,
  an as FeeTarget,
  sn as FeeType,
  o1 as LanguageISO6391Schema,
  G1 as MAPBOX_API_CONFIG,
  A1 as ONE_EURO_STARTING_PRICE,
  I1 as PowertrainWarrantyIneligibilityReason,
  S1 as STEP_LOWEST_COMMON_DENOMINATOR,
  t0 as SaleSteppedPrice,
  c0 as VAS_CLAIM_CONFIGURATION,
  Y1 as adaptFormDataToDto,
  Q1 as adaptMapboxFeatureToAddressBody,
  U1 as addressFormFieldSchema,
  s0 as computeBuyerMaxOfferAndFees,
  i0 as computeFees,
  u0 as computeReservePrice,
  o0 as computeSaleDefaultValues,
  a0 as computeSellerReservePriceAndFees,
  ki as countriesConfig,
  Ic as countryIso2List,
  L1 as customerServiceEmail,
  F1 as customerServicePhone,
  j1 as fetchFormatQuery,
  $1 as getAddressFormFieldSchema,
  E1 as getAsCountryISO2,
  w1 as getAsCountryISO3,
  R1 as getAsLanguageISO6391,
  z1 as getAsTaxCodeOrigin,
  l1 as getAsTin,
  x1 as getCountryCodesByContinent,
  M1 as getCountryISO3FromISO2,
  N1 as getCountryNameInEnglish,
  D1 as getLanguage6391FromCountryIso2,
  X1 as initFormData,
  J1 as insertIf,
  n1 as isCountryISO2,
  r1 as isCountryISO3,
  r0 as isDbIntegerValidator,
  a1 as isTaxCodeOrigin,
  q1 as isTin,
  O1 as languageNames,
  Z1 as languageToRepresentativeCountryMap,
  V1 as parseAsTin,
  e0 as phoneValidator,
  P1 as provinces,
  i1 as taxCodeOriginList,
  n0 as vinValidator,
  W1 as zodPhoneE164
};
//# sourceMappingURL=shared.mjs.map
